import { down, only, up, between } from 'styled-breakpoints';
import { useBreakpoint } from 'styled-breakpoints/react-styled';
import styled, { css, createGlobalStyle, keyframes } from 'styled-components';
import * as React from 'react';
import React__default, { useState, useEffect, forwardRef, useRef } from 'react';
import require$$1$1 from 'react-dom';
import require$$1 from 'prop-types';

var DEFAULT_BREAKPOINTS = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400,
};
var useBreakpoints = function () {
    var isXs = useBreakpoint(down("xs"));
    var isSm = useBreakpoint(only("sm"));
    var isMd = useBreakpoint(only("md"));
    var isLg = useBreakpoint(only("lg"));
    var isXl = useBreakpoint(only("xl"));
    var isXXl = useBreakpoint(up("xxl"));
    var isMobile = useBreakpoint(down("xs"));
    var isTablet = useBreakpoint(between("sm", "md"));
    var isDesktop = useBreakpoint(up("lg"));
    return {
        isXs: isXs,
        isSm: isSm,
        isMd: isMd,
        isLg: isLg,
        isXl: isXl,
        isXXl: isXXl,
        isMobile: isMobile,
        isTablet: isTablet,
        isDesktop: isDesktop,
    };
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var ValignTextMiddle = css(templateObject_1$u || (templateObject_1$u = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n"])));
var OpensansBoldWhite16px = css(templateObject_2$q || (templateObject_2$q = __makeTemplateObject(["\n  color: var(--white);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-16);\n  font-weight: 700;\n  font-style: normal;\n"], ["\n  color: var(--white);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-16);\n  font-weight: 700;\n  font-style: normal;\n"])));
var OpensansNormalTundora12px = css(templateObject_3$m || (templateObject_3$m = __makeTemplateObject(["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-12);\n  font-weight: 400;\n  font-style: normal;\n"], ["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-12);\n  font-weight: 400;\n  font-style: normal;\n"])));
var OpensansNormalDark12px = css(templateObject_4$l || (templateObject_4$l = __makeTemplateObject(["\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n  color: #464646;\n"], ["\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n  color: #464646;\n"])));
var OpensansNormalTundora14px = css(templateObject_5$f || (templateObject_5$f = __makeTemplateObject(["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-14);\n  font-weight: 400;\n  font-style: normal;\n"], ["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-14);\n  font-weight: 400;\n  font-style: normal;\n"])));
var OpensansBoldWhite14px = css(templateObject_6$d || (templateObject_6$d = __makeTemplateObject(["\n  color: var(--white);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-14);\n  font-weight: 700;\n  font-style: normal;\n"], ["\n  color: var(--white);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-14);\n  font-weight: 700;\n  font-style: normal;\n"])));
var OpensansBoldWhite24px = css(templateObject_7$b || (templateObject_7$b = __makeTemplateObject(["\n  color: var(--white);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-24);\n  font-weight: 700;\n  font-style: normal;\n"], ["\n  color: var(--white);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-24);\n  font-weight: 700;\n  font-style: normal;\n"])));
var TempostdHeavycondensedNormalWhite18 = css(templateObject_8$8 || (templateObject_8$8 = __makeTemplateObject(["\n  color: var(--white);\n  font-family: var(--font-family-tempo_std-heavycondensed);\n  font-size: var(--font-size-18);\n  font-weight: 400;\n  font-style: normal;\n"], ["\n  color: var(--white);\n  font-family: var(--font-family-tempo_std-heavycondensed);\n  font-size: var(--font-size-18);\n  font-weight: 400;\n  font-style: normal;\n"])));
var OpensansBoldTundora16px = css(templateObject_9$7 || (templateObject_9$7 = __makeTemplateObject(["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-16);\n  font-weight: 700;\n  font-style: normal;\n"], ["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-16);\n  font-weight: 700;\n  font-style: normal;\n"])));
var OpensansBoldTundora12px = css(templateObject_10$5 || (templateObject_10$5 = __makeTemplateObject(["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-12);\n  font-weight: 700;\n  font-style: normal;\n"], ["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-12);\n  font-weight: 700;\n  font-style: normal;\n"])));
var OpensansBoldTundora24px = css(templateObject_11$4 || (templateObject_11$4 = __makeTemplateObject(["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-24);\n  font-weight: 700;\n  font-style: normal;\n"], ["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-24);\n  font-weight: 700;\n  font-style: normal;\n"])));
var OpensansBoldTundora20px = css(templateObject_12$4 || (templateObject_12$4 = __makeTemplateObject(["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-20);\n  font-weight: 700;\n  font-style: normal;\n"], ["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-20);\n  font-weight: 700;\n  font-style: normal;\n"])));
var OpensansSemiBoldWhite12px = css(templateObject_13$4 || (templateObject_13$4 = __makeTemplateObject(["\n  color: var(--white);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-12);\n  font-weight: 600;\n  font-style: normal;\n"], ["\n  color: var(--white);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-12);\n  font-weight: 600;\n  font-style: normal;\n"])));
var OpensansBoldWhite12px = css(templateObject_14$4 || (templateObject_14$4 = __makeTemplateObject(["\n  color: var(--white);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-12);\n  font-weight: 700;\n  font-style: normal;\n"], ["\n  color: var(--white);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-12);\n  font-weight: 700;\n  font-style: normal;\n"])));
var OpensansNormalToryBlue14px = css(templateObject_15$4 || (templateObject_15$4 = __makeTemplateObject(["\n  color: var(--tory-blue);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-14);\n  font-weight: 400;\n  font-style: normal;\n"], ["\n  color: var(--tory-blue);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-14);\n  font-weight: 400;\n  font-style: normal;\n"])));
var OpensansNormalTundora16px = css(templateObject_16$3 || (templateObject_16$3 = __makeTemplateObject(["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-16);\n  font-weight: 400;\n  font-style: normal;\n"], ["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-16);\n  font-weight: 400;\n  font-style: normal;\n"])));
var OpensansBoldTundora32px = css(templateObject_17$2 || (templateObject_17$2 = __makeTemplateObject(["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-32);\n  font-weight: 700;\n  font-style: normal;\n"], ["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-32);\n  font-weight: 700;\n  font-style: normal;\n"])));
var OpensansBoldTundora14px = css(templateObject_18$2 || (templateObject_18$2 = __makeTemplateObject(["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-14);\n  font-weight: 700;\n  font-style: normal;\n"], ["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-14);\n  font-weight: 700;\n  font-style: normal;\n"])));
var TempostdHeavycondensedNormalToryBlu18px = css(templateObject_19$2 || (templateObject_19$2 = __makeTemplateObject(["\n  color: var(--tory-blue);\n  font-family: var(--font-family-tempo_std-heavycondensed);\n  font-size: var(--font-size-18);\n  font-weight: 400;\n  font-style: normal;\n"], ["\n  color: var(--tory-blue);\n  font-family: var(--font-family-tempo_std-heavycondensed);\n  font-size: var(--font-size-18);\n  font-weight: 400;\n  font-style: normal;\n"])));
var OpensansNormalToryBlue12px = css(templateObject_20$2 || (templateObject_20$2 = __makeTemplateObject(["\n  color: var(--tory-blue);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-12);\n  font-weight: 400;\n  font-style: normal;\n"], ["\n  color: var(--tory-blue);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-12);\n  font-weight: 400;\n  font-style: normal;\n"])));
var OpensansBoldToryBlue12px = css(templateObject_21$2 || (templateObject_21$2 = __makeTemplateObject(["\n  color: var(--tory-blue);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-12);\n  font-weight: 700;\n  font-style: normal;\n"], ["\n  color: var(--tory-blue);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-12);\n  font-weight: 700;\n  font-style: normal;\n"])));
var Border1pxOutlineStructuresoutlineGr = css(templateObject_22$1 || (templateObject_22$1 = __makeTemplateObject(["\n  border: 1px solid var(--gray);\n"], ["\n  border: 1px solid var(--gray);\n"])));
var Border1pxToryBlue = css(templateObject_23$1 || (templateObject_23$1 = __makeTemplateObject(["\n  border: 1px solid var(--tory-blue);\n"], ["\n  border: 1px solid var(--tory-blue);\n"])));
var TempostdHeavycondensedNormalToryBlu = css(templateObject_24$1 || (templateObject_24$1 = __makeTemplateObject(["\n  color: var(--tory-blue);\n  font-family: var(--font-family-tempo_std-heavycondensed);\n  font-size: var(--font-size-20);\n  font-weight: 400;\n  font-style: normal;\n"], ["\n  color: var(--tory-blue);\n  font-family: var(--font-family-tempo_std-heavycondensed);\n  font-size: var(--font-size-20);\n  font-weight: 400;\n  font-style: normal;\n"])));
var OpensansNormalTundora10px = css(templateObject_25$1 || (templateObject_25$1 = __makeTemplateObject(["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-10);\n  font-weight: 400;\n  font-style: normal;\n"], ["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-10);\n  font-weight: 400;\n  font-style: normal;\n"])));
var Border08pxGray = css(templateObject_26$1 || (templateObject_26$1 = __makeTemplateObject(["\n  border: 0.8px solid var(--gray);\n"], ["\n  border: 0.8px solid var(--gray);\n"])));
var Border1pxGray = css(templateObject_27$1 || (templateObject_27$1 = __makeTemplateObject(["\n  border: 1px solid var(--gray);\n"], ["\n  border: 1px solid var(--gray);\n"])));
var OpensansBoldSonicSilver12px = css(templateObject_28 || (templateObject_28 = __makeTemplateObject(["\n  color: var(--sonic-silver);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-12);\n  font-weight: 700;\n  font-style: normal;\n"], ["\n  color: var(--sonic-silver);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-12);\n  font-weight: 700;\n  font-style: normal;\n"])));
var OpensansNormalWhite12px = css(templateObject_29 || (templateObject_29 = __makeTemplateObject(["\n  color: var(--white);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-12);\n  font-weight: 400;\n  font-style: normal;\n"], ["\n  color: var(--white);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-12);\n  font-weight: 400;\n  font-style: normal;\n"])));
var OpensansNormalSonicSilver12px = css(templateObject_30 || (templateObject_30 = __makeTemplateObject(["\n  color: var(--sonic-silver);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-12);\n  font-weight: 400;\n  font-style: normal;\n"], ["\n  color: var(--sonic-silver);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-12);\n  font-weight: 400;\n  font-style: normal;\n"])));
var OpensansNormalWhite14px = css(templateObject_31 || (templateObject_31 = __makeTemplateObject(["\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-14);\n  font-weight: 400;\n  font-style: normal;\n"], ["\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-14);\n  font-weight: 400;\n  font-style: normal;\n"])));
var Border1pxBlack2 = css(templateObject_32 || (templateObject_32 = __makeTemplateObject(["\n  border: 1px solid var(--black-2);\n"], ["\n  border: 1px solid var(--black-2);\n"])));
var OpensansNormalTundora14px2 = css(templateObject_33 || (templateObject_33 = __makeTemplateObject(["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-14);\n  font-weight: 400;\n  font-style: normal;\n"], ["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-14);\n  font-weight: 400;\n  font-style: normal;\n"])));
var OpensansBoldToryBlue14px = css(templateObject_34 || (templateObject_34 = __makeTemplateObject(["\n  color: var(--tory-blue);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-14);\n  font-weight: 700;\n  font-style: normal;\n"], ["\n  color: var(--tory-blue);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-14);\n  font-weight: 700;\n  font-style: normal;\n"])));
var PlainButtonStyle = css(templateObject_35 || (templateObject_35 = __makeTemplateObject(["\n  cursor: pointer;\n  border: 0;\n  appearance: none;\n  background: none;\n  padding: 0;\n  margin: 0;\n"], ["\n  cursor: pointer;\n  border: 0;\n  appearance: none;\n  background: none;\n  padding: 0;\n  margin: 0;\n"])));
var OpensansNormalToryBlue16px = css(templateObject_36 || (templateObject_36 = __makeTemplateObject(["\n  color: var(--tory-blue);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-16);\n  font-weight: 400;\n  font-style: normal;\n"], ["\n  color: var(--tory-blue);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-16);\n  font-weight: 400;\n  font-style: normal;\n"])));
var OpensansBoldToryBlue16px = css(templateObject_37 || (templateObject_37 = __makeTemplateObject(["\n  color: var(--tory-blue);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-16);\n  font-weight: 700;\n  font-style: normal;\n"], ["\n  color: var(--tory-blue);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-16);\n  font-weight: 700;\n  font-style: normal;\n"])));
var OpensansSemiBoldSonicSilver10px = css(templateObject_38 || (templateObject_38 = __makeTemplateObject(["\n  color: var(--sonic-silver);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-10);\n  font-weight: 600;\n  font-style: normal;\n"], ["\n  color: var(--sonic-silver);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-10);\n  font-weight: 600;\n  font-style: normal;\n"])));
var TempostdHeavycondensedNormalToryBlu1 = css(templateObject_39 || (templateObject_39 = __makeTemplateObject(["\n  color: var(--tory-blue);\n  font-family: var(--font-family-tempo_std-heavycondensed);\n  font-size: var(--font-size-34);\n  font-weight: 400;\n  font-style: normal;\n"], ["\n  color: var(--tory-blue);\n  font-family: var(--font-family-tempo_std-heavycondensed);\n  font-size: var(--font-size-34);\n  font-weight: 400;\n  font-style: normal;\n"])));
var Border2pxToryBlue = css(templateObject_40 || (templateObject_40 = __makeTemplateObject(["\n  border: 2px solid var(--tory-blue);\n"], ["\n  border: 2px solid var(--tory-blue);\n"])));
var Border21pxToryBlue = css(templateObject_41 || (templateObject_41 = __makeTemplateObject(["\n  border: 2.1px solid var(--tory-blue);\n"], ["\n  border: 2.1px solid var(--tory-blue);\n"])));
var TempostdHeavycondensedNormalWhite34 = css(templateObject_42 || (templateObject_42 = __makeTemplateObject(["\n  color: var(--white);\n  font-family: var(--font-family-tempo_std-heavycondensed);\n  font-size: var(--font-size-34);\n  font-weight: 400;\n  font-style: normal;\n"], ["\n  color: var(--white);\n  font-family: var(--font-family-tempo_std-heavycondensed);\n  font-size: var(--font-size-34);\n  font-weight: 400;\n  font-style: normal;\n"])));
var TempostdHeavycondensedNormalToryBlu2 = css(templateObject_43 || (templateObject_43 = __makeTemplateObject(["\n  color: var(--tory-blue);\n  font-family: var(--font-family-tempo_std-heavycondensed);\n  font-size: var(--font-size-24);\n  font-weight: 400;\n  font-style: normal;\n"], ["\n  color: var(--tory-blue);\n  font-family: var(--font-family-tempo_std-heavycondensed);\n  font-size: var(--font-size-24);\n  font-weight: 400;\n  font-style: normal;\n"])));
var OpensansBoldTundora22px = css(templateObject_44 || (templateObject_44 = __makeTemplateObject(["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-22);\n  font-weight: 700;\n  font-style: normal;\n"], ["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-22);\n  font-weight: 700;\n  font-style: normal;\n"])));
var OpensansBoldTundora18px = css(templateObject_45 || (templateObject_45 = __makeTemplateObject(["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-18);\n  font-weight: 700;\n  font-style: normal;\n"], ["\n  color: var(--tundora);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-18);\n  font-weight: 700;\n  font-style: normal;\n"])));
var OpensansBoldSonicSilver14px = css(templateObject_46 || (templateObject_46 = __makeTemplateObject(["\n  color: var(--sonic-silver);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-14);\n  font-weight: 700;\n  font-style: normal;\n"], ["\n  color: var(--sonic-silver);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-14);\n  font-weight: 700;\n  font-style: normal;\n"])));
var TempostdHeavycondensedNormalTundora = css(templateObject_47 || (templateObject_47 = __makeTemplateObject(["\n  color: var(--tundora);\n  font-family: var(--font-family-tempo_std-heavycondensed);\n  font-size: var(--font-size-16);\n  font-weight: 400;\n  font-style: normal;\n"], ["\n  color: var(--tundora);\n  font-family: var(--font-family-tempo_std-heavycondensed);\n  font-size: var(--font-size-16);\n  font-weight: 400;\n  font-style: normal;\n"])));
var OpensansBoldToryBlue18px = css(templateObject_48 || (templateObject_48 = __makeTemplateObject(["\n  color: var(--tory-blue);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-18);\n  font-weight: 700;\n  font-style: normal;\n"], ["\n  color: var(--tory-blue);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-18);\n  font-weight: 700;\n  font-style: normal;\n"])));
var OpensansBoldFunBlue14px = css(templateObject_49 || (templateObject_49 = __makeTemplateObject(["\n  color: var(--fun-blue);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-14);\n  font-weight: 700;\n  font-style: normal;\n"], ["\n  color: var(--fun-blue);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-14);\n  font-weight: 700;\n  font-style: normal;\n"])));
var OpensansBoldCrimson14px = css(templateObject_50 || (templateObject_50 = __makeTemplateObject(["\n  color: var(--crimson);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-14);\n  font-weight: 700;\n  font-style: normal;\n"], ["\n  color: var(--crimson);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-14);\n  font-weight: 700;\n  font-style: normal;\n"])));
var OpensansHeavyCrimson12px = css(templateObject_51 || (templateObject_51 = __makeTemplateObject(["\n  color: var(--crimson);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-12);\n  font-weight: 400;\n  font-style: normal;\n"], ["\n  color: var(--crimson);\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-12);\n  font-weight: 400;\n  font-style: normal;\n"])));
var ArrowStyled = css(templateObject_52 || (templateObject_52 = __makeTemplateObject(["\n    position: absolute;\n    top: 16px;\n    right: 16px;\n    box-sizing: content-box;\n    width: 8px;\n    height: 8px;\n    pointer-events: none;\n    content: \" \";\n    border-right: 3px solid var(", ");\n    border-bottom: 3px solid var(", ");\n    transform: ", ";\n    transition: transform .2s ease-in-out;\n"], ["\n    position: absolute;\n    top: 16px;\n    right: 16px;\n    box-sizing: content-box;\n    width: 8px;\n    height: 8px;\n    pointer-events: none;\n    content: \" \";\n    border-right: 3px solid var(", ");\n    border-bottom: 3px solid var(", ");\n    transform: ", ";\n    transition: transform .2s ease-in-out;\n"])), function (props) { return props.$hasError ? '--crimson' : '--tory-blue'; }, function (props) { return props.$hasError ? '--crimson' : '--tory-blue'; }, function (props) { return props.$isExpanded ? "rotate(225deg) translateY(-5px) translateX(-3px)" : "rotate(45deg)"; });
var CustomSelect = css(templateObject_53 || (templateObject_53 = __makeTemplateObject(["\n    ", "\n    ", "\n    height: 48px;\n    display: flex;\n    border-radius: var(--border-radius-s);\n    width: 100%;\n    text-overflow: \"\"; \n    appearance: none;  \n    padding-left: var(--spacing_token_s);\n    padding-right: var(--spacing_token_s);\n    line-height : 18px;   \n    background-color: var(--white);\n"], ["\n    ", "\n    ", "\n    height: 48px;\n    display: flex;\n    border-radius: var(--border-radius-s);\n    width: 100%;\n    text-overflow: \"\"; \n    appearance: none;  \n    padding-left: var(--spacing_token_s);\n    padding-right: var(--spacing_token_s);\n    line-height : 18px;   \n    background-color: var(--white);\n"])), Border1pxGray, OpensansNormalTundora14px);
var Focus = css(templateObject_54 || (templateObject_54 = __makeTemplateObject(["\n    box-shadow: 0 0 0 3px var(--bondi-blue); \n"], ["\n    box-shadow: 0 0 0 3px var(--bondi-blue); \n"])));
var CustomInput = css(templateObject_55 || (templateObject_55 = __makeTemplateObject(["\n    ", "\n    width: 100%;\n    height: 48px;\n    border-radius: var(--border-radius-s);\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    text-overflow: \"\"; \n    font-size: var(--font-size-14);\n    font-weight: 700;\n    padding: var(--spacing_token_s);\n"], ["\n    ", "\n    width: 100%;\n    height: 48px;\n    border-radius: var(--border-radius-s);\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    text-overflow: \"\"; \n    font-size: var(--font-size-14);\n    font-weight: 700;\n    padding: var(--spacing_token_s);\n"])), Border1pxGray);
var Error$1 = css(templateObject_56 || (templateObject_56 = __makeTemplateObject(["\n  ", "\n  ", "\n  letter-spacing: 0;\n  line-height: 16px;\n  padding: var(--spacing_token_xxs) 0;\n"], ["\n  ", "\n  ", "\n  letter-spacing: 0;\n  line-height: 16px;\n  padding: var(--spacing_token_xxs) 0;\n"])), ValignTextMiddle, OpensansHeavyCrimson12px);
var CustomBorderErrorStyle = css(templateObject_57 || (templateObject_57 = __makeTemplateObject(["\n   ", ";\n"], ["\n   ", ";\n"])), function (props) { return props.$hasError && "\n    border: solid 1px var(--crimson);\n  "; });
var CustomColorErrorStyle = css(templateObject_58 || (templateObject_58 = __makeTemplateObject(["\n   ", ";\n"], ["\n   ", ";\n"])), function (props) { return props.$hasError && "\n    color: var(--crimson);\n  "; });
var IconContainer = styled.div(templateObject_59 || (templateObject_59 = __makeTemplateObject(["\n  min-height: var(--spacing_token_s);\n  min-width: var(--spacing_token_s); \n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  min-height: var(--spacing_token_s);\n  min-width: var(--spacing_token_s); \n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])));
var templateObject_1$u, templateObject_2$q, templateObject_3$m, templateObject_4$l, templateObject_5$f, templateObject_6$d, templateObject_7$b, templateObject_8$8, templateObject_9$7, templateObject_10$5, templateObject_11$4, templateObject_12$4, templateObject_13$4, templateObject_14$4, templateObject_15$4, templateObject_16$3, templateObject_17$2, templateObject_18$2, templateObject_19$2, templateObject_20$2, templateObject_21$2, templateObject_22$1, templateObject_23$1, templateObject_24$1, templateObject_25$1, templateObject_26$1, templateObject_27$1, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41, templateObject_42, templateObject_43, templateObject_44, templateObject_45, templateObject_46, templateObject_47, templateObject_48, templateObject_49, templateObject_50, templateObject_51, templateObject_52, templateObject_53, templateObject_54, templateObject_55, templateObject_56, templateObject_57, templateObject_58, templateObject_59;

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
	if (n.__esModule) return n;
	var a = Object.defineProperty({}, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

var jsxRuntime = {exports: {}};

var reactJsxRuntime_production_min = {};

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols$2 = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols$2) {
			symbols = getOwnPropertySymbols$2(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f=React__default,g=60103;reactJsxRuntime_production_min.Fragment=60107;if("function"===typeof Symbol&&Symbol.for){var h=Symbol.for;g=h("react.element");reactJsxRuntime_production_min.Fragment=h("react.fragment");}var m=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,n=Object.prototype.hasOwnProperty,p={key:!0,ref:!0,__self:!0,__source:!0};
function q(c,a,k){var b,d={},e=null,l=null;void 0!==k&&(e=""+k);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(l=a.ref);for(b in a)n.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return {$$typeof:g,type:c,key:e,ref:l,props:d,_owner:m.current}}reactJsxRuntime_production_min.jsx=q;reactJsxRuntime_production_min.jsxs=q;

var reactJsxRuntime_development = {};

/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

(function (exports) {

if (process.env.NODE_ENV !== "production") {
  (function() {

var React = React__default;
var _assign = objectAssign;

// ATTENTION
// When adding new symbols to this file,
// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var REACT_ELEMENT_TYPE = 0xeac7;
var REACT_PORTAL_TYPE = 0xeaca;
exports.Fragment = 0xeacb;
var REACT_STRICT_MODE_TYPE = 0xeacc;
var REACT_PROFILER_TYPE = 0xead2;
var REACT_PROVIDER_TYPE = 0xeacd;
var REACT_CONTEXT_TYPE = 0xeace;
var REACT_FORWARD_REF_TYPE = 0xead0;
var REACT_SUSPENSE_TYPE = 0xead1;
var REACT_SUSPENSE_LIST_TYPE = 0xead8;
var REACT_MEMO_TYPE = 0xead3;
var REACT_LAZY_TYPE = 0xead4;
var REACT_BLOCK_TYPE = 0xead9;
var REACT_SERVER_BLOCK_TYPE = 0xeada;
var REACT_FUNDAMENTAL_TYPE = 0xead5;
var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;

if (typeof Symbol === 'function' && Symbol.for) {
  var symbolFor = Symbol.for;
  REACT_ELEMENT_TYPE = symbolFor('react.element');
  REACT_PORTAL_TYPE = symbolFor('react.portal');
  exports.Fragment = symbolFor('react.fragment');
  REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
  REACT_PROFILER_TYPE = symbolFor('react.profiler');
  REACT_PROVIDER_TYPE = symbolFor('react.provider');
  REACT_CONTEXT_TYPE = symbolFor('react.context');
  REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
  REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
  REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
  REACT_MEMO_TYPE = symbolFor('react.memo');
  REACT_LAZY_TYPE = symbolFor('react.lazy');
  REACT_BLOCK_TYPE = symbolFor('react.block');
  REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
  REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
  symbolFor('react.scope');
  symbolFor('react.opaque.id');
  REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
  symbolFor('react.offscreen');
  REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
}

var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator';
function getIteratorFn(maybeIterable) {
  if (maybeIterable === null || typeof maybeIterable !== 'object') {
    return null;
  }

  var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

  if (typeof maybeIterator === 'function') {
    return maybeIterator;
  }

  return null;
}

var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

function error(format) {
  {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    printWarning('error', format, args);
  }
}

function printWarning(level, format, args) {
  // When changing this logic, you might want to also
  // update consoleWithStackDev.www.js as well.
  {
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    var stack = ReactDebugCurrentFrame.getStackAddendum();

    if (stack !== '') {
      format += '%s';
      args = args.concat([stack]);
    }

    var argsWithFormat = args.map(function (item) {
      return '' + item;
    }); // Careful: RN currently depends on this prefix

    argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
    // breaks IE9: https://github.com/facebook/react/issues/13610
    // eslint-disable-next-line react-internal/no-production-logging

    Function.prototype.apply.call(console[level], console, argsWithFormat);
  }
}

// Filter certain DOM attributes (e.g. src, href) if their values are empty strings.

var enableScopeAPI = false; // Experimental Create Event Handle API.

function isValidElementType(type) {
  if (typeof type === 'string' || typeof type === 'function') {
    return true;
  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


  if (type === exports.Fragment || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI ) {
    return true;
  }

  if (typeof type === 'object' && type !== null) {
    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
      return true;
    }
  }

  return false;
}

function getWrappedName(outerType, innerType, wrapperName) {
  var functionName = innerType.displayName || innerType.name || '';
  return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
}

function getContextName(type) {
  return type.displayName || 'Context';
}

function getComponentName(type) {
  if (type == null) {
    // Host root, text node or just invalid type.
    return null;
  }

  {
    if (typeof type.tag === 'number') {
      error('Received an unexpected object in getComponentName(). ' + 'This is likely a bug in React. Please file an issue.');
    }
  }

  if (typeof type === 'function') {
    return type.displayName || type.name || null;
  }

  if (typeof type === 'string') {
    return type;
  }

  switch (type) {
    case exports.Fragment:
      return 'Fragment';

    case REACT_PORTAL_TYPE:
      return 'Portal';

    case REACT_PROFILER_TYPE:
      return 'Profiler';

    case REACT_STRICT_MODE_TYPE:
      return 'StrictMode';

    case REACT_SUSPENSE_TYPE:
      return 'Suspense';

    case REACT_SUSPENSE_LIST_TYPE:
      return 'SuspenseList';
  }

  if (typeof type === 'object') {
    switch (type.$$typeof) {
      case REACT_CONTEXT_TYPE:
        var context = type;
        return getContextName(context) + '.Consumer';

      case REACT_PROVIDER_TYPE:
        var provider = type;
        return getContextName(provider._context) + '.Provider';

      case REACT_FORWARD_REF_TYPE:
        return getWrappedName(type, type.render, 'ForwardRef');

      case REACT_MEMO_TYPE:
        return getComponentName(type.type);

      case REACT_BLOCK_TYPE:
        return getComponentName(type._render);

      case REACT_LAZY_TYPE:
        {
          var lazyComponent = type;
          var payload = lazyComponent._payload;
          var init = lazyComponent._init;

          try {
            return getComponentName(init(payload));
          } catch (x) {
            return null;
          }
        }
    }
  }

  return null;
}

// Helpers to patch console.logs to avoid logging during side-effect free
// replaying on render function. This currently only patches the object
// lazily which won't cover if the log function was extracted eagerly.
// We could also eagerly patch the method.
var disabledDepth = 0;
var prevLog;
var prevInfo;
var prevWarn;
var prevError;
var prevGroup;
var prevGroupCollapsed;
var prevGroupEnd;

function disabledLog() {}

disabledLog.__reactDisabledLog = true;
function disableLogs() {
  {
    if (disabledDepth === 0) {
      /* eslint-disable react-internal/no-production-logging */
      prevLog = console.log;
      prevInfo = console.info;
      prevWarn = console.warn;
      prevError = console.error;
      prevGroup = console.group;
      prevGroupCollapsed = console.groupCollapsed;
      prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099

      var props = {
        configurable: true,
        enumerable: true,
        value: disabledLog,
        writable: true
      }; // $FlowFixMe Flow thinks console is immutable.

      Object.defineProperties(console, {
        info: props,
        log: props,
        warn: props,
        error: props,
        group: props,
        groupCollapsed: props,
        groupEnd: props
      });
      /* eslint-enable react-internal/no-production-logging */
    }

    disabledDepth++;
  }
}
function reenableLogs() {
  {
    disabledDepth--;

    if (disabledDepth === 0) {
      /* eslint-disable react-internal/no-production-logging */
      var props = {
        configurable: true,
        enumerable: true,
        writable: true
      }; // $FlowFixMe Flow thinks console is immutable.

      Object.defineProperties(console, {
        log: _assign({}, props, {
          value: prevLog
        }),
        info: _assign({}, props, {
          value: prevInfo
        }),
        warn: _assign({}, props, {
          value: prevWarn
        }),
        error: _assign({}, props, {
          value: prevError
        }),
        group: _assign({}, props, {
          value: prevGroup
        }),
        groupCollapsed: _assign({}, props, {
          value: prevGroupCollapsed
        }),
        groupEnd: _assign({}, props, {
          value: prevGroupEnd
        })
      });
      /* eslint-enable react-internal/no-production-logging */
    }

    if (disabledDepth < 0) {
      error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
    }
  }
}

var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
var prefix;
function describeBuiltInComponentFrame(name, source, ownerFn) {
  {
    if (prefix === undefined) {
      // Extract the VM specific prefix used by each line.
      try {
        throw Error();
      } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        prefix = match && match[1] || '';
      }
    } // We use the prefix to ensure our stacks line up with native stack frames.


    return '\n' + prefix + name;
  }
}
var reentry = false;
var componentFrameCache;

{
  var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
  componentFrameCache = new PossiblyWeakMap();
}

function describeNativeComponentFrame(fn, construct) {
  // If something asked for a stack inside a fake render, it should get ignored.
  if (!fn || reentry) {
    return '';
  }

  {
    var frame = componentFrameCache.get(fn);

    if (frame !== undefined) {
      return frame;
    }
  }

  var control;
  reentry = true;
  var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.

  Error.prepareStackTrace = undefined;
  var previousDispatcher;

  {
    previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
    // for warnings.

    ReactCurrentDispatcher.current = null;
    disableLogs();
  }

  try {
    // This should throw.
    if (construct) {
      // Something should be setting the props in the constructor.
      var Fake = function () {
        throw Error();
      }; // $FlowFixMe


      Object.defineProperty(Fake.prototype, 'props', {
        set: function () {
          // We use a throwing setter instead of frozen or non-writable props
          // because that won't throw in a non-strict mode function.
          throw Error();
        }
      });

      if (typeof Reflect === 'object' && Reflect.construct) {
        // We construct a different control for this case to include any extra
        // frames added by the construct call.
        try {
          Reflect.construct(Fake, []);
        } catch (x) {
          control = x;
        }

        Reflect.construct(fn, [], Fake);
      } else {
        try {
          Fake.call();
        } catch (x) {
          control = x;
        }

        fn.call(Fake.prototype);
      }
    } else {
      try {
        throw Error();
      } catch (x) {
        control = x;
      }

      fn();
    }
  } catch (sample) {
    // This is inlined manually because closure doesn't do it for us.
    if (sample && control && typeof sample.stack === 'string') {
      // This extracts the first frame from the sample that isn't also in the control.
      // Skipping one frame that we assume is the frame that calls the two.
      var sampleLines = sample.stack.split('\n');
      var controlLines = control.stack.split('\n');
      var s = sampleLines.length - 1;
      var c = controlLines.length - 1;

      while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
        // We expect at least one stack frame to be shared.
        // Typically this will be the root most one. However, stack frames may be
        // cut off due to maximum stack limits. In this case, one maybe cut off
        // earlier than the other. We assume that the sample is longer or the same
        // and there for cut off earlier. So we should find the root most frame in
        // the sample somewhere in the control.
        c--;
      }

      for (; s >= 1 && c >= 0; s--, c--) {
        // Next we find the first one that isn't the same which should be the
        // frame that called our sample function and the control.
        if (sampleLines[s] !== controlLines[c]) {
          // In V8, the first line is describing the message but other VMs don't.
          // If we're about to return the first line, and the control is also on the same
          // line, that's a pretty good indicator that our sample threw at same line as
          // the control. I.e. before we entered the sample frame. So we ignore this result.
          // This can happen if you passed a class to function component, or non-function.
          if (s !== 1 || c !== 1) {
            do {
              s--;
              c--; // We may still have similar intermediate frames from the construct call.
              // The next one that isn't the same should be our match though.

              if (c < 0 || sampleLines[s] !== controlLines[c]) {
                // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                var _frame = '\n' + sampleLines[s].replace(' at new ', ' at ');

                {
                  if (typeof fn === 'function') {
                    componentFrameCache.set(fn, _frame);
                  }
                } // Return the line we found.


                return _frame;
              }
            } while (s >= 1 && c >= 0);
          }

          break;
        }
      }
    }
  } finally {
    reentry = false;

    {
      ReactCurrentDispatcher.current = previousDispatcher;
      reenableLogs();
    }

    Error.prepareStackTrace = previousPrepareStackTrace;
  } // Fallback to just using the name if we couldn't make it throw.


  var name = fn ? fn.displayName || fn.name : '';
  var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';

  {
    if (typeof fn === 'function') {
      componentFrameCache.set(fn, syntheticFrame);
    }
  }

  return syntheticFrame;
}
function describeFunctionComponentFrame(fn, source, ownerFn) {
  {
    return describeNativeComponentFrame(fn, false);
  }
}

function shouldConstruct(Component) {
  var prototype = Component.prototype;
  return !!(prototype && prototype.isReactComponent);
}

function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {

  if (type == null) {
    return '';
  }

  if (typeof type === 'function') {
    {
      return describeNativeComponentFrame(type, shouldConstruct(type));
    }
  }

  if (typeof type === 'string') {
    return describeBuiltInComponentFrame(type);
  }

  switch (type) {
    case REACT_SUSPENSE_TYPE:
      return describeBuiltInComponentFrame('Suspense');

    case REACT_SUSPENSE_LIST_TYPE:
      return describeBuiltInComponentFrame('SuspenseList');
  }

  if (typeof type === 'object') {
    switch (type.$$typeof) {
      case REACT_FORWARD_REF_TYPE:
        return describeFunctionComponentFrame(type.render);

      case REACT_MEMO_TYPE:
        // Memo may contain any component type so we recursively resolve it.
        return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);

      case REACT_BLOCK_TYPE:
        return describeFunctionComponentFrame(type._render);

      case REACT_LAZY_TYPE:
        {
          var lazyComponent = type;
          var payload = lazyComponent._payload;
          var init = lazyComponent._init;

          try {
            // Lazy may contain any component type so we recursively resolve it.
            return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
          } catch (x) {}
        }
    }
  }

  return '';
}

var loggedTypeFailures = {};
var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;

function setCurrentlyValidatingElement(element) {
  {
    if (element) {
      var owner = element._owner;
      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
      ReactDebugCurrentFrame.setExtraStackFrame(stack);
    } else {
      ReactDebugCurrentFrame.setExtraStackFrame(null);
    }
  }
}

function checkPropTypes(typeSpecs, values, location, componentName, element) {
  {
    // $FlowFixMe This is okay but Flow doesn't know it.
    var has = Function.call.bind(Object.prototype.hasOwnProperty);

    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.

        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
            err.name = 'Invariant Violation';
            throw err;
          }

          error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
        } catch (ex) {
          error$1 = ex;
        }

        if (error$1 && !(error$1 instanceof Error)) {
          setCurrentlyValidatingElement(element);

          error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);

          setCurrentlyValidatingElement(null);
        }

        if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error$1.message] = true;
          setCurrentlyValidatingElement(element);

          error('Failed %s type: %s', location, error$1.message);

          setCurrentlyValidatingElement(null);
        }
      }
    }
  }
}

var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};
var specialPropKeyWarningShown;
var specialPropRefWarningShown;
var didWarnAboutStringRefs;

{
  didWarnAboutStringRefs = {};
}

function hasValidRef(config) {
  {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;

      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }

  return config.ref !== undefined;
}

function hasValidKey(config) {
  {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;

      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }

  return config.key !== undefined;
}

function warnIfStringRefCannotBeAutoConverted(config, self) {
  {
    if (typeof config.ref === 'string' && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
      var componentName = getComponentName(ReactCurrentOwner.current.type);

      if (!didWarnAboutStringRefs[componentName]) {
        error('Component "%s" contains the string ref "%s". ' + 'Support for string refs will be removed in a future major release. ' + 'This case cannot be automatically converted to an arrow function. ' + 'We ask you to manually fix this case by using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-string-ref', getComponentName(ReactCurrentOwner.current.type), config.ref);

        didWarnAboutStringRefs[componentName] = true;
      }
    }
  }
}

function defineKeyPropWarningGetter(props, displayName) {
  {
    var warnAboutAccessingKey = function () {
      if (!specialPropKeyWarningShown) {
        specialPropKeyWarningShown = true;

        error('%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
      }
    };

    warnAboutAccessingKey.isReactWarning = true;
    Object.defineProperty(props, 'key', {
      get: warnAboutAccessingKey,
      configurable: true
    });
  }
}

function defineRefPropWarningGetter(props, displayName) {
  {
    var warnAboutAccessingRef = function () {
      if (!specialPropRefWarningShown) {
        specialPropRefWarningShown = true;

        error('%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
      }
    };

    warnAboutAccessingRef.isReactWarning = true;
    Object.defineProperty(props, 'ref', {
      get: warnAboutAccessingRef,
      configurable: true
    });
  }
}
/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */


var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allows us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,
    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,
    // Record the component responsible for creating this element.
    _owner: owner
  };

  {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.

    Object.defineProperty(element._store, 'validated', {
      configurable: false,
      enumerable: false,
      writable: true,
      value: false
    }); // self and source are DEV only properties.

    Object.defineProperty(element, '_self', {
      configurable: false,
      enumerable: false,
      writable: false,
      value: self
    }); // Two elements created in two different places should be considered
    // equal for testing purposes and therefore we hide it from enumeration.

    Object.defineProperty(element, '_source', {
      configurable: false,
      enumerable: false,
      writable: false,
      value: source
    });

    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};
/**
 * https://github.com/reactjs/rfcs/pull/107
 * @param {*} type
 * @param {object} props
 * @param {string} key
 */

function jsxDEV(type, config, maybeKey, source, self) {
  {
    var propName; // Reserved names are extracted

    var props = {};
    var key = null;
    var ref = null; // Currently, key can be spread in as a prop. This causes a potential
    // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
    // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
    // but as an intermediary step, we will use jsxDEV for everything except
    // <div {...props} key="Hi" />, because we aren't currently able to tell if
    // key is explicitly declared to be undefined or not.

    if (maybeKey !== undefined) {
      key = '' + maybeKey;
    }

    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    if (hasValidRef(config)) {
      ref = config.ref;
      warnIfStringRefCannotBeAutoConverted(config, self);
    } // Remaining properties are added to a new props object


    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    } // Resolve default props


    if (type && type.defaultProps) {
      var defaultProps = type.defaultProps;

      for (propName in defaultProps) {
        if (props[propName] === undefined) {
          props[propName] = defaultProps[propName];
        }
      }
    }

    if (key || ref) {
      var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;

      if (key) {
        defineKeyPropWarningGetter(props, displayName);
      }

      if (ref) {
        defineRefPropWarningGetter(props, displayName);
      }
    }

    return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
  }
}

var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;

function setCurrentlyValidatingElement$1(element) {
  {
    if (element) {
      var owner = element._owner;
      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
      ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
    } else {
      ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
  }
}

var propTypesMisspellWarningShown;

{
  propTypesMisspellWarningShown = false;
}
/**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */

function isValidElement(object) {
  {
    return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
  }
}

function getDeclarationErrorAddendum() {
  {
    if (ReactCurrentOwner$1.current) {
      var name = getComponentName(ReactCurrentOwner$1.current.type);

      if (name) {
        return '\n\nCheck the render method of `' + name + '`.';
      }
    }

    return '';
  }
}

function getSourceInfoErrorAddendum(source) {
  {
    if (source !== undefined) {
      var fileName = source.fileName.replace(/^.*[\\\/]/, '');
      var lineNumber = source.lineNumber;
      return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
    }

    return '';
  }
}
/**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */


var ownerHasKeyUseWarning = {};

function getCurrentComponentErrorInfo(parentType) {
  {
    var info = getDeclarationErrorAddendum();

    if (!info) {
      var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;

      if (parentName) {
        info = "\n\nCheck the top-level render call using <" + parentName + ">.";
      }
    }

    return info;
  }
}
/**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */


function validateExplicitKey(element, parentType) {
  {
    if (!element._store || element._store.validated || element.key != null) {
      return;
    }

    element._store.validated = true;
    var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);

    if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
      return;
    }

    ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
    // property, it may be the creator of the child that's responsible for
    // assigning it a key.

    var childOwner = '';

    if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
      // Give the component that originally created this child.
      childOwner = " It was passed a child from " + getComponentName(element._owner.type) + ".";
    }

    setCurrentlyValidatingElement$1(element);

    error('Each child in a list should have a unique "key" prop.' + '%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);

    setCurrentlyValidatingElement$1(null);
  }
}
/**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */


function validateChildKeys(node, parentType) {
  {
    if (typeof node !== 'object') {
      return;
    }

    if (Array.isArray(node)) {
      for (var i = 0; i < node.length; i++) {
        var child = node[i];

        if (isValidElement(child)) {
          validateExplicitKey(child, parentType);
        }
      }
    } else if (isValidElement(node)) {
      // This element was passed in a valid location.
      if (node._store) {
        node._store.validated = true;
      }
    } else if (node) {
      var iteratorFn = getIteratorFn(node);

      if (typeof iteratorFn === 'function') {
        // Entry iterators used to provide implicit keys,
        // but now we print a separate warning for them later.
        if (iteratorFn !== node.entries) {
          var iterator = iteratorFn.call(node);
          var step;

          while (!(step = iterator.next()).done) {
            if (isValidElement(step.value)) {
              validateExplicitKey(step.value, parentType);
            }
          }
        }
      }
    }
  }
}
/**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */


function validatePropTypes(element) {
  {
    var type = element.type;

    if (type === null || type === undefined || typeof type === 'string') {
      return;
    }

    var propTypes;

    if (typeof type === 'function') {
      propTypes = type.propTypes;
    } else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
    // Inner props are checked in the reconciler.
    type.$$typeof === REACT_MEMO_TYPE)) {
      propTypes = type.propTypes;
    } else {
      return;
    }

    if (propTypes) {
      // Intentionally inside to avoid triggering lazy initializers:
      var name = getComponentName(type);
      checkPropTypes(propTypes, element.props, 'prop', name, element);
    } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
      propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:

      var _name = getComponentName(type);

      error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
    }

    if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) {
      error('getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.');
    }
  }
}
/**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */


function validateFragmentProps(fragment) {
  {
    var keys = Object.keys(fragment.props);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];

      if (key !== 'children' && key !== 'key') {
        setCurrentlyValidatingElement$1(fragment);

        error('Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.', key);

        setCurrentlyValidatingElement$1(null);
        break;
      }
    }

    if (fragment.ref !== null) {
      setCurrentlyValidatingElement$1(fragment);

      error('Invalid attribute `ref` supplied to `React.Fragment`.');

      setCurrentlyValidatingElement$1(null);
    }
  }
}

function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
  {
    var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
    // succeed and there will likely be errors in render.

    if (!validType) {
      var info = '';

      if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
        info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
      }

      var sourceInfo = getSourceInfoErrorAddendum(source);

      if (sourceInfo) {
        info += sourceInfo;
      } else {
        info += getDeclarationErrorAddendum();
      }

      var typeString;

      if (type === null) {
        typeString = 'null';
      } else if (Array.isArray(type)) {
        typeString = 'array';
      } else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
        typeString = "<" + (getComponentName(type.type) || 'Unknown') + " />";
        info = ' Did you accidentally export a JSX literal instead of a component?';
      } else {
        typeString = typeof type;
      }

      error('React.jsx: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
    }

    var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
    // TODO: Drop this when these are no longer allowed as the type argument.

    if (element == null) {
      return element;
    } // Skip key warning if the type isn't valid since our key validation logic
    // doesn't expect a non-string/function type and can throw confusing errors.
    // We don't want exception behavior to differ between dev and prod.
    // (Rendering will throw with a helpful message and as soon as the type is
    // fixed, the key warnings will appear.)


    if (validType) {
      var children = props.children;

      if (children !== undefined) {
        if (isStaticChildren) {
          if (Array.isArray(children)) {
            for (var i = 0; i < children.length; i++) {
              validateChildKeys(children[i], type);
            }

            if (Object.freeze) {
              Object.freeze(children);
            }
          } else {
            error('React.jsx: Static children should always be an array. ' + 'You are likely explicitly calling React.jsxs or React.jsxDEV. ' + 'Use the Babel transform instead.');
          }
        } else {
          validateChildKeys(children, type);
        }
      }
    }

    if (type === exports.Fragment) {
      validateFragmentProps(element);
    } else {
      validatePropTypes(element);
    }

    return element;
  }
} // These two functions exist to still get child warnings in dev
// even with the prod transform. This means that jsxDEV is purely
// opt-in behavior for better messages but that we won't stop
// giving you warnings if you use production apis.

function jsxWithValidationStatic(type, props, key) {
  {
    return jsxWithValidation(type, props, key, true);
  }
}
function jsxWithValidationDynamic(type, props, key) {
  {
    return jsxWithValidation(type, props, key, false);
  }
}

var jsx =  jsxWithValidationDynamic ; // we may want to special case jsxs internally to take advantage of static children.
// for now we can ship identical prod functions

var jsxs =  jsxWithValidationStatic ;

exports.jsx = jsx;
exports.jsxs = jsxs;
  })();
}
}(reactJsxRuntime_development));

if (process.env.NODE_ENV === 'production') {
  jsxRuntime.exports = reactJsxRuntime_production_min;
} else {
  jsxRuntime.exports = reactJsxRuntime_development;
}

var _path$c;
function _extends$d() { _extends$d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }
var SvgChevronCaretsDown = function SvgChevronCaretsDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$d({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$c || (_path$c = /*#__PURE__*/React.createElement("path", {
    d: "M7.293 12.062 1.22 5.989a.75.75 0 0 1 0-1.061l.708-.708a.75.75 0 0 1 1.06-.002l4.835 4.814 4.836-4.814a.75.75 0 0 1 1.06.002l.708.708a.75.75 0 0 1 0 1.06l-6.073 6.074a.75.75 0 0 1-1.061 0Z",
    fill: "#10559A"
  })));
};

var ExpandableButton$1 = styled.button(templateObject_1$t || (templateObject_1$t = __makeTemplateObject(["\n  height: 18px;   \n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  ", "\n  padding-right: var(--spacing_token_xxs);\n  ", " { \n    height: 16px;   \n  }\n"], ["\n  height: 18px;   \n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  ", "\n  padding-right: var(--spacing_token_xxs);\n  ", " { \n    height: 16px;   \n  }\n"])), PlainButtonStyle, up("sm"));
var Title$3 = styled.div(templateObject_2$p || (templateObject_2$p = __makeTemplateObject(["\n    ", "\n    line-height: 18px;\n    letter-spacing: 0;\n    color: ", ";\n    font-size: ", ";\n    \n    ", " {  \n      ", "\n      line-height: 16px;\n      color: ", ";\n  }\n"], ["\n    ", "\n    line-height: 18px;\n    letter-spacing: 0;\n    color: ", ";\n    font-size: ", ";\n    \n    ", " {  \n      ", "\n      line-height: 16px;\n      color: ", ";\n  }\n"])), OpensansBoldTundora14px, function (props) { return props.color; }, function (props) { return props.fontSize; }, up("sm"), OpensansBoldTundora12px, function (props) { return props.color; });
var Icon$2 = styled.img(templateObject_3$l || (templateObject_3$l = __makeTemplateObject(["\n  min-width: 16px;\n  height: 16px;\n  align-self: center;\n  transition: all .5s ease;\n  transform: ", ";\n  src: ", ";\n"], ["\n  min-width: 16px;\n  height: 16px;\n  align-self: center;\n  transition: all .5s ease;\n  transform: ", ";\n  src: ", ";\n"])), function (props) { return props.$isExpanded && "rotate(-180deg)"; }, function (props) { return props.src; });
var DefaultIcon = styled(SvgChevronCaretsDown)(templateObject_4$k || (templateObject_4$k = __makeTemplateObject(["\n  min-width: 16px;\n  height: 16px;\n  align-self: center;\n  transition: all .5s ease;\n  transform: ", ";\n"], ["\n  min-width: 16px;\n  height: 16px;\n  align-self: center;\n  transition: all .5s ease;\n  transform: ", ";\n"])), function (props) { return props.$isExpanded && "rotate(-180deg)"; });
var templateObject_1$t, templateObject_2$p, templateObject_3$l, templateObject_4$k;

var ExpandableButton = function (props) {
    return (jsxRuntime.exports.jsxs(ExpandableButton$1, __assign({ className: props.className, onClick: props.onClick, "aria-expanded": props.isExpanded, "aria-label": props.ariaLabel, "data-testid": props.testId }, { children: [jsxRuntime.exports.jsx(Title$3, __assign({ color: props.titleColor, fontSize: props.fontSize }, { children: props.title })), !props.hideIcon && (props.iconSrc ?
                jsxRuntime.exports.jsx(Icon$2, { "$isExpanded": props.isExpanded, src: props.iconSrc, "aria-hidden": 'true' }) :
                jsxRuntime.exports.jsx(DefaultIcon, { "$isExpanded": props.isExpanded, "aria-hidden": 'true' }))] })));
};

var _path$b;
function _extends$c() { _extends$c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }
var SvgCloseModalIcon24 = function SvgCloseModalIcon24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$c({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$b || (_path$b = /*#__PURE__*/React.createElement("path", {
    d: "m15.57 12 8.079-8.079a1.198 1.198 0 0 0 0-1.693L21.77.35a1.198 1.198 0 0 0-1.693 0L12 8.43 3.92.351a1.198 1.198 0 0 0-1.693 0L.35 2.228a1.198 1.198 0 0 0 0 1.693L8.43 12 .35 20.079a1.198 1.198 0 0 0 0 1.693l1.878 1.878a1.198 1.198 0 0 0 1.693 0L12 15.57l8.079 8.079a1.198 1.198 0 0 0 1.693 0l1.878-1.877a1.198 1.198 0 0 0 0-1.694L15.57 12Z",
    fill: "#10559A"
  })));
};

var HeadingWrapper$3 = styled.div(templateObject_1$s || (templateObject_1$s = __makeTemplateObject(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  width: 100%;\n  align-items: flex-start;\n  height : fit-content;\n"], ["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  width: 100%;\n  align-items: flex-start;\n  height : fit-content;\n"])));
var Heading = styled.h1(templateObject_2$o || (templateObject_2$o = __makeTemplateObject(["\n  font-family: ", ";\n  color:  ", ";\n  font-size: var(--font-size-24);\n  line-height: 28px;\n  letter-spacing: 0;\n  justify-content: space-between;\n  font-weight: 900;\n  font-size: var(--font-size-24);\n  margin-right:  var(--spacing_token_m);\n  margin-top:  0px;\n  margin-bottom:  0px;\n\n  ", " {    \n    font-size: ", "; \n    line-height: 38px;\n  }\n\n"], ["\n  font-family: ", ";\n  color:  ", ";\n  font-size: var(--font-size-24);\n  line-height: 28px;\n  letter-spacing: 0;\n  justify-content: space-between;\n  font-weight: 900;\n  font-size: var(--font-size-24);\n  margin-right:  var(--spacing_token_m);\n  margin-top:  0px;\n  margin-bottom:  0px;\n\n  ", " {    \n    font-size: ", "; \n    line-height: 38px;\n  }\n\n"])), function (props) { return props.$isDefault ? 'var(--font-family-tempo_std-heavycondensed)' : 'var(--font-family-open_sans)'; }, function (props) { return props.$isDefault ? 'var(--tory-blue)' : 'var(--tundora)'; }, up('sm'), function (props) { return props.$isDefault ? 'var(--font-size-34)' : 'var(--font-size-24)'; });
var CloseIcon$1 = styled.img(templateObject_3$k || (templateObject_3$k = __makeTemplateObject(["\n  min-width: 16px;\n  height: 16px;\n"], ["\n  min-width: 16px;\n  height: 16px;\n"])));
var CloseButton$4 = styled.button(templateObject_4$j || (templateObject_4$j = __makeTemplateObject(["\n  display: flex;\n  ", " \n"], ["\n  display: flex;\n  ", " \n"])), PlainButtonStyle);
var ContentWrapper$4 = styled.div(templateObject_5$e || (templateObject_5$e = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var DefaultCloseModalIcon$1 = styled(SvgCloseModalIcon24)(templateObject_6$c || (templateObject_6$c = __makeTemplateObject(["\n  width: 16px;\n  height: 16px;\n\n  ", " {\n      width: 24px;\n      height: 24px;\n  }"], ["\n  width: 16px;\n  height: 16px;\n\n  ", " {\n      width: 24px;\n      height: 24px;\n  }"])), up("sm"));
var ContentContainer$3 = styled.div(templateObject_7$a || (templateObject_7$a = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var templateObject_1$s, templateObject_2$o, templateObject_3$k, templateObject_4$j, templateObject_5$e, templateObject_6$c, templateObject_7$a;

var lib = {exports: {}};

var Modal$2 = {};

var ModalPortal = {exports: {}};

var focusManager = {};

var tabbable = {exports: {}};

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var DISPLAY_NONE = "none";
var DISPLAY_CONTENTS = "contents";

var tabbableNode = /input|select|textarea|button|object|iframe/;

function isNotOverflowing(element, style) {
  return style.getPropertyValue("overflow") !== "visible" ||
  // if 'overflow: visible' set, check if there is actually any overflow
  element.scrollWidth <= 0 && element.scrollHeight <= 0;
}

function hidesContents(element) {
  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

  // If the node is empty, this is good enough
  if (zeroSize && !element.innerHTML) return true;

  try {
    // Otherwise we need to check some styles
    var style = window.getComputedStyle(element);
    var displayValue = style.getPropertyValue("display");
    return zeroSize ? displayValue !== DISPLAY_CONTENTS && isNotOverflowing(element, style) : displayValue === DISPLAY_NONE;
  } catch (exception) {
    // eslint-disable-next-line no-console
    console.warn("Failed to inspect element style");
    return false;
  }
}

function visible(element) {
  var parentElement = element;
  var rootNode = element.getRootNode && element.getRootNode();
  while (parentElement) {
    if (parentElement === document.body) break;

    // if we are not hidden yet, skip to checking outside the Web Component
    if (rootNode && parentElement === rootNode) parentElement = rootNode.host.parentNode;

    if (hidesContents(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  var descendants = [].slice.call(element.querySelectorAll("*"), 0).reduce(function (finished, el) {
    return finished.concat(!el.shadowRoot ? [el] : findTabbableDescendants(el.shadowRoot));
  }, []);
  return descendants.filter(tabbable);
}
module.exports = exports["default"];
}(tabbable, tabbable.exports));

Object.defineProperty(focusManager, "__esModule", {
  value: true
});
focusManager.resetState = resetState$4;
focusManager.log = log$4;
focusManager.handleBlur = handleBlur;
focusManager.handleFocus = handleFocus;
focusManager.markForFocusLater = markForFocusLater;
focusManager.returnFocus = returnFocus;
focusManager.popWithoutFocus = popWithoutFocus;
focusManager.setupScopedFocus = setupScopedFocus;
focusManager.teardownScopedFocus = teardownScopedFocus;

var _tabbable = tabbable.exports;

var _tabbable2 = _interopRequireDefault$4(_tabbable);

function _interopRequireDefault$4(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState$4() {
  focusLaterElements = [];
}

/* istanbul ignore next */
function log$4() {
  if (process.env.NODE_ENV !== "production") {
    console.log("focusManager ----------");
    focusLaterElements.forEach(function (f) {
      var check = f || {};
      console.log(check.nodeName, check.className, check.id);
    });
    console.log("end focusManager ----------");
  }
}
/* eslint-enable no-console */

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus({ preventScroll: preventScroll });
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */

function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}

var scopeTab = {exports: {}};

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scopeTab;

var _tabbable = tabbable.exports;

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getActiveElement() {
  var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

  return el.activeElement.shadowRoot ? getActiveElement(el.activeElement.shadowRoot) : el.activeElement;
}

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);

  if (!tabbable.length) {
    // Do nothing, since there are no elements that can receive focus.
    event.preventDefault();
    return;
  }

  var target = void 0;

  var shiftKey = event.shiftKey;
  var head = tabbable[0];
  var tail = tabbable[tabbable.length - 1];
  var activeElement = getActiveElement();

  // proceed with default browser behavior on tab.
  // Focus on last element on shift + tab.
  if (node === activeElement) {
    if (!shiftKey) return;
    target = tail;
  }

  if (tail === activeElement && !shiftKey) {
    target = head;
  }

  if (head === activeElement && shiftKey) {
    target = tail;
  }

  if (target) {
    event.preventDefault();
    target.focus();
    return;
  }

  // Safari radio issue.
  //
  // Safari does not move the focus to the radio button,
  // so we need to force it to really walk through all elements.
  //
  // This is very error prone, since we are trying to guess
  // if it is a safari browser from the first occurence between
  // chrome or safari.
  //
  // The chrome user agent contains the first ocurrence
  // as the 'chrome/version' and later the 'safari/version'.
  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;

  // If we are not in safari desktop, let the browser control
  // the focus
  if (!isSafariDesktop) return;

  var x = tabbable.indexOf(activeElement);

  if (x > -1) {
    x += shiftKey ? -1 : 1;
  }

  target = tabbable[x];

  // If the tabbable element does not exist,
  // focus head/tail based on shiftKey
  if (typeof target === "undefined") {
    event.preventDefault();
    target = shiftKey ? tail : head;
    target.focus();
    return;
  }

  event.preventDefault();

  target.focus();
}
module.exports = exports["default"];
}(scopeTab, scopeTab.exports));

var ariaAppHider$1 = {};

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = process.env.NODE_ENV !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

var warning_1 = warning;

var safeHTMLElement = {};

var exenv = {exports: {}};

/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/

(function (module) {
/* global define */

(function () {

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());
}(exenv));

Object.defineProperty(safeHTMLElement, "__esModule", {
  value: true
});
safeHTMLElement.canUseDOM = safeHTMLElement.SafeNodeList = safeHTMLElement.SafeHTMLCollection = undefined;

var _exenv = exenv.exports;

var _exenv2 = _interopRequireDefault$3(_exenv);

function _interopRequireDefault$3(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

safeHTMLElement.SafeHTMLCollection = EE.canUseDOM ? window.HTMLCollection : {};

safeHTMLElement.SafeNodeList = EE.canUseDOM ? window.NodeList : {};

safeHTMLElement.canUseDOM = EE.canUseDOM;

safeHTMLElement.default = SafeHTMLElement;

Object.defineProperty(ariaAppHider$1, "__esModule", {
  value: true
});
ariaAppHider$1.resetState = resetState$3;
ariaAppHider$1.log = log$3;
ariaAppHider$1.assertNodeList = assertNodeList;
ariaAppHider$1.setElement = setElement;
ariaAppHider$1.validateElement = validateElement;
ariaAppHider$1.hide = hide;
ariaAppHider$1.show = show;
ariaAppHider$1.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;

var _warning = warning_1;

var _warning2 = _interopRequireDefault$2(_warning);

var _safeHTMLElement$1 = safeHTMLElement;

function _interopRequireDefault$2(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalElement = null;

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState$3() {
  if (globalElement) {
    if (globalElement.removeAttribute) {
      globalElement.removeAttribute("aria-hidden");
    } else if (globalElement.length != null) {
      globalElement.forEach(function (element) {
        return element.removeAttribute("aria-hidden");
      });
    } else {
      document.querySelectorAll(globalElement).forEach(function (element) {
        return element.removeAttribute("aria-hidden");
      });
    }
  }
  globalElement = null;
}

/* istanbul ignore next */
function log$3() {
  if (process.env.NODE_ENV !== "production") {
    var check = globalElement || {};
    console.log("ariaAppHider ----------");
    console.log(check.nodeName, check.className, check.id);
    console.log("end ariaAppHider ----------");
  }
}
/* eslint-enable no-console */

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string" && _safeHTMLElement$1.canUseDOM) {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function validateElement(appElement) {
  var el = appElement || globalElement;
  if (el) {
    return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [el];
  } else {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));

    return [];
  }
}

function hide(appElement) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var el = _step.value;

      el.setAttribute("aria-hidden", "true");
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

function show(appElement) {
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var el = _step2.value;

      el.removeAttribute("aria-hidden");
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

var classList = {};

Object.defineProperty(classList, "__esModule", {
  value: true
});
classList.resetState = resetState$2;
classList.log = log$2;
var htmlClassList = {};
var docBodyClassList = {};

/* eslint-disable no-console */
/* istanbul ignore next */
function removeClass(at, cls) {
  at.classList.remove(cls);
}

/* istanbul ignore next */
function resetState$2() {
  var htmlElement = document.getElementsByTagName("html")[0];
  for (var cls in htmlClassList) {
    removeClass(htmlElement, htmlClassList[cls]);
  }

  var body = document.body;
  for (var _cls in docBodyClassList) {
    removeClass(body, docBodyClassList[_cls]);
  }

  htmlClassList = {};
  docBodyClassList = {};
}

/* istanbul ignore next */
function log$2() {
  if (process.env.NODE_ENV !== "production") {
    var classes = document.getElementsByTagName("html")[0].className;
    var buffer = "Show tracked classes:\n\n";

    buffer += "<html /> (" + classes + "):\n  ";
    for (var x in htmlClassList) {
      buffer += "  " + x + " " + htmlClassList[x] + "\n  ";
    }

    classes = document.body.className;

    buffer += "\n\ndoc.body (" + classes + "):\n  ";
    for (var _x in docBodyClassList) {
      buffer += "  " + _x + " " + docBodyClassList[_x] + "\n  ";
    }

    buffer += "\n";

    console.log(buffer);
  }
}
/* eslint-enable no-console */

/**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var incrementReference = function incrementReference(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};

/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var decrementReference = function decrementReference(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};

/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */
var trackClass = function trackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};

/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */
var untrackClass = function untrackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};

/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
classList.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
classList.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

var portalOpenInstances$1 = {};

Object.defineProperty(portalOpenInstances$1, "__esModule", {
  value: true
});
portalOpenInstances$1.log = log$1;
portalOpenInstances$1.resetState = resetState$1;

function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Tracks portals that are open and emits events to subscribers

var PortalOpenInstances = function PortalOpenInstances() {
  var _this = this;

  _classCallCheck$1(this, PortalOpenInstances);

  this.register = function (openInstance) {
    if (_this.openInstances.indexOf(openInstance) !== -1) {
      if (process.env.NODE_ENV !== "production") {
        // eslint-disable-next-line no-console
        console.warn("React-Modal: Cannot register modal instance that's already open");
      }
      return;
    }
    _this.openInstances.push(openInstance);
    _this.emit("register");
  };

  this.deregister = function (openInstance) {
    var index = _this.openInstances.indexOf(openInstance);
    if (index === -1) {
      if (process.env.NODE_ENV !== "production") {
        // eslint-disable-next-line no-console
        console.warn("React-Modal: Unable to deregister " + openInstance + " as " + "it was never registered");
      }
      return;
    }
    _this.openInstances.splice(index, 1);
    _this.emit("deregister");
  };

  this.subscribe = function (callback) {
    _this.subscribers.push(callback);
  };

  this.emit = function (eventType) {
    _this.subscribers.forEach(function (subscriber) {
      return subscriber(eventType,
      // shallow copy to avoid accidental mutation
      _this.openInstances.slice());
    });
  };

  this.openInstances = [];
  this.subscribers = [];
};

var portalOpenInstances = new PortalOpenInstances();

/* eslint-disable no-console */
/* istanbul ignore next */
function log$1() {
  console.log("portalOpenInstances ----------");
  console.log(portalOpenInstances.openInstances.length);
  portalOpenInstances.openInstances.forEach(function (p) {
    return console.log(p);
  });
  console.log("end portalOpenInstances ----------");
}

/* istanbul ignore next */
function resetState$1() {
  portalOpenInstances = new PortalOpenInstances();
}
/* eslint-enable no-console */

portalOpenInstances$1.default = portalOpenInstances;

var bodyTrap$1 = {};

Object.defineProperty(bodyTrap$1, "__esModule", {
  value: true
});
bodyTrap$1.resetState = resetState;
bodyTrap$1.log = log;

var _portalOpenInstances = portalOpenInstances$1;

var _portalOpenInstances2 = _interopRequireDefault$1(_portalOpenInstances);

function _interopRequireDefault$1(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Body focus trap see Issue #742

var before = void 0,
    after = void 0,
    instances = [];

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState() {
  var _arr = [before, after];

  for (var _i = 0; _i < _arr.length; _i++) {
    var item = _arr[_i];
    if (!item) continue;
    item.parentNode && item.parentNode.removeChild(item);
  }
  before = after = null;
  instances = [];
}

/* istanbul ignore next */
function log() {
  console.log("bodyTrap ----------");
  console.log(instances.length);
  var _arr2 = [before, after];
  for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
    var item = _arr2[_i2];
    var check = item || {};
    console.log(check.nodeName, check.className, check.id);
  }
  console.log("edn bodyTrap ----------");
}
/* eslint-enable no-console */

function focusContent() {
  if (instances.length === 0) {
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.warn("React-Modal: Open instances > 0 expected");
    }
    return;
  }
  instances[instances.length - 1].focusContent();
}

function bodyTrap(eventType, openInstances) {
  if (!before && !after) {
    before = document.createElement("div");
    before.setAttribute("data-react-modal-body-trap", "");
    before.style.position = "absolute";
    before.style.opacity = "0";
    before.setAttribute("tabindex", "0");
    before.addEventListener("focus", focusContent);
    after = before.cloneNode();
    after.addEventListener("focus", focusContent);
  }

  instances = openInstances;

  if (instances.length > 0) {
    // Add focus trap
    if (document.body.firstChild !== before) {
      document.body.insertBefore(before, document.body.firstChild);
    }
    if (document.body.lastChild !== after) {
      document.body.appendChild(after);
    }
  } else {
    // Remove focus trap
    if (before.parentElement) {
      before.parentElement.removeChild(before);
    }
    if (after.parentElement) {
      after.parentElement.removeChild(after);
    }
  }
}

_portalOpenInstances2.default.subscribe(bodyTrap);

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = React__default;

var _propTypes = require$$1;

var _propTypes2 = _interopRequireDefault(_propTypes);

var _focusManager = focusManager;

var focusManager$1 = _interopRequireWildcard(_focusManager);

var _scopeTab = scopeTab.exports;

var _scopeTab2 = _interopRequireDefault(_scopeTab);

var _ariaAppHider = ariaAppHider$1;

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _classList = classList;

var classList$1 = _interopRequireWildcard(_classList);

var _safeHTMLElement = safeHTMLElement;

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _portalOpenInstances = portalOpenInstances$1;

var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);



function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: "ReactModal__Overlay",
  content: "ReactModal__Content"
};

/**
 * We need to support the deprecated `KeyboardEvent.keyCode` in addition to
 * `KeyboardEvent.code` for apps that still support IE11. Can be removed when
 * `react-modal` only supports React >18 (which dropped IE support).
 */
var isTabKey = function isTabKey(event) {
  return event.code === "Tab" || event.keyCode === 9;
};
var isEscKey = function isEscKey(event) {
  return event.code === "Escape" || event.keyCode === 27;
};

var ariaHiddenInstances = 0;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
      _this.props.overlayRef && _this.props.overlayRef(overlay);
    };

    _this.setContentRef = function (content) {
      _this.content = content;
      _this.props.contentRef && _this.props.contentRef(content);
    };

    _this.afterClose = function () {
      var _this$props = _this.props,
          appElement = _this$props.appElement,
          ariaHideApp = _this$props.ariaHideApp,
          htmlOpenClassName = _this$props.htmlOpenClassName,
          bodyOpenClassName = _this$props.bodyOpenClassName,
          parentSelector = _this$props.parentSelector;


      var parentDocument = parentSelector && parentSelector().ownerDocument || document;

      // Remove classes.
      bodyOpenClassName && classList$1.remove(parentDocument.body, bodyOpenClassName);

      htmlOpenClassName && classList$1.remove(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);

      // Reset aria-hidden attribute if all modals have been removed
      if (ariaHideApp && ariaHiddenInstances > 0) {
        ariaHiddenInstances -= 1;

        if (ariaHiddenInstances === 0) {
          ariaAppHider.show(appElement);
        }
      }

      if (_this.props.shouldFocusAfterRender) {
        if (_this.props.shouldReturnFocusAfterClose) {
          focusManager$1.returnFocus(_this.props.preventScroll);
          focusManager$1.teardownScopedFocus();
        } else {
          focusManager$1.popWithoutFocus();
        }
      }

      if (_this.props.onAfterClose) {
        _this.props.onAfterClose();
      }

      _portalOpenInstances2.default.deregister(_this);
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        if (_this.props.shouldFocusAfterRender) {
          focusManager$1.setupScopedFocus(_this.node);
          focusManager$1.markForFocusLater();
        }

        _this.setState({ isOpen: true }, function () {
          _this.openAnimationFrame = requestAnimationFrame(function () {
            _this.setState({ afterOpen: true });

            if (_this.props.isOpen && _this.props.onAfterOpen) {
              _this.props.onAfterOpen({
                overlayEl: _this.overlay,
                contentEl: _this.content
              });
            }
          });
        });
      }
    };

    _this.close = function () {
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus({ preventScroll: true });
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (isTabKey(event)) {
        (0, _scopeTab2.default)(_this.content, event);
      }

      if (_this.props.shouldCloseOnEsc && isEscKey(event)) {
        event.stopPropagation();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function (event) {
      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
        event.preventDefault();
      }
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + "--after-open",
        beforeClose: CLASS_NAMES[which] + "--before-close"
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + " " + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + " " + classNames.beforeClose;
      }
      return typeof additional === "string" && additional ? className + " " + additional : className;
    };

    _this.attributesFromObject = function (prefix, items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc[prefix + "-" + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.open();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (process.env.NODE_ENV !== "production") {
        if (prevProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
        if (prevProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "htmlOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
      }

      if (this.props.isOpen && !prevProps.isOpen) {
        this.open();
      } else if (!this.props.isOpen && prevProps.isOpen) {
        this.close();
      }

      // Focus only needs to be set once when the modal is being opened
      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
        this.focusContent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.isOpen) {
        this.afterClose();
      }
      clearTimeout(this.closeTimer);
      cancelAnimationFrame(this.openAnimationFrame);
    }
  }, {
    key: "beforeOpen",
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          htmlOpenClassName = _props.htmlOpenClassName,
          bodyOpenClassName = _props.bodyOpenClassName,
          parentSelector = _props.parentSelector;


      var parentDocument = parentSelector && parentSelector().ownerDocument || document;

      // Add classes.
      bodyOpenClassName && classList$1.add(parentDocument.body, bodyOpenClassName);

      htmlOpenClassName && classList$1.add(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);

      if (ariaHideApp) {
        ariaHiddenInstances += 1;
        ariaAppHider.hide(appElement);
      }

      _portalOpenInstances2.default.register(this);
    }

    // Don't steal focus from inner elements

  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          id = _props2.id,
          className = _props2.className,
          overlayClassName = _props2.overlayClassName,
          defaultStyles = _props2.defaultStyles,
          children = _props2.children;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      if (this.shouldBeClosed()) {
        return null;
      }

      var overlayProps = {
        ref: this.setOverlayRef,
        className: this.buildClassName("overlay", overlayClassName),
        style: _extends({}, overlayStyles, this.props.style.overlay),
        onClick: this.handleOverlayOnClick,
        onMouseDown: this.handleOverlayOnMouseDown
      };

      var contentProps = _extends({
        id: id,
        ref: this.setContentRef,
        style: _extends({}, contentStyles, this.props.style.content),
        className: this.buildClassName("content", className),
        tabIndex: "-1",
        onKeyDown: this.handleKeyDown,
        onMouseDown: this.handleContentOnMouseDown,
        onMouseUp: this.handleContentOnMouseUp,
        onClick: this.handleContentOnClick,
        role: this.props.role,
        "aria-label": this.props.contentLabel
      }, this.attributesFromObject("aria", _extends({ modal: true }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
        "data-testid": this.props.testId
      });

      var contentElement = this.props.contentElement(contentProps, children);
      return this.props.overlayElement(overlayProps, contentElement);
    }
  }]);

  return ModalPortal;
}(_react.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  },
  defaultStyles: {}
};
ModalPortal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  defaultStyles: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  parentSelector: _propTypes2.default.func,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  ariaHideApp: _propTypes2.default.bool,
  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
  onAfterOpen: _propTypes2.default.func,
  onAfterClose: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  children: _propTypes2.default.node,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func,
  testId: _propTypes2.default.string
};
exports.default = ModalPortal;
module.exports = exports["default"];
}(ModalPortal, ModalPortal.exports));

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}

var reactLifecyclesCompat_es = /*#__PURE__*/Object.freeze({
    __proto__: null,
    polyfill: polyfill
});

var require$$6 = /*@__PURE__*/getAugmentedNamespace(reactLifecyclesCompat_es);

Object.defineProperty(Modal$2, "__esModule", {
  value: true
});
Modal$2.bodyOpenClassName = Modal$2.portalClassName = undefined;

var _extends$b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = React__default;

var _react2 = _interopRequireDefault(_react);

var _reactDom = require$$1$1;

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = require$$1;

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalPortal = ModalPortal.exports;

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

var _ariaAppHider = ariaAppHider$1;

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _safeHTMLElement = safeHTMLElement;

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _reactLifecyclesCompat = require$$6;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = Modal$2.portalClassName = "ReactModalPortal";
var bodyOpenClassName = Modal$2.bodyOpenClassName = "ReactModal__Body--open";

var isReact16 = _safeHTMLElement.canUseDOM && _reactDom2.default.createPortal !== undefined;

var createHTMLElement = function createHTMLElement(name) {
  return document.createElement(name);
};

var getCreatePortal = function getCreatePortal() {
  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
};

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal$1 = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      if (parent && parent.contains(_this.node)) {
        parent.removeChild(_this.node);
      } else {
        // eslint-disable-next-line no-console
        console.warn('React-Modal: "parentSelector" prop did not returned any DOM ' + "element. Make sure that the parent element is unmounted to " + "avoid any memory leaks.");
      }
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var createPortal = getCreatePortal();
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends$b({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = createHTMLElement("div");
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var prevParent = getParentElement(prevProps.parentSelector);
      var nextParent = getParentElement(this.props.parentSelector);
      return { prevParent: prevParent, nextParent: nextParent };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _, snapshot) {
      if (!_safeHTMLElement.canUseDOM) return;
      var _props = this.props,
          isOpen = _props.isOpen,
          portalClassName = _props.portalClassName;


      if (prevProps.portalClassName !== portalClassName) {
        this.node.className = portalClassName;
      }

      var prevParent = snapshot.prevParent,
          nextParent = snapshot.nextParent;

      if (nextParent !== prevParent) {
        prevParent.removeChild(this.node);
        nextParent.appendChild(this.node);
      }

      // Stop unnecessary renders if modal is remaining closed
      if (!prevProps.isOpen && !isOpen) return;

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!_safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = createHTMLElement("div");
      }

      var createPortal = getCreatePortal();
      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends$b({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(_react.Component);

Modal$1.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func
};
Modal$1.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  role: "dialog",
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  preventScroll: false,
  parentSelector: function parentSelector() {
    return document.body;
  },
  overlayElement: function overlayElement(props, contentEl) {
    return _react2.default.createElement(
      "div",
      props,
      contentEl
    );
  },
  contentElement: function contentElement(props, children) {
    return _react2.default.createElement(
      "div",
      props,
      children
    );
  }
};
Modal$1.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};


(0, _reactLifecyclesCompat.polyfill)(Modal$1);

if (process.env.NODE_ENV !== "production") {
  Modal$1.setCreateHTMLElement = function (fn) {
    return createHTMLElement = fn;
  };
}

Modal$2.default = Modal$1;

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Modal = Modal$2;

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Modal2.default;
module.exports = exports["default"];
}(lib, lib.exports));

var Modal = /*@__PURE__*/getDefaultExportFromCjs(lib.exports);

var SharedModal = function (props) {
    var _a;
    var customStyles = props.customStyles, heading = props.heading, iconCloseSrc = props.iconCloseSrc, iconCloseAlt = props.iconCloseAlt, modalIsOpen = props.modalIsOpen, closeAriaLabel = props.closeAriaLabel, appElement = props.appElement, testId = props.testId, ariaDescribedBy = props.ariaDescribedBy, isDefaultModal = props.isDefaultModal, shouldCloseOnEsc = props.shouldCloseOnEsc, shouldCloseOnOverlayClick = props.shouldCloseOnOverlayClick, onClose = props.onClose, onAfterOpen = props.onAfterOpen, onAfterClose = props.onAfterClose, contentRef = props.contentRef, overlayRef = props.overlayRef, children = props.children, closeButtonDataTestID = props.closeButtonDataTestID, headingDataTestID = props.headingDataTestID, overlayClassName = props.overlayClassName, bodyClassName = props.bodyClassName, bodyHeadingClassName = props.bodyHeadingClassName, bodyContentClassName = props.bodyContentClassName, closeIconClassName = props.closeIconClassName, modalAriaLabelledBy = props.modalAriaLabelledBy;
    var isBrowser = function () { return typeof window !== "undefined"; };
    var defaultAppElement = (_a = document.getElementById("__next")) !== null && _a !== void 0 ? _a : document.getElementById("root");
    return (jsxRuntime.exports.jsx(Modal, __assign({ id: props.id, isOpen: modalIsOpen, style: customStyles, appElement: appElement ||
            (isBrowser() ? defaultAppElement : appElement), aria: {
            labelledby: modalAriaLabelledBy !== null && modalAriaLabelledBy !== void 0 ? modalAriaLabelledBy : "heading",
            describedby: ariaDescribedBy,
        }, testId: testId, onRequestClose: onClose, onAfterOpen: onAfterOpen, onAfterClose: onAfterClose, contentRef: contentRef, overlayRef: overlayRef, shouldCloseOnEsc: shouldCloseOnEsc !== null && shouldCloseOnEsc !== void 0 ? shouldCloseOnEsc : true, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick !== null && shouldCloseOnOverlayClick !== void 0 ? shouldCloseOnOverlayClick : true, overlayClassName: overlayClassName, bodyOpenClassName: bodyClassName }, { children: jsxRuntime.exports.jsxs(ContentContainer$3, { children: [(closeAriaLabel || heading) && (jsxRuntime.exports.jsxs(HeadingWrapper$3, __assign({ className: bodyHeadingClassName !== null && bodyHeadingClassName !== void 0 ? bodyHeadingClassName : 'shared-modal-header-container' }, { children: [heading && jsxRuntime.exports.jsx(Heading, __assign({ id: "heading".concat(props.id ? "-".concat(props.id) : ""), "$isDefault": isDefaultModal, "data-testid": headingDataTestID }, { children: heading })), closeAriaLabel && jsxRuntime.exports.jsx(CloseButton$4, __assign({ onClick: onClose, "aria-label": closeAriaLabel, "data-testid": closeButtonDataTestID, className: closeIconClassName !== null && closeIconClassName !== void 0 ? closeIconClassName : 'shared-modal-close-btn' }, { children: iconCloseSrc ? (jsxRuntime.exports.jsx(CloseIcon$1, { src: iconCloseSrc, alt: iconCloseAlt, "aria-hidden": 'true' })) : (jsxRuntime.exports.jsx(DefaultCloseModalIcon$1, { "aria-hidden": 'true' })) }))] }))), jsxRuntime.exports.jsx(ContentWrapper$4, __assign({ id: ariaDescribedBy, className: bodyContentClassName !== null && bodyContentClassName !== void 0 ? bodyContentClassName : 'shared-modal-content-container' }, { children: children }))] }) })));
};

var FilterBy = styled.div(templateObject_1$r || (templateObject_1$r = __makeTemplateObject(["\n    margin-top: var(--spacing_token_l);\n    margin-bottom: var(--spacing_token_l);\n    width: 100%;\n"], ["\n    margin-top: var(--spacing_token_l);\n    margin-bottom: var(--spacing_token_l);\n    width: 100%;\n"])));
var HorizontalDividerLight$3 = styled.div(templateObject_2$n || (templateObject_2$n = __makeTemplateObject(["\n  width: 100%;\n  height: 1px;\n  background-color: var(--silver);\n"], ["\n  width: 100%;\n  height: 1px;\n  background-color: var(--silver);\n"])));
var Content$5 = styled.div(templateObject_3$j || (templateObject_3$j = __makeTemplateObject(["\n  margin-bottom: var(--spacing_token_l);\n  width: 100%;\n"], ["\n  margin-bottom: var(--spacing_token_l);\n  width: 100%;\n"])));
var templateObject_1$r, templateObject_2$n, templateObject_3$j;

var AccordionItem = function (props) {
    return (jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [jsxRuntime.exports.jsx(FilterBy, { children: jsxRuntime.exports.jsx(ExpandableButton, { title: props.title, titleColor: props.titleColor, iconSrc: props.iconSrc, className: props.className, isExpanded: props.isExpanded, onClick: props.onClick, ariaLabel: props.ariaLabel, testId: props.buttonTestId }) }), props.isExpanded &&
                jsxRuntime.exports.jsx(Content$5, { children: props.children }), jsxRuntime.exports.jsx(HorizontalDividerLight$3, {})] }));
};

var HeightMap = new Map([
    ['small', '48px'],
    ['medium', '56px'],
    ['large', '60px'],
]);
var BackgroundColorMap = new Map([
    ['primary-blue', 'var(--tory-blue)'],
    ['primary-red', 'var(--crimson)'],
    ['primary-green', 'var(--la-palma)'],
    ['secondary-blue', 'var(--white)'],
    ['primary-white', 'var(--white)'],
    ['secondary-white', 'var(--tory-blue)'],
    ['transparent-blue', 'transparent'],
]);
var ColorMap$1 = new Map([
    ['primary-blue', 'var(--white)'],
    ['primary-red', 'var(--white)'],
    ['primary-green', 'var(--white)'],
    ['secondary-blue', 'var(--tory-blue)'],
    ['primary-white', 'var(--tory-blue)'],
    ['secondary-white', 'var(--white)'],
    ['transparent-blue', 'var(--tory-blue)'],
]);
var HoverBackgroundColorMap = new Map([
    ['primary-blue', 'var(--congress-blue)'],
    ['primary-red', 'var(--monza)'],
    ['primary-green', 'var(--bilbao)'],
    ['secondary-blue', 'var(--congress-blue)'],
]);
var HoverColorMap = new Map([
    ['primary-blue', 'var(--white)'],
    ['primary-red', 'var(--white)'],
    ['primary-green', 'var(--white)'],
    ['secondary-blue', 'var(--white)'],
    ['transparent-blue', 'var(--congress-blue)']
]);
var PressedBackgroundColorMap = new Map([
    ['primary-blue', 'var(--regal-blue)'],
    ['primary-red', 'var(--carmine)'],
    ['primary-green', 'var(--green-house)'],
    ['secondary-blue', 'var(--regal-blue)'],
    ['primary-white', 'var(--tory-blue)'],
    ['secondary-white', 'var(--white)'],
]);
var PressedColorMap = new Map([
    ['primary-blue', 'var(--white)'],
    ['primary-red', 'var(--white)'],
    ['primary-green', 'var(--white)'],
    ['secondary-blue', 'var(--white)'],
    ['primary-white', 'var(--white)'],
    ['secondary-white', 'var(--tory-blue)'],
]);
var BorderMap$1 = new Map([
    ['primary-blue', '1px solid transparent;'],
    ['primary-red', '1px solid transparent;'],
    ['primary-green', '1px solid transparent;'],
    ['secondary-blue', '1px solid var(--tory-blue)'],
    ['primary-white', '1px solid var(--tory-blue)'],
    ['transparent-blue', 'transparent'],
]);
var FocusBackgroundColorMap = new Map([
    ['primary-blue', 'var(--tory-blue)'],
    ['primary-red', 'var(--crimson)'],
    ['primary-green', 'var( --la-palma)'],
    ['secondary-blue', 'var(--white)'],
]);
var FocusColorMap = new Map([
    ['primary-blue', 'var(--white)'],
    ['primary-red', 'var(--white)'],
    ['primary-green', 'var(--white)'],
    ['secondary-blue', 'var(--tory-blue)'],
]);
var sharedCss = css(templateObject_3$i || (templateObject_3$i = __makeTemplateObject(["\n  width: 100%;\n  display: inline-block;\n  ", "\n  font-size: 18px;\n  line-height: 22px;\n  text-align: center;\n  padding: 0;\n  text-decoration: none;\n  white-space:", " ;\n  vertical-align: middle;\n  user-select: none;\n  -webkit-appearance: none;\n  font-weight: 900;\n  border: ", ";\n  border-radius: var(--border-radius-s);\n  height: ", ";\n  color: ", ";\n  background-color: ", ";\n  cursor:  ", ";\n\n  ", "\n  \n  &:focus {      \n    background-color: ", ";\n    color: ", ";\n  }\n  \n  &:hover {\n    background-color: ", ";\n    color: ", ";\n  }\n\n  &:active {\n    background-color: ", ";\n    color: ", ";\n  }\n\n  ", "  \n"], ["\n  width: 100%;\n  display: inline-block;\n  ", "\n  font-size: 18px;\n  line-height: 22px;\n  text-align: center;\n  padding: 0;\n  text-decoration: none;\n  white-space:", " ;\n  vertical-align: middle;\n  user-select: none;\n  -webkit-appearance: none;\n  font-weight: 900;\n  border: ", ";\n  border-radius: var(--border-radius-s);\n  height: ", ";\n  color: ", ";\n  background-color: ", ";\n  cursor:  ", ";\n\n  ", "\n  \n  &:focus {      \n    background-color: ", ";\n    color: ", ";\n  }\n  \n  &:hover {\n    background-color: ", ";\n    color: ", ";\n  }\n\n  &:active {\n    background-color: ", ";\n    color: ", ";\n  }\n\n  ", "  \n"])), TempostdHeavycondensedNormalToryBlu, function (props) { return props.wrapContent ? 'none' : 'nowrap'; }, function (props) { return BorderMap$1.get(props.buttonType); }, function (props) { return HeightMap.get(props.size); }, function (props) { return props.isPressed ? PressedColorMap.get(props.buttonType) || 'primary-blue' : ColorMap$1.get(props.buttonType); }, function (props) { return props.isPressed ? PressedBackgroundColorMap.get(props.buttonType) || 'primary-blue' : BackgroundColorMap.get(props.buttonType); }, function (props) { return props.disabled ? 'not-allowed' : 'pointer'; }, function (props) {
    return props.isBlock && css(templateObject_1$q || (templateObject_1$q = __makeTemplateObject(["\n      display: block;\n      &:not(:first-child) {\n        margin-top: 8px;\n      }\n    "], ["\n      display: block;\n      &:not(:first-child) {\n        margin-top: 8px;\n      }\n    "])));
}, function (props) { return !props.disabled && FocusBackgroundColorMap.get(props.buttonType); }, function (props) { return !props.disabled && FocusColorMap.get(props.buttonType); }, function (props) { return !props.disabled && HoverBackgroundColorMap.get(props.buttonType); }, function (props) { return !props.disabled && HoverColorMap.get(props.buttonType); }, function (props) { return !props.disabled && PressedBackgroundColorMap.get(props.buttonType); }, function (props) { return !props.disabled && PressedColorMap.get(props.buttonType); }, function (props) {
    return props.disabled && css(templateObject_2$m || (templateObject_2$m = __makeTemplateObject(["\n      color: var(--tundora); \n      background-color: var(--cararra);\n      border: none;\n    "], ["\n      color: var(--tundora); \n      background-color: var(--cararra);\n      border: none;\n    "])));
});
var Button$1 = styled.button(templateObject_4$i || (templateObject_4$i = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), sharedCss);
var Anchor = styled.a(templateObject_6$b || (templateObject_6$b = __makeTemplateObject(["\n  ", "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  ", "\n"], ["\n  ", "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  ", "\n"])), sharedCss, function (props) {
    return props.isBlock && css(templateObject_5$d || (templateObject_5$d = __makeTemplateObject(["\n      display: flex;\n      &:not(:first-child) {\n        margin-top: 8px;\n      }\n    "], ["\n      display: flex;\n      &:not(:first-child) {\n        margin-top: 8px;\n      }\n    "])));
});
var templateObject_1$q, templateObject_2$m, templateObject_3$i, templateObject_4$i, templateObject_5$d, templateObject_6$b;

var Button = function (props) {
    if (props.isAnchorButton) {
        return (jsxRuntime.exports.jsx(Anchor, __assign({ href: props.href, "data-testid": props.testId, "aria-label": props.ariaLabel }, props, { children: props.children })));
    }
    return (jsxRuntime.exports.jsx(Button$1, __assign({ "data-testid": props.testId, onClick: props.clickHandler, onKeyUp: props.keyUpHandler, "aria-label": props.ariaLabel, ref: props.elRef }, props, { children: props.children })));
};

var _path$a;
function _extends$a() { _extends$a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }
var SvgCaretDown = function SvgCaretDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a({
    width: 14,
    height: 8,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$a || (_path$a = /*#__PURE__*/React.createElement("path", {
    d: "M.938 0h12.06c.835 0 1.252 1.008.662 1.598L7.63 7.631a.94.94 0 0 1-1.326 0L.277 1.598C-.313 1.008.103 0 .937 0Z",
    fill: "#fff"
  })));
};

var ChevronsCarets$1 = styled(SvgCaretDown)(templateObject_1$p || (templateObject_1$p = __makeTemplateObject(["\n  width: 14px;\n  margin-left: var(--spacing_token_xxs);\n"], ["\n  width: 14px;\n  margin-left: var(--spacing_token_xxs);\n"])));
var ButtonChevron$1 = styled(Button$1)(templateObject_4$h || (templateObject_4$h = __makeTemplateObject(["\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  border: 1px solid var(--tory-blue);\n  align-items: center;\n  padding: 12px var(--spacing_token_s);\n\n  & svg {\n    margin-left: 9px;\n    transform: ", ";\n  }\n  \n  & svg path { \n    fill: ", ";\n  }  \n\n  &:focus svg path {\n    fill: ", ";\n  }  \n\n  &:hover svg path {\n    fill: ", ";\n  }\n\n  &:active svg path {\n    fill: ", ";\n  }\n\n  ", "\n\n  ", "\n"], ["\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  border: 1px solid var(--tory-blue);\n  align-items: center;\n  padding: 12px var(--spacing_token_s);\n\n  & svg {\n    margin-left: 9px;\n    transform: ", ";\n  }\n  \n  & svg path { \n    fill: ", ";\n  }  \n\n  &:focus svg path {\n    fill: ", ";\n  }  \n\n  &:hover svg path {\n    fill: ", ";\n  }\n\n  &:active svg path {\n    fill: ", ";\n  }\n\n  ", "\n\n  ", "\n"])), function (props) {
    var styles;
    switch (props.direction) {
        case "up":
            styles = "rotate(180deg)";
            break;
        case "right":
            styles = "rotate(270deg)";
            break;
        case "left":
            styles = "rotate(90deg)";
            break;
        case "down":
        default:
            styles = "rotate(0deg)";
    }
    return styles;
}, function (props) { return ColorMap$1.get(props.buttonType); }, function (props) { return FocusColorMap.get(props.buttonType); }, function (props) { return HoverColorMap.get(props.buttonType); }, function (props) { return PressedColorMap.get(props.buttonType); }, function (props) {
    return !props.disabled &&
        props.isPressed &&
        css(templateObject_2$l || (templateObject_2$l = __makeTemplateObject(["\n  & svg path {   \n    fill:"], ["\n  & svg path {   \n    fill:"]))) +
            (PressedColorMap.get(props.buttonType) || "primary-blue") +
            ";\n  ";
}, function (props) {
    return props.disabled && css(templateObject_3$h || (templateObject_3$h = __makeTemplateObject(["\n      & svg path {\n        stroke: var(--tundora);\n        fill: var(--tundora);\n      }\n    "], ["\n      & svg path {\n        stroke: var(--tundora);\n        fill: var(--tundora);\n      }\n    "])));
});
var templateObject_1$p, templateObject_2$l, templateObject_3$h, templateObject_4$h;

function HeavyChevron(props) {
    return jsxRuntime.exports.jsx(ChevronsCarets$1, { "aria-hidden": 'true' });
}
var ButtonChevron = function (props) {
    return (jsxRuntime.exports.jsx(ButtonChevron$1, __assign({}, props, { ref: props.elRef, onClick: props.clickHandler, "aria-label": props.ariaLabel, "aria-expanded": props.ariaExpanded, "aria-controls": props.ariaControls, "data-testid": props.testId }, { children: jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [props.children, jsxRuntime.exports.jsx(HeavyChevron, { color: ColorMap$1.get(props.buttonType), direction: props.direction })] }) })));
};

var ChevronsCarets = styled(SvgChevronCaretsDown)(templateObject_1$o || (templateObject_1$o = __makeTemplateObject(["\n  width: 16px;\n  height: 16px;\n"], ["\n  width: 16px;\n  height: 16px;\n"])));
var LinkToggle$1 = styled.button(templateObject_2$k || (templateObject_2$k = __makeTemplateObject(["\n  color: var(--tory-blue);\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 18px;\n  text-decoration: none;\n  width: fit-content;\n  background: none;\n  border: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n\n  ", " {\n    font-size: 16px;\n    line-height: 20px;\n  }\n"], ["\n  color: var(--tory-blue);\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 18px;\n  text-decoration: none;\n  width: fit-content;\n  background: none;\n  border: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n\n  ", " {\n    font-size: 16px;\n    line-height: 20px;\n  }\n"])), up("md"));
var Text$2 = styled.span(templateObject_3$g || (templateObject_3$g = __makeTemplateObject([""], [""])));
var Icon$1 = styled.span(templateObject_4$g || (templateObject_4$g = __makeTemplateObject(["\n  vertical-align: text-top;\n  margin-left: ", ";\n  display: flex;\n"], ["\n  vertical-align: text-top;\n  margin-left: ", ";\n  display: flex;\n"])), function (props) { var _a; return (_a = props.iconMargin) !== null && _a !== void 0 ? _a : '8px'; });
var templateObject_1$o, templateObject_2$k, templateObject_3$g, templateObject_4$g;

function mapDirectionToRotation(direction) {
    switch (direction) {
        case 'up':
            return 'rotate(180deg)';
        case 'down':
        default:
            return 'rotate(0deg)';
    }
}
var LinkToggle = function (props) {
    function Arrow(props) {
        var styles = {
            transform: mapDirectionToRotation(props.direction),
        };
        return jsxRuntime.exports.jsx(ChevronsCarets, { style: styles });
    }
    return (jsxRuntime.exports.jsxs(LinkToggle$1, __assign({ "data-testid": props.testId }, props, { "aria-expanded": props.ariaExpanded, "aria-controls": props.ariaControls, "aria-label": props.ariaLabel }, { children: [jsxRuntime.exports.jsx(Text$2, { children: props.children }), jsxRuntime.exports.jsx(Icon$1, __assign({ iconMargin: props.iconMargin }, { children: jsxRuntime.exports.jsx(Arrow, { direction: props.direction }) }))] })));
};

var ReadMoreWrapper = styled.div(templateObject_1$n || (templateObject_1$n = __makeTemplateObject([""], [""])));
var ContentWrapper$3 = styled.div(templateObject_2$j || (templateObject_2$j = __makeTemplateObject(["\n  margin-bottom: ", ";\n\n  p {\n    margin: 8px 0px;\n  }\n\n  sup {\n    vertical-align: super;\n  }\n"], ["\n  margin-bottom: ", ";\n\n  p {\n    margin: 8px 0px;\n  }\n\n  sup {\n    vertical-align: super;\n  }\n"])), function (props) { var _a; return (_a = props.contentMarginBottom) !== null && _a !== void 0 ? _a : '8px'; });
var templateObject_1$n, templateObject_2$j;

var HTML_TAG_BEGINNING = '<';
var HTML_TAG_CLOSING = '>';
var HTML_SYMBOL_BEGINNING = '&';
var HTML_SYMBOL_ENDING = ';';
function isAValidSymbolChar(char) {
    return /^[A-Za-z0-9#]*$/i.test(char);
}
function isLetterOrNumber(char) {
    return /^[A-Za-z0-9]*$/i.test(char);
}
function isEscapeSequence(char) {
    if (char === '\t' ||
        char === '\n' ||
        char === '\n' ||
        char === '\r' ||
        char === '\rn' ||
        char === '\v')
        return true;
    return false;
}
function isSelfClosingTag(tagName) {
    switch (tagName) {
        case 'area':
        case 'base ':
        case 'br ':
        case 'col ':
        case 'embed ':
        case 'hr ':
        case 'img ':
        case 'input ':
        case 'link ':
        case 'meta ':
        case 'param ':
        case 'source ':
        case 'track ':
        case 'wbr ':
            return true;
        default:
            return false;
    }
}
var ReadMore = function (props) {
    var _a, _b, _c;
    var _d = __read(useState(props.isExpanded ? true : false), 2), isExpanded = _d[0], setIsExpanded = _d[1];
    var showLinkToggle = true;
    function clickHandler(event) {
        event.preventDefault();
        setIsExpanded(!isExpanded);
    }
    function processRawHTML(htmlString) {
        var characterLimit = !isExpanded ? props.characterLimit : Number.MAX_SAFE_INTEGER;
        var chars = __spreadArray([], __read(htmlString.toString().trim()), false);
        var markupsStack = [];
        var result = '';
        var remainingCharacters = characterLimit;
        var charCount = 0;
        for (var i = 0; i < chars.length; i++) {
            if (remainingCharacters <= 0) {
                if (!isLetterOrNumber(result[result.length - 1])) {
                    if (result.length <= chars.length)
                        result = isExpanded ? result : result + '...';
                    break;
                }
                while (isLetterOrNumber(chars[i])) {
                    result += chars[i];
                    i++;
                    charCount++;
                }
                if (props.trimEndCharacter) {
                    result += props.trimEndCharacter;
                }
                if (result.length <= chars.length)
                    result = isExpanded ? result : result + '...';
                break;
            }
            if (chars[i] === HTML_TAG_BEGINNING) {
                var markup = '';
                var tagNameBegins = false;
                var tagNameEnds = false;
                var tagName = '';
                do {
                    if (!tagNameBegins && isLetterOrNumber(chars[i]))
                        tagNameBegins = true;
                    if (tagNameBegins && !tagNameEnds && !isLetterOrNumber(chars[i]))
                        tagNameEnds = true;
                    if (tagNameBegins && !tagNameEnds)
                        tagName += chars[i];
                    markup += chars[i];
                    i++;
                } while (chars[i] !== HTML_TAG_CLOSING && i < chars.length);
                var isClosingTag = markup.replace(' ', '').slice(0, 2) === '</';
                if (isClosingTag && markupsStack.indexOf(tagName) !== -1) {
                    while (markupsStack.length > 0) {
                        if (markupsStack[markupsStack.length - 1] === tagName) {
                            result += '</' + markupsStack.pop() + HTML_TAG_CLOSING;
                            break;
                        }
                        else {
                            result += '</' + markupsStack.pop() + HTML_TAG_CLOSING;
                        }
                    }
                }
                else if (!isSelfClosingTag(tagName)) {
                    result += markup + HTML_TAG_CLOSING;
                    markupsStack.push(tagName);
                }
            }
            else if (chars[i] === HTML_SYMBOL_BEGINNING) {
                var symbol = '';
                do {
                    symbol += chars[i];
                    result += chars[i];
                    i++;
                } while (chars[i] !== HTML_SYMBOL_ENDING &&
                    isAValidSymbolChar(chars[i]) &&
                    i < chars.length);
                if (chars[i] !== HTML_SYMBOL_ENDING) {
                    remainingCharacters -= symbol.length;
                    charCount++;
                }
                else {
                    result += HTML_SYMBOL_ENDING;
                    remainingCharacters--;
                    charCount++;
                }
            }
            else {
                result += chars[i];
                if (!isEscapeSequence(chars[i])) {
                    remainingCharacters--;
                    charCount++;
                }
            }
        }
        while (markupsStack.length > 0)
            result += '</' + markupsStack.pop() + HTML_TAG_CLOSING;
        if (!isExpanded) {
            showLinkToggle = remainingCharacters <= 0;
        }
        else {
            showLinkToggle = charCount >= props.characterLimit;
        }
        return result;
    }
    return (jsxRuntime.exports.jsxs(ReadMoreWrapper, { children: [jsxRuntime.exports.jsx(ContentWrapper$3, { "aria-live": 'polite', id: props.ariaControls, "data-testid": props.textTestId, contentMarginBottom: props.contentMarginBottom, dangerouslySetInnerHTML: {
                    __html: processRawHTML(props.children),
                } }), showLinkToggle && (jsxRuntime.exports.jsx(LinkToggle, __assign({ testId: props.btnReadMoreTestId, block: true, direction: isExpanded ? 'up' : 'down', onClick: clickHandler, ariaExpanded: isExpanded, ariaControls: props.ariaControls, ariaLabel: isExpanded ? (_a = props.ariaLabelRedLess) !== null && _a !== void 0 ? _a : props.ariaLabel : props.ariaLabel, iconMargin: props.iconMargin }, { children: isExpanded ? (_b = props.btnReadLessText) !== null && _b !== void 0 ? _b : 'Read less' : (_c = props.btnReadMoreText) !== null && _c !== void 0 ? _c : 'Read more' })))] }));
};

var Hidden = styled.div(templateObject_1$m || (templateObject_1$m = __makeTemplateObject(["\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  width: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  position: absolute;\n  outline: none;\n"], ["\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  width: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  position: absolute;\n  outline: none;\n"])));
var templateObject_1$m;

var VisuallyHidden = function (_a) {
    var children = _a.children, elRef = _a.elRef, otherProps = __rest(_a, ["children", "elRef"]);
    return (jsxRuntime.exports.jsx(Hidden, __assign({ ref: elRef }, otherProps, { children: children })));
};

var PricingContainer = styled.div(templateObject_1$l || (templateObject_1$l = __makeTemplateObject(["\n  height: 38px;\n  display: flex;\n"], ["\n  height: 38px;\n  display: flex;\n"])));
var PlaceContainer = styled.div(templateObject_2$i || (templateObject_2$i = __makeTemplateObject(["\n  ", "\n  min-height: 16px;\n  min-width: 30px;\n  letter-spacing: 0;\n  line-height: 16px;\n  white-space: nowrap;\n"], ["\n  ", "\n  min-height: 16px;\n  min-width: 30px;\n  letter-spacing: 0;\n  line-height: 16px;\n  white-space: nowrap;\n"])), OpensansNormalTundora12px);
var PriceContainer = styled.div(templateObject_3$f || (templateObject_3$f = __makeTemplateObject(["\n  height: 38px;\n  margin-left: 4px;\n  display: flex;\n  align-items: flex-start;\n"], ["\n  height: 38px;\n  margin-left: 4px;\n  display: flex;\n  align-items: flex-start;\n"])));
var Price2 = styled.div(templateObject_4$f || (templateObject_4$f = __makeTemplateObject(["\n  ", "\n  width: 10px;\n  min-height: 20px;\n  margin-top: 1px;\n  letter-spacing: 0;\n  line-height: 20px;\n  white-space: nowrap;\n"], ["\n  ", "\n  width: 10px;\n  min-height: 20px;\n  margin-top: 1px;\n  letter-spacing: 0;\n  line-height: 20px;\n  white-space: nowrap;\n"])), OpensansBoldTundora16px);
var Amount$1 = styled.div(templateObject_5$c || (templateObject_5$c = __makeTemplateObject(["\n  ", "\n  min-height: 38px;\n  letter-spacing: 0;\n  line-height: 38px;\n  white-space: nowrap;\n"], ["\n  ", "\n  min-height: 38px;\n  letter-spacing: 0;\n  line-height: 38px;\n  white-space: nowrap;\n"])), OpensansBoldTundora32px);
var PersonsDetailsContainer = styled.div(templateObject_6$a || (templateObject_6$a = __makeTemplateObject(["\n  ", "\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: column;\n  align-items: flex-start;\n  min-height: 32px;\n  margin-left: 8px;\n"], ["\n  ", "\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: column;\n  align-items: flex-start;\n  min-height: 32px;\n  margin-left: 8px;\n"])), OpensansBoldTundora12px);
var PerPerson = styled.p(templateObject_7$9 || (templateObject_7$9 = __makeTemplateObject(["\n  min-height: 16px;\n  letter-spacing: 0;\n  line-height: 16px;\n  white-space: nowrap;\n"], ["\n  min-height: 16px;\n  letter-spacing: 0;\n  line-height: 16px;\n  white-space: nowrap;\n"])));
var PersonsInRoom = styled.div(templateObject_8$7 || (templateObject_8$7 = __makeTemplateObject(["\n  min-height: 16px;\n  margin-left: 10px;\n  letter-spacing: 0;\n  line-height: 16px;\n  white-space: nowrap;\n"], ["\n  min-height: 16px;\n  margin-left: 10px;\n  letter-spacing: 0;\n  line-height: 16px;\n  white-space: nowrap;\n"])));
var templateObject_1$l, templateObject_2$i, templateObject_3$f, templateObject_4$f, templateObject_5$c, templateObject_6$a, templateObject_7$9, templateObject_8$7;

var Pricing = function (props) {
    return (jsxRuntime.exports.jsxs(PricingContainer, __assign({ "data-testid": "pricingContainer" }, { children: [jsxRuntime.exports.jsx(PlaceContainer, __assign({ "data-testid": "fromText" }, { children: props.fromText })), jsxRuntime.exports.jsxs(PriceContainer, __assign({ "data-testid": "priceContainer" }, { children: [jsxRuntime.exports.jsx(Price2, __assign({ "data-testid": "priceSymbol" }, { children: props.priceSymbol })), jsxRuntime.exports.jsx(Amount$1, __assign({ "data-testid": "priceAmount" }, { children: props.priceValue }))] })), jsxRuntime.exports.jsxs(PersonsDetailsContainer, __assign({ "data-testid": "personDetailsContainer" }, { children: [jsxRuntime.exports.jsx(PerPerson, __assign({ "data-testid": "perPersonText" }, { children: props.perPersonText })), jsxRuntime.exports.jsx(PersonsInRoom, __assign({ "data-testid": "personsInRoomText" }, { children: props.personsInRoomText }))] }))] })));
};

var _path$9;
function _extends$9() { _extends$9 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }
var SvgChevronDownGray = function SvgChevronDownGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$9 || (_path$9 = /*#__PURE__*/React.createElement("path", {
    d: "m2.095 5.632.537-.536a.326.326 0 0 1 .461 0l4.909 4.898 4.91-4.898a.326.326 0 0 1 .46 0l.537.536a.326.326 0 0 1 0 .461L8.232 11.77a.326.326 0 0 1-.46 0L2.095 6.093a.326.326 0 0 1 0-.46Z",
    fill: "#464646"
  })));
};

var _path$8;
function _extends$8() { _extends$8 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }
var SvgCloseIcon = function SvgCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8({
    width: 9,
    height: 9,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$8 || (_path$8 = /*#__PURE__*/React.createElement("path", {
    d: "m5.455 4.5 2.884-2.884.595-.595a.225.225 0 0 0 0-.318L8.298.066a.225.225 0 0 0-.318 0L4.5 3.546 1.02.066a.225.225 0 0 0-.317 0L.066.702a.225.225 0 0 0 0 .318l3.48 3.48-3.48 3.48a.225.225 0 0 0 0 .318l.636.636c.088.088.23.088.318 0l3.48-3.48L7.385 8.34l.595.595c.087.088.23.088.318 0l.636-.636a.225.225 0 0 0 0-.318L5.454 4.5Z",
    fill: "#464646"
  })));
};

var Content$4 = styled.div(templateObject_1$k || (templateObject_1$k = __makeTemplateObject([""], [""])));
var RadiusMap = new Map([
    ['oval', '19px'],
    ['square', '4px'],
]);
var BorderMap = new Map([
    ['oval', '1px solid var(--gray)'],
    ['square', 'none'],
]);
var BorderMapOnPressed = new Map([
    ['oval', '1px solid var(--regal-blue)'],
    ['square', 'none'],
]);
var BorderMapOnHover = new Map([
    ['oval', '1px solid var(--congress-blue)'],
    ['square', 'none'],
]);
var HoverMap = new Map([
    ['oval', 'var(--congress-blue)'],
    ['square', 'var(--congress-blue)'],
]);
var PressedMap = new Map([
    ['oval', 'var(--regal-blue)'],
    ['square', 'var(--regal-blue)'],
]);
var ColorMap = new Map([
    ['oval', 'var(--hint-of-red)'],
    ['square', 'var(--cararra)'],
]);
var BoxShadow = new Map([
    ['oval', 'none'],
    ['square', '0px 4px 6px rgba(0, 0, 0, 0.04)'],
]);
var ChipBase = css(templateObject_2$h || (templateObject_2$h = __makeTemplateObject(["\n  border: ", ";\n  width: fit-content;\n  text-align: center;\n  text-decoration: none;\n  height: 32px;\n  display: flex;\n  padding: 6px 16px;\n  align-items: flex-start;\n  min-width: 50px;\n  justify-content: center;\n  align-items: center;\n  white-space:", " ;\n  vertical-align: middle;\n  -webkit-appearance: none;\n  border-radius:  ", ";\n  cursor: pointer;\n  box-shadow: ", ";\n  color: ", ";\n  background-color: ", ";\n  ", "\n  min-height: 16px;\n  letter-spacing: 0;\n  line-height: 16px;\n\n  &:hover {\n    background-color: ", ";\n    color: var(--white);    \n    border: ", ";\n   \n    & svg path {\n      fill: var(--white);\n      stroke: ", ";\n    }\n  }\n\n  &:focus {\n    box-shadow: 0 0 0 3px var(--bondi-blue);\n  }\n\n\n\n  &:active {\n    background-color: ", ";\n    color: var(--white);    \n    border: ", ";\n   \n    & svg path {\n      fill: var(--white);\n      stroke: ", ";\n    }  \n  }\n\n"], ["\n  border: ", ";\n  width: fit-content;\n  text-align: center;\n  text-decoration: none;\n  height: 32px;\n  display: flex;\n  padding: 6px 16px;\n  align-items: flex-start;\n  min-width: 50px;\n  justify-content: center;\n  align-items: center;\n  white-space:", " ;\n  vertical-align: middle;\n  -webkit-appearance: none;\n  border-radius:  ", ";\n  cursor: pointer;\n  box-shadow: ", ";\n  color: ", ";\n  background-color: ", ";\n  ", "\n  min-height: 16px;\n  letter-spacing: 0;\n  line-height: 16px;\n\n  &:hover {\n    background-color: ", ";\n    color: var(--white);    \n    border: ", ";\n   \n    & svg path {\n      fill: var(--white);\n      stroke: ", ";\n    }\n  }\n\n  &:focus {\n    box-shadow: 0 0 0 3px var(--bondi-blue);\n  }\n\n\n\n  &:active {\n    background-color: ", ";\n    color: var(--white);    \n    border: ", ";\n   \n    & svg path {\n      fill: var(--white);\n      stroke: ", ";\n    }  \n  }\n\n"])), function (props) { return !props.isExpanded ? BorderMap.get(props.chipForm) : BorderMapOnPressed.get(props.chipForm); }, function (props) { return props.wrapContent ? 'none' : 'nowrap'; }, function (props) { return RadiusMap.get(props.chipForm); }, function (props) { return BoxShadow.get(props.chipForm); }, function (props) { return !props.isExpanded ? 'var(--tundora)' : 'var(--white)'; }, function (props) { return !props.isExpanded ? ColorMap.get(props.chipForm) : 'var(--regal-blue)'; }, OpensansNormalTundora12px, function (props) { return HoverMap.get(props.chipForm); }, function (props) { return BorderMapOnHover.get(props.chipForm); }, function (props) { return props.chipForm === 'oval' && 'var(--white)'; }, function (props) { return PressedMap.get(props.chipForm); }, function (props) { return BorderMapOnPressed.get(props.chipForm); }, function (props) { return props.chipForm === 'oval' && 'var(--white)'; });
var ChipButton = styled.button(templateObject_3$e || (templateObject_3$e = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), ChipBase);
var ChipDiv = styled.div(templateObject_4$e || (templateObject_4$e = __makeTemplateObject(["\n  ", "\n  &:hover button {\n    background-color: var(--congress-blue);\n  }\n  \n  &:active button {\n    background-color: var(--regal-blue);\n  }  \n\n"], ["\n  ", "\n  &:hover button {\n    background-color: var(--congress-blue);\n  }\n  \n  &:active button {\n    background-color: var(--regal-blue);\n  }  \n\n"])), ChipBase);
var ChevronIconContainer = styled(IconContainer)(templateObject_5$b || (templateObject_5$b = __makeTemplateObject(["\n  align-self: center;\n  margin-left: var(--spacing_token_xs);\n"], ["\n  align-self: center;\n  margin-left: var(--spacing_token_xs);\n"])));
var ChevronIcon = styled(SvgChevronDownGray)(templateObject_6$9 || (templateObject_6$9 = __makeTemplateObject(["\n  transition: all .5s ease;\n  transform: ", ";\n \n  & path {\n    stroke:", ";\n    fill: ", ";\n  }\n\n"], ["\n  transition: all .5s ease;\n  transform: ", ";\n \n  & path {\n    stroke:", ";\n    fill: ", ";\n  }\n\n"])), function (props) { return props.$isExpanded && "rotate(-180deg)"; }, function (props) { return props.$isExpanded ? 'var(--white)' : 'var(--tundora)'; }, function (props) { return props.$isExpanded ? 'var(--white)' : 'var(--tundora)'; });
var CloseIcon = styled(SvgCloseIcon)(templateObject_7$8 || (templateObject_7$8 = __makeTemplateObject(["\n  align-self: center;\n  transition: all .5s ease;\n"], ["\n  align-self: center;\n  transition: all .5s ease;\n"])));
var CloseIconContainer = styled(IconContainer)(templateObject_8$6 || (templateObject_8$6 = __makeTemplateObject(["\n"], ["\n"])));
var CloseButton$3 = styled.button(templateObject_9$6 || (templateObject_9$6 = __makeTemplateObject(["\n  background-color: var(--cararra);\n  -webkit-appearance: none;\n  cursor: pointer;\n  justify-content: center;\n  align-items: center;\n  appearance: none;\n  border: none;\n  margin-left: 12px;\n  padding: 0;\n  \n  &:hover {\n    background-color: var(--tory-blue);\n\n    & svg path {\n      fill: var(--white) ;\n    }\n  }\n \n  &:active {\n    background-color: var(--regal-blue);\n\n    & svg path {\n      fill: var(--white) ;\n    }\n  }\n\n  &:active:not(:hover) {\n    /* This will prevent the style from being applied\n    when the user presses the space key or enter*/\n    background-color: var(--cararra);\n    & svg path {\n      fill: var(--tundora);\n    }    \n  }\n\n  &:focus {\n    box-shadow: 0 0 0 3px var(--bondi-blue);\n  }\n"], ["\n  background-color: var(--cararra);\n  -webkit-appearance: none;\n  cursor: pointer;\n  justify-content: center;\n  align-items: center;\n  appearance: none;\n  border: none;\n  margin-left: 12px;\n  padding: 0;\n  \n  &:hover {\n    background-color: var(--tory-blue);\n\n    & svg path {\n      fill: var(--white) ;\n    }\n  }\n \n  &:active {\n    background-color: var(--regal-blue);\n\n    & svg path {\n      fill: var(--white) ;\n    }\n  }\n\n  &:active:not(:hover) {\n    /* This will prevent the style from being applied\n    when the user presses the space key or enter*/\n    background-color: var(--cararra);\n    & svg path {\n      fill: var(--tundora);\n    }    \n  }\n\n  &:focus {\n    box-shadow: 0 0 0 3px var(--bondi-blue);\n  }\n"])));
var templateObject_1$k, templateObject_2$h, templateObject_3$e, templateObject_4$e, templateObject_5$b, templateObject_6$9, templateObject_7$8, templateObject_8$6, templateObject_9$6;

var Chip = function (props) {
    if (props.chipForm === 'oval') {
        return (jsxRuntime.exports.jsx(ChipButton, __assign({ type: "button", role: props.role, "data-testid": props.testId, onClick: props.clickHandler, "aria-expanded": props.isExpanded, "aria-label": props.ariaLabel }, props, { children: jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [props.children, jsxRuntime.exports.jsx(ChevronIconContainer, { children: jsxRuntime.exports.jsx(ChevronIcon, { "$isExpanded": props.isExpanded, "aria-hidden": 'true' }) })] }) })));
    }
    var buttonTestId = "closebutton-".concat(props.testId);
    return (jsxRuntime.exports.jsx(ChipDiv, __assign({ tabIndex: 0, role: props.role, "data-testid": props.testId, onClick: props.clickHandler, "aria-expanded": props.isExpanded, "aria-label": props.ariaLabel }, props, { children: jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [props.containsHtmlTag ?
                    jsxRuntime.exports.jsx(Content$4, { dangerouslySetInnerHTML: { __html: props.children.toString() } }) : props.children, jsxRuntime.exports.jsx(CloseButton$3, __assign({ type: 'button', role: props.roleClose, onClick: props.onCloseHandler, "aria-label": props.closeAriaLabel, "data-testid": buttonTestId }, { children: jsxRuntime.exports.jsx(CloseIconContainer, { children: jsxRuntime.exports.jsx(CloseIcon, { "aria-hidden": 'true' }) }) }))] }) })));
};

var _path$7;
function _extends$7() { _extends$7 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }
var SvgInfoCircle = function SvgInfoCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$7 || (_path$7 = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.667c-3.866 0-7 3.13-7 6.99 0 3.86 3.134 6.989 7 6.989s7-3.129 7-6.99c0-3.858-3.134-6.989-7-6.989Zm0 12.626A5.637 5.637 0 1 1 8 3.02a5.638 5.638 0 1 1 0 11.273Zm0-9.526a1.185 1.185 0 1 1 .002 2.37A1.185 1.185 0 0 1 8 4.766Zm1.58 7.159a.338.338 0 0 1-.338.338H6.758a.338.338 0 0 1-.339-.338v-.677c0-.187.152-.338.34-.338h.338V9.107h-.339a.338.338 0 0 1-.339-.338v-.676c0-.187.152-.338.34-.338h1.806c.187 0 .338.15.338.338v2.818h.339c.187 0 .339.152.339.338v.677Z",
    fill: "#10559A"
  })));
};

var GuestLevelPricingContainer = styled.div(templateObject_1$j || (templateObject_1$j = __makeTemplateObject(["\n  ", "\n  display: grid;\n  flex-direction: column;\n  align-items: flex-start;\n  overflow: hidden;\n"], ["\n  ", "\n  display: grid;\n  flex-direction: column;\n  align-items: flex-start;\n  overflow: hidden;\n"])), OpensansNormalTundora14px);
var GuestLabelContainer = styled.div(templateObject_2$g || (templateObject_2$g = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var ItemContainer = styled.div(templateObject_3$d || (templateObject_3$d = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  letter-spacing: 0;\n  line-height: 18px;\n  margin-top: 4px;\n\n  :first-child{\n    margin-top: unset;\n  }\n"], ["\n  display: flex;\n  justify-content: space-between;\n  letter-spacing: 0;\n  line-height: 18px;\n  margin-top: 4px;\n\n  :first-child{\n    margin-top: unset;\n  }\n"])));
var Taxes = styled.div(templateObject_4$d || (templateObject_4$d = __makeTemplateObject(["\n  margin-top: var(--spacing_token_xxs);\n  display: flex;\n  justify-content: space-between;\n"], ["\n  margin-top: var(--spacing_token_xxs);\n  display: flex;\n  justify-content: space-between;\n"])));
var TaxesLabelContainer = styled.div(templateObject_5$a || (templateObject_5$a = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var TotalContainer = styled.div(templateObject_6$8 || (templateObject_6$8 = __makeTemplateObject(["\n  margin-top: 16px;\n  margin-bottom: 24px;\n  display: flex;\n  justify-content: space-between;\n"], ["\n  margin-top: 16px;\n  margin-bottom: 24px;\n  display: flex;\n  justify-content: space-between;\n"])));
var Label = styled.div(templateObject_7$7 || (templateObject_7$7 = __makeTemplateObject(["\n  letter-spacing: 0;\n  line-height: 18px;\n"], ["\n  letter-spacing: 0;\n  line-height: 18px;\n"])));
var InfoCircle = styled(SvgInfoCircle)(templateObject_8$5 || (templateObject_8$5 = __makeTemplateObject(["\n  width: 16px;\n  height: 16px;\n  margin-left: 4px;\n  cursor: pointer;\n"], ["\n  width: 16px;\n  height: 16px;\n  margin-left: 4px;\n  cursor: pointer;\n"])));
var Amount = styled.div(templateObject_9$5 || (templateObject_9$5 = __makeTemplateObject(["\n  text-align: right;\n  letter-spacing: 0;\n  line-height: 18px;\n"], ["\n  text-align: right;\n  letter-spacing: 0;\n  line-height: 18px;\n"])));
styled.div(templateObject_10$4 || (templateObject_10$4 = __makeTemplateObject(["\n  display: none;\n"], ["\n  display: none;\n"])));
var ModalContent$1 = styled.div(templateObject_11$3 || (templateObject_11$3 = __makeTemplateObject(["\n  display: flex;\n  width: 100%;\n  position: relative;\n  margin: 0 auto;\n"], ["\n  display: flex;\n  width: 100%;\n  position: relative;\n  margin: 0 auto;\n"])));
var ContentContainer$2 = styled.div(templateObject_12$3 || (templateObject_12$3 = __makeTemplateObject(["\n  flex-flow: column wrap;\n  flex-grow: 1;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  row-gap: 24px;\n"], ["\n  flex-flow: column wrap;\n  flex-grow: 1;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  row-gap: 24px;\n"])));
var HeadingContent$1 = styled.div(templateObject_13$3 || (templateObject_13$3 = __makeTemplateObject(["\n  flex-flow: column wrap;\n  flex-grow: 1;\n  height: 100%;\n  display: flex;\n  row-gap: 24px;\n  align-self: stretch;\n"], ["\n  flex-flow: column wrap;\n  flex-grow: 1;\n  height: 100%;\n  display: flex;\n  row-gap: 24px;\n  align-self: stretch;\n"])));
var HeadingWrapper$2 = styled.div(templateObject_14$3 || (templateObject_14$3 = __makeTemplateObject(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  height : fit-content;\n  flex: 0 0 40%;\n"], ["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  height : fit-content;\n  flex: 0 0 40%;\n"])));
styled.div(templateObject_15$3 || (templateObject_15$3 = __makeTemplateObject(["\n  ", "\n  font-size: var(--font-size-24);\n  min-height: 28px;\n  text-align: center;\n  letter-spacing: 0;\n  width: 170px;\n  justify-content: space-between;\n  line-height: 28px;\n  margin-right:  var(--spacing_token_m);\n  ", " {\n    font-size: var(--font-size-34);\n    width: 100%;\n  }\n"], ["\n  ", "\n  font-size: var(--font-size-24);\n  min-height: 28px;\n  text-align: center;\n  letter-spacing: 0;\n  width: 170px;\n  justify-content: space-between;\n  line-height: 28px;\n  margin-right:  var(--spacing_token_m);\n  ", " {\n    font-size: var(--font-size-34);\n    width: 100%;\n  }\n"])), TempostdHeavycondensedNormalToryBlu, up("md"));
styled.p(templateObject_16$2 || (templateObject_16$2 = __makeTemplateObject(["\n  ", "\n  min-height: 36px;\n  width: 227px;\n  text-align: center;\n  letter-spacing: 0;\n  line-height: 18px;\n"], ["\n  ", "\n  min-height: 36px;\n  width: 227px;\n  text-align: center;\n  letter-spacing: 0;\n  line-height: 18px;\n"])), OpensansNormalTundora14px);
styled.div(templateObject_17$1 || (templateObject_17$1 = __makeTemplateObject(["\n  flex: 0 0 60%;\n  display: flex;\n"], ["\n  flex: 0 0 60%;\n  display: flex;\n"])));
var ModalCloseButtonContainer$1 = styled.div(templateObject_18$1 || (templateObject_18$1 = __makeTemplateObject(["\n  display: flex;\n  margin-left: auto;\n"], ["\n  display: flex;\n  margin-left: auto;\n"])));
var CloseButton$2 = styled.button(templateObject_19$1 || (templateObject_19$1 = __makeTemplateObject(["\n  display: flex;\n  ", "\n"], ["\n  display: flex;\n  ", "\n"])), PlainButtonStyle);
var HorizontalDividerLight$2 = styled.div(templateObject_20$1 || (templateObject_20$1 = __makeTemplateObject(["\n  width: 100%;\n  height: 1px;\n  margin-top: 24px;\n  background-color: var(--silver);\n\n"], ["\n  width: 100%;\n  height: 1px;\n  margin-top: 24px;\n  background-color: var(--silver);\n\n"])));
var Content$3 = styled.div(templateObject_21$1 || (templateObject_21$1 = __makeTemplateObject(["\n  ", "\n  line-height: 18px;\n"], ["\n  ", "\n  line-height: 18px;\n"])), OpensansNormalTundora14px);
var templateObject_1$j, templateObject_2$g, templateObject_3$d, templateObject_4$d, templateObject_5$a, templateObject_6$8, templateObject_7$7, templateObject_8$5, templateObject_9$5, templateObject_10$4, templateObject_11$3, templateObject_12$3, templateObject_13$3, templateObject_14$3, templateObject_15$3, templateObject_16$2, templateObject_17$1, templateObject_18$1, templateObject_19$1, templateObject_20$1, templateObject_21$1;

var PlainButton$1 = styled.button(templateObject_1$i || (templateObject_1$i = __makeTemplateObject(["\n  padding: 0;\n  margin: 0;\n  font-family: inherit;\n  color: inherit;\n  cursor: pointer;\n  background: none;\n  border: 0;\n  appearance: none;\n"], ["\n  padding: 0;\n  margin: 0;\n  font-family: inherit;\n  color: inherit;\n  cursor: pointer;\n  background: none;\n  border: 0;\n  appearance: none;\n"])));
var templateObject_1$i;

var classnames = {exports: {}};

/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/

(function (module) {
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
}(classnames));

var classNames = classnames.exports;

var PlainButton = function (props) {
    var children = props.children, className = props.className, otherProps = __rest(props, ["children", "className"]);
    return (jsxRuntime.exports.jsx(PlainButton$1, __assign({ className: classNames('btn-plain', className) }, otherProps, { children: children })));
};

var GuestLevelPricing = function (props) {
    var _a, _b, _c, _d, _e, _f;
    var _g = __read(useState("$0"), 2), taxesFeesPortExpensesAmount = _g[0], setTaxesFeesPortExpensesAmount = _g[1];
    var _h = __read(useState("$0"), 2), roomTotalAmount = _h[0], setRoomTotalAmount = _h[1];
    var _j = __read(useState(null), 2), currencyFormatter = _j[0], setcurrencyFormatter = _j[1];
    var _k = __read(useState(new Array()), 2), guestPrices = _k[0], setGuestPrices = _k[1];
    var _l = __read(useState(false), 2), isTaxesAndFeesOpen = _l[0], setIsTaxesAndFeesOpen = _l[1];
    var _m = __read(useState(false), 2), isGuestRateOpen = _m[0], setIsGuestRateOpen = _m[1];
    var _o = __read(useState(false), 2), isBrowser = _o[0], setIsBrowser = _o[1];
    var bp = useBreakpoints();
    var onAfterOpen = function () {
        document.body.style.overflow = 'hidden';
    };
    var onAfterClose = function () {
        document.body.style.overflow = 'unset';
    };
    var customStyles = {
        overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.66)",
            zIndex: 10000,
            position: 'fixed',
            width: 'auto',
            display: 'grid',
            gridTemplateColumns: bp.isMobile ? 'repeat(4,1fr)' : bp.isTablet ? 'repeat(8,1fr)' : bp.isXXl ? '1fr repeat(12, 88px) 1fr' : 'repeat(12,1fr)',
            gridColumnGap: '24px',
            margin: 'auto',
            padding: bp.isMobile ? '0 var(--spacing_token_s)' : '0',
            alignItems: 'flex-start',
            overflow: 'auto'
        },
        content: {
            inset: 'var(--spacing_token_3xl) 0 auto',
            padding: bp.isMobile ? 'var(--spacing_token_m)' : 'var(--spacing_token_2xl)',
            boxShadow: '0px 0px 6px #0000002e',
            border: 'none',
            position: 'relative',
            borderRadius: '8px',
            gridColumnStart: (bp.isMobile) ? "1" : bp.isTablet ? "2" : bp.isXXl ? "4" : "3",
            gridColumnEnd: (bp.isMobile) ? "span 4" : bp.isTablet ? "span 6" : "span 8",
            display: 'grid'
        }
    };
    useEffect(function () {
        var _a, _b;
        var guestCount = (_b = (_a = props === null || props === void 0 ? void 0 : props.guestPrices) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
        if (guestCount != 0) {
            calculatePricing(props);
        }
    }, [props]);
    useEffect(function () {
        setIsBrowser(true);
    }, []);
    useEffect(function () {
        var _a;
        if ((_a = props.options) === null || _a === void 0 ? void 0 : _a.callbackCheckModalStatus) {
            props.options.callbackCheckModalStatus(isGuestRateOpen || isTaxesAndFeesOpen);
        }
    }, [isGuestRateOpen, isTaxesAndFeesOpen, props.options]);
    return (jsxRuntime.exports.jsxs(GuestLevelPricingContainer, { children: [guestPrices.map(function (guest, index) {
                return (jsxRuntime.exports.jsxs(ItemContainer, { children: [jsxRuntime.exports.jsxs(GuestLabelContainer, { children: [jsxRuntime.exports.jsxs(Label, __assign({ "data-testid": 'guestLabel' }, { children: ["Guest ".concat(index + 1, ":"), " "] })), index > 1 && (jsxRuntime.exports.jsx(PlainButton, __assign({ onClick: handleGuestsModal, "aria-label": 'Guest Rate Dialog', "data-testid": "guestRateInfoCircleButton" }, { children: jsxRuntime.exports.jsx(InfoCircle, { "aria-label": 'More Information Guest Rate Info Circle' }) })))] }), jsxRuntime.exports.jsx(Amount, __assign({ "data-testid": 'guestAmount' }, { children: guest.price }))] }, index));
            }), (isBrowser) && (jsxRuntime.exports.jsx("div", { children: jsxRuntime.exports.jsx(SharedModal, __assign({ heading: (_a = props === null || props === void 0 ? void 0 : props.guestRateModalProps) === null || _a === void 0 ? void 0 : _a.heading, testId: "tooTip", "data-testid": 'guestRateModal', closeAriaLabel: 'Close Guest Rate dialog', customStyles: customStyles, onAfterOpen: onAfterOpen, onAfterClose: onAfterClose, modalIsOpen: isGuestRateOpen, isDefaultModal: true, shouldCloseOnOverlayClick: true, shouldCloseOnEsc: true, onClose: function () { handleGuestsModal(); } }, { children: jsxRuntime.exports.jsx(ModalContent$1, { children: jsxRuntime.exports.jsx(ContentContainer$2, { children: jsxRuntime.exports.jsxs(HeadingWrapper$2, { children: [jsxRuntime.exports.jsxs(HeadingContent$1, { children: [jsxRuntime.exports.jsx(HorizontalDividerLight$2, {}), jsxRuntime.exports.jsx(Content$3, { dangerouslySetInnerHTML: { __html: (_b = props === null || props === void 0 ? void 0 : props.guestRateModalProps) === null || _b === void 0 ? void 0 : _b.content } })] }), jsxRuntime.exports.jsx(ModalCloseButtonContainer$1, { children: jsxRuntime.exports.jsx(CloseButton$2, { "aria-label": (_c = props === null || props === void 0 ? void 0 : props.guestRateModalProps) === null || _c === void 0 ? void 0 : _c.headingArialLabel, "data-testid": 'guestRateCloseButton' }) })] }) }) }) })) })), jsxRuntime.exports.jsxs(Taxes, { children: [jsxRuntime.exports.jsxs(TaxesLabelContainer, { children: [jsxRuntime.exports.jsx(Label, __assign({ "data-testid": 'taxesFeesPortExpensesLabel' }, { children: 'Taxes, fees, & port expenses' })), isBrowser && (jsxRuntime.exports.jsx(SharedModal, __assign({ heading: (_d = props === null || props === void 0 ? void 0 : props.taxesFeesAndPortExpensesModalProps) === null || _d === void 0 ? void 0 : _d.heading, testId: "tooTip", "data-testid": 'taxesFeesAndPortExpensesModal', closeAriaLabel: "Close Taxes, Fees & Port Expenses dialog", customStyles: customStyles, onAfterOpen: onAfterOpen, onAfterClose: onAfterClose, modalIsOpen: isTaxesAndFeesOpen, isDefaultModal: true, shouldCloseOnOverlayClick: true, shouldCloseOnEsc: true, onClose: function () { handleTaxesAndFeesModal(); } }, { children: jsxRuntime.exports.jsx(ModalContent$1, { children: jsxRuntime.exports.jsx(ContentContainer$2, { children: jsxRuntime.exports.jsxs(HeadingWrapper$2, { children: [jsxRuntime.exports.jsxs(HeadingContent$1, { children: [jsxRuntime.exports.jsx(HorizontalDividerLight$2, {}), jsxRuntime.exports.jsx(Content$3, { dangerouslySetInnerHTML: { __html: (_e = props === null || props === void 0 ? void 0 : props.taxesFeesAndPortExpensesModalProps) === null || _e === void 0 ? void 0 : _e.content } })] }), jsxRuntime.exports.jsx(ModalCloseButtonContainer$1, { children: jsxRuntime.exports.jsx(CloseButton$2, { "aria-label": (_f = props === null || props === void 0 ? void 0 : props.taxesFeesAndPortExpensesModalProps) === null || _f === void 0 ? void 0 : _f.closeButtonAriaLabel, "data-testid": 'closeButton' }) })] }) }) }) }))), jsxRuntime.exports.jsx(PlainButton, __assign({ onClick: handleTaxesAndFeesModal, "aria-label": 'Taxes Fees Port Expenses Dialog', "data-testid": "taxesFeesPortExpensesInfoCircleButton" }, { children: jsxRuntime.exports.jsx(InfoCircle, { "aria-label": 'More Information about Taxes Fees Port Expenses' }) }))] }), jsxRuntime.exports.jsx(Amount, __assign({ "data-testid": 'taxesFeesPortExpensesAmount' }, { children: taxesFeesPortExpensesAmount }))] }), jsxRuntime.exports.jsxs(TotalContainer, { children: [jsxRuntime.exports.jsx(Label, __assign({ "data-testid": 'roomTotalLabel' }, { children: 'Room Total:' })), jsxRuntime.exports.jsx(Amount, __assign({ "data-testid": 'roomTotalAmount' }, { children: roomTotalAmount }))] })] }));
    /**
     * Calculate the guest prices, taxes & fees and room total.
     * @param props the GuestLevelPricingProps the properties used to calculate the pricing.
     */
    function calculatePricing(props) {
        var _a, _b, _c;
        var taxesAndFeesTotal = props.taxesAndFeesIncludedInPrice
            ? 0 : props.guestPrices.reduce(function (acc, obj) { return acc + obj.taxesAndFees; }, 0);
        var guestPriceTotal = props.guestPrices.reduce(function (acc, obj) { return acc + obj.price; }, 0);
        var formatter = Intl.NumberFormat(props.locales, { style: 'currency', currency: props.currency });
        setcurrencyFormatter(formatter);
        setTaxesFeesPortExpensesAmount(props.taxesAndFeesIncludedInPrice ? 'Included' : (_a = currencyFormatter === null || currencyFormatter === void 0 ? void 0 : currencyFormatter.format(taxesAndFeesTotal)) !== null && _a !== void 0 ? _a : '');
        var totalAmount = (_b = currencyFormatter === null || currencyFormatter === void 0 ? void 0 : currencyFormatter.format(guestPriceTotal + taxesAndFeesTotal)) !== null && _b !== void 0 ? _b : '';
        setRoomTotalAmount(totalAmount);
        if ((_c = props === null || props === void 0 ? void 0 : props.options) === null || _c === void 0 ? void 0 : _c.externalTotalSetter) {
            props.options.externalTotalSetter(totalAmount);
        }
        var prices = props.guestPrices.map(function (gp) { var _a; return ({ price: (_a = currencyFormatter === null || currencyFormatter === void 0 ? void 0 : currencyFormatter.format(gp.price)) !== null && _a !== void 0 ? _a : '' }); });
        setGuestPrices(prices);
    }
    function handleTaxesAndFeesModal() {
        setIsTaxesAndFeesOpen(!isTaxesAndFeesOpen);
    }
    function handleGuestsModal() {
        setIsGuestRateOpen(!isGuestRateOpen);
    }
};

var RoomDescription$1 = styled.div(templateObject_1$h || (templateObject_1$h = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n"])));
var LinkToggleContainer$1 = styled.div(templateObject_2$f || (templateObject_2$f = __makeTemplateObject(["\n  & button {\n    font-size: 14px;\n    line-height: 18px;\n  }\n"], ["\n  & button {\n    font-size: 14px;\n    line-height: 18px;\n  }\n"])));
var RoomType = styled.div(templateObject_3$c || (templateObject_3$c = __makeTemplateObject(["\n  font-family: var(--font-family-open_sans);\n  font-weight: 700;\n  color: var(--tundora);\n  font-size: var(--font-size-20);\n  letter-spacing: 0;\n  line-height: 24px;\n"], ["\n  font-family: var(--font-family-open_sans);\n  font-weight: 700;\n  color: var(--tundora);\n  font-size: var(--font-size-20);\n  letter-spacing: 0;\n  line-height: 24px;\n"])));
var Description$1 = styled.p(templateObject_4$c || (templateObject_4$c = __makeTemplateObject(["\n  margin-top: 4px;\n  margin-bottom: 4px;\n  font-family: var(--font-family-open_sans);\n  font-weight: 400;\n  color: var(--tundora);\n  font-size: var(--font-size-14);\n  letter-spacing: 0;\n  line-height: 18px;\n"], ["\n  margin-top: 4px;\n  margin-bottom: 4px;\n  font-family: var(--font-family-open_sans);\n  font-weight: 400;\n  color: var(--tundora);\n  font-size: var(--font-size-14);\n  letter-spacing: 0;\n  line-height: 18px;\n"])));
styled.div(templateObject_5$9 || (templateObject_5$9 = __makeTemplateObject(["\n  height: 18px;\n  margin-top: 4px;\n  display: flex;\n  align-items: flex-start;\n"], ["\n  height: 18px;\n  margin-top: 4px;\n  display: flex;\n  align-items: flex-start;\n"])));
styled.div(templateObject_6$7 || (templateObject_6$7 = __makeTemplateObject(["\n  min-height: 18px;\n  font-family: var(--font-family-open_sans);\n  font-weight: 700;\n  color: var(--tory-blue);\n  font-size: var(--font-size-14);\n  letter-spacing: 0.01px;\n  line-height: 18px;\n  margin-top: 4px;\n"], ["\n  min-height: 18px;\n  font-family: var(--font-family-open_sans);\n  font-weight: 700;\n  color: var(--tory-blue);\n  font-size: var(--font-size-14);\n  letter-spacing: 0.01px;\n  line-height: 18px;\n  margin-top: 4px;\n"])));
styled(SvgChevronCaretsDown)(templateObject_7$6 || (templateObject_7$6 = __makeTemplateObject(["\n  width: 16px;\n  height: 16px;\n  align-self: center;\n  margin-left: 5px;\n"], ["\n  width: 16px;\n  height: 16px;\n  align-self: center;\n  margin-left: 5px;\n"])));
var Amenities = styled.div(templateObject_8$4 || (templateObject_8$4 = __makeTemplateObject(["\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-14);\n  color: var(--tundora);\n  position: relative;\n  margin-top: 8px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  strong {\n    font-weight: bold;\n  }\n  ul {\n    margin-top: 8px;\n    padding-left: 24px;\n    list-style-type: disc;\n  }\n  li {\n    font-size: var(--font-size-14);\n    left: calc(50% - 208.25px/2);\n    top: calc(50% - 13px / 2 - 63px);\n    line-height: 16px;\n  }\n"], ["\n  font-family: var(--font-family-open_sans);\n  font-size: var(--font-size-14);\n  color: var(--tundora);\n  position: relative;\n  margin-top: 8px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  strong {\n    font-weight: bold;\n  }\n  ul {\n    margin-top: 8px;\n    padding-left: 24px;\n    list-style-type: disc;\n  }\n  li {\n    font-size: var(--font-size-14);\n    left: calc(50% - 208.25px/2);\n    top: calc(50% - 13px / 2 - 63px);\n    line-height: 16px;\n  }\n"])));
var RoomWillBeAssigned = styled.div(templateObject_9$4 || (templateObject_9$4 = __makeTemplateObject(["\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: var(--spacing_token_xxs) var(--spacing_token_s);\n  height: 24px;\n  border: 1px solid var(--gray);\n  border-radius: 16px;\n\n  font-family: var(--font-family-open_sans);\n  font-style: normal;\n  font-weight: 700;\n  font-size: var(--font-size-12);\n  line-height: 16px;\n  color: var(--tundora);\n  margin: var(--spacing_token_xxs) 0 var(--spacing_token_xs);\n  text-transform: uppercase;\n"], ["\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: var(--spacing_token_xxs) var(--spacing_token_s);\n  height: 24px;\n  border: 1px solid var(--gray);\n  border-radius: 16px;\n\n  font-family: var(--font-family-open_sans);\n  font-style: normal;\n  font-weight: 700;\n  font-size: var(--font-size-12);\n  line-height: 16px;\n  color: var(--tundora);\n  margin: var(--spacing_token_xxs) 0 var(--spacing_token_xs);\n  text-transform: uppercase;\n"])));
var templateObject_1$h, templateObject_2$f, templateObject_3$c, templateObject_4$c, templateObject_5$9, templateObject_6$7, templateObject_7$6, templateObject_8$4, templateObject_9$4;

var RoomDescription = function (props) {
    var _a = __read(useState(false), 2), isExpanded = _a[0], setIsExpanded = _a[1];
    function amenitiesClickHandler(event) {
        event.preventDefault();
        setIsExpanded(!isExpanded);
    }
    useEffect(function () {
        setIsExpanded(!props.collapseAmenities);
    }, [props]);
    return (jsxRuntime.exports.jsxs(RoomDescription$1, { children: [jsxRuntime.exports.jsx(RoomType, { children: props.roomType }), jsxRuntime.exports.jsx(Description$1, { dangerouslySetInnerHTML: { __html: props.description } }), props.isGtee && (jsxRuntime.exports.jsx(RoomWillBeAssigned, { children: props.isGteeDesc })), props.showAmenities && (jsxRuntime.exports.jsx(LinkToggleContainer$1, { children: jsxRuntime.exports.jsx(LinkToggle, __assign({ direction: isExpanded ? "up" : "down", ariaExpanded: isExpanded, onClick: amenitiesClickHandler, "data-testid": 'viewAmenitiesButton' }, { children: "View Amenities" })) })), props.showAmenities && isExpanded && (jsxRuntime.exports.jsx(Amenities, { dangerouslySetInnerHTML: { __html: props.amenities }, "data-testid": 'viewAmenitiesText' }))] }));
};

var _path$6;
function _extends$6() { _extends$6 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }
var SvgScissor = function SvgScissor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6 || (_path$6 = /*#__PURE__*/React.createElement("path", {
    d: "m14.477 10.15-.241-.921a.87.87 0 0 0-.231-.398.87.87 0 0 0-.399-.231l-8.35-1.928a2.605 2.605 0 0 0-.923-1.12c-.409-.28-.87-.424-1.299-.403-.428.021-.793.205-1.026.518-.232.312-.317.73-.238 1.178.079.447.316.891.668 1.25a2.45 2.45 0 0 0 1.24.695c.447.09.871.017 1.192-.206.32-.223.514-.58.547-1.005l1.683.397 1.345 5.785a.87.87 0 0 0 .231.398.87.87 0 0 0 .399.231l.919.243-1.19-5.674 5.673 1.191ZM2.99 7.577a1.314 1.314 0 0 1-.324-.523.923.923 0 0 1-.016-.545.66.66 0 0 1 .297-.384.798.798 0 0 1 .51-.093c.19.024.382.104.552.229.171.125.313.29.407.474.095.184.139.379.126.56a.707.707 0 0 1-.2.456c-.156.155-.386.224-.64.192a1.26 1.26 0 0 1-.712-.366ZM7.809 6.413l-.23-.996c.424-.033.782-.227 1.005-.547.223-.32.296-.744.206-1.192a2.45 2.45 0 0 0-.696-1.24 2.424 2.424 0 0 0-1.25-.668c-.446-.08-.865.006-1.177.239-.313.232-.497.597-.518 1.025-.021.428.122.89.403 1.3.28.409.679.737 1.12.923l.203.949.934.207ZM6.394 4.175a1.314 1.314 0 0 1-.324-.523.923.923 0 0 1-.016-.546.66.66 0 0 1 .297-.384.798.798 0 0 1 .51-.093c.19.024.381.104.552.23.17.124.312.29.407.473.095.184.138.379.125.56a.707.707 0 0 1-.199.456c-.156.155-.386.224-.64.19a1.258 1.258 0 0 1-.71-.365l-.002.002Z",
    fill: "#DC1125"
  })));
};

var CouponContainer = styled.div(templateObject_1$g || (templateObject_1$g = __makeTemplateObject(["\n", "\nwidth: 194px;\nheight: 32px;\ndisplay: flex;\nbackground-color: var(--hint-of-red);\nmargin-top: 8px;\n\n:first-child {\n  margin-top: unset; \n}\n"], ["\n", "\nwidth: 194px;\nheight: 32px;\ndisplay: flex;\nbackground-color: var(--hint-of-red);\nmargin-top: 8px;\n\n:first-child {\n  margin-top: unset; \n}\n"])), Border1pxGray);
var Content$2 = styled.div(templateObject_2$e || (templateObject_2$e = __makeTemplateObject(["\nmargin-top: 8px;\nmargin-left: 12px;\ndisplay: flex;\nalign-items: flex-start;\nmin-width: 172px;\n"], ["\nmargin-top: 8px;\nmargin-left: 12px;\ndisplay: flex;\nalign-items: flex-start;\nmin-width: 172px;\n"])));
var ScissorIcon$1 = styled(SvgScissor)(templateObject_3$b || (templateObject_3$b = __makeTemplateObject(["\nwidth: 16px;\nheight: 16px;\n"], ["\nwidth: 16px;\nheight: 16px;\n"])));
var Text$1 = styled.div(templateObject_4$b || (templateObject_4$b = __makeTemplateObject(["\n", "\nmin-height: 16px;\nmargin-left: 5px;\nletter-spacing: 0;\nline-height: 16px;\n"], ["\n", "\nmin-height: 16px;\nmargin-left: 5px;\nletter-spacing: 0;\nline-height: 16px;\n"])), OpensansNormalTundora12px);
var templateObject_1$g, templateObject_2$e, templateObject_3$b, templateObject_4$b;

function Coupon(props) {
    props.className;
    return (jsxRuntime.exports.jsx(CouponContainer, { children: jsxRuntime.exports.jsxs(Content$2, { children: [jsxRuntime.exports.jsx(ScissorIcon$1, {}), jsxRuntime.exports.jsx(Text$1, { children: "COUPON APPLIED (RU123)" })] }) }));
}

var _path$5;
function _extends$5() { _extends$5 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }
var SvgCheckmark = function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5 || (_path$5 = /*#__PURE__*/React.createElement("path", {
    d: "m6.076 12.794-3.9-3.91a.602.602 0 0 1 0-.85l.848-.85a.599.599 0 0 1 .849 0L6.5 9.816l5.627-5.64a.6.6 0 0 1 .849 0l.848.85a.602.602 0 0 1 0 .85l-6.9 6.917a.599.599 0 0 1-.848 0Z",
    fill: "#DC1125"
  })));
};

var BenefitContainer = styled.div(templateObject_1$f || (templateObject_1$f = __makeTemplateObject(["\n  display: flex;\n  align-items: flex-start;\n  min-width: 248px;\n  margin-top: 8px;\n"], ["\n  display: flex;\n  align-items: flex-start;\n  min-width: 248px;\n  margin-top: 8px;\n"])));
var CheckmarkIcon = styled(SvgCheckmark)(templateObject_2$d || (templateObject_2$d = __makeTemplateObject(["\n   flex: 0 0 1em;\n"], ["\n   flex: 0 0 1em;\n"])));
var ScissorIcon = styled(SvgScissor)(templateObject_3$a || (templateObject_3$a = __makeTemplateObject(["\n   flex: 0 0 1em;\n"], ["\n   flex: 0 0 1em;\n"])));
var Text = styled.div(templateObject_4$a || (templateObject_4$a = __makeTemplateObject(["\n  ", "\n  min-height: 16px;\n  margin-left: 8px;\n  letter-spacing: 0;\n  line-height: 16px;\n"], ["\n  ", "\n  min-height: 16px;\n  margin-left: 8px;\n  letter-spacing: 0;\n  line-height: 16px;\n"])), OpensansNormalTundora12px);
var templateObject_1$f, templateObject_2$d, templateObject_3$a, templateObject_4$a;

function Benefit(props) {
    var benefit = props.benefit;
    return (jsxRuntime.exports.jsxs(BenefitContainer, { children: [benefit.iconName === "checkmark" ?
                jsxRuntime.exports.jsx(CheckmarkIcon, {}) :
                jsxRuntime.exports.jsx(ScissorIcon, {}), jsxRuntime.exports.jsx(Text, { children: benefit.text })] }));
}

var _path$4;
function _extends$4() { _extends$4 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }
var SvgVifpOffersAndPromotions = function SvgVifpOffersAndPromotions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4({
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4 || (_path$4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.083 11.848V3.875C2.083 2.839 2.958 2 4.036 2h8.306c.518 0 1.015.198 1.381.55l8.621 8.276c.763.732.763 1.92 0 2.651l-8.305 7.974c-.763.732-2 .732-2.762 0l-8.622-8.277a1.838 1.838 0 0 1-.572-1.326ZM6.641 4.5c-1.08 0-1.954.84-1.954 1.875 0 1.036.875 1.875 1.954 1.875 1.078 0 1.953-.84 1.953-1.875 0-1.036-.875-1.875-1.953-1.875Z",
    fill: "#DC1125"
  })));
};

var OffersContainer = styled.div(templateObject_1$e || (templateObject_1$e = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  background-color: #ffffff;\n"], ["\n  display: flex;\n  flex-direction: column;\n  background-color: #ffffff;\n"])));
var SaleName = styled.div(templateObject_2$c || (templateObject_2$c = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var VifpOffersAndPromotionsIcon = styled(SvgVifpOffersAndPromotions)(templateObject_3$9 || (templateObject_3$9 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n"], ["\n  width: 100%;\n  height: 100%;\n"])));
var Title$2 = styled.div(templateObject_4$9 || (templateObject_4$9 = __makeTemplateObject(["\n  margin-left: 8px;\n  font-family: var(--font-family-open_sans);\n  font-weight: 700;\n  color: var(--tundora);\n  font-size: var(--font-size-16);\n  letter-spacing: 0;\n  line-height: 20px;\n"], ["\n  margin-left: 8px;\n  font-family: var(--font-family-open_sans);\n  font-weight: 700;\n  color: var(--tundora);\n  font-size: var(--font-size-16);\n  letter-spacing: 0;\n  line-height: 20px;\n"])));
var Content$1 = styled.div(templateObject_5$8 || (templateObject_5$8 = __makeTemplateObject(["\n  ", "\n  line-height: 18px;\n"], ["\n  ", "\n  line-height: 18px;\n"])), OpensansNormalTundora14px);
var LinkToggleContainer = styled.div(templateObject_6$6 || (templateObject_6$6 = __makeTemplateObject(["\n  margin-top: var(--spacing_token_xs);\n  & button {\n    font-size: 12px;\n    line-height: 16px;\n  }\n"], ["\n  margin-top: var(--spacing_token_xs);\n  & button {\n    font-size: 12px;\n    line-height: 16px;\n  }\n"])));
var Title1 = styled.div(templateObject_7$5 || (templateObject_7$5 = __makeTemplateObject(["\n  margin-top: var(--spacing_token_s);\n  display: flex;\n"], ["\n  margin-top: var(--spacing_token_s);\n  display: flex;\n"])));
var Title2 = styled.div(templateObject_8$3 || (templateObject_8$3 = __makeTemplateObject(["\n  ", "\n  letter-spacing: 0;\n  line-height: 16px;\n"], ["\n  ", "\n  letter-spacing: 0;\n  line-height: 16px;\n"])), OpensansBoldTundora12px);
var Benefits = styled.div(templateObject_9$3 || (templateObject_9$3 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n"], ["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n"])));
var TheFinePrint = styled.div(templateObject_10$3 || (templateObject_10$3 = __makeTemplateObject(["\n  margin-top: var(--spacing_token_s);\n  display: flex;\n  flex-direction: column;\n"], ["\n  margin-top: var(--spacing_token_s);\n  display: flex;\n  flex-direction: column;\n"])));
var Title3 = styled.div(templateObject_11$2 || (templateObject_11$2 = __makeTemplateObject(["\n  ", "\n  letter-spacing: 0;\n  line-height: 16px;\n"], ["\n  ", "\n  letter-spacing: 0;\n  line-height: 16px;\n"])), OpensansBoldTundora12px);
var Content1 = styled.div(templateObject_12$2 || (templateObject_12$2 = __makeTemplateObject(["\n  margin-top: var(--spacing_token_xxs);\n  display: flex;\n  flex-direction: column;\n"], ["\n  margin-top: var(--spacing_token_xxs);\n  display: flex;\n  flex-direction: column;\n"])));
var Line1 = styled.div(templateObject_13$2 || (templateObject_13$2 = __makeTemplateObject(["\n  ", "\n  letter-spacing: 0;\n  line-height: 16px;\n"], ["\n  ", "\n  letter-spacing: 0;\n  line-height: 16px;\n"])), OpensansNormalTundora12px);
styled.p(templateObject_14$2 || (templateObject_14$2 = __makeTemplateObject(["\n  ", "\n  margin-top: var(--spacing_token_xs);\n  letter-spacing: 0;\n  line-height: 16px;\n"], ["\n  ", "\n  margin-top: var(--spacing_token_xs);\n  letter-spacing: 0;\n  line-height: 16px;\n"])), OpensansNormalTundora12px);
styled.div(templateObject_15$2 || (templateObject_15$2 = __makeTemplateObject(["\n  ", "\n  margin-top: var(--spacing_token_xs);\n  letter-spacing: 0;\n  line-height: 16px;\n"], ["\n  ", "\n  margin-top: var(--spacing_token_xs);\n  letter-spacing: 0;\n  line-height: 16px;\n"])), OpensansNormalTundora12px);
var Terms = styled(PlainButton)(templateObject_16$1 || (templateObject_16$1 = __makeTemplateObject(["\n  width: 124px;\n  height: 16px;\n  margin-top: 8px;\n  font-family: var(--font-family-open_sans);\n  font-weight: 400;\n  color: #10559a;\n  font-size: var(--font-size-12);\n  letter-spacing: 0.01px;\n  line-height: 16px;\n  text-decoration: underline;\n  white-space: nowrap;\n"], ["\n  width: 124px;\n  height: 16px;\n  margin-top: 8px;\n  font-family: var(--font-family-open_sans);\n  font-weight: 400;\n  color: #10559a;\n  font-size: var(--font-size-12);\n  letter-spacing: 0.01px;\n  line-height: 16px;\n  text-decoration: underline;\n  white-space: nowrap;\n"])));
var VifpIconWrapper = styled.div(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n  width: 24px;\n  height: 24px;\n"], ["\n  width: 24px;\n  height: 24px;\n"])));
var ModalContent = styled.div(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n  display: flex;\n  width: 100%;\n  position: relative;\n  margin: 0 auto;\n"], ["\n  display: flex;\n  width: 100%;\n  position: relative;\n  margin: 0 auto;\n"])));
var ContentContainer$1 = styled.div(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n  flex-flow: column wrap;\n  flex-grow: 1;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  row-gap: 24px;\n"], ["\n  flex-flow: column wrap;\n  flex-grow: 1;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  row-gap: 24px;\n"])));
var HeadingContent = styled.div(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n  flex-flow: column wrap;\n  flex-grow: 1;\n  height: 100%;\n  display: flex;\n  row-gap: 24px;\n  align-self: stretch;\n"], ["\n  flex-flow: column wrap;\n  flex-grow: 1;\n  height: 100%;\n  display: flex;\n  row-gap: 24px;\n  align-self: stretch;\n"])));
var HeadingWrapper$1 = styled.div(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  height : fit-content;\n  flex: 0 0 40%;\n"], ["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  height : fit-content;\n  flex: 0 0 40%;\n"])));
styled.div(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n  ", "\n  font-size: var(--font-size-24);\n  min-height: 28px;\n  text-align: center;\n  letter-spacing: 0;\n  width: 170px;\n  justify-content: space-between;\n  line-height: 28px;\n  margin-right:  var(--spacing_token_m);\n  ", " {\n    font-size: var(--font-size-34);\n    width: 100%;\n  }\n"], ["\n  ", "\n  font-size: var(--font-size-24);\n  min-height: 28px;\n  text-align: center;\n  letter-spacing: 0;\n  width: 170px;\n  justify-content: space-between;\n  line-height: 28px;\n  margin-right:  var(--spacing_token_m);\n  ", " {\n    font-size: var(--font-size-34);\n    width: 100%;\n  }\n"])), TempostdHeavycondensedNormalToryBlu, up("md"));
styled.p(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n  ", "\n  min-height: 36px;\n  width: 227px;\n  text-align: center;\n  letter-spacing: 0;\n  line-height: 18px;\n"], ["\n  ", "\n  min-height: 36px;\n  width: 227px;\n  text-align: center;\n  letter-spacing: 0;\n  line-height: 18px;\n"])), OpensansNormalTundora14px);
styled.div(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n  flex: 0 0 60%;\n  display: flex;\n"], ["\n  flex: 0 0 60%;\n  display: flex;\n"])));
var ModalCloseButtonContainer = styled.div(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n  display: flex;\n  margin-left: auto;\n"], ["\n  display: flex;\n  margin-left: auto;\n"])));
var CloseButton$1 = styled.button(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n  display: flex;\n  ", "\n"], ["\n  display: flex;\n  ", "\n"])), PlainButtonStyle);
var HorizontalDividerLight$1 = styled.div(templateObject_27 || (templateObject_27 = __makeTemplateObject(["\n  width: 100%;\n  height: 1px;\n  margin-top: 24px;\n  background-color: var(--silver);\n\n"], ["\n  width: 100%;\n  height: 1px;\n  margin-top: 24px;\n  background-color: var(--silver);\n\n"])));
var templateObject_1$e, templateObject_2$c, templateObject_3$9, templateObject_4$9, templateObject_5$8, templateObject_6$6, templateObject_7$5, templateObject_8$3, templateObject_9$3, templateObject_10$3, templateObject_11$2, templateObject_12$2, templateObject_13$2, templateObject_14$2, templateObject_15$2, templateObject_16$1, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27;

var Offers = function (props) {
    var _a;
    var _b = __read(useState(false), 2), isExpanded = _b[0], setIsExpanded = _b[1];
    var _c = __read(useState(false), 2), isBrowser = _c[0], setIsBrowser = _c[1];
    var _d = __read(useState(false), 2), isTermsAndConditionsOpen = _d[0], setIsTermsAndConditionsOpen = _d[1];
    var bp = useBreakpoints();
    function showViewMoreClickHandler(event) {
        event.preventDefault();
        setIsExpanded(!isExpanded);
    }
    useEffect(function () {
        setIsExpanded(false);
    }, [props]);
    useEffect(function () {
        setIsBrowser(true);
    }, []);
    var onAfterOpen = function () {
        document.body.style.overflow = 'hidden';
    };
    var onAfterClose = function () {
        document.body.style.overflow = 'unset';
    };
    var customStyles = {
        overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.66)",
            zIndex: 10000,
            position: 'fixed',
            width: 'auto',
            display: 'grid',
            gridTemplateColumns: bp.isMobile ? 'repeat(4,1fr)' : bp.isTablet ? 'repeat(8,1fr)' : bp.isXXl ? '1fr repeat(12, 88px) 1fr' : 'repeat(12,1fr)',
            gridColumnGap: '24px',
            margin: 'auto',
            padding: bp.isMobile ? '0 var(--spacing_token_s)' : '0',
            alignItems: 'flex-start',
            overflow: 'auto'
        },
        content: {
            inset: 'var(--spacing_token_3xl) 0 auto',
            padding: bp.isMobile ? 'var(--spacing_token_m)' : 'var(--spacing_token_2xl)',
            boxShadow: '0px 0px 6px #0000002e',
            border: 'none',
            position: 'relative',
            borderRadius: '8px',
            gridColumnStart: (bp.isMobile) ? "1" : bp.isTablet ? "2" : bp.isXXl ? "4" : "3",
            gridColumnEnd: (bp.isMobile) ? "span 4" : bp.isTablet ? "span 6" : "span 8",
            display: 'grid'
        }
    };
    return (jsxRuntime.exports.jsxs(OffersContainer, { children: [jsxRuntime.exports.jsxs(SaleName, { children: [jsxRuntime.exports.jsx(VifpIconWrapper, { children: jsxRuntime.exports.jsx(VifpOffersAndPromotionsIcon, {}) }), jsxRuntime.exports.jsx(Title$2, { children: props.title1 })] }), jsxRuntime.exports.jsxs(Content$1, { children: [props.showCoupons && (jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [jsxRuntime.exports.jsx(Coupon, {}), jsxRuntime.exports.jsx(Coupon, {})] })), props.showViewMore && (jsxRuntime.exports.jsx(LinkToggleContainer, { children: jsxRuntime.exports.jsx(LinkToggle, __assign({ direction: isExpanded ? "up" : "down", ariaExpanded: isExpanded, onClick: showViewMoreClickHandler }, { children: "View more offer details" })) })), (!props.showViewMore || isExpanded) && (jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [jsxRuntime.exports.jsx(Title1, { children: jsxRuntime.exports.jsx(Title2, { children: props.title2 }) }), jsxRuntime.exports.jsx(Benefits, { children: props.benefitsProps.map(function (benefit, index) {
                                    return jsxRuntime.exports.jsx(Benefit, { benefit: benefit, index: index }, index);
                                }) }), jsxRuntime.exports.jsxs(TheFinePrint, { children: [jsxRuntime.exports.jsx(Title3, { children: props.title3 }), jsxRuntime.exports.jsxs(Content1, { children: [props.line1 && (jsxRuntime.exports.jsx(Line1, { children: props.line1 })), props.line2 && (jsxRuntime.exports.jsx(Line1, { children: props.line2 })), props.line3 && (jsxRuntime.exports.jsx(Line1, { children: props.line3 })), props.additionalLines.map(function (line, index) {
                                                return jsxRuntime.exports.jsx(Line1, { children: line }, index);
                                            }), (props === null || props === void 0 ? void 0 : props.termsDisclaimer.length) > 0 && (jsxRuntime.exports.jsx(Terms, __assign({ "aria-label": 'Terms and Conditions', "data-testid": 'termsAndConditionsButton', onClick: function () { return handleTermsAndConditionsModal(); } }, { children: props === null || props === void 0 ? void 0 : props.terms }))), isBrowser && (jsxRuntime.exports.jsx(SharedModal, __assign({ heading: (_a = props === null || props === void 0 ? void 0 : props.terms) === null || _a === void 0 ? void 0 : _a.toLocaleUpperCase(), testId: "tooTip", "data-testid": 'termsAndConditionsModal', closeAriaLabel: "Close Terms and Conditions dialog", customStyles: customStyles, onAfterOpen: onAfterOpen, onAfterClose: onAfterClose, modalIsOpen: isTermsAndConditionsOpen, isDefaultModal: true, shouldCloseOnOverlayClick: true, shouldCloseOnEsc: true, onClose: function () { handleTermsAndConditionsModal(); } }, { children: jsxRuntime.exports.jsx(ModalContent, { children: jsxRuntime.exports.jsx(ContentContainer$1, { children: jsxRuntime.exports.jsxs(HeadingWrapper$1, { children: [jsxRuntime.exports.jsxs(HeadingContent, { children: [jsxRuntime.exports.jsx(HorizontalDividerLight$1, {}), jsxRuntime.exports.jsx(Content$1, { dangerouslySetInnerHTML: { __html: props === null || props === void 0 ? void 0 : props.termsDisclaimer } })] }), jsxRuntime.exports.jsx(ModalCloseButtonContainer, { children: jsxRuntime.exports.jsx(CloseButton$1, { "aria-label": 'close button', "data-testid": 'closeButton' }) })] }) }) }) })))] })] })] }))] })] }));
    function handleTermsAndConditionsModal() {
        setIsTermsAndConditionsOpen(!isTermsAndConditionsOpen);
    }
};

var _path$3;
function _extends$3() { _extends$3 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
var SvgRedTag = function SvgRedTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3({
    width: 12,
    height: 12,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3 || (_path$3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.879V1.5A1.5 1.5 0 0 1 1.5 0h6.379a1.5 1.5 0 0 1 1.06.44l6.622 6.62a1.5 1.5 0 0 1 0 2.122l-6.379 6.379a1.5 1.5 0 0 1-2.121 0L.439 8.939A1.5 1.5 0 0 1 0 7.88ZM3.5 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z",
    fill: "#DC1125"
  })));
};

var MerchandisingChip$1 = styled.div(templateObject_1$d || (templateObject_1$d = __makeTemplateObject(["\n  ", "\n  width: 100%;\n  text-align: center;\n  text-decoration: none;\n  height: 30px;\n  display: flex;\n  padding: 6px 12px;\n  align-items: flex-start;\n  min-width: 88px;\n  white-space:'nowrap';\n  vertical-align: middle;\n  -webkit-appearance: none;\n  border-radius:  19px;\n  color:  var(--tundora);\n  background-color: var(--white); \n"], ["\n  ", "\n  width: 100%;\n  text-align: center;\n  text-decoration: none;\n  height: 30px;\n  display: flex;\n  padding: 6px 12px;\n  align-items: flex-start;\n  min-width: 88px;\n  white-space:'nowrap';\n  vertical-align: middle;\n  -webkit-appearance: none;\n  border-radius:  19px;\n  color:  var(--tundora);\n  background-color: var(--white); \n"])), Border1pxOutlineStructuresoutlineGr);
var Icon = styled(SvgRedTag)(templateObject_2$b || (templateObject_2$b = __makeTemplateObject(["\n  align-self: center;\n  margin-right: var(--spacing_token_xxs); \n\n  & path {\n    stroke:", ";\n    fill: ", ";\n  }\n"], ["\n  align-self: center;\n  margin-right: var(--spacing_token_xxs); \n\n  & path {\n    stroke:", ";\n    fill: ", ";\n  }\n"])), function (props) { return props.$iconColor; }, function (props) { return props.$iconColor; });
var templateObject_1$d, templateObject_2$b;

var MerchandisingChip = function (props) {
    return (jsxRuntime.exports.jsx(MerchandisingChip$1, __assign({ "data-testid": props.testId, "aria-label": props.ariaLabel }, { children: jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [jsxRuntime.exports.jsx(Icon, { "$iconColor": props.iconColor, "aria-hidden": 'true' }), props.children] }) })));
};

var _path$2, _path2;
function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
var SvgCircleHeartEmpty = function SvgCircleHeartEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2 || (_path$2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 20c0 11.046-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0s20 8.954 20 20Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "circle-heart-empty_svg__heart",
    d: "m28.441 21.566-7.545 7.801c-.494.51-1.302.51-1.796 0l-7.544-7.801c-2.189-2.265-2.068-6.01.36-8.11 2.12-1.835 5.364-1.505 7.315.51l.77.794.768-.794c1.951-2.014 5.196-2.345 7.316-.51 2.427 2.1 2.548 5.845.356 8.11Z",
    fill: "#fff",
    stroke: "#10559A",
    strokeWidth: 2
  })));
};

var HeartCircleContainer = styled.button(templateObject_1$c || (templateObject_1$c = __makeTemplateObject(["\n    position: relative;\n    display: flex;\n    margin-left: auto;\n    cursor: pointer;\n    background: none;\n    appearance: none;\n    border: none;\n    padding: 0;\n    margin: 0;\n    font-family: inherit;\n    color: inherit;\n    overflow: visible;\n    \n    &:focus {\n        box-shadow: 0 0 0 3px var(--bondi-blue);\n      }\n"], ["\n    position: relative;\n    display: flex;\n    margin-left: auto;\n    cursor: pointer;\n    background: none;\n    appearance: none;\n    border: none;\n    padding: 0;\n    margin: 0;\n    font-family: inherit;\n    color: inherit;\n    overflow: visible;\n    \n    &:focus {\n        box-shadow: 0 0 0 3px var(--bondi-blue);\n      }\n"])));
var Heart = styled(SvgCircleHeartEmpty)(templateObject_2$a || (templateObject_2$a = __makeTemplateObject(["\n  .circle-heart-empty_svg__heart {\n    stroke:", ";\n    fill: ", ";\n  }\n"], ["\n  .circle-heart-empty_svg__heart {\n    stroke:", ";\n    fill: ", ";\n  }\n"])), function (props) { return props.$isSaved && 'var(--tory-blue)'; }, function (props) { return props.$isSaved && 'var(--tory-blue)'; });
var templateObject_1$c, templateObject_2$a;

var SaveItinerary = function (props) {
    return (jsxRuntime.exports.jsx(HeartCircleContainer, __assign({ "aria-checked": props.isSaved, role: "checkbox", "aria-label": props.ariaLabel, "data-testid": props.testId, onClick: props.clickHandler }, { children: jsxRuntime.exports.jsx(Heart, { "$isSaved": props.isSaved, "aria-hidden": 'true' }) })));
};

var ItineraryTitleFontSizeMap$1 = new Map([
    ['small', { sm: 'var(--font-size-16)', upSm: 'var(--font-size-16)' }],
    ['medium', { sm: 'var(--font-size-18)', upSm: 'var(--font-size-20)' }],
    ['large', { sm: 'var(--font-size-18)', upSm: 'var(--font-size-24)' }],
]);
var ItineraryTitleLineHeightMap$1 = new Map([
    ['small', { sm: '20px', upSm: '20px' }],
    ['medium', { sm: '22px', upSm: '24px' }],
    ['large', { sm: '18px', upSm: '28px' }],
]);
var EventFontSizeMap$1 = new Map([
    ['small', { sm: 'var(--font-size-12)', upSm: 'var(--font-size-12)' }],
    ['medium', { sm: 'var(--font-size-14)', upSm: 'var(--font-size-14)' }],
    ['large', { sm: 'var(--font-size-14)', upSm: 'var(--font-size-16)' }],
]);
var EventLineHeightMap$1 = new Map([
    ['small', '16px'],
    ['medium', '18px'],
    ['large', '20px'],
]);
var ContentWrapperMinHeightMap$1 = new Map([
    ['small', 'auto'],
    ['medium', 'auto'],
    ['large', '68px'],
]);
var NonWrap$1 = css(templateObject_1$b || (templateObject_1$b = __makeTemplateObject(["\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"], ["\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"])));
var Title$1 = styled.div(templateObject_2$9 || (templateObject_2$9 = __makeTemplateObject(["\n  font-weight: 700;\n  color: var(--tundora); \n  font-size: ", ";\n  line-height: ", ";\n  \n  ", ";\n  \n  ", " { \n    font-size: ", ";\n    line-height: ", ";\n  } \n  ", " { \n    font-size: ", ";\n    line-height: ", ";\n  } \n"], ["\n  font-weight: 700;\n  color: var(--tundora); \n  font-size: ", ";\n  line-height: ", ";\n  \n  ", ";\n  \n  ", " { \n    font-size: ", ";\n    line-height: ", ";\n  } \n  ", " { \n    font-size: ", ";\n    line-height: ", ";\n  } \n"])), function (props) { var _a; return (_a = ItineraryTitleFontSizeMap$1.get(props.$size)) === null || _a === void 0 ? void 0 : _a.sm; }, function (props) { var _a; return (_a = ItineraryTitleLineHeightMap$1.get(props.$size)) === null || _a === void 0 ? void 0 : _a.sm; }, function (props) { return props.$nonWrapItineraryTitle && NonWrap$1; }, up('md'), function (props) { var _a; return (_a = ItineraryTitleFontSizeMap$1.get(props.$size)) === null || _a === void 0 ? void 0 : _a.upSm; }, function (props) { var _a; return (_a = ItineraryTitleLineHeightMap$1.get(props.$size)) === null || _a === void 0 ? void 0 : _a.upSm; }, only('md'), function (props) { var _a; return (_a = ItineraryTitleFontSizeMap$1.get(props.$size)) === null || _a === void 0 ? void 0 : _a.upSm; }, function (props) { var _a; return (_a = ItineraryTitleLineHeightMap$1.get(props.$size)) === null || _a === void 0 ? void 0 : _a.upSm; });
var EventTitle$1 = styled.div(templateObject_3$8 || (templateObject_3$8 = __makeTemplateObject(["\n  font-family: var(--font-family-open_sans);\n  font-style: normal;\n  font-weight: 400;\n  font-size: ", ";\n  line-height: ", ";\n  color: var(--tundora);  \n  ", " {\n    font-size: ", ";\n  }  \n"], ["\n  font-family: var(--font-family-open_sans);\n  font-style: normal;\n  font-weight: 400;\n  font-size: ", ";\n  line-height: ", ";\n  color: var(--tundora);  \n  ", " {\n    font-size: ", ";\n  }  \n"])), function (props) { var _a; return (_a = EventFontSizeMap$1.get(props.$size)) === null || _a === void 0 ? void 0 : _a.sm; }, function (props) { return EventLineHeightMap$1.get(props.$size); }, up('sm'), function (props) { var _a; return (_a = EventFontSizeMap$1.get(props.$size)) === null || _a === void 0 ? void 0 : _a.upSm; });
styled.div(templateObject_4$8 || (templateObject_4$8 = __makeTemplateObject(["\n  text-transform: uppercase;\n  background: var(--tundora);\n  color: var(--white);\n  border-radius: 27.7778px;\n  width: 40px;\n  height: 40px;\n  min-width: 40px;\n  font-weight: 400;\n  font-size: var(--font-size-12);;\n  line-height: 16px;\n  text-align: center;\n\n  p {\n    line-height: 1;\n    padding: 8px 5px 0 6px;\n    margin: 0;\n  }\n\n  span {\n    font-weight: bold;\n  }\n"], ["\n  text-transform: uppercase;\n  background: var(--tundora);\n  color: var(--white);\n  border-radius: 27.7778px;\n  width: 40px;\n  height: 40px;\n  min-width: 40px;\n  font-weight: 400;\n  font-size: var(--font-size-12);;\n  line-height: 16px;\n  text-align: center;\n\n  p {\n    line-height: 1;\n    padding: 8px 5px 0 6px;\n    margin: 0;\n  }\n\n  span {\n    font-weight: bold;\n  }\n"])));
styled.div(templateObject_5$7 || (templateObject_5$7 = __makeTemplateObject(["\n  min-height: ", " \n  "], ["\n  min-height: ", " \n  "])), function (props) { return ContentWrapperMinHeightMap$1.get(props.$size); });
var templateObject_1$b, templateObject_2$9, templateObject_3$8, templateObject_4$8, templateObject_5$7;

var ItineraryTitle = function (props) {
    var size = props.size || 'large';
    return (jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [jsxRuntime.exports.jsx(EventTitle$1, __assign({ "$size": size, "data-testid": "cg-event_".concat(props.testId) }, { children: props.eventTitle1 })), jsxRuntime.exports.jsx(EventTitle$1, __assign({ "$size": size }, { children: props.eventTitle2 })), jsxRuntime.exports.jsxs(Title$1, __assign({ "$size": size, "$nonWrapItineraryTitle": props.nonWrapItineraryTitle, "data-testid": "itinerary-title" }, { children: [jsxRuntime.exports.jsxs("span", __assign({ "data-testid": "cg-date_".concat(props.testId) }, { children: ["".concat(props.duration, "-").concat(props.dayText), " "] })), jsxRuntime.exports.jsx("span", __assign({ "data-testid": "cg-region_".concat(props.testId) }, { children: props.regionName })), jsxRuntime.exports.jsxs("span", { children: [" ", props.fromText, " "] }), jsxRuntime.exports.jsx("span", { "data-testid": "cg-departure-port_".concat(props.testId), dangerouslySetInnerHTML: { __html: props.longDeparturePortName } })] }))] }));
};

var _path$1;
function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
var SvgLocationPin = function SvgLocationPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1 || (_path$1 = /*#__PURE__*/React.createElement("path", {
    d: "M7.486 15.064C3.702 9.58 3 9.016 3 7a5 5 0 1 1 10 0c0 2.016-.702 2.579-4.486 8.064a.625.625 0 0 1-1.028 0ZM8 9.084a2.083 2.083 0 1 0 0-4.167 2.083 2.083 0 0 0 0 4.166Z",
    fill: "#464646"
  })));
};

var ItineraryTitleFontSizeMap = new Map([
    ['small', { sm: 'var(--font-size-16)', upSm: 'var(--font-size-16)' }],
    ['medium', { sm: 'var(--font-size-18)', upSm: 'var(--font-size-20)' }],
    ['large', { sm: 'var(--font-size-18)', upSm: 'var(--font-size-24)' }],
]);
var ItineraryTitleLineHeightMap = new Map([
    ['small', { sm: '20px', upSm: '20px' }],
    ['medium', { sm: '22px', upSm: '24px' }],
    ['large', { sm: '18px', upSm: '28px' }],
]);
var ShipNameFontSizeMap = new Map([
    ['small', { sm: 'var(--font-size-12)', upSm: 'var(--font-size-12)' }],
    ['medium', { sm: 'var(--font-size-14)', upSm: 'var(--font-size-14)' }],
    ['large', { sm: 'var(--font-size-14)', upSm: 'var(--font-size-16)' }],
]);
var ShipNameLineHeightMap = new Map([
    ['small', '16px'],
    ['medium', '18px'],
    ['large', '20px'],
]);
var EventFontSizeMap = new Map([
    ['small', { sm: 'var(--font-size-12)', upSm: 'var(--font-size-12)' }],
    ['medium', { sm: 'var(--font-size-14)', upSm: 'var(--font-size-14)' }],
    ['large', { sm: 'var(--font-size-14)', upSm: 'var(--font-size-16)' }],
]);
var EventLineHeightMap = new Map([
    ['small', '16px'],
    ['medium', '18px'],
    ['large', '20px'],
]);
var ContentWrapperMinHeightMap = new Map([
    ['small', 'auto'],
    ['medium', 'auto'],
    ['large', '68px'],
]);
var NonWrap = css(templateObject_1$a || (templateObject_1$a = __makeTemplateObject(["\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"], ["\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"])));
var CruiseGlanceContainer = styled.div(templateObject_2$8 || (templateObject_2$8 = __makeTemplateObject(["\n  width: 100%;\n  text-align: left;\n  display: flex;\n  flex-direction: column;\n  font-family: var(--font-family-open_sans);\n"], ["\n  width: 100%;\n  text-align: left;\n  display: flex;\n  flex-direction: column;\n  font-family: var(--font-family-open_sans);\n"])));
styled.div(templateObject_3$7 || (templateObject_3$7 = __makeTemplateObject(["\n  font-weight: 700;\n  color: var(--tundora); \n  font-size: ", ";\n  line-height: ", ";\n  \n  ", ";\n  \n  ", " { \n    font-size: ", ";\n    line-height: ", ";\n  } \n  ", " { \n    font-size: ", ";\n    line-height: ", ";\n  } \n"], ["\n  font-weight: 700;\n  color: var(--tundora); \n  font-size: ", ";\n  line-height: ", ";\n  \n  ", ";\n  \n  ", " { \n    font-size: ", ";\n    line-height: ", ";\n  } \n  ", " { \n    font-size: ", ";\n    line-height: ", ";\n  } \n"])), function (props) { var _a; return (_a = ItineraryTitleFontSizeMap.get(props.$size)) === null || _a === void 0 ? void 0 : _a.sm; }, function (props) { var _a; return (_a = ItineraryTitleLineHeightMap.get(props.$size)) === null || _a === void 0 ? void 0 : _a.sm; }, function (props) { return props.$nonWrapItineraryTitle && NonWrap; }, up('md'), function (props) { var _a; return (_a = ItineraryTitleFontSizeMap.get(props.$size)) === null || _a === void 0 ? void 0 : _a.upSm; }, function (props) { var _a; return (_a = ItineraryTitleLineHeightMap.get(props.$size)) === null || _a === void 0 ? void 0 : _a.upSm; }, only('md'), function (props) { var _a; return (_a = ItineraryTitleFontSizeMap.get(props.$size)) === null || _a === void 0 ? void 0 : _a.upSm; }, function (props) { var _a; return (_a = ItineraryTitleLineHeightMap.get(props.$size)) === null || _a === void 0 ? void 0 : _a.upSm; });
var ShipName = styled.div(templateObject_4$7 || (templateObject_4$7 = __makeTemplateObject(["\n  font-family: var(--font-family-open_sans);\n  font-style: normal;\n  font-weight: 700;\n  font-size: ", ";\n  line-height: ", ";\n  color: var(--tundora);\n  ", " {\n    font-size: ", ";\n  }  \n"], ["\n  font-family: var(--font-family-open_sans);\n  font-style: normal;\n  font-weight: 700;\n  font-size: ", ";\n  line-height: ", ";\n  color: var(--tundora);\n  ", " {\n    font-size: ", ";\n  }  \n"])), function (props) { var _a; return (_a = ShipNameFontSizeMap.get(props.$size)) === null || _a === void 0 ? void 0 : _a.sm; }, function (props) { return ShipNameLineHeightMap.get(props.$size); }, up('sm'), function (props) { var _a; return (_a = ShipNameFontSizeMap.get(props.$size)) === null || _a === void 0 ? void 0 : _a.upSm; });
styled.div(templateObject_5$6 || (templateObject_5$6 = __makeTemplateObject(["\n  font-family: var(--font-family-open_sans);\n  font-style: normal;\n  font-weight: 400;\n  font-size: ", ";\n  line-height: ", ";\n  color: var(--tundora);  \n  ", " {\n    font-size: ", ";\n  }  \n"], ["\n  font-family: var(--font-family-open_sans);\n  font-style: normal;\n  font-weight: 400;\n  font-size: ", ";\n  line-height: ", ";\n  color: var(--tundora);  \n  ", " {\n    font-size: ", ";\n  }  \n"])), function (props) { var _a; return (_a = EventFontSizeMap.get(props.$size)) === null || _a === void 0 ? void 0 : _a.sm; }, function (props) { return EventLineHeightMap.get(props.$size); }, up('sm'), function (props) { var _a; return (_a = EventFontSizeMap.get(props.$size)) === null || _a === void 0 ? void 0 : _a.upSm; });
styled.div(templateObject_6$5 || (templateObject_6$5 = __makeTemplateObject(["\n  text-transform: uppercase;\n  background: var(--tundora);\n  color: var(--white);\n  border-radius: 27.7778px;\n  width: 40px;\n  height: 40px;\n  min-width: 40px;\n  font-weight: 400;\n  font-size: var(--font-size-12);;\n  line-height: 16px;\n  text-align: center;\n\n  p {\n    line-height: 1;\n    padding: 8px 5px 0 6px;\n    margin: 0;\n  }\n\n  span {\n    font-weight: bold;\n  }\n"], ["\n  text-transform: uppercase;\n  background: var(--tundora);\n  color: var(--white);\n  border-radius: 27.7778px;\n  width: 40px;\n  height: 40px;\n  min-width: 40px;\n  font-weight: 400;\n  font-size: var(--font-size-12);;\n  line-height: 16px;\n  text-align: center;\n\n  p {\n    line-height: 1;\n    padding: 8px 5px 0 6px;\n    margin: 0;\n  }\n\n  span {\n    font-weight: bold;\n  }\n"])));
var Wrapper = styled.div(templateObject_7$4 || (templateObject_7$4 = __makeTemplateObject(["\n  display: flex;\n  font-size: var(--font-size-14);\n  line-height: 18px;\n  margin-top: var(--spacing_token_xs); \n"], ["\n  display: flex;\n  font-size: var(--font-size-14);\n  line-height: 18px;\n  margin-top: var(--spacing_token_xs); \n"])));
var Details = styled.div(templateObject_8$2 || (templateObject_8$2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-self:center;\n\n  ", " {\n    flex-direction: row;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-self:center;\n\n  ", " {\n    flex-direction: row;\n  }\n"])), up('lg'));
var Ports = styled.div(templateObject_9$2 || (templateObject_9$2 = __makeTemplateObject(["\n  position: relative;\n  color: var(--tundora);\n"], ["\n  position: relative;\n  color: var(--tundora);\n"])));
var PinIcon = styled(SvgLocationPin)(templateObject_10$2 || (templateObject_10$2 = __makeTemplateObject(["\n  width: 16px;\n  height: 16px;\n  "], ["\n  width: 16px;\n  height: 16px;\n  "])));
var DateRange = styled.div(templateObject_11$1 || (templateObject_11$1 = __makeTemplateObject(["\n  font-weight: 700;\n  margin-top: var(--spacing_token_xxs);\n  \n  ", " {\n    border-left: 1px solid #cbc9c9;\n    padding-left: var(--spacing_token_xs);\n    margin-left: var(--spacing_token_xs);\n    margin-top: 0;\n  }\n  "], ["\n  font-weight: 700;\n  margin-top: var(--spacing_token_xxs);\n  \n  ", " {\n    border-left: 1px solid #cbc9c9;\n    padding-left: var(--spacing_token_xs);\n    margin-left: var(--spacing_token_xs);\n    margin-top: 0;\n  }\n  "])), up('lg'));
var InfoCta = styled.div(templateObject_12$1 || (templateObject_12$1 = __makeTemplateObject(["\n  font-size: 16px;\n  line-height: 20px;\n  margin-top: var(--spacing_token_xs);\n  margin-left: 64px;\n\n  ", " {\n    margin-top: var(--spacing_token_xxs);\n  }\n\n  ", " {\n    margin-left: 70px;\n  }\n  \n  a {\n    text-decoration: underline;\n    color: var(--tory-blue)\n  }\n"], ["\n  font-size: 16px;\n  line-height: 20px;\n  margin-top: var(--spacing_token_xs);\n  margin-left: 64px;\n\n  ", " {\n    margin-top: var(--spacing_token_xxs);\n  }\n\n  ", " {\n    margin-left: 70px;\n  }\n  \n  a {\n    text-decoration: underline;\n    color: var(--tory-blue)\n  }\n"])), up('md'), up('lg'));
var TripOption = styled.span(templateObject_13$1 || (templateObject_13$1 = __makeTemplateObject(["\n  font-family:  var(--font-family-open_sans);\n  font-style: normal;\n  font-weight: 700;\n  font-size: var(--font-size-14);\n  line-height: 18px;\n  color: #464646;\n  text-transform: uppercase;\n  padding-right: var(--spacing_token_xxs);\n  "], ["\n  font-family:  var(--font-family-open_sans);\n  font-style: normal;\n  font-weight: 700;\n  font-size: var(--font-size-14);\n  line-height: 18px;\n  color: #464646;\n  text-transform: uppercase;\n  padding-right: var(--spacing_token_xxs);\n  "])));
var ViewItineraryCtaText = styled.span(templateObject_14$1 || (templateObject_14$1 = __makeTemplateObject(["\n  font-size: var(--font-size-14);\n  line-height: 18px;\n  padding-left: var(--spacing_token_xxs);\n\n  a {\n    text-decoration: underline;\n    color: #10559a;\n    &:focus {\n        box-shadow: 0 0 0 3px var(--bondi-blue);\n      }\n    }\n    "], ["\n  font-size: var(--font-size-14);\n  line-height: 18px;\n  padding-left: var(--spacing_token_xxs);\n\n  a {\n    text-decoration: underline;\n    color: #10559a;\n    &:focus {\n        box-shadow: 0 0 0 3px var(--bondi-blue);\n      }\n    }\n    "])));
var PinIconContainer = styled(IconContainer)(templateObject_15$1 || (templateObject_15$1 = __makeTemplateObject(["\n  margin-right: var(--spacing_token_xxs);\n  "], ["\n  margin-right: var(--spacing_token_xxs);\n  "])));
var ContentWrapper$2 = styled.div(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n  min-height: ", " \n  "], ["\n  min-height: ", " \n  "])), function (props) { return ContentWrapperMinHeightMap.get(props.$size); });
var templateObject_1$a, templateObject_2$8, templateObject_3$7, templateObject_4$7, templateObject_5$6, templateObject_6$5, templateObject_7$4, templateObject_8$2, templateObject_9$2, templateObject_10$2, templateObject_11$1, templateObject_12$1, templateObject_13$1, templateObject_14$1, templateObject_15$1, templateObject_16;

var CruiseGlance = function (props) {
    var size = props.size || 'large';
    return (jsxRuntime.exports.jsxs(CruiseGlanceContainer, __assign({ "data-testid": "cg-cruise-glance_".concat(props.testId) }, { children: [jsxRuntime.exports.jsxs(ContentWrapper$2, __assign({ "$size": size }, { children: [jsxRuntime.exports.jsx(ItineraryTitle, { eventTitle1: props.eventTitle1, eventTitle2: props.eventTitle2, regionName: props.regionName, longDeparturePortName: props.longDeparturePortName, returnPortName: props.returnPortName, duration: props.duration, fromText: props.fromText, dayText: props.dayText, nonWrapItineraryTitle: props.nonWrapItineraryTitle, size: props.size, testId: props.testId }), jsxRuntime.exports.jsx(ShipName, __assign({ "$size": size, "data-testid": "cg-ship_".concat(props.testId) }, { children: props.shipName }))] })), jsxRuntime.exports.jsxs(Wrapper, { children: [jsxRuntime.exports.jsx(PinIconContainer, { children: jsxRuntime.exports.jsx(PinIcon, { "aria-hidden": 'true' }) }), jsxRuntime.exports.jsxs(Details, { children: [jsxRuntime.exports.jsxs(Ports, __assign({ "data-testid": "cg-ports_".concat(props.testId) }, { children: [props.tripOption && jsxRuntime.exports.jsx(TripOption, { children: props.tripOption }), props.startText, " ", props.departurePortName, " >", ' ', props.destinationPorts.map(function (item, index) { return (jsxRuntime.exports.jsxs("span", { children: [item, " > "] }, index)); }), props.endText, " ", props.returnPortName, props.viewItineraryCtaText &&
                                        jsxRuntime.exports.jsx(ViewItineraryCtaText, { children: jsxRuntime.exports.jsx("a", __assign({ href: props.itineraryUrl, "data-testid": "cg-itinerary_".concat(props.testId), "aria-label": props.ariaLabelItineraryCta, tabIndex: 0, type: "button" }, { children: props.viewItineraryCtaText })) })] })), props.dateRange && jsxRuntime.exports.jsx(DateRange, { children: props.dateRange })] })] }), props.infoCtaText &&
                jsxRuntime.exports.jsx(InfoCta, { children: jsxRuntime.exports.jsx("a", __assign({ tabIndex: 0, type: "button" }, { children: props.infoCtaText })) })] })));
};

var checkMarkStyles = css(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["  \n  position: relative;\n  top: 6px;\n  left: 10px;\n  display: block;\n  width: 3px;\n  height: 8px;\n  content: \"\";\n  border-width: 0 2px 2px 0;\n  -webkit-transform: rotate(45deg);  \n"], ["  \n  position: relative;\n  top: 6px;\n  left: 10px;\n  display: block;\n  width: 3px;\n  height: 8px;\n  content: \"\";\n  border-width: 0 2px 2px 0;\n  -webkit-transform: rotate(45deg);  \n"])));
var CheckboxContainer = styled.div(templateObject_2$7 || (templateObject_2$7 = __makeTemplateObject(["\n  display: inline-block;\n  vertical-align: middle;\n"], ["\n  display: inline-block;\n  vertical-align: middle;\n"])));
var StyledCheckbox = styled.input(templateObject_7$3 || (templateObject_7$3 = __makeTemplateObject(["\n  width: 24px;\n  height: 24px;\n  background:", ";\n  transition: all 150ms;\n  border: ", "; \n  box-sizing: border-box;\n  border-radius: 2px;\n  appearance: none;\n  vertical-align: middle;\n\n  ", "\n\n  ", "\n\n", "\n"], ["\n  width: 24px;\n  height: 24px;\n  background:", ";\n  transition: all 150ms;\n  border: ", "; \n  box-sizing: border-box;\n  border-radius: 2px;\n  appearance: none;\n  vertical-align: middle;\n\n  ", "\n\n  ", "\n\n", "\n"])), function (props) { return props.checked ? 'var(--tory-blue)' : 'var(--white)'; }, function (props) { return props.checked ? 'none' : '1px solid var(--gray)'; }, function (props) {
    return !props.disabled && css(templateObject_3$6 || (templateObject_3$6 = __makeTemplateObject(["\n      &:focus {\n        box-shadow: 0 0 0 3px var(--bondi-blue);\n      }\n    "], ["\n      &:focus {\n        box-shadow: 0 0 0 3px var(--bondi-blue);\n      }\n    "])));
}, function (props) {
    return props.checked && (!props.disabled ? css(templateObject_4$6 || (templateObject_4$6 = __makeTemplateObject(["\n      &:after {     \n        border: solid var(--white);\n        ", "  \n      }"], ["\n      &:after {     \n        border: solid var(--white);\n        ", "  \n      }"])), checkMarkStyles) : css(templateObject_5$5 || (templateObject_5$5 = __makeTemplateObject(["\n      &:after {\n        border: solid var(--gray);\n        ", "  \n      }\n      border: none;\n      "], ["\n      &:after {\n        border: solid var(--gray);\n        ", "  \n      }\n      border: none;\n      "])), checkMarkStyles));
}, function (props) {
    return props.disabled && css(templateObject_6$4 || (templateObject_6$4 = __makeTemplateObject([" \n      background: var(--cararra);\n    "], [" \n      background: var(--cararra);\n    "])));
});
var templateObject_1$9, templateObject_2$7, templateObject_3$6, templateObject_4$6, templateObject_5$5, templateObject_6$4, templateObject_7$3;

var CheckBox = React__default.forwardRef(function (props, ref) {
    return (jsxRuntime.exports.jsx(jsxRuntime.exports.Fragment, { children: jsxRuntime.exports.jsx(CheckboxContainer, { children: jsxRuntime.exports.jsx(StyledCheckbox, __assign({ checked: props.isChecked, "aria-checked": props.isChecked, type: "checkbox", "aria-label": props.ariaLabel, "data-testid": props.testId, onChange: props.clickHandler, disabled: props.disabled, ref: ref }, props)) }) }));
});

var Select$1 = styled.select(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject([" \n  ", "\n  ", "\n  ", "  \n  ", "\n  height: ", ";\n  font-weight: ", ";\n  &:focus,\n  &:focus-visible {\n    ", "\n  }\n"], [" \n  ", "\n  ", "\n  ", "  \n  ", "\n  height: ", ";\n  font-weight: ", ";\n  &:focus,\n  &:focus-visible {\n    ", "\n  }\n"])), CustomSelect, CustomBorderErrorStyle, CustomColorErrorStyle, function (props) { return props.selectType == 'transparent' ? Transparent : ''; }, (function (props) { return props.selectSize == 'small' ? '18px' : '48px'; }), function (props) { return props.isOptionPlaceHolder || props.selectType == 'transparent' ? 400 : 700; }, Focus);
var SelectWrapper = styled.div(templateObject_2$6 || (templateObject_2$6 = __makeTemplateObject(["\n  width: 100%;\n  position: relative;\n  font-weight: 700;\n  height: ", ";\n  &::after {     \n    ", "\n    ", "\n    ", "\n    ", "\n  }\n  \n  &:focus,\n  &:focus-visible {\n    ", "\n  }\n"], ["\n  width: 100%;\n  position: relative;\n  font-weight: 700;\n  height: ", ";\n  &::after {     \n    ", "\n    ", "\n    ", "\n    ", "\n  }\n  \n  &:focus,\n  &:focus-visible {\n    ", "\n  }\n"])), (function (props) { return props.selectSize == 'small' ? '18px' : '48px'; }), ArrowStyled, function (props) { return props.arrowColor ? "border-color: var(--".concat(props.arrowColor, ");") : ''; }, function (props) { return props.selectType == 'transparent' ? "right: 4px;" : ''; }, function (props) { return props.selectSize == 'small' ? "top: 0;" : ''; }, Focus);
var Option = styled.option(templateObject_3$5 || (templateObject_3$5 = __makeTemplateObject(["\n  color: var(--black);\n"], ["\n  color: var(--black);\n"])));
var OptionPlaceHolder = styled.option(templateObject_4$5 || (templateObject_4$5 = __makeTemplateObject(["\n ", "\n height: 48px;\n"], ["\n ", "\n height: 48px;\n"])), OpensansNormalTundora14px);
var Transparent = css(templateObject_5$4 || (templateObject_5$4 = __makeTemplateObject(["\n  border: none; \n  padding: 0 8px; \n"], ["\n  border: none; \n  padding: 0 8px; \n"])));
var templateObject_1$8, templateObject_2$6, templateObject_3$5, templateObject_4$5, templateObject_5$4;

var Select = forwardRef(function (props, ref) {
    var _a;
    var _b = __read(React__default.useState(!props.value), 2), isOptionPlaceHolder = _b[0], setIsOptionPlaceHolder = _b[1];
    var _c = __read(React__default.useState(false), 2), isExpanded = _c[0], setIsExpanded = _c[1];
    useEffect(function () {
        if (props.value && props.value !== props.placeHolderLabel) {
            setIsOptionPlaceHolder(false);
        }
        else if (!props.value || props.value === props.placeHolderLabel) {
            setIsOptionPlaceHolder(true);
        }
    }, [props.value, props.placeHolderLabel]);
    function handleOnChange(option) {
        if (!option.target.value) {
            setIsOptionPlaceHolder(true);
        }
        else {
            setIsOptionPlaceHolder(false);
        }
        props.onChange(option);
    }
    return (jsxRuntime.exports.jsx(SelectWrapper, __assign({ "$hasError": props.hasError, "$isExpanded": isExpanded, selectType: props.selectType, arrowColor: props.arrowColor, selectSize: props.selectSize }, { children: jsxRuntime.exports.jsxs(Select$1, __assign({ "$hasError": props.hasError, onChange: handleOnChange, isOptionPlaceHolder: isOptionPlaceHolder, id: props.id, ref: ref, disabled: props.disabled, "$isExpanded": isExpanded, onClick: function () { return setIsExpanded(!isExpanded); }, onBlur: function () { return setIsExpanded(false); }, "data-testid": props.testId, "aria-label": props.ariaLabel, "aria-describedby": props.ariaDescribedBy, value: props.value, selectType: (_a = props.selectType) !== null && _a !== void 0 ? _a : 'outline', selectSize: props.selectSize }, { children: [!props.disablePlaceHolder &&
                    jsxRuntime.exports.jsx(OptionPlaceHolder, __assign({ value: '' }, { children: props.placeHolderLabel ? props.placeHolderLabel : 'Select' }), "".concat(props.id, "Select")), props.optionsList &&
                    props.optionsList.map(function (s) { return (jsxRuntime.exports.jsx(Option, __assign({ value: s.value }, { children: s.label }), "".concat(props.id).concat(s.value))); })] })) })));
});

var ResourcesContainer = styled.div(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n    margin-top: var(--spacing_token_s);\n    margin-left: var(--spacing_token_s);\n    display: inline-grid;\n    grid-template-columns: auto auto;\n    column-gap : 20px;\n    row-gap: 10px;\n\n"], ["\n    margin-top: var(--spacing_token_s);\n    margin-left: var(--spacing_token_s);\n    display: inline-grid;\n    grid-template-columns: auto auto;\n    column-gap : 20px;\n    row-gap: 10px;\n\n"])));
var Title = styled.div(templateObject_2$5 || (templateObject_2$5 = __makeTemplateObject(["\n  font-weight: bold;\n"], ["\n  font-weight: bold;\n"])));
var TwoColumns = styled.div(templateObject_3$4 || (templateObject_3$4 = __makeTemplateObject(["\n    grid-column: span 2;\n"], ["\n    grid-column: span 2;\n"])));
var TwoColumnsCentered = styled.div(templateObject_4$4 || (templateObject_4$4 = __makeTemplateObject(["\n    grid-column: span 2;\n    text-align: center;\n"], ["\n    grid-column: span 2;\n    text-align: center;\n"])));
var templateObject_1$7, templateObject_2$5, templateObject_3$4, templateObject_4$4;

function handleNetworkError() {
    const error = { code: 'NetworkError', message: 'There is a network issue and your request could not be processed.' };
    throw error;
}
function isJSONResponse(response) {
    if (!response) {
        return false;
    }
    return response.headers.has('Content-Type') && response.headers.get('Content-Type').indexOf('application/json') > -1;
}
function handleResponseStatus(response) {
    const isJSON = isJSONResponse(response);
    if (response.ok) {
        return isJSON ? response.json() : response.text();
    }
    if (isJSON) {
        return response.json().then((apiError) => {
            throw apiError;
        });
    }
    const error = { code: 'ServerError', message: 'We couldn\'t process your request. Please try again or call us at 1.800.764.7419.', response: response };
    throw error;
}
function cclFetch(input, init) {
    const credentials = 'include';
    const initWithCredentials = Object.assign({ credentials: credentials }, init);
    return fetch(input, initWithCredentials)
        .catch(handleNetworkError)
        .then((response) => handleResponseStatus(response));
}

// Brought from https://github.com/js-cookie/js-cookie
// and modified to play nice with typescript and webpack
function set$1(key, value, attributes) {
    if (typeof document === 'undefined' || !key || !value) {
        return undefined;
    }
    attributes = Object.assign({ path: '/' }, attributes);
    if (typeof attributes.expires === 'number') {
        attributes.expires = new Date(new Date().getTime() + attributes.expires * 864e+5);
    }
    // We're using "expires" because "max-age" is not supported by IE
    attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
    try {
        const result = JSON.stringify(value);
        if (/^[\{\[]/.test(result)) {
            value = result;
        }
        // tslint:disable-next-line:no-empty
    }
    catch (e) { }
    value =
        encodeURIComponent(String(value))
            .replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
    key = encodeURIComponent(String(key))
        .replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
        .replace(/[\(\)]/g, escape);
    let stringifiedAttributes = '';
    for (const attributeName in attributes) {
        if (!attributes[attributeName]) {
            continue;
        }
        stringifiedAttributes += '; ' + attributeName;
        if (attributes[attributeName] === true) {
            continue;
        }
        // Considers RFC 6265 section 5.2:
        // ...
        // 3.  If the remaining unparsed-attributes contains a %x3B (";")
        //     character:
        // Consume the characters of the unparsed-attributes up to,
        // not including, the first %x3B (";") character.
        // ...
        stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }
    return (document.cookie = key + '=' + value + stringifiedAttributes);
}
function get$1(key) {
    return getHelper(key, false /* read as raw */);
}
function getJSON(key) {
    return getHelper(key, true /* read as json */);
}
function remove(key, attributes) {
    let value = CookieService.get(key);
    CookieService.set(key, value ? value : '_', Object.assign({}, attributes, { expires: -1 }));
}
function decode(s) {
    return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
}
function getHelper(key, json) {
    if (typeof document === 'undefined') {
        return undefined;
    }
    const jar = {};
    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    const cookies = document.cookie ? document.cookie.split('; ') : [];
    let i = 0;
    for (; i < cookies.length; i++) {
        const parts = cookies[i].split('=');
        let cookie = parts.slice(1).join('=');
        if (!json && cookie.charAt(0) === '"') {
            cookie = cookie.slice(1, -1);
        }
        try {
            const name = decode(parts[0]);
            cookie = decode(cookie);
            if (json) {
                try {
                    cookie = JSON.parse(cookie);
                    // tslint:disable-next-line:no-empty
                }
                catch (e) { }
            }
            jar[name] = cookie;
            if (key === name) {
                break;
            }
            // tslint:disable-next-line:no-empty
        }
        catch (e) { }
    }
    return key ? jar[key] : jar;
}
/**
 * Returns the domain to be used when handling cookies.
 * @param {string} host - optional, will use window.location.host by default.
 * @returns {string} The domain to be used when handling cookies.
 */
function getCookieDomain(host) {
    if (!host) {
        host = window.location.host;
    }
    const parts = host.split('.');
    if (parts.length <= 2) {
        return host;
    }
    return parts.splice(1).join('.');
}
const CookieService = {
    set: set$1,
    get: get$1,
    getJSON,
    remove,
    getCookieDomain
};

const isSupported = checkBrowserSupport();
function get(key) {
    if (hasError(key)) {
        return null;
    }
    try {
        let result = window.localStorage.getItem(key);
        return result !== null ? JSON.parse(result) : null;
    }
    catch (e) {
        return null;
    }
}
function set(key, value) {
    if (hasError(key) || !value) {
        return false;
    }
    window.localStorage.setItem(key, JSON.stringify(value));
    return true;
}
function hasError(key) {
    return !isSupported || !key;
}
function checkBrowserSupport() {
    let supported;
    try {
        supported = window.localStorage !== null;
        if (supported) {
            const key = '__testbrowsersupport';
            window.localStorage.setItem(key, key);
            window.localStorage.removeItem(key);
        }
        return supported;
    }
    catch (e) {
        supported = false;
    }
    return supported;
}
const LocalStorageService = {
    get,
    set,
    isSupported
};

let locality;
let currencies;
var LocalityEnum;
(function (LocalityEnum) {
    LocalityEnum["US"] = "1";
    LocalityEnum["UK"] = "3";
    LocalityEnum["AU"] = "7";
})(LocalityEnum || (LocalityEnum = {}));
var CurrencySourceEnum;
(function (CurrencySourceEnum) {
    CurrencySourceEnum["URL"] = "Url";
    CurrencySourceEnum["LOCAL_STORAGE"] = "LocalStorage";
    CurrencySourceEnum["COOKIE"] = "Cookie";
    CurrencySourceEnum["SERVER"] = "Server";
})(CurrencySourceEnum || (CurrencySourceEnum = {}));
const CURRENCY_KEY = 'SelectedCurrency';
const LOCALITY_KEY = 'SelectedLocality';
function initialize(data) {
    if (!data) {
        return;
    }
    locality = data.locality;
    currencies = data.currencies;
}
function getLocality() {
    return getLocalityFromUrl() || getLocalityFromLocalStorage() || getLocalityFromInitialData();
}
function setLocality(locality) {
    if (!locality) {
        return;
    }
    if (LocalStorageService.isSupported) {
        LocalStorageService.set(LOCALITY_KEY, locality);
    }
    else {
        CookieService.set(LOCALITY_KEY, locality, {
            path: '/'
        });
    }
}
function getLocalityFromInitialData() {
    if (!locality) {
        return null;
    }
    setLocality(locality);
    return getEnumLocalityValue(locality);
}
function getLocalityFromUrl() {
    const urlLocality = getUrlParameter('locality');
    if (!urlLocality) {
        return null;
    }
    return getEnumLocalityValue(urlLocality);
}
function getLocalityFromLocalStorage() {
    if (!LocalStorageService.isSupported) {
        return null;
    }
    const storedLocality = LocalStorageService.get(LOCALITY_KEY);
    if (!storedLocality) {
        return null;
    }
    return getEnumLocalityValue(storedLocality);
}
function getEnumLocalityValue(locality) {
    for (let idx in LocalityEnum) {
        if (LocalityEnum[idx] == locality) {
            return LocalityEnum[idx];
        }
    }
    return null;
}
function getCurrency() {
    return getCurrencyFromUrl() || getCurrencyFromLocalStorage() || getCurrencyFromCookie() || getCurrencyFromInitialData();
}
function setCurrency(currencyCode) {
    if (!currencyCode) {
        return;
    }
    if (LocalStorageService.isSupported) {
        LocalStorageService.set(CURRENCY_KEY, currencyCode);
    }
    else {
        CookieService.set(CURRENCY_KEY, currencyCode, {
            path: '/'
        });
    }
}
function getCurrencyFromUrl() {
    const urlCurrency = getUrlParameter('currency');
    if (!urlCurrency) {
        return null;
    }
    const currencyCode = currencies.find(currency => currency.toLowerCase() === urlCurrency.toLowerCase());
    if (!currencyCode) {
        return null;
    }
    setCurrency(currencyCode);
    return {
        code: currencyCode,
        source: CurrencySourceEnum.URL
    };
}
function getCurrencyFromLocalStorage() {
    if (!LocalStorageService.isSupported) {
        return null;
    }
    const currencyCode = LocalStorageService.get(CURRENCY_KEY);
    if (!currencyCode) {
        return null;
    }
    return {
        code: currencyCode,
        source: CurrencySourceEnum.LOCAL_STORAGE
    };
}
function getCurrencyFromCookie() {
    const currencyCode = CookieService.getJSON(CURRENCY_KEY) || null;
    if (!currencyCode) {
        return null;
    }
    return {
        code: currencyCode,
        source: CurrencySourceEnum.COOKIE
    };
}
function getCurrencyFromInitialData() {
    if (!currencies || !currencies.length) {
        return null;
    }
    const currencyCode = currencies[0];
    setCurrency(currencyCode);
    return {
        code: currencies[0],
        source: CurrencySourceEnum.SERVER
    };
}
function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    const results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}
const LocalityService = {
    initialize,
    getLocality,
    setLocality,
    getCurrency,
    setCurrency,
    LocalityEnum
};

function parseAllLowerCaseKeys$1(querystring) {
    return parseGeneric$1(querystring, (valueFromQueryString) => {
        return valueFromQueryString.toLowerCase();
    });
}
function parseGeneric$1(querystring, getKey) {
    if (!querystring) {
        return {};
    }
    if (querystring.charAt(0) === '?') {
        querystring = querystring.substring(1);
    }
    const hash = {};
    querystring.split('&').map(n => n.split('=')).forEach(kv => {
        hash[getKey(decodeURIComponent(kv[0]))] = decodeURIComponent(kv[1]);
    });
    return hash;
}

String.format = function (s, ...args) {
    if (!s) {
        return '';
    }
    return s.replace(/{(\d+)}/g, function (match, number) {
        return typeof args[number] != 'undefined' ? args[number] : match;
    });
};

var ResourcesLookup = function (props) {
    var _a = __read(useState(null), 2), resourceLocations = _a[0], setResourceLocations = _a[1];
    var locality = LocalityService.getLocality() === '7' ? "AU" : "US";
    function getResourceLocations(searchValue) {
        var result = [];
        props.resources.forEach(function (currentResource) {
            var e_1, _a, e_2, _b;
            try {
                for (var _c = __values(Object.entries(currentResource)), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var _e = __read(_d.value, 2), key = _e[0], value = _e[1];
                    if (key === "ComponentName") {
                        continue;
                    }
                    try {
                        for (var _f = (e_2 = void 0, __values(Object.entries(value))), _g = _f.next(); !_g.done; _g = _f.next()) {
                            var _h = __read(_g.value, 2), key1 = _h[0], value1 = _h[1];
                            if (typeof value1 === 'string' || value1 instanceof String) {
                                if (searchValue) {
                                    if (!value1.toLowerCase().includes(searchValue.toLowerCase())) {
                                        continue;
                                    }
                                }
                                result.push({
                                    location: "/sitecore/content/Domain/ComponentResources/".concat(currentResource.ComponentName, "/").concat(key, "/").concat(key1),
                                    resource: value1
                                });
                            }
                            else {
                                var url = Reflect.get(value1, 'Url');
                                if (searchValue) {
                                    if (!url.toLowerCase().includes(searchValue.toLowerCase())) {
                                        continue;
                                    }
                                }
                                result.push({
                                    location: "/sitecore/content/Domain/ComponentResources/".concat(currentResource.ComponentName, "/").concat(key, "/").concat(key1),
                                    resource: Reflect.get(value1, 'Url')
                                });
                            }
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_1) throw e_1.error; }
            }
        });
        setResourceLocations(result);
    }
    useEffect(function () {
        getResourceLocations();
        // eslint-disable-next-line
    }, [props.resources]);
    return (jsxRuntime.exports.jsxs(ResourcesContainer, { children: [jsxRuntime.exports.jsx(TwoColumnsCentered, { children: (locality === 'AU') ? jsxRuntime.exports.jsxs("div", { children: [jsxRuntime.exports.jsx("b", { children: "Australia" }), "\u00A0|\u00A0", jsxRuntime.exports.jsx("a", __assign({ href: "./resources?locality=1" }, { children: "US" }))] })
                    : jsxRuntime.exports.jsxs("div", { children: [jsxRuntime.exports.jsx("a", __assign({ href: "./resources?locality=7" }, { children: "Australia" })), "\u00A0|\u00A0", jsxRuntime.exports.jsx("b", { children: "US" })] }) }), jsxRuntime.exports.jsxs(TwoColumnsCentered, { children: ["Search:\u00A0", jsxRuntime.exports.jsx("input", { onChange: function (event) { return getResourceLocations(event.target.value); } })] }), jsxRuntime.exports.jsx(Title, { children: "Text" }), jsxRuntime.exports.jsx(Title, { children: "Sitecore location" }), jsxRuntime.exports.jsx(TwoColumns, { children: jsxRuntime.exports.jsx("hr", {}) }), resourceLocations &&
                resourceLocations.map(function (resourceLocation) { return (jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [jsxRuntime.exports.jsx("div", { children: resourceLocation.resource }), jsxRuntime.exports.jsx("div", { children: resourceLocation.location })] })); })] }));
};

var monthByNumber = {
    0: 'January',
    1: 'February',
    2: 'March',
    3: 'April',
    4: 'May',
    5: 'June',
    6: 'July',
    7: 'August',
    8: 'September',
    9: 'October',
    10: 'November',
    11: 'December'
};
var daysByMonth = {
    0: 31,
    1: 29,
    2: 31,
    3: 30,
    4: 31,
    5: 30,
    6: 31,
    7: 31,
    8: 30,
    9: 31,
    10: 30,
    11: 31
};
var daysByMonthNonZeroIndexFormat = {
    1: 31,
    2: 29,
    3: 31,
    4: 30,
    5: 31,
    6: 30,
    7: 31,
    8: 31,
    9: 30,
    10: 31,
    11: 30,
    12: 31
};
function populateYearOptions(start, end, reverse) {
    var startYear = start || 1900;
    var endYear = end || new Date().getFullYear();
    var yearOptions = [];
    if (startYear <= endYear) {
        for (var year = startYear; year <= endYear; ++year) {
            yearOptions.push({ value: year.toString(), label: year.toString() });
        }
    }
    else {
        for (var year = endYear; year >= startYear; --year) {
            yearOptions.push({ value: year.toString(), label: year.toString() });
        }
    }
    if (reverse) {
        yearOptions.reverse();
    }
    return yearOptions;
}
function populateMonthOptions(year, useNonZeroIndexMonthValues) {
    var today = new Date();
    var months = [];
    var currentMonth = 11;
    var monthOptions = [];
    if (+year === today.getFullYear()) {
        currentMonth = today.getMonth();
    }
    for (var month = 0; month <= currentMonth; ++month) {
        months.push(monthByNumber[month]);
    }
    months.forEach(function (month, index) {
        monthOptions.push({ value: (useNonZeroIndexMonthValues ? index + 1 : index).toString(), label: month });
    });
    return monthOptions;
}
function populateDayOptions(month, year, usingNonZeroIndexMonthValues) {
    var days = usingNonZeroIndexMonthValues ? daysByMonthNonZeroIndexFormat[+month] : daysByMonth[+month];
    var today = new Date();
    var dayOptions = [];
    if (isNaN(days))
        days = 31;
    if (+year === today.getFullYear() && +month === today.getMonth()) {
        days = today.getDate();
    }
    for (var day = 1; day <= days; ++day) {
        dayOptions.push({ value: day.toString(), label: day.toString() });
    }
    return dayOptions;
}

var YearSelect = forwardRef(function (props, ref) {
    return (jsxRuntime.exports.jsx(Select, __assign({ ref: ref }, props, { optionsList: populateYearOptions(props.start, props.end, props.reverse) })));
});

var MonthSelect = forwardRef(function (props, ref) {
    return (jsxRuntime.exports.jsx(Select, __assign({ ref: ref }, props, { optionsList: populateMonthOptions(props.year, props.useNonZeroIndexMonthValues) })));
});

var DaySelect = forwardRef(function (props, ref) {
    return (jsxRuntime.exports.jsx(Select, __assign({ ref: ref }, props, { optionsList: populateDayOptions(props.month, props.year, props.usingNonZeroIndexMonthValues) })));
});

var statesApiResponseMock = {
    "states": [
        {
            "code": "AL",
            "name": "Alabama",
            "countryCode": "US"
        },
        {
            "code": "AK",
            "name": "Alaska",
            "countryCode": "US"
        },
        {
            "code": "AZ",
            "name": "Arizona",
            "countryCode": "US"
        },
        {
            "code": "AR",
            "name": "Arkansas",
            "countryCode": "US"
        },
        {
            "code": "CA",
            "name": "California",
            "countryCode": "US"
        },
        {
            "code": "CO",
            "name": "Colorado",
            "countryCode": "US"
        },
        {
            "code": "CT",
            "name": "Connecticut",
            "countryCode": "US"
        },
        {
            "code": "DE",
            "name": "Delaware",
            "countryCode": "US"
        },
        {
            "code": "DC",
            "name": "Dist of Columbia",
            "countryCode": "US"
        },
        {
            "code": "FL",
            "name": "Florida",
            "countryCode": "US"
        },
        {
            "code": "GA",
            "name": "Georgia",
            "countryCode": "US"
        },
        {
            "code": "HI",
            "name": "Hawaii",
            "countryCode": "US"
        },
        {
            "code": "ID",
            "name": "Idaho",
            "countryCode": "US"
        },
        {
            "code": "IL",
            "name": "Illinois",
            "countryCode": "US"
        },
        {
            "code": "IN",
            "name": "Indiana",
            "countryCode": "US"
        },
        {
            "code": "IA",
            "name": "Iowa",
            "countryCode": "US"
        },
        {
            "code": "KS",
            "name": "Kansas",
            "countryCode": "US"
        },
        {
            "code": "KY",
            "name": "Kentucky",
            "countryCode": "US"
        },
        {
            "code": "LA",
            "name": "Louisiana",
            "countryCode": "US"
        },
        {
            "code": "ME",
            "name": "Maine",
            "countryCode": "US"
        },
        {
            "code": "MD",
            "name": "Maryland",
            "countryCode": "US"
        },
        {
            "code": "MA",
            "name": "Massachusetts",
            "countryCode": "US"
        },
        {
            "code": "MI",
            "name": "Michigan",
            "countryCode": "US"
        },
        {
            "code": "MN",
            "name": "Minnesota",
            "countryCode": "US"
        },
        {
            "code": "MS",
            "name": "Mississippi",
            "countryCode": "US"
        },
        {
            "code": "MO",
            "name": "Missouri",
            "countryCode": "US"
        },
        {
            "code": "MT",
            "name": "Montana",
            "countryCode": "US"
        },
        {
            "code": "NE",
            "name": "Nebraska",
            "countryCode": "US"
        },
        {
            "code": "NV",
            "name": "Nevada",
            "countryCode": "US"
        },
        {
            "code": "NH",
            "name": "New Hampshire",
            "countryCode": "US"
        },
        {
            "code": "NJ",
            "name": "New Jersey",
            "countryCode": "US"
        },
        {
            "code": "NM",
            "name": "New Mexico",
            "countryCode": "US"
        },
        {
            "code": "NY",
            "name": "New York",
            "countryCode": "US"
        },
        {
            "code": "NC",
            "name": "North Carolina",
            "countryCode": "US"
        },
        {
            "code": "ND",
            "name": "North Dakota",
            "countryCode": "US"
        },
        {
            "code": "OH",
            "name": "Ohio",
            "countryCode": "US"
        },
        {
            "code": "OK",
            "name": "Oklahoma",
            "countryCode": "US"
        },
        {
            "code": "OR",
            "name": "Oregon",
            "countryCode": "US"
        },
        {
            "code": "PA",
            "name": "Pennsylvania",
            "countryCode": "US"
        },
        {
            "code": "PR",
            "name": "Puerto Rico",
            "countryCode": "US"
        },
        {
            "code": "RI",
            "name": "Rhode Island",
            "countryCode": "US"
        },
        {
            "code": "SC",
            "name": "South Carolina",
            "countryCode": "US"
        },
        {
            "code": "SD",
            "name": "South Dakota",
            "countryCode": "US"
        },
        {
            "code": "TN",
            "name": "Tennessee",
            "countryCode": "US"
        },
        {
            "code": "TX",
            "name": "Texas",
            "countryCode": "US"
        },
        {
            "code": "UT",
            "name": "Utah",
            "countryCode": "US"
        },
        {
            "code": "VT",
            "name": "Vermont",
            "countryCode": "US"
        },
        {
            "code": "VA",
            "name": "Virginia",
            "countryCode": "US"
        },
        {
            "code": "WA",
            "name": "Washington",
            "countryCode": "US"
        },
        {
            "code": "WV",
            "name": "West Virginia",
            "countryCode": "US"
        },
        {
            "code": "WI",
            "name": "Wisconsin",
            "countryCode": "US"
        },
        {
            "code": "WY",
            "name": "Wyoming",
            "countryCode": "US"
        },
        {
            "code": "XX",
            "name": "Other State",
            "countryCode": "US"
        },
        {
            "code": "AB",
            "name": "Alberta",
            "countryCode": "CA"
        },
        {
            "code": "BC",
            "name": "British Columbia",
            "countryCode": "CA"
        },
        {
            "code": "MB",
            "name": "Manitoba",
            "countryCode": "CA"
        },
        {
            "code": "NB",
            "name": "New Brunswick",
            "countryCode": "CA"
        },
        {
            "code": "NL",
            "name": "Newfoundland",
            "countryCode": "CA"
        },
        {
            "code": "NT",
            "name": "Northwest Territories",
            "countryCode": "CA"
        },
        {
            "code": "NS",
            "name": "Nova Scotia",
            "countryCode": "CA"
        },
        {
            "code": "NU",
            "name": "Nunavut",
            "countryCode": "CA"
        },
        {
            "code": "ON",
            "name": "Ontario",
            "countryCode": "CA"
        },
        {
            "code": "PE",
            "name": "Prince Edward",
            "countryCode": "CA"
        },
        {
            "code": "QC",
            "name": "Quebec",
            "countryCode": "CA"
        },
        {
            "code": "SK",
            "name": "Saskatchewan",
            "countryCode": "CA"
        },
        {
            "code": "YT",
            "name": "Yukon",
            "countryCode": "CA"
        }
    ]
};

var BASE_API_URL = '/profilemanagement/api/v1.0';
var API_URLS = {
    States: "".concat(BASE_API_URL, "/states/states"),
    GetProfile: "".concat(BASE_API_URL, "/Profiles"),
    TERMS_AND_CONDITIONS_API: '/tnc-api/api/tncshopping/merchandising',
};

var cachedResponse;
function getStates() {
    var shouldMockApiCall = (typeof process !== 'undefined' && process !== undefined && process !== null && process.env.REACT_APP_CYPRESS);
    if (shouldMockApiCall) {
        return Promise.resolve(statesApiResponseMock);
    }
    var opts = {
        method: 'GET',
        headers: new Headers({
            'Accept': 'application/json', 'Content-Type': 'application/json',
        })
    };
    if (cachedResponse) {
        return cachedResponse;
    }
    cachedResponse = cclFetch(API_URLS.States, opts);
    return cachedResponse;
}
var StatesService = {
    getStates: getStates
};

var ErrorLabel = styled.span(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), Error$1);
var templateObject_1$6;

var StateSelect = forwardRef(function (props, ref) {
    var _a = __read(useState(null), 2), states = _a[0], setStates = _a[1];
    var _b = __read(useState(null), 2), errorMessage = _b[0], setErrorMessage = _b[1];
    var mapAdditionalDataToOptionsList = function (states) {
        return states === null ? [] :
            states.map(function (option) {
                return {
                    value: option.code,
                    label: option.name
                };
            });
    };
    useEffect(function () {
        var getStatesData = function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, StatesService.getStates()
                            .then(function (statesResponse) {
                            setStates(statesResponse.states);
                        })
                            .catch(function () {
                            setErrorMessage(props.errorMessageLabel);
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        getStatesData();
    }, [props.errorMessageLabel]);
    return (jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [jsxRuntime.exports.jsx(Select, __assign({}, props, { optionsList: mapAdditionalDataToOptionsList(states), ref: ref })), errorMessage && jsxRuntime.exports.jsxs(ErrorLabel, __assign({ role: "alert", "data-testid": 'StateApiErrorMessage' }, { children: ["Error: ", errorMessage] }))] }));
});

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgCloseModalIcon = function SvgCloseModalIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.57 12 8.079-8.079a1.198 1.198 0 0 0 0-1.693L21.77.35a1.198 1.198 0 0 0-1.693 0L12 8.43 3.92.351a1.198 1.198 0 0 0-1.693 0L.35 2.228a1.198 1.198 0 0 0 0 1.693L8.43 12 .35 20.079a1.198 1.198 0 0 0 0 1.693l1.878 1.878a1.198 1.198 0 0 0 1.693 0L12 15.57l8.079 8.079a1.198 1.198 0 0 0 1.693 0l1.878-1.877a1.198 1.198 0 0 0 0-1.694L15.57 12Z",
    fill: "#10559A"
  })));
};

var HeadingBoldTextUsingH2 = styled.h2(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n  font-weight: 700;\n"], ["\n  font-weight: 700;\n"])));
var HeadingBoldTextUsingH3 = styled.h3(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject(["\n  font-weight: 700;\n"], ["\n  font-weight: 700;\n"])));
var SlideOutOverlayGlobalStyle = createGlobalStyle(templateObject_3$3 || (templateObject_3$3 = __makeTemplateObject(["\n  // Overlay\n  .", " > div {\n    position: absolute !important;\n    background-color: rgba(0, 0, 0, 0.6) !important;\n    z-index: 1001;\n    display: ", ";\n    grid-template-columns: repeat(7, 1fr);\n    grid-gap: 16px\n    justify-content: flex-end;\n    height: ", ";\n    left: 0;\n    top: ", ";\n  \n    ", " {\n      height: ", ";\n    }\n\n    ", " {\n      grid-template-columns: repeat(12, 1fr);\n    }\n\n    @media (max-height : 400px) and (orientation : landscape) {\n      top: 0;\n      z-index: 1010;\n      height: 100vh;\n      position: fixed;\n    }\n  }\n\n  // Content\n  .", " *:not(:first-child):focus {\n    outline-color: var(--bondi-blue);\n  }\n  // Content\n  .", " {\n    &:first-of-type:focus,\n    &:first-of-type:focus-visible {\n      outline: 0px; \n    }\n\n    width: 100%;\n    max-width: 688px;\n    inset: auto !important;\n    background-color: var(--white);\n    font-family: var(--font-family-open_sans);\n    color: var(--tundora);\n    padding: var(--spacing_token_s);\n    overflow-y: auto;\n    margin-top: 0;\n    margin-bottom: 50px;\n    justify-self: end;\n    \n    ", " {\n      grid-column: 3 / 8 !important;\n      padding: var(--spacing_token_m);\n    }\n    ", " {\n      grid-column: 7 / auto !important;\n    }\n    ", " {\n      margin-bottom: 66px;\n    }\n    ", " {\n    }\n    position: absolute;\n    top: 0;\n    height: 100%;\n  }\n"], ["\n  // Overlay\n  .", " > div {\n    position: absolute !important;\n    background-color: rgba(0, 0, 0, 0.6) !important;\n    z-index: 1001;\n    display: ", ";\n    grid-template-columns: repeat(7, 1fr);\n    grid-gap: 16px\n    justify-content: flex-end;\n    height: ", ";\n    left: 0;\n    top: ", ";\n  \n    ", " {\n      height: ", ";\n    }\n\n    ", " {\n      grid-template-columns: repeat(12, 1fr);\n    }\n\n    @media (max-height : 400px) and (orientation : landscape) {\n      top: 0;\n      z-index: 1010;\n      height: 100vh;\n      position: fixed;\n    }\n  }\n\n  // Content\n  .", " *:not(:first-child):focus {\n    outline-color: var(--bondi-blue);\n  }\n  // Content\n  .", " {\n    &:first-of-type:focus,\n    &:first-of-type:focus-visible {\n      outline: 0px; \n    }\n\n    width: 100%;\n    max-width: 688px;\n    inset: auto !important;\n    background-color: var(--white);\n    font-family: var(--font-family-open_sans);\n    color: var(--tundora);\n    padding: var(--spacing_token_s);\n    overflow-y: auto;\n    margin-top: 0;\n    margin-bottom: 50px;\n    justify-self: end;\n    \n    ", " {\n      grid-column: 3 / 8 !important;\n      padding: var(--spacing_token_m);\n    }\n    ", " {\n      grid-column: 7 / auto !important;\n    }\n    ", " {\n      margin-bottom: 66px;\n    }\n    ", " {\n    }\n    position: absolute;\n    top: 0;\n    height: 100%;\n  }\n"])), function (props) { return props.$modalClassName; }, function (props) { return ("grid" ); }, function (props) { return ("calc(100vh - ".concat(props.$diffHeaderHeight, "px) !important")); }, function (props) { return ("".concat(props.$diffTopHeight, "px !important")); }, up("md"), function (props) { return ("calc(100vh - ".concat(props.$diffHeaderHeight, "px) !important")); }, up("lg"), function (props) { return props.$contentClassName; }, function (props) { return props.$contentClassName; }, up("md"), up("lg"), up("xl"), up("xxl"));
var ContentContainer = styled.div(templateObject_4$3 || (templateObject_4$3 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var HeadingContainer = styled.div(templateObject_5$3 || (templateObject_5$3 = __makeTemplateObject(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  height : fit-content;\n  flex: 0 0 40%;\n"], ["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  height : fit-content;\n  flex: 0 0 40%;\n"])));
var HeadingWrapper = styled.div(templateObject_6$3 || (templateObject_6$3 = __makeTemplateObject(["\n  flex-flow: column wrap;\n  flex-grow: 1;\n  height: 100%;\n  display: flex;\n  row-gap: 24px;\n  align-self: stretch;\n"], ["\n  flex-flow: column wrap;\n  flex-grow: 1;\n  height: 100%;\n  display: flex;\n  row-gap: 24px;\n  align-self: stretch;\n"])));
var SlideOutOverlayHeadingTitle = styled(HeadingBoldTextUsingH2)(templateObject_7$2 || (templateObject_7$2 = __makeTemplateObject(["\n  font-family: var(--font-family-tempo_std-heavycondensed);\n  color:  var(--tory-blue);\n  font-size: var(--font-size-24);\n  line-height: 28px;\n  letter-spacing: 0;\n  justify-content: space-between;\n  font-weight: 900;\n  margin-right:  var(--spacing_token_m);\n  margin-top:  0px;\n  margin-bottom:  0px;\n\n  ", " {\n    font-size: var(--font-size-34);\n    line-height: 38px;\n  }\n"], ["\n  font-family: var(--font-family-tempo_std-heavycondensed);\n  color:  var(--tory-blue);\n  font-size: var(--font-size-24);\n  line-height: 28px;\n  letter-spacing: 0;\n  justify-content: space-between;\n  font-weight: 900;\n  margin-right:  var(--spacing_token_m);\n  margin-top:  0px;\n  margin-bottom:  0px;\n\n  ", " {\n    font-size: var(--font-size-34);\n    line-height: 38px;\n  }\n"])), up("lg"));
var ChangeDateHeadingTitle = styled(HeadingBoldTextUsingH3)(templateObject_8$1 || (templateObject_8$1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (props) {
    var _a;
    var styles = "";
    var headingTitle = (_a = props === null || props === void 0 ? void 0 : props.changeDate) === null || _a === void 0 ? void 0 : _a.headingTitle;
    if (headingTitle) {
        styles = "\n      font-family: ".concat(headingTitle === null || headingTitle === void 0 ? void 0 : headingTitle.fontFamily, ";\n      font-style: ").concat(headingTitle === null || headingTitle === void 0 ? void 0 : headingTitle.fontStyle, ";\n      font-size: ").concat(headingTitle === null || headingTitle === void 0 ? void 0 : headingTitle.fontSize, ";\n      line-height: ").concat(headingTitle === null || headingTitle === void 0 ? void 0 : headingTitle.lineHeight, ";\n      color: ").concat(headingTitle === null || headingTitle === void 0 ? void 0 : headingTitle.color, ";\n      padding-right: ").concat(headingTitle === null || headingTitle === void 0 ? void 0 : headingTitle.paddingRight, ";\n\n      ").concat([up("lg")(props)], "{\n        font-size: ").concat(headingTitle === null || headingTitle === void 0 ? void 0 : headingTitle.fontSizeUpLG, ";\n        line-height: ").concat(headingTitle === null || headingTitle === void 0 ? void 0 : headingTitle.lineHeightUpLG, ";\n      }\n\n      ").concat([up("sm")(props)], "{\n        padding-right: ").concat(headingTitle === null || headingTitle === void 0 ? void 0 : headingTitle.paddingRightUpSM, ";\n      }\n      ");
    }
    return styles;
});
var SlideOutOverlayHeadingContent = styled.div(templateObject_9$1 || (templateObject_9$1 = __makeTemplateObject(["\n  color: var(--tundora);\n"], ["\n  color: var(--tundora);\n"])));
var SlideOutOverlayContainer = styled.div(templateObject_10$1 || (templateObject_10$1 = __makeTemplateObject([""], [""])));
var CloseButton = styled.button(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  display: flex;\n  ", " \n"], ["\n  display: flex;\n  ", " \n"])), PlainButtonStyle);
var DefaultCloseModalIcon = styled(SvgCloseModalIcon)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  width: 24px;\n  height: 24px;\n"], ["\n  width: 24px;\n  height: 24px;\n"])));
var HorizontalDividerLight = styled.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  width: 100%;\n  height: 1px;\n  margin-top: 24px;\n  background-color: var(--silver);\n\n"], ["\n  width: 100%;\n  height: 1px;\n  margin-top: 24px;\n  background-color: var(--silver);\n\n"])));
var ContentWrapper$1 = styled.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var EventSectionContainer = styled.div(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  padding-bottom: 72px\n"], ["\n  padding-bottom: 72px\n"])));
var templateObject_1$5, templateObject_2$4, templateObject_3$3, templateObject_4$3, templateObject_5$3, templateObject_6$3, templateObject_7$2, templateObject_8$1, templateObject_9$1, templateObject_10$1, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15;

/**
 * The `InteractionManager` class provides utility functions for managing user interactions with a component.
 * These functions include locking and unlocking scrolling behavior, and setting the focusable elements of a component.
 *
 * @class
 */
var InteractionHandler = /** @class */ (function () {
    function InteractionHandler() {
    }
    /**
     * Unlocks the scrolling behavior of the window.
    */
    InteractionHandler.unlockScroll = function () {
        window.onscroll = null;
        document.body.style.overflow = "auto";
    };
    /**
     * A method to focus an element by its ID.
     * @param id - The ID of the element to focus.
     */
    InteractionHandler.focusElementById = function (id) {
        var element = document.getElementById(id);
        if (element) {
            element === null || element === void 0 ? void 0 : element.scrollIntoView();
            element.focus();
        }
    };
    /**
     * Locks the scrolling behavior of the window.
     */
    InteractionHandler.lockScroll = function () {
        var yPos = window.scrollY;
        window.onscroll = function () {
            window.scroll({
                left: 0,
                top: yPos,
                behavior: "auto",
            });
        };
    };
    return InteractionHandler;
}());

var EventContainer = styled.div(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n  padding-top: var(--spacing_token_m);\n"], ["\n  padding-top: var(--spacing_token_m);\n"])));
var EventRow = styled.div(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["\n  display: flex;\n  margin-bottom: var(--spacing_token_xs);\n"], ["\n  display: flex;\n  margin-bottom: var(--spacing_token_xs);\n"])));
var EventTitle = styled.h3(templateObject_3$2 || (templateObject_3$2 = __makeTemplateObject(["\n  margin-right: var(--spacing_token_xxs);\n  margin-bottom: var(--spacing_token_xs);\n  ", "\n  line-height: 20px;\n  font-weight: 700;\n"], ["\n  margin-right: var(--spacing_token_xxs);\n  margin-bottom: var(--spacing_token_xs);\n  ", "\n  line-height: 20px;\n  font-weight: 700;\n"])), OpensansNormalTundora16px);
var ImageContainerWrapper$1 = styled.div(templateObject_4$2 || (templateObject_4$2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: var(--spacing_token_xs);\n  padding: 0px;\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: var(--spacing_token_xs);\n  padding: 0px;\n"])));
var Image$1 = styled.img(templateObject_5$2 || (templateObject_5$2 = __makeTemplateObject(["\n  width: 100%;\n  flex: none;\n  order: 0;\n  align-self: stretch;\n  flex-grow: 0;\n  border-radius: 8px;\n"], ["\n  width: 100%;\n  flex: none;\n  order: 0;\n  align-self: stretch;\n  flex-grow: 0;\n  border-radius: 8px;\n"])));
var Description = styled.div(templateObject_6$2 || (templateObject_6$2 = __makeTemplateObject(["\n  ", "\n  line-height: 20px;\n  margin-top: 16px;\n  ul { \n    margin-bottom: 8px;\n    position: relative;\n    margin-left: 5%;\n    list-style-type: disc; \n  }\n  li { \n    margin-bottom: 8px;\n  }  \n  & > ul > li { \n    margin-bottom: 8px;\n  }  \n"], ["\n  ", "\n  line-height: 20px;\n  margin-top: 16px;\n  ul { \n    margin-bottom: 8px;\n    position: relative;\n    margin-left: 5%;\n    list-style-type: disc; \n  }\n  li { \n    margin-bottom: 8px;\n  }  \n  & > ul > li { \n    margin-bottom: 8px;\n  }  \n"])), OpensansNormalTundora14px);
var templateObject_1$4, templateObject_2$3, templateObject_3$2, templateObject_4$2, templateObject_5$2, templateObject_6$2;

var EventSection = function (props) {
    return (jsxRuntime.exports.jsxs(EventContainer, __assign({ "data-testid": 'eventSection' + props.keyProp }, { children: [jsxRuntime.exports.jsx(EventRow, { children: jsxRuntime.exports.jsx(EventTitle, __assign({ "data-testid": 'eventTitle' + props.keyProp }, { children: props.Title })) }), jsxRuntime.exports.jsx(ImageContainerWrapper$1, { children: jsxRuntime.exports.jsx(Image$1, { "data-testid": 'eventImg' + props.keyProp, src: props.Image.Url, alt: "" }) }), jsxRuntime.exports.jsx(Description, { "data-testid": 'eventDescription' + props.keyProp, dangerouslySetInnerHTML: { __html: props.Description } })] }), props.keyProp));
};

/**
 * The top value including the booking header and login
 * @returns the top value
 */
var defaultTopValue = function () {
    var _a, _b, _c;
    var header = document.getElementsByTagName("header")[0];
    var headerHeight = (_a = header === null || header === void 0 ? void 0 : header.getBoundingClientRect()) === null || _a === void 0 ? void 0 : _a.bottom;
    var headerNotInView = !(headerHeight > 0); // If headerHeight > 0 , then it is in view.
    var currentHeaderHeight = headerNotInView ? 0 : headerHeight;
    var bookingHeaderHeight = (_c = (_b = document.getElementById("bookingHeader")) === null || _b === void 0 ? void 0 : _b.clientHeight) !== null && _c !== void 0 ? _c : 0;
    var currentScrollY = (window.scrollY == 0) ? Math.floor(document.documentElement.scrollTop) : Math.floor(window.scrollY);
    var topHeight = currentScrollY + (currentHeaderHeight + bookingHeaderHeight);
    return topHeight;
};
/**
 * The height value including the booking header and login and advisories.
 * @returns the height value
 */
var defaultHeightValue = function () {
    var _a, _b, _c;
    var header = document.getElementsByTagName("header")[0];
    var headerHeight = (_a = header === null || header === void 0 ? void 0 : header.getBoundingClientRect()) === null || _a === void 0 ? void 0 : _a.bottom;
    var headerInView = headerHeight > 0;
    var currentHeaderHeight = !headerInView ? 0 : headerHeight;
    // No header is in view or desktop
    var bookingHeaderHeight = (_c = (_b = document.getElementById("bookingHeader")) === null || _b === void 0 ? void 0 : _b.clientHeight) !== null && _c !== void 0 ? _c : 0;
    var defaultHeightValue = 0;
    if (!headerInView && bookingHeaderHeight === 0)
        defaultHeightValue = 0;
    else if (headerInView && bookingHeaderHeight === 0)
        defaultHeightValue = currentHeaderHeight - 22;
    else if (!headerInView && bookingHeaderHeight !== 0)
        defaultHeightValue = bookingHeaderHeight;
    else
        defaultHeightValue = currentHeaderHeight + bookingHeaderHeight;
    return defaultHeightValue;
};
var SlideOutOverlay = function (props) {
    var _a, _b, _c, _d, _e, _f, _g;
    var ref = useRef(null);
    var _h = __read(React__default.useState((props === null || props === void 0 ? void 0 : props.diffHeaderHeight) !== undefined ? props.diffHeaderHeight : defaultHeightValue()), 1), diffHeaderHeight = _h[0];
    var _j = __read(React__default.useState((props === null || props === void 0 ? void 0 : props.calcTopValue) ? props.calcTopValue() : defaultTopValue()), 2), diffTopHeight = _j[0], setDiffTopHeight = _j[1];
    var _k = __read(React__default.useState(props.events.sort(function (a, b) { return (a.Order > b.Order) ? 1 : -1; })), 1), events = _k[0];
    var _l = __read(React__default.useState((props.id) ? props.id : "slideOutOverlay"), 1), id = _l[0];
    var _m = __read(React__default.useState((_a = props.overlayClassName) !== null && _a !== void 0 ? _a : "".concat(id, "Portal")), 1), overlayClassName = _m[0];
    var _o = __read(React__default.useState((_b = props.contentClassName) !== null && _b !== void 0 ? _b : "".concat(id, "ContentClass")), 1), contentClassName = _o[0];
    var closeOverlay = function () {
        try {
            props.onClose();
            InteractionHandler.unlockScroll();
        }
        catch (error) {
            console.log(error);
        }
        finally {
            document.removeEventListener("touchstart", closeOverlay);
        }
    };
    var onAfterOpen = function () {
        setTimeout(function () {
            var element = document.getElementById("".concat(id, "CloseButton"));
            if (element)
                element === null || element === void 0 ? void 0 : element.addEventListener('touchend', closeOverlay);
        }, 1);
        if (props.onAfterOpen)
            props.onAfterOpen();
    };
    useEffect(function () {
        var _a;
        var topHeight = (_a = props === null || props === void 0 ? void 0 : props.calcTopValue) !== null && _a !== void 0 ? _a : defaultTopValue();
        setDiffTopHeight(topHeight);
        document.body.style.overflow = props.isOpen ? "hidden" : "auto";
        InteractionHandler.lockScroll();
    }, [props.isOpen]);
    useEffect(function () {
        var handleClickOutside = function (event) {
            var modal = document.getElementsByClassName(contentClassName)[0];
            if (modal && !modal.contains(event.target)) {
                InteractionHandler.unlockScroll();
                props.onClose();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function () {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);
    return (jsxRuntime.exports.jsx(SlideOutOverlayContainer, { children: jsxRuntime.exports.jsxs(Modal, __assign({ isOpen: props.isOpen, appElement: document.getElementsByClassName("ReactModalPortal")[0], aria: { labelledby: "".concat(id, "Title") }, onRequestClose: closeOverlay, onAfterOpen: onAfterOpen, shouldCloseOnEsc: true, shouldCloseOnOverlayClick: true, portalClassName: overlayClassName, className: contentClassName }, { children: [jsxRuntime.exports.jsx(SlideOutOverlayGlobalStyle, { "$modalClassName": overlayClassName, "$contentClassName": contentClassName, "$diffHeaderHeight": diffHeaderHeight, "$diffTopHeight": diffTopHeight }), jsxRuntime.exports.jsxs(ContentContainer, __assign({ ref: ref }, { children: [jsxRuntime.exports.jsxs(HeadingContainer, __assign({ id: "".concat(id, "HeadingWrapper") }, { children: [jsxRuntime.exports.jsxs(HeadingWrapper, { children: [((_c = props === null || props === void 0 ? void 0 : props.customStyles) === null || _c === void 0 ? void 0 : _c.changeDate) ?
                                            jsxRuntime.exports.jsx(ChangeDateHeadingTitle, __assign({ id: "".concat(id, "Title"), changeDate: (_d = props === null || props === void 0 ? void 0 : props.customStyles) === null || _d === void 0 ? void 0 : _d.changeDate }, { children: props.headingTitle }))
                                            :
                                                jsxRuntime.exports.jsx(SlideOutOverlayHeadingTitle, __assign({ id: "".concat(id, "Title"), headingTitle: (_e = props === null || props === void 0 ? void 0 : props.customStyles) === null || _e === void 0 ? void 0 : _e.headingTitle }, { children: props.headingTitle })), (props === null || props === void 0 ? void 0 : props.headingContent) &&
                                            jsxRuntime.exports.jsx(SlideOutOverlayHeadingContent, { id: "".concat(id, "HeadingContent"), style: (_f = props === null || props === void 0 ? void 0 : props.customStyles) === null || _f === void 0 ? void 0 : _f.headingContent, dangerouslySetInnerHTML: { __html: props === null || props === void 0 ? void 0 : props.headingContent } })] }), jsxRuntime.exports.jsx(CloseButton, __assign({ onClick: closeOverlay, "aria-label": props.closeButtonAriaLabel, "data-testid": "".concat(id, "CloseButtonDataTestID"), id: "".concat(id, "CloseButton") }, { children: jsxRuntime.exports.jsx(DefaultCloseModalIcon, { "aria-hidden": 'true' }) }))] })), jsxRuntime.exports.jsx(HorizontalDividerLight, { style: (_g = props === null || props === void 0 ? void 0 : props.customStyles) === null || _g === void 0 ? void 0 : _g.horizontalDividerLight }), jsxRuntime.exports.jsx(ContentWrapper$1, __assign({ id: "".concat(id, "ContentWrapper") }, { children: jsxRuntime.exports.jsx(EventSectionContainer, { children: events.map(function (item, i) { return (jsxRuntime.exports.jsx(EventSection, __assign({}, item), i)); }) }) }))] }))] })) }));
};

var spin = keyframes(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n0%  { transform: rotate(0deg); }\n100% { transform: rotate(360deg); }\n"], ["\n0%  { transform: rotate(0deg); }\n100% { transform: rotate(360deg); }\n"])));
var SpinnerContainer = styled.div.attrs(function (props) { return props; })(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n  border: .25em solid var(--", ");\n  border-top: .25em solid transparent;\n  border-radius: 50%;\n  width: ", "rem;\n  height: ", "rem;\n  animation: ", " 1s linear infinite;\n"], ["\n  border: .25em solid var(--", ");\n  border-top: .25em solid transparent;\n  border-radius: 50%;\n  width: ", "rem;\n  height: ", "rem;\n  animation: ", " 1s linear infinite;\n"])), function (props) { var _a; return (_a = props.color) !== null && _a !== void 0 ? _a : 'tundora'; }, function (props) { return props.radius; }, function (props) { return props.radius; }, spin);
var templateObject_1$3, templateObject_2$2;

var Loader = function (props) {
    var _a;
    var size = (_a = props.size) !== null && _a !== void 0 ? _a : 'small';
    var radius = size === 'small' ? 2 : 4;
    return !props.busy ? null :
        jsxRuntime.exports.jsx(SpinnerContainer, __assign({ "data-testid": props.testId, radius: radius, color: props.color, role: "alert", "aria-label": props.ariaLabel, "aria-busy": props.busy }, { children: jsxRuntime.exports.jsx(VisuallyHidden, { children: props.ariaLabel }) }));
};

var radioButtonStyles = css(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["  \n  position: relative;\n  top: 6px;\n  left: 10px;\n  display: block;\n  width: 5px;\n  height: 10px;\n  content: \"\";\n  border-width: 0 1.8px 1.8px 0;\n  -webkit-transform: rotate(45deg);\n"], ["  \n  position: relative;\n  top: 6px;\n  left: 10px;\n  display: block;\n  width: 5px;\n  height: 10px;\n  content: \"\";\n  border-width: 0 1.8px 1.8px 0;\n  -webkit-transform: rotate(45deg);\n"])));
styled.div(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n  display: inline-block;\n  vertical-align: middle;\n"], ["\n  display: inline-block;\n  vertical-align: middle;\n"])));
var StyledRadioButton = styled.input(templateObject_7$1 || (templateObject_7$1 = __makeTemplateObject(["\n  width: 24px;\n  height: 24px;\n  background:", ";\n  transition: all 150ms;\n  border: ", "; \n  box-sizing: border-box;\n  border-radius: 50%;\n  appearance: none;\n\n  ", "\n\n  ", "\n\n", "\n"], ["\n  width: 24px;\n  height: 24px;\n  background:", ";\n  transition: all 150ms;\n  border: ", "; \n  box-sizing: border-box;\n  border-radius: 50%;\n  appearance: none;\n\n  ", "\n\n  ", "\n\n", "\n"])), function (props) { return props.checked ? 'var(--tory-blue)' : 'var(--white)'; }, function (props) { return props.checked ? 'none' : '1px solid var(--gray)'; }, function (props) {
    return !props.disabled && css(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n      &:focus {\n        box-shadow: 0 0 0 3px var(--bondi-blue);\n      }\n    "], ["\n      &:focus {\n        box-shadow: 0 0 0 3px var(--bondi-blue);\n      }\n    "])));
}, function (props) {
    return props.checked && (!props.disabled ? css(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject(["\n      &:after {     \n        border: solid var(--white);\n        ", "  \n      }"], ["\n      &:after {     \n        border: solid var(--white);\n        ", "  \n      }"])), radioButtonStyles) : css(templateObject_5$1 || (templateObject_5$1 = __makeTemplateObject(["\n      &:after {\n        border: solid var(--gray);\n        ", "  \n      }\n      border: none;\n      "], ["\n      &:after {\n        border: solid var(--gray);\n        ", "  \n      }\n      border: none;\n      "])), radioButtonStyles));
}, function (props) {
    return props.disabled && css(templateObject_6$1 || (templateObject_6$1 = __makeTemplateObject([" \n      background: var(--cararra);\n    "], [" \n      background: var(--cararra);\n    "])));
});
var templateObject_1$2, templateObject_2$1, templateObject_3$1, templateObject_4$1, templateObject_5$1, templateObject_6$1, templateObject_7$1;

var RadioButton = function (props) {
    function handleKeyDown(e) {
        if (e.key === 'Enter') {
            props.clickHandler();
        }
    }
    return (jsxRuntime.exports.jsx(jsxRuntime.exports.Fragment, { children: jsxRuntime.exports.jsx(StyledRadioButton, { ref: props.elRef, checked: props.isChecked, "aria-checked": props.isChecked, type: "checkbox", "aria-label": props.ariaLabel, "data-testid": props.testId, onChange: props.clickHandler, onKeyDown: handleKeyDown, disabled: props.disabled }) }));
};

var OptimizelyScript = function (props) {
    return (props.optimizelyUrl !== undefined && props.optimizelyUrl !== null && props.optimizelyUrl.length > 0 ?
        jsxRuntime.exports.jsx("script", { src: props.optimizelyUrl })
        : jsxRuntime.exports.jsx(jsxRuntime.exports.Fragment, {}));
};

var TAB = 'Tab';

var focusableSelector = "\n    a[href]:not([tabindex=\"-1\"]),\n    area[href]:not([tabindex=\"-1\"]),\n    input:not([disabled]):not([tabindex=\"-1\"]),\n    select:not([disabled]):not([tabindex=\"-1\"]),\n    textarea:not([disabled]):not([tabindex=\"-1\"]),\n    button:not([disabled]):not([tabindex=\"-1\"]),\n    iframe:not([tabindex=\"-1\"]),\n    object:not([tabindex=\"-1\"]),\n    embed:not([tabindex=\"-1\"]),\n    [tabindex]:not([tabindex=\"-1\"]),\n    [contenteditable]:not([tabindex=\"-1\"])\n";

var FocusTrap = function (_a) {
    var children = _a.children, _b = _a.disabled, disabled = _b === void 0 ? false : _b, dataId = _a.dataId;
    var nodeRef = useRef(null);
    var getFocusableElements = function () {
        if (!nodeRef.current) {
            return [];
        }
        return Array.from(nodeRef.current.querySelectorAll(focusableSelector));
    };
    var handleKeyDown = function (event) {
        if (disabled || event.key !== TAB) {
            return;
        }
        var focusableElements = getFocusableElements();
        if (focusableElements.length === 0 || !document.activeElement) {
            return;
        }
        var focusIndex = focusableElements.indexOf(document.activeElement);
        var initialIndex = focusIndex;
        do {
            if (event.shiftKey) {
                if (focusIndex < 1) {
                    focusIndex = focusableElements.length - 1;
                }
                else {
                    focusIndex -= 1;
                }
            }
            else if (focusIndex === focusableElements.length - 1) {
                focusIndex = 0;
            }
            else {
                focusIndex += 1;
            }
            var element = focusableElements[focusIndex];
            if (element instanceof HTMLElement) {
                element.focus();
            }
            if (focusIndex === initialIndex) {
                break;
            }
        } while (document.activeElement !== focusableElements[focusIndex]);
        event.preventDefault();
    };
    return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    jsxRuntime.exports.jsx("div", __assign({ ref: nodeRef, onKeyDown: handleKeyDown, "data-testid": dataId }, { children: children })));
};

var AdaGlobalOutlineStyle = createGlobalStyle(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  .be-ada-global-outline {\n    a:focus,\n    input:focus,\n    button:focus,\n    select:focus,\n    object:focus,\n    [tabindex]:focus {\n      outline: 3px solid var(--bondi-blue);\n      outline-offset: 0;\n    };\n  };\n"], ["\n  .be-ada-global-outline {\n    a:focus,\n    input:focus,\n    button:focus,\n    select:focus,\n    object:focus,\n    [tabindex]:focus {\n      outline: 3px solid var(--bondi-blue);\n      outline-offset: 0;\n    };\n  };\n"])));
var templateObject_1$1;

function adaListener() {
    document.documentElement.classList.add('be-ada-global-outline');
}
var AdaGlobalOutline = function (_a) {
    var children = _a.children;
    React.useEffect(function () {
        document.addEventListener('keyup', adaListener);
        return function () { return document.removeEventListener('keyup', adaListener); };
    }, []);
    return (jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, { children: [jsxRuntime.exports.jsx(AdaGlobalOutlineStyle, {}), children] }));
};

//**desktop styles***/
var ContentWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  min-width: 343px;\n  min-height: 300px;\n\n  ", " {     \n    min-width: 308px;\n    min-height: 311px;\n  }\n"], ["\n  display: flex;\n  min-width: 343px;\n  min-height: 300px;\n\n  ", " {     \n    min-width: 308px;\n    min-height: 311px;\n  }\n"])), up('md'));
var Content = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n"], ["\n"])));
var ImageContainerWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n"], ["\n  display: flex;\n  justify-content: center;\n"])));
var Image = styled.img(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  height: 110px;\n  width: 96px;\n\n  ", " {    \n    height: 138px;\n    width: 119px;\n  }\n"], ["\n  height: 110px;\n  width: 96px;\n\n  ", " {    \n    height: 138px;\n    width: 119px;\n  }\n"])), up('md'));
var OhSnapContainerWrapper = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n"], ["\n  display: flex;\n  justify-content: center;\n"])));
var OhSnapContainer = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", "\n  font-size: var(--font-size-34);\n  width: 119px;\n  height: 38px;\n  margin-top: var(--spacing_token_m); \n  letter-spacing: 0;\n  line-height: 38px;\n  white-space: nowrap;\n"], ["\n  ", "\n  font-size: var(--font-size-34);\n  width: 119px;\n  height: 38px;\n  margin-top: var(--spacing_token_m); \n  letter-spacing: 0;\n  line-height: 38px;\n  white-space: nowrap;\n"])), TempostdHeavycondensedNormalToryBlu);
var MessageContainerWrapper = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n"], ["\n  display: flex;\n  justify-content: center;\n"])));
var MessageContainer = styled.p(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  ", "\n  font-weight: 400;\n  line-height:20px;\n  font-size:16px;\n  width: 343px;\n  min-height: 40px;\n  margin-top: var(--spacing_token_s);\n  letter-spacing: 0;\n  text-align: center;\n\n  ", " {    \n    width: 311px;\n    min-height: 20px;\n  }\n"], ["\n  ", "\n  font-weight: 400;\n  line-height:20px;\n  font-size:16px;\n  width: 343px;\n  min-height: 40px;\n  margin-top: var(--spacing_token_s);\n  letter-spacing: 0;\n  text-align: center;\n\n  ", " {    \n    width: 311px;\n    min-height: 20px;\n  }\n"])), OpensansNormalTundora16px, up('md'));
var NewSearchButtonContainerWrapper = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n"], ["\n  display: flex;\n  justify-content: center;\n"])));
var NewSearchButtonContainer = styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  width: 173px;\n  height: 48px;\n  margin-top: var(--spacing_token_m);\n"], ["\n  width: 173px;\n  height: 48px;\n  margin-top: var(--spacing_token_m);\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;

var img$1 = "data:image/png;base64,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";

var img = "data:image/png;base64,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";

var OhSnap = function (props) {
    var _a, _b;
    var bp = useBreakpoints();
    return (jsxRuntime.exports.jsx(ContentWrapper, __assign({ "data-testid": props.ohSnapContainerTestId }, { children: jsxRuntime.exports.jsxs(Content, { children: [jsxRuntime.exports.jsx(ImageContainerWrapper, { children: jsxRuntime.exports.jsx(Image, { src: bp.isDesktop ? img$1 : img }) }), jsxRuntime.exports.jsx(OhSnapContainerWrapper, { children: jsxRuntime.exports.jsx(OhSnapContainer, { children: (_a = props.ohSnapContainerHeaderLabel) === null || _a === void 0 ? void 0 : _a.toLocaleUpperCase() }) }), jsxRuntime.exports.jsx(MessageContainerWrapper, { children: jsxRuntime.exports.jsx(MessageContainer, { children: props.errorMessage }) }), jsxRuntime.exports.jsx(NewSearchButtonContainerWrapper, { children: jsxRuntime.exports.jsx(NewSearchButtonContainer, { children: jsxRuntime.exports.jsx(Button, __assign({ buttonType: "primary-red", size: "small", clickHandler: props.startNewSearch, "data-testid": props.startNewSearchButtonTestId, ariaLabel: props.startNewSearchButtonCaption }, { children: (_b = props.startNewSearchButtonCaption) === null || _b === void 0 ? void 0 : _b.toLocaleUpperCase() })) }) })] }) })));
};

function getLocalResources() {
    return {
        ComponentName: "PullDownReceipt",
        // AppName:"",
        PullDownReceiptResources: {
            cruiseSummaryTitle: "Cruise Summary",
            itineraryLabel: "Itinerary: ",
            shipLabel: "Ship: ",
            roomLabel: "Your Room: ",
            totalLabel: "Total:",
            todaysDepositLabel: "Today’s Deposit:",
            balanceLabel: "Balance Due on {0}:",
            continueButtonText: "CONTINUE",
            addGuestRoomButtonText: "ADD GUEST OR ROOMS",
        }
    };
}
function getLocalResourcesAU() {
    var resources = getLocalResources();
    return resources;
}

function fetchApi(input, init) {
    var proxy = 'false';
    var token = '';
    var cypress = 'false';
    if (typeof process !== 'undefined') {
        if (process !== undefined && process !== null) {
            proxy = process.env.REACT_APP_PROXY_TO_UAT;
            token = process.env.REACT_APP_UAT_TOKEN_PARAM;
            cypress = process.env.REACT_APP_CYPRESS;
        }
    }
    if (proxy === 'true' && typeof input === 'string' && !cypress) {
        if (input.indexOf('?') > -1) {
            input += "&".concat(token);
        }
        else {
            input += "/?".concat(token);
        }
    }
    return cclFetch(input, init);
}

/**
 * @param getLocalResources  - function that returns resources for US locality
 * @param getLocalResourcesAU - function that returns resources for AU locality
 * @param shouldFetchRemote - optional function that returns a boolean indicating to fetch/override resources from resources repository (aka sitecore)
 * @returns resources for current locality conditionally fetching from remote repository
 */
function useResources(getLocalResources, getLocalResourcesAU, shouldFetchRemote) {
    var _a = __read(useState({}), 2), resources = _a[0], setResources = _a[1];
    var _b = __read(useState(false), 2), isInitialized = _b[0], setIsInitialized = _b[1];
    useEffect(function () {
        var _a;
        if (!isInitialized) {
            setIsInitialized(true);
            var language = LocalityService.getLocality() === '7' ? 'en-AU' : 'en';
            var resources_1 = language === 'en' ? getLocalResources() : getLocalResourcesAU();
            var retrieveFromSitecore = false;
            if (shouldFetchRemote === undefined) {
                retrieveFromSitecore = (typeof process !== 'undefined' && process !== undefined && process !== null && !process.env.REACT_APP_CYPRESS);
            }
            else {
                retrieveFromSitecore = shouldFetchRemote();
            }
            if (retrieveFromSitecore) {
                var appName = (_a = resources_1.AppName) !== null && _a !== void 0 ? _a : resources_1.ComponentName;
                var url = "/Carnival.ComponentResources.axd?componentNames=".concat(resources_1.ComponentName, "&lang=").concat(language, "&app=").concat(appName, "&propName=").concat(appName, "&format=json");
                fetchApi(url).then(function (result) {
                    var e_1, _a;
                    var _b;
                    var _loop_1 = function (key, value) {
                        var e_2, _f;
                        var fullKeyComponentResource = (_b = Object.keys(result).find(function (x) { return x.includes(key); })) !== null && _b !== void 0 ? _b : '';
                        var currentResources = result[fullKeyComponentResource];
                        if (currentResources) {
                            currentObject = Reflect.get(resources_1, key);
                            try {
                                for (var _g = (e_2 = void 0, __values(Object.keys(value))), _h = _g.next(); !_h.done; _h = _g.next()) {
                                    var key1 = _h.value;
                                    item = currentResources.StringResources[key1];
                                    if (item) {
                                        Reflect.set(currentObject, key1, item);
                                    }
                                    else {
                                        item = currentResources.HtmlFragmentResources[key1];
                                        if (item) {
                                            Reflect.set(currentObject, key1, item);
                                        }
                                        else {
                                            image = currentResources.ImageResources[key1];
                                            if (image) {
                                                Reflect.set(currentObject, key1, image);
                                            }
                                        }
                                    }
                                }
                            }
                            catch (e_2_1) { e_2 = { error: e_2_1 }; }
                            finally {
                                try {
                                    if (_h && !_h.done && (_f = _g.return)) _f.call(_g);
                                }
                                finally { if (e_2) throw e_2.error; }
                            }
                            Reflect.set(resources_1, key, currentObject);
                        }
                    };
                    var currentObject, item, image;
                    try {
                        for (var _c = __values(Object.entries(resources_1)), _d = _c.next(); !_d.done; _d = _c.next()) {
                            var _e = __read(_d.value, 2), key = _e[0], value = _e[1];
                            _loop_1(key, value);
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                    setResources(__assign({}, resources_1));
                }).catch(function () {
                    setResources(resources_1);
                });
            }
            else {
                setResources(resources_1);
            }
        }
    }, [isInitialized, getLocalResources, getLocalResourcesAU, shouldFetchRemote]);
    return resources;
}

var profileApiResponseMock = {
    "title": '',
    "username": "maria_90@hotmail.com",
    "sex": "M",
    "dateOfBirth": new Date("1992-05-09T04:00:00Z"),
    "emailPreference": "OUT",
    "email": "maria_90@hotmail.com",
    "lastName": "Rodriguez",
    "middleName": '',
    "firstName": "Maria",
    "personNumber": 999999009966224,
    "loyaltyNumber": 9012459651,
    "yearFirstSailed": 0,
    "sendToMail": true,
    "sendToEmail": false,
    "totalCruisesSinceFirstSailed": 3,
    "tier": {
        "activationDate": "2020-05-07T00:00:00Z",
        "adjustedDayPoints": 0,
        "totalCruiseDays": 0,
        "totalEarnedCruiseDays": 0,
        "totalVifpPoints": 0,
        "cruiseDaysToNextTier": 1,
        "tierCode": "00",
        "tierTitle": "BLUE"
    },
    "household": {
        "address1": '',
        "address2": '',
        "city": '',
        "stateCode": '',
        "countryCode": "CA",
        "zipCode": ''
    },
    "phone": {
        "type": "DAY",
        "countryCode": "1",
        "areaCode": "123",
        "number": "4567890",
        "ext": ''
    },
    "bookings": [],
    "nextTier": {
        "tierCode": "01",
        "tierName": "RED"
    }
};

function getProfileApiResponseMock(isUserAuthenticated) {
    return new Promise(function (resolve, reject) {
        if (isUserAuthenticated) {
            resolve(profileApiResponseMock);
        }
        else {
            reject({
                status: 401,
                message: 'Unauthorized'
            });
        }
    });
}

var CCL_USER_COOKIE_NAME = "cclUser";
var CCL_SESSION_COOKIE_NAME = "cclSession";
function getCclUserFromCookie() {
    return CookieService.getJSON(CCL_USER_COOKIE_NAME);
}
function isUserAuthenticated() {
    var cclSession = CookieService.getJSON(CCL_SESSION_COOKIE_NAME);
    return !!cclSession && cclSession.IsAuthenticated;
}
function getProfile(shouldFetchRemote) {
    var opts = {
        method: 'GET',
        headers: new Headers({ 'Accept': 'application/json', 'Content-Type': 'application/json' })
    };
    var shouldMockCall = shouldFetchRemote === undefined || shouldFetchRemote === null ?
        typeof process !== "undefined" &&
            process !== undefined &&
            process !== null &&
            process.env.REACT_APP_CYPRESS :
        !shouldFetchRemote();
    return shouldMockCall ?
        getProfileApiResponseMock(isUserAuthenticated()) : cclFetch(API_URLS.GetProfile, opts).then(function (res) { return res; });
}
var ProfileService = {
    isUserAuthenticated: isUserAuthenticated,
    getCclUserFromCookie: getCclUserFromCookie,
    getProfile: getProfile
};

function useProfile() {
    var _a = __read(useState(ProfileService.getCclUserFromCookie()), 1), user = _a[0];
    var _b = __read(useState(ProfileService.isUserAuthenticated()), 1), authenticated = _b[0];
    return {
        user: user,
        authenticated: authenticated
    };
}

function loadJS(src, cb) {
    var ref = document.getElementsByTagName("script")[0];
    var script = document.createElement("script");
    script.src = src;
    script.async = true;
    if (ref.parentNode) {
        ref.parentNode.insertBefore(script, ref);
        if (cb && typeof cb === "function") {
            script.onload = cb;
        }
        return script;
    }
}
function initAndOpenLoginSignUpModal(route, fnCallBack, appElement, onAfterClose, onAfterOpen) {
    if (window["LoginRegisterApp"]) {
        openLoginSignUpModal(route, fnCallBack, appElement, onAfterClose, onAfterOpen);
    }
    else {
        loadJS("/profilemanagement/cclr-login-register-app/static/js/main.js", function () {
            loginSignUpModalFirstRun(route, fnCallBack, appElement, onAfterClose, onAfterOpen);
        });
    }
}
function loginSignUpModalFirstRun(route, fnCallBack, appElement, onAfterClose, onAfterOpen) {
    if (window["LoginRegisterApp"]) {
        openLoginSignUpModal(route, fnCallBack, appElement, onAfterClose, onAfterOpen);
    }
    else {
        setTimeout(function () {
            loginSignUpModalFirstRun(route, fnCallBack, appElement, onAfterClose, onAfterOpen);
        }, 500);
    }
}
function openLoginSignUpModal(route, fnCallBack, appElement, onAfterClose, onAfterOpen) {
    var _a;
    var defaultAppElement = (_a = document.getElementById("__next")) !== null && _a !== void 0 ? _a : document.getElementById("root");
    var options = {
        mode: "modal",
        initialRoute: route,
        mainContent: appElement !== null && appElement !== void 0 ? appElement : defaultAppElement,
        onLogin: fnCallBack !== null && fnCallBack !== void 0 ? fnCallBack : ssoOnLogin,
        enrollMethod: "",
        onAfterClose: onAfterClose,
        onAfterOpen: onAfterOpen
    };
    window["LoginRegisterApp"].open(options);
}
function ssoOnLogin(token, hasBookings) {
    window.location.reload();
}

var sugarCore = {exports: {}};

/*
 *  Sugar v2.0.6
 *
 *  Freely distributable and licensed under the MIT-style license.
 *  Copyright (c) Andrew Plummer
 *  https://sugarjs.com/
 *
 * ---------------------------- */

(function (module) {
(function() {

  /***
   * @module Core
   * @description Core functionality including the ability to define methods and
   *              extend onto natives.
   *
   ***/

  // The global to export.
  var Sugar;

  // The name of Sugar in the global namespace.
  var SUGAR_GLOBAL = 'Sugar';

  // Natives available on initialization. Letting Object go first to ensure its
  // global is set by the time the rest are checking for chainable Object methods.
  var NATIVE_NAMES = 'Object Number String Array Date RegExp Function';

  // Static method flag
  var STATIC   = 0x1;

  // Instance method flag
  var INSTANCE = 0x2;

  // IE8 has a broken defineProperty but no defineProperties so this saves a try/catch.
  var PROPERTY_DESCRIPTOR_SUPPORT = !!(Object.defineProperty && Object.defineProperties);

  var globalContext = getGlobal();

  // Whether object instance methods can be mapped to the prototype.
  var allowObjectPrototype = false;

  // A map from Array to SugarArray.
  var namespacesByName = {};

  // A map from [object Object] to namespace.
  var namespacesByClassString = {};

  // Defining properties.
  // istanbul ignore next
  var defineProperty = PROPERTY_DESCRIPTOR_SUPPORT ?  Object.defineProperty : definePropertyShim;

  // A default chainable class for unknown types.
  var DefaultChainable = getNewChainableClass('Chainable');


  // Global methods

  function getGlobal() {
    // Get global context by keyword here to avoid issues with libraries
    // that can potentially alter this script's context object.
    return testGlobal(typeof commonjsGlobal !== 'undefined' && commonjsGlobal) ||
           testGlobal(typeof window !== 'undefined' && window);
  }

  function testGlobal(obj) {
    // Note that Rhino uses a different "global" keyword so perform an
    // extra check here to ensure that it's actually the global object.
    return obj && obj.Object === Object ? obj : null;
  }

  function setupGlobal() {
    Sugar = globalContext[SUGAR_GLOBAL];
    // istanbul ignore if
    if (Sugar) {
      // Reuse already defined Sugar global object.
      return;
    }
    Sugar = function(arg) {
      forEachProperty(Sugar, function(sugarNamespace, name) {
        // Although only the only enumerable properties on the global
        // object are Sugar namespaces, environments that can't set
        // non-enumerable properties will step through the utility methods
        // as well here, so use this check to only allow true namespaces.
        if (hasOwn(namespacesByName, name)) {
          sugarNamespace.extend(arg);
        }
      });
      return Sugar;
    };
    // istanbul ignore else
    if (module.exports) {
      // Node or webpack environment
      module.exports = Sugar;
    } else {
      // Unwrapped browser environment
      try {
        globalContext[SUGAR_GLOBAL] = Sugar;
      } catch (e) {
        // Contexts such as QML have a read-only global context.
      }
    }
    forEachProperty(NATIVE_NAMES.split(' '), function(name) {
      createNamespace(name);
    });
    setGlobalProperties();
  }

  /***
   * @method createNamespace(name)
   * @returns SugarNamespace
   * @namespace Sugar
   * @short Creates a new Sugar namespace.
   * @extra This method is for plugin developers who want to define methods to be
   *        used with natives that Sugar does not handle by default. The new
   *        namespace will appear on the `Sugar` global with all the methods of
   *        normal namespaces, including the ability to define new methods. When
   *        extended, any defined methods will be mapped to `name` in the global
   *        context.
   *
   * @example
   *
   *   Sugar.createNamespace('Boolean');
   *
   * @param {string} name - The namespace name.
   *
   ***/
  function createNamespace(name) {

    // Is the current namespace Object?
    var isObject = name === 'Object';

    // A Sugar namespace is also a chainable class: Sugar.Array, etc.
    var sugarNamespace = getNewChainableClass(name);

    /***
     * @method extend([opts])
     * @returns Sugar
     * @namespace Sugar
     * @short Extends Sugar defined methods onto natives.
     * @extra This method can be called on individual namespaces like
     *        `Sugar.Array` or on the `Sugar` global itself, in which case
     *        [opts] will be forwarded to each `extend` call. For more,
     *        see `extending`.
     *
     * @options
     *
     *   methods           An array of method names to explicitly extend.
     *
     *   except            An array of method names or global namespaces (`Array`,
     *                     `String`) to explicitly exclude. Namespaces should be the
     *                     actual global objects, not strings.
     *
     *   namespaces        An array of global namespaces (`Array`, `String`) to
     *                     explicitly extend. Namespaces should be the actual
     *                     global objects, not strings.
     *
     *   enhance           A shortcut to disallow all "enhance" flags at once
     *                     (flags listed below). For more, see `enhanced methods`.
     *                     Default is `true`.
     *
     *   enhanceString     A boolean allowing String enhancements. Default is `true`.
     *
     *   enhanceArray      A boolean allowing Array enhancements. Default is `true`.
     *
     *   objectPrototype   A boolean allowing Sugar to extend Object.prototype
     *                     with instance methods. This option is off by default
     *                     and should generally not be used except with caution.
     *                     For more, see `object methods`.
     *
     * @example
     *
     *   Sugar.Array.extend();
     *   Sugar.extend();
     *
     * @option {Array<string>} [methods]
     * @option {Array<string|NativeConstructor>} [except]
     * @option {Array<NativeConstructor>} [namespaces]
     * @option {boolean} [enhance]
     * @option {boolean} [enhanceString]
     * @option {boolean} [enhanceArray]
     * @option {boolean} [objectPrototype]
     * @param {ExtendOptions} [opts]
     *
     ***
     * @method extend([opts])
     * @returns SugarNamespace
     * @namespace SugarNamespace
     * @short Extends Sugar defined methods for a specific namespace onto natives.
     * @param {ExtendOptions} [opts]
     *
     ***/
    var extend = function (opts) {

      var nativeClass = globalContext[name], nativeProto = nativeClass.prototype;
      var staticMethods = {}, instanceMethods = {}, methodsByName;

      function objectRestricted(name, target) {
        return isObject && target === nativeProto &&
               (!allowObjectPrototype || name === 'get' || name === 'set');
      }

      function arrayOptionExists(field, val) {
        var arr = opts[field];
        if (arr) {
          for (var i = 0, el; el = arr[i]; i++) {
            if (el === val) {
              return true;
            }
          }
        }
        return false;
      }

      function arrayOptionExcludes(field, val) {
        return opts[field] && !arrayOptionExists(field, val);
      }

      function disallowedByFlags(methodName, target, flags) {
        // Disallowing methods by flag currently only applies if methods already
        // exist to avoid enhancing native methods, as aliases should still be
        // extended (i.e. Array#all should still be extended even if Array#every
        // is being disallowed by a flag).
        if (!target[methodName] || !flags) {
          return false;
        }
        for (var i = 0; i < flags.length; i++) {
          if (opts[flags[i]] === false) {
            return true;
          }
        }
      }

      function namespaceIsExcepted() {
        return arrayOptionExists('except', nativeClass) ||
               arrayOptionExcludes('namespaces', nativeClass);
      }

      function methodIsExcepted(methodName) {
        return arrayOptionExists('except', methodName);
      }

      function canExtend(methodName, method, target) {
        return !objectRestricted(methodName, target) &&
               !disallowedByFlags(methodName, target, method.flags) &&
               !methodIsExcepted(methodName);
      }

      opts = opts || {};
      methodsByName = opts.methods;

      if (namespaceIsExcepted()) {
        return;
      } else if (isObject && typeof opts.objectPrototype === 'boolean') {
        // Store "objectPrototype" flag for future reference.
        allowObjectPrototype = opts.objectPrototype;
      }

      forEachProperty(methodsByName || sugarNamespace, function(method, methodName) {
        if (methodsByName) {
          // If we have method names passed in an array,
          // then we need to flip the key and value here
          // and find the method in the Sugar namespace.
          methodName = method;
          method = sugarNamespace[methodName];
        }
        if (hasOwn(method, 'instance') && canExtend(methodName, method, nativeProto)) {
          instanceMethods[methodName] = method.instance;
        }
        if(hasOwn(method, 'static') && canExtend(methodName, method, nativeClass)) {
          staticMethods[methodName] = method;
        }
      });

      // Accessing the extend target each time instead of holding a reference as
      // it may have been overwritten (for example Date by Sinon). Also need to
      // access through the global to allow extension of user-defined namespaces.
      extendNative(nativeClass, staticMethods);
      extendNative(nativeProto, instanceMethods);

      if (!methodsByName) {
        // If there are no method names passed, then
        // all methods in the namespace will be extended
        // to the native. This includes all future defined
        // methods, so add a flag here to check later.
        setProperty(sugarNamespace, 'active', true);
      }
      return sugarNamespace;
    };

    function defineWithOptionCollect(methodName, instance, args) {
      setProperty(sugarNamespace, methodName, function(arg1, arg2, arg3) {
        var opts = collectDefineOptions(arg1, arg2, arg3);
        defineMethods(sugarNamespace, opts.methods, instance, args, opts.last);
        return sugarNamespace;
      });
    }

    /***
     * @method defineStatic(methods)
     * @returns SugarNamespace
     * @namespace SugarNamespace
     * @short Defines static methods on the namespace that can later be extended
     *        onto the native globals.
     * @extra Accepts either a single object mapping names to functions, or name
     *        and function as two arguments. If `extend` was previously called
     *        with no arguments, the method will be immediately mapped to its
     *        native when defined.
     *
     * @example
     *
     *   Sugar.Number.defineStatic({
     *     isOdd: function (num) {
     *       return num % 2 === 1;
     *     }
     *   });
     *
     * @signature defineStatic(methodName, methodFn)
     * @param {Object} methods - Methods to be defined.
     * @param {string} methodName - Name of a single method to be defined.
     * @param {Function} methodFn - Function body of a single method to be defined.
     ***/
    defineWithOptionCollect('defineStatic', STATIC);

    /***
     * @method defineInstance(methods)
     * @returns SugarNamespace
     * @namespace SugarNamespace
     * @short Defines methods on the namespace that can later be extended as
     *        instance methods onto the native prototype.
     * @extra Accepts either a single object mapping names to functions, or name
     *        and function as two arguments. All functions should accept the
     *        native for which they are mapped as their first argument, and should
     *        never refer to `this`. If `extend` was previously called with no
     *        arguments, the method will be immediately mapped to its native when
     *        defined.
     *
     *        Methods cannot accept more than 4 arguments in addition to the
     *        native (5 arguments total). Any additional arguments will not be
     *        mapped. If the method needs to accept unlimited arguments, use
     *        `defineInstanceWithArguments`. Otherwise if more options are
     *        required, use an options object instead.
     *
     * @example
     *
     *   Sugar.Number.defineInstance({
     *     square: function (num) {
     *       return num * num;
     *     }
     *   });
     *
     * @signature defineInstance(methodName, methodFn)
     * @param {Object} methods - Methods to be defined.
     * @param {string} methodName - Name of a single method to be defined.
     * @param {Function} methodFn - Function body of a single method to be defined.
     ***/
    defineWithOptionCollect('defineInstance', INSTANCE);

    /***
     * @method defineInstanceAndStatic(methods)
     * @returns SugarNamespace
     * @namespace SugarNamespace
     * @short A shortcut to define both static and instance methods on the namespace.
     * @extra This method is intended for use with `Object` instance methods. Sugar
     *        will not map any methods to `Object.prototype` by default, so defining
     *        instance methods as static helps facilitate their proper use.
     *
     * @example
     *
     *   Sugar.Object.defineInstanceAndStatic({
     *     isAwesome: function (obj) {
     *       // check if obj is awesome!
     *     }
     *   });
     *
     * @signature defineInstanceAndStatic(methodName, methodFn)
     * @param {Object} methods - Methods to be defined.
     * @param {string} methodName - Name of a single method to be defined.
     * @param {Function} methodFn - Function body of a single method to be defined.
     ***/
    defineWithOptionCollect('defineInstanceAndStatic', INSTANCE | STATIC);


    /***
     * @method defineStaticWithArguments(methods)
     * @returns SugarNamespace
     * @namespace SugarNamespace
     * @short Defines static methods that collect arguments.
     * @extra This method is identical to `defineStatic`, except that when defined
     *        methods are called, they will collect any arguments past `n - 1`,
     *        where `n` is the number of arguments that the method accepts.
     *        Collected arguments will be passed to the method in an array
     *        as the last argument defined on the function.
     *
     * @example
     *
     *   Sugar.Number.defineStaticWithArguments({
     *     addAll: function (num, args) {
     *       for (var i = 0; i < args.length; i++) {
     *         num += args[i];
     *       }
     *       return num;
     *     }
     *   });
     *
     * @signature defineStaticWithArguments(methodName, methodFn)
     * @param {Object} methods - Methods to be defined.
     * @param {string} methodName - Name of a single method to be defined.
     * @param {Function} methodFn - Function body of a single method to be defined.
     ***/
    defineWithOptionCollect('defineStaticWithArguments', STATIC, true);

    /***
     * @method defineInstanceWithArguments(methods)
     * @returns SugarNamespace
     * @namespace SugarNamespace
     * @short Defines instance methods that collect arguments.
     * @extra This method is identical to `defineInstance`, except that when
     *        defined methods are called, they will collect any arguments past
     *        `n - 1`, where `n` is the number of arguments that the method
     *        accepts. Collected arguments will be passed to the method as the
     *        last argument defined on the function.
     *
     * @example
     *
     *   Sugar.Number.defineInstanceWithArguments({
     *     addAll: function (num, args) {
     *       for (var i = 0; i < args.length; i++) {
     *         num += args[i];
     *       }
     *       return num;
     *     }
     *   });
     *
     * @signature defineInstanceWithArguments(methodName, methodFn)
     * @param {Object} methods - Methods to be defined.
     * @param {string} methodName - Name of a single method to be defined.
     * @param {Function} methodFn - Function body of a single method to be defined.
     ***/
    defineWithOptionCollect('defineInstanceWithArguments', INSTANCE, true);

    /***
     * @method defineStaticPolyfill(methods)
     * @returns SugarNamespace
     * @namespace SugarNamespace
     * @short Defines static methods that are mapped onto the native if they do
     *        not already exist.
     * @extra Intended only for use creating polyfills that follow the ECMAScript
     *        spec. Accepts either a single object mapping names to functions, or
     *        name and function as two arguments. Note that polyfill methods will
     *        be immediately mapped onto their native prototype regardless of the
     *        use of `extend`.
     *
     * @example
     *
     *   Sugar.Object.defineStaticPolyfill({
     *     keys: function (obj) {
     *       // get keys!
     *     }
     *   });
     *
     * @signature defineStaticPolyfill(methodName, methodFn)
     * @param {Object} methods - Methods to be defined.
     * @param {string} methodName - Name of a single method to be defined.
     * @param {Function} methodFn - Function body of a single method to be defined.
     ***/
    setProperty(sugarNamespace, 'defineStaticPolyfill', function(arg1, arg2, arg3) {
      var opts = collectDefineOptions(arg1, arg2, arg3);
      extendNative(globalContext[name], opts.methods, true, opts.last);
      return sugarNamespace;
    });

    /***
     * @method defineInstancePolyfill(methods)
     * @returns SugarNamespace
     * @namespace SugarNamespace
     * @short Defines instance methods that are mapped onto the native prototype
     *        if they do not already exist.
     * @extra Intended only for use creating polyfills that follow the ECMAScript
     *        spec. Accepts either a single object mapping names to functions, or
     *        name and function as two arguments. This method differs from
     *        `defineInstance` as there is no static signature (as the method
     *        is mapped as-is to the native), so it should refer to its `this`
     *        object. Note that polyfill methods will be immediately mapped onto
     *        their native prototype regardless of the use of `extend`.
     *
     * @example
     *
     *   Sugar.Array.defineInstancePolyfill({
     *     indexOf: function (arr, el) {
     *       // index finding code here!
     *     }
     *   });
     *
     * @signature defineInstancePolyfill(methodName, methodFn)
     * @param {Object} methods - Methods to be defined.
     * @param {string} methodName - Name of a single method to be defined.
     * @param {Function} methodFn - Function body of a single method to be defined.
     ***/
    setProperty(sugarNamespace, 'defineInstancePolyfill', function(arg1, arg2, arg3) {
      var opts = collectDefineOptions(arg1, arg2, arg3);
      extendNative(globalContext[name].prototype, opts.methods, true, opts.last);
      // Map instance polyfills to chainable as well.
      forEachProperty(opts.methods, function(fn, methodName) {
        defineChainableMethod(sugarNamespace, methodName, fn);
      });
      return sugarNamespace;
    });

    /***
     * @method alias(toName, from)
     * @returns SugarNamespace
     * @namespace SugarNamespace
     * @short Aliases one Sugar method to another.
     *
     * @example
     *
     *   Sugar.Array.alias('all', 'every');
     *
     * @signature alias(toName, fn)
     * @param {string} toName - Name for new method.
     * @param {string|Function} from - Method to alias, or string shortcut.
     ***/
    setProperty(sugarNamespace, 'alias', function(name, source) {
      var method = typeof source === 'string' ? sugarNamespace[source] : source;
      setMethod(sugarNamespace, name, method);
      return sugarNamespace;
    });

    // Each namespace can extend only itself through its .extend method.
    setProperty(sugarNamespace, 'extend', extend);

    // Cache the class to namespace relationship for later use.
    namespacesByName[name] = sugarNamespace;
    namespacesByClassString['[object ' + name + ']'] = sugarNamespace;

    mapNativeToChainable(name);
    mapObjectChainablesToNamespace(sugarNamespace);


    // Export
    return Sugar[name] = sugarNamespace;
  }

  function setGlobalProperties() {
    setProperty(Sugar, 'VERSION', '2.0.6');
    setProperty(Sugar, 'extend', Sugar);
    setProperty(Sugar, 'toString', toString);
    setProperty(Sugar, 'createNamespace', createNamespace);

    setProperty(Sugar, 'util', {
      'hasOwn': hasOwn,
      'getOwn': getOwn,
      'setProperty': setProperty,
      'classToString': classToString,
      'defineProperty': defineProperty,
      'forEachProperty': forEachProperty,
      'mapNativeToChainable': mapNativeToChainable
    });
  }

  function toString() {
    return SUGAR_GLOBAL;
  }


  // Defining Methods

  function defineMethods(sugarNamespace, methods, type, args, flags) {
    forEachProperty(methods, function(method, methodName) {
      var instanceMethod, staticMethod = method;
      if (args) {
        staticMethod = wrapMethodWithArguments(method);
      }
      if (flags) {
        staticMethod.flags = flags;
      }

      // A method may define its own custom implementation, so
      // make sure that's not the case before creating one.
      if (type & INSTANCE && !method.instance) {
        instanceMethod = wrapInstanceMethod(method, args);
        setProperty(staticMethod, 'instance', instanceMethod);
      }

      if (type & STATIC) {
        setProperty(staticMethod, 'static', true);
      }

      setMethod(sugarNamespace, methodName, staticMethod);

      if (sugarNamespace.active) {
        // If the namespace has been activated (.extend has been called),
        // then map this method as well.
        sugarNamespace.extend(methodName);
      }
    });
  }

  function collectDefineOptions(arg1, arg2, arg3) {
    var methods, last;
    if (typeof arg1 === 'string') {
      methods = {};
      methods[arg1] = arg2;
      last = arg3;
    } else {
      methods = arg1;
      last = arg2;
    }
    return {
      last: last,
      methods: methods
    };
  }

  function wrapInstanceMethod(fn, args) {
    return args ? wrapMethodWithArguments(fn, true) : wrapInstanceMethodFixed(fn);
  }

  function wrapMethodWithArguments(fn, instance) {
    // Functions accepting enumerated arguments will always have "args" as the
    // last argument, so subtract one from the function length to get the point
    // at which to start collecting arguments. If this is an instance method on
    // a prototype, then "this" will be pushed into the arguments array so start
    // collecting 1 argument earlier.
    var startCollect = fn.length - 1 - (instance ? 1 : 0);
    return function() {
      var args = [], collectedArgs = [], len;
      if (instance) {
        args.push(this);
      }
      len = Math.max(arguments.length, startCollect);
      // Optimized: no leaking arguments
      for (var i = 0; i < len; i++) {
        if (i < startCollect) {
          args.push(arguments[i]);
        } else {
          collectedArgs.push(arguments[i]);
        }
      }
      args.push(collectedArgs);
      return fn.apply(this, args);
    };
  }

  function wrapInstanceMethodFixed(fn) {
    switch(fn.length) {
      // Wrapped instance methods will always be passed the instance
      // as the first argument, but requiring the argument to be defined
      // may cause confusion here, so return the same wrapped function regardless.
      case 0:
      case 1:
        return function() {
          return fn(this);
        };
      case 2:
        return function(a) {
          return fn(this, a);
        };
      case 3:
        return function(a, b) {
          return fn(this, a, b);
        };
      case 4:
        return function(a, b, c) {
          return fn(this, a, b, c);
        };
      case 5:
        return function(a, b, c, d) {
          return fn(this, a, b, c, d);
        };
    }
  }

  // Method helpers

  function extendNative(target, source, polyfill, override) {
    forEachProperty(source, function(method, name) {
      if (polyfill && !override && target[name]) {
        // Method exists, so bail.
        return;
      }
      setProperty(target, name, method);
    });
  }

  function setMethod(sugarNamespace, methodName, method) {
    sugarNamespace[methodName] = method;
    if (method.instance) {
      defineChainableMethod(sugarNamespace, methodName, method.instance);
    }
  }


  // Chainables

  function getNewChainableClass(name) {
    var fn = function SugarChainable(obj, arg) {
      if (!(this instanceof fn)) {
        return new fn(obj, arg);
      }
      if (this.constructor !== fn) {
        // Allow modules to define their own constructors.
        obj = this.constructor.apply(obj, arguments);
      }
      this.raw = obj;
    };
    setProperty(fn, 'toString', function() {
      return SUGAR_GLOBAL + name;
    });
    setProperty(fn.prototype, 'valueOf', function() {
      return this.raw;
    });
    return fn;
  }

  function defineChainableMethod(sugarNamespace, methodName, fn) {
    var wrapped = wrapWithChainableResult(fn), existing, collision, dcp;
    dcp = DefaultChainable.prototype;
    existing = dcp[methodName];

    // If the method was previously defined on the default chainable, then a
    // collision exists, so set the method to a disambiguation function that will
    // lazily evaluate the object and find it's associated chainable. An extra
    // check is required to avoid false positives from Object inherited methods.
    collision = existing && existing !== Object.prototype[methodName];

    // The disambiguation function is only required once.
    if (!existing || !existing.disambiguate) {
      dcp[methodName] = collision ? disambiguateMethod(methodName) : wrapped;
    }

    // The target chainable always receives the wrapped method. Additionally,
    // if the target chainable is Sugar.Object, then map the wrapped method
    // to all other namespaces as well if they do not define their own method
    // of the same name. This way, a Sugar.Number will have methods like
    // isEqual that can be called on any object without having to traverse up
    // the prototype chain and perform disambiguation, which costs cycles.
    // Note that the "if" block below actually does nothing on init as Object
    // goes first and no other namespaces exist yet. However it needs to be
    // here as Object instance methods defined later also need to be mapped
    // back onto existing namespaces.
    sugarNamespace.prototype[methodName] = wrapped;
    if (sugarNamespace === Sugar.Object) {
      mapObjectChainableToAllNamespaces(methodName, wrapped);
    }
  }

  function mapObjectChainablesToNamespace(sugarNamespace) {
    forEachProperty(Sugar.Object && Sugar.Object.prototype, function(val, methodName) {
      if (typeof val === 'function') {
        setObjectChainableOnNamespace(sugarNamespace, methodName, val);
      }
    });
  }

  function mapObjectChainableToAllNamespaces(methodName, fn) {
    forEachProperty(namespacesByName, function(sugarNamespace) {
      setObjectChainableOnNamespace(sugarNamespace, methodName, fn);
    });
  }

  function setObjectChainableOnNamespace(sugarNamespace, methodName, fn) {
    var proto = sugarNamespace.prototype;
    if (!hasOwn(proto, methodName)) {
      proto[methodName] = fn;
    }
  }

  function wrapWithChainableResult(fn) {
    return function() {
      return new DefaultChainable(fn.apply(this.raw, arguments));
    };
  }

  function disambiguateMethod(methodName) {
    var fn = function() {
      var raw = this.raw, sugarNamespace;
      if (raw != null) {
        // Find the Sugar namespace for this unknown.
        sugarNamespace = namespacesByClassString[classToString(raw)];
      }
      if (!sugarNamespace) {
        // If no sugarNamespace can be resolved, then default
        // back to Sugar.Object so that undefined and other
        // non-supported types can still have basic object
        // methods called on them, such as type checks.
        sugarNamespace = Sugar.Object;
      }

      return new sugarNamespace(raw)[methodName].apply(this, arguments);
    };
    fn.disambiguate = true;
    return fn;
  }

  function mapNativeToChainable(name, methodNames) {
    var sugarNamespace = namespacesByName[name],
        nativeProto = globalContext[name].prototype;

    if (!methodNames && ownPropertyNames) {
      methodNames = ownPropertyNames(nativeProto);
    }

    forEachProperty(methodNames, function(methodName) {
      if (nativeMethodProhibited(methodName)) {
        // Sugar chainables have their own constructors as well as "valueOf"
        // methods, so exclude them here. The __proto__ argument should be trapped
        // by the function check below, however simply accessing this property on
        // Object.prototype causes QML to segfault, so pre-emptively excluding it.
        return;
      }
      try {
        var fn = nativeProto[methodName];
        if (typeof fn !== 'function') {
          // Bail on anything not a function.
          return;
        }
      } catch (e) {
        // Function.prototype has properties that
        // will throw errors when accessed.
        return;
      }
      defineChainableMethod(sugarNamespace, methodName, fn);
    });
  }

  function nativeMethodProhibited(methodName) {
    return methodName === 'constructor' ||
           methodName === 'valueOf' ||
           methodName === '__proto__';
  }


  // Util

  // Internal references
  var ownPropertyNames = Object.getOwnPropertyNames,
      internalToString = Object.prototype.toString,
      internalHasOwnProperty = Object.prototype.hasOwnProperty;

  // Defining this as a variable here as the ES5 module
  // overwrites it to patch DONTENUM.
  var forEachProperty = function (obj, fn) {
    for(var key in obj) {
      if (!hasOwn(obj, key)) continue;
      if (fn.call(obj, obj[key], key, obj) === false) break;
    }
  };

  // istanbul ignore next
  function definePropertyShim(obj, prop, descriptor) {
    obj[prop] = descriptor.value;
  }

  function setProperty(target, name, value, enumerable) {
    defineProperty(target, name, {
      value: value,
      enumerable: !!enumerable,
      configurable: true,
      writable: true
    });
  }

  // PERF: Attempts to speed this method up get very Heisenbergy. Quickly
  // returning based on typeof works for primitives, but slows down object
  // types. Even === checks on null and undefined (no typeof) will end up
  // basically breaking even. This seems to be as fast as it can go.
  function classToString(obj) {
    return internalToString.call(obj);
  }

  function hasOwn(obj, prop) {
    return !!obj && internalHasOwnProperty.call(obj, prop);
  }

  function getOwn(obj, prop) {
    if (hasOwn(obj, prop)) {
      return obj[prop];
    }
  }

  setupGlobal();

  // For type checking, etc. Excludes object as this is more nuanced.
  var NATIVE_TYPES = 'Boolean Number String Date RegExp Function Array Error Set Map';

  // Do strings have no keys?
  var NO_KEYS_IN_STRING_OBJECTS = !('0' in Object('a'));

  // WhiteSpace/LineTerminator as defined in ES5.1 plus Unicode characters in the Space, Separator category.
  var TRIM_CHARS = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u2028\u2029\u3000\uFEFF';

  // Common chars
  var HALF_WIDTH_ZERO = 0x30,
      FULL_WIDTH_ZERO = 0xff10,
      HALF_WIDTH_PERIOD   = '.',
      FULL_WIDTH_PERIOD   = '．',
      HALF_WIDTH_COMMA    = ',';

  // Namespace aliases
  var sugarObject   = Sugar.Object,
      sugarArray    = Sugar.Array,
      sugarDate     = Sugar.Date,
      sugarString   = Sugar.String;
      Sugar.Number;
      var sugarFunction = Sugar.Function;
      Sugar.RegExp;

  // Class checks
  var isString,
      isFunction,
      isArray;

  function buildClassChecks() {

    function addCoreTypes() {

      var names = spaceSplit(NATIVE_TYPES);

      buildPrimitiveClassCheck(names[0]);
      buildPrimitiveClassCheck(names[1]);
      isString  = buildPrimitiveClassCheck(names[2]);

      buildClassCheck(names[3]);
      buildClassCheck(names[4]);

      // Wanted to enhance performance here by using simply "typeof"
      // but Firefox has two major issues that make this impossible,
      // one fixed, the other not, so perform a full class check here.
      //
      // 1. Regexes can be typeof "function" in FF < 3
      //    https://bugzilla.mozilla.org/show_bug.cgi?id=61911 (fixed)
      //
      // 2. HTMLEmbedElement and HTMLObjectElement are be typeof "function"
      //    https://bugzilla.mozilla.org/show_bug.cgi?id=268945 (won't fix)
      isFunction = buildClassCheck(names[5]);

      // istanbul ignore next
      isArray = Array.isArray || buildClassCheck(names[6]);
      buildClassCheck(names[7]);

      buildClassCheck(names[8], typeof Set !== 'undefined' && Set);
      buildClassCheck(names[9], typeof Map !== 'undefined' && Map);
      addKnownType(names[0]);
      addKnownType(names[1]);
      addKnownType(names[2]);
      addKnownType(names[3]);
      addKnownType(names[4]);
      addKnownType(names[6]);

    }

    function addArrayTypes() {
      var types = 'Int8 Uint8 Uint8Clamped Int16 Uint16 Int32 Uint32 Float32 Float64';
      forEach(spaceSplit(types), function(str) {
      });
    }

    function addKnownType(className) {
    }

    function buildClassCheck(className, globalObject) {
      // istanbul ignore if
      if (globalObject && isClass(new globalObject, 'Object')) {
        return getConstructorClassCheck(globalObject);
      } else {
        return getToStringClassCheck(className);
      }
    }

    // Map and Set may be [object Object] in certain IE environments.
    // In this case we need to perform a check using the constructor
    // instead of Object.prototype.toString.
    // istanbul ignore next
    function getConstructorClassCheck(obj) {
      var ctorStr = String(obj);
      return function(obj) {
        return String(obj.constructor) === ctorStr;
      };
    }

    function getToStringClassCheck(className) {
      return function(obj, str) {
        // perf: Returning up front on instanceof appears to be slower.
        return isClass(obj, className, str);
      };
    }

    function buildPrimitiveClassCheck(className) {
      var type = className.toLowerCase();
      return function(obj) {
        var t = typeof obj;
        return t === type || t === 'object' && isClass(obj, className);
      };
    }

    addCoreTypes();
    addArrayTypes();

  }

  function isClass(obj, className, str) {
    if (!str) {
      str = classToString(obj);
    }
    return str === '[object '+ className +']';
  }

  // Wrapping the core's "define" methods to
  // save a few bytes in the minified script.
  function wrapNamespace(method) {
    return function(sugarNamespace, arg1, arg2) {
      sugarNamespace[method](arg1, arg2);
    };
  }

  // Method define aliases
  var defineStaticPolyfill        = wrapNamespace('defineStaticPolyfill'),
      defineInstancePolyfill      = wrapNamespace('defineInstancePolyfill');

  function assertCallable(obj) {
    if (!isFunction(obj)) {
      throw new TypeError('Function is not callable');
    }
  }


  // General helpers

  function isDefined(o) {
    return o !== undefined;
  }

  function isPrimitive(obj, type) {
    type = type || typeof obj;
    return obj == null || type === 'string' || type === 'number' || type === 'boolean';
  }

  // Make primtives types like strings into objects.
  function coercePrimitiveToObject(obj) {
    if (isPrimitive(obj)) {
      obj = Object(obj);
    }
    // istanbul ignore next
    if (NO_KEYS_IN_STRING_OBJECTS && isString(obj)) {
      forceStringCoercion(obj);
    }
    return obj;
  }

  // Force strings to have their indexes set in
  // environments that don't do this automatically.
  // istanbul ignore next
  function forceStringCoercion(obj) {
    var i = 0, chr;
    while (chr = obj.charAt(i)) {
      obj[i++] = chr;
    }
  }


  // Array helpers

  function isArrayIndex(n) {
    return n >>> 0 == n && n != 0xFFFFFFFF;
  }

  function iterateOverSparseArray(arr, fn, fromIndex, loop) {
    var indexes = getSparseArrayIndexes(arr, fromIndex, loop), index;
    for (var i = 0, len = indexes.length; i < len; i++) {
      index = indexes[i];
      fn.call(arr, arr[index], index, arr);
    }
    return arr;
  }

  // It's unclear whether or not sparse arrays qualify as "simple enumerables".
  // If they are not, however, the wrapping function will be deoptimized, so
  // isolate here (also to share between es5 and array modules).
  function getSparseArrayIndexes(arr, fromIndex, loop, fromRight) {
    var indexes = [], i;
    for (i in arr) {
      // istanbul ignore next
      if (isArrayIndex(i) && (loop || (fromRight ? i <= fromIndex : i >= fromIndex))) {
        indexes.push(+i);
      }
    }
    indexes.sort(function(a, b) {
      var aLoop = a > fromIndex;
      var bLoop = b > fromIndex;
      // This block cannot be reached unless ES5 methods are being shimmed.
      // istanbul ignore if
      if (aLoop !== bLoop) {
        return aLoop ? -1 : 1;
      }
      return a - b;
    });
    return indexes;
  }

  function spaceSplit(str) {
    return str.split(' ');
  }

  function forEach(arr, fn) {
    for (var i = 0, len = arr.length; i < len; i++) {
      if (!(i in arr)) {
        return iterateOverSparseArray(arr, fn, i);
      }
      fn(arr[i], i);
    }
  }

  // Number helpers

  // istanbul ignore next
  var trunc = Math.trunc || function(n) {
    if (n === 0 || !isFinite(n)) return n;
    return n < 0 ? ceil(n) : floor(n);
  };

  function padNumber(num, place, sign, base, replacement) {
    var str = abs(num).toString(base || 10);
    str = repeatString(replacement || '0', place - str.replace(/\.\d+/, '').length) + str;
    if (sign || num < 0) {
      str = (num < 0 ? '-' : '+') + str;
    }
    return str;
  }

  // Fullwidth number helpers
  var fullWidthNumberMap;

  function buildFullWidthNumber() {
    var fwp = FULL_WIDTH_PERIOD, hwp = HALF_WIDTH_PERIOD, hwc = HALF_WIDTH_COMMA;
    fullWidthNumberMap = {};
    for (var i = 0, digit; i <= 9; i++) {
      digit = chr(i + FULL_WIDTH_ZERO);
      fullWidthNumberMap[digit] = chr(i + HALF_WIDTH_ZERO);
    }
    fullWidthNumberMap[hwc] = '';
    fullWidthNumberMap[fwp] = hwp;
    // Mapping this to itself to capture it easily
    // in stringToNumber to detect decimals later.
    fullWidthNumberMap[hwp] = hwp;
  }

  // Math aliases
  var abs   = Math.abs,
      ceil  = Math.ceil,
      floor = Math.floor;


  // String helpers

  var chr = String.fromCharCode;

  function repeatString(str, num) {
    var result = '';
    str = str.toString();
    while (num > 0) {
      if (num & 1) {
        result += str;
      }
      if (num >>= 1) {
        str += str;
      }
    }
    return result;
  }

  buildClassChecks();
  buildFullWidthNumber();

  /***
   * @module ES5
   * @description Functions and polyfill methods that fix ES5 functionality. This
   *              module is excluded from default builds, and can be included if
   *              you need legacy browser support (IE8 and below).
   *
   ***/

  // Non-enumerable properties on Object.prototype. In early JScript implementations
  // (< IE9) these will shadow object properties and break for..in loops.
  var DONT_ENUM_PROPS = [
    'valueOf',
    'toString',
    'constructor',
    'isPrototypeOf',
    'hasOwnProperty',
    'toLocaleString',
    'propertyIsEnumerable'
  ];

  /***
   * @fix
   * @short Fixes DontEnum bug for iteration methods in < IE9.
   ***/
  function buildDontEnumFix() {
    if (!({toString:1}).propertyIsEnumerable('toString')) {
      var forEachEnumerableProperty = forEachProperty;
      forEachProperty = function(obj, fn) {
        forEachEnumerableProperty(obj, fn);
        for (var i = 0, key; key = DONT_ENUM_PROPS[i]; i++) {
          if (hasOwn(obj, key)) {
            if(fn.call(obj, obj[key], key, obj) === false) break;
          }
        }
      };
    }
  }

  /***
   * @fix
   * @short Adds native methods to chainables in < IE9.
   ***/
  function buildChainableNativeMethodsFix() {
    if (!Object.getOwnPropertyNames) {
      defineNativeMethodsOnChainable();
    }
  }

  // Polyfilled methods will automatically be added to the chainable prototype.
  // However, Object.getOwnPropertyNames cannot be shimmed for non-enumerable
  // properties, so if it does not exist, then the only way to access native
  // methods previous to ES5 is to provide them as a list of tokens here.
  function defineNativeMethodsOnChainable() {

    var nativeTokens = {
      'Function': 'apply,call',
      'RegExp':   'compile,exec,test',
      'Number':   'toExponential,toFixed,toLocaleString,toPrecision',
      'Object':   'hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString',
      'Array':    'concat,join,pop,push,reverse,shift,slice,sort,splice,toLocaleString,unshift',
      'Date':     'getTime,getTimezoneOffset,setTime,toDateString,toGMTString,toLocaleDateString,toLocaleString,toLocaleTimeString,toTimeString,toUTCString',
      'String':   'anchor,big,blink,bold,charAt,charCodeAt,concat,fixed,fontcolor,fontsize,indexOf,italics,lastIndexOf,link,localeCompare,match,replace,search,slice,small,split,strike,sub,substr,substring,sup,toLocaleLowerCase,toLocaleUpperCase,toLowerCase,toUpperCase'
    };

    var dateTokens = 'FullYear,Month,Date,Hours,Minutes,Seconds,Milliseconds'.split(',');

    function addDateTokens(prefix, arr) {
      for (var i = 0; i < dateTokens.length; i++) {
        arr.push(prefix + dateTokens[i]);
      }
    }

    forEachProperty(nativeTokens, function(str, name) {
      var tokens = str.split(',');
      if (name === 'Date') {
        addDateTokens('get', tokens);
        addDateTokens('set', tokens);
        addDateTokens('getUTC', tokens);
        addDateTokens('setUTC', tokens);
      }
      tokens.push('toString');
      mapNativeToChainable(name, tokens);
    });

  }


  buildDontEnumFix();
  buildChainableNativeMethodsFix();


  /*** @namespace Object ***/

  function assertNonNull(obj) {
    if (obj == null) {
      throw new TypeError('Object required');
    }
  }

  defineStaticPolyfill(sugarObject, {

    'keys': function(obj) {
      var keys = [];
      assertNonNull(obj);
      forEachProperty(coercePrimitiveToObject(obj), function(val, key) {
        keys.push(key);
      });
      return keys;
    }

  });


  /*** @namespace Array ***/

  function arrayIndexOf(arr, search, fromIndex, fromRight) {
    var length = arr.length, defaultFromIndex, index, increment;

    increment = fromRight ? -1 : 1;
    defaultFromIndex = fromRight ? length - 1 : 0;
    fromIndex = trunc(fromIndex);
    if (!fromIndex && fromIndex !== 0) {
      fromIndex = defaultFromIndex;
    }
    if (fromIndex < 0) {
      fromIndex = length + fromIndex;
    }
    if ((!fromRight && fromIndex < 0) || (fromRight && fromIndex >= length)) {
      fromIndex = defaultFromIndex;
    }

    index = fromIndex;

    while((fromRight && index >= 0) || (!fromRight && index < length)) {
      if (!(index in arr)) {
        return sparseIndexOf(arr, search, fromIndex, fromRight);
      }
      if (isArrayIndex(index) && arr[index] === search) {
        return index;
      }
      index += increment;
    }
    return -1;
  }

  function sparseIndexOf(arr, search, fromIndex, fromRight) {
    var indexes = getSparseArrayIndexes(arr, fromIndex, false, fromRight), index;
    indexes.sort(function(a, b) {
      return fromRight ? b - a : a - b;
    });
    while ((index = indexes.shift()) !== undefined) {
      if (arr[index] === search) {
        return +index;
      }
    }
    return -1;
  }

  function arrayReduce(arr, fn, initialValue, fromRight) {
    var length = arr.length, count = 0, defined = isDefined(initialValue), result, index;
    assertCallable(fn);
    if (length == 0 && !defined) {
      throw new TypeError('Reduce called on empty array with no initial value');
    } else if (defined) {
      result = initialValue;
    } else {
      result = arr[fromRight ? length - 1 : count];
      count++;
    }
    while(count < length) {
      index = fromRight ? length - count - 1 : count;
      if (index in arr) {
        result = fn(result, arr[index], index, arr);
      }
      count++;
    }
    return result;
  }

  defineStaticPolyfill(sugarArray, {

    /***
     *
     * @method isArray(obj)
     * @returns Boolean
     * @polyfill ES5
     * @static
     * @short Returns true if `obj` is an Array.
     *
     * @example
     *
     *   Array.isArray(3)        -> false
     *   Array.isArray(true)     -> false
     *   Array.isArray('wasabi') -> false
     *   Array.isArray([1,2,3])  -> true
     *
     ***/
    'isArray': function(obj) {
      return isArray(obj);
    }

  });

  defineInstancePolyfill(sugarArray, {

    'every': function(fn) {
      // Force compiler to respect argument length.
      var context = arguments[1];
      var length = this.length, index = 0;
      assertCallable(fn);
      while(index < length) {
        if (index in this && !fn.call(context, this[index], index, this)) {
          return false;
        }
        index++;
      }
      return true;
    },

    'some': function(fn) {
      // Force compiler to respect argument length.
      var context = arguments[1];
      var length = this.length, index = 0;
      assertCallable(fn);
      while(index < length) {
        if (index in this && fn.call(context, this[index], index, this)) {
          return true;
        }
        index++;
      }
      return false;
    },

    'map': function(fn) {
      // Force compiler to respect argument length.
      var context = arguments[1];
      var length = this.length, index = 0, result = new Array(length);
      assertCallable(fn);
      while(index < length) {
        if (index in this) {
          result[index] = fn.call(context, this[index], index, this);
        }
        index++;
      }
      return result;
    },

    'filter': function(fn) {
      // Force compiler to respect argument length.
      var context = arguments[1];
      var length = this.length, index = 0, result = [];
      assertCallable(fn);
      while(index < length) {
        if (index in this && fn.call(context, this[index], index, this)) {
          result.push(this[index]);
        }
        index++;
      }
      return result;
    },

    /***
     * @method indexOf(search, [fromIndex] = 0)
     * @returns Number
     * @polyfill ES5
     * @short Searches the array and returns the first index where `search` occurs,
     *        or `-1` if the element is not found.
     * @extra [fromIndex] is the index from which to begin the search. This
     *        method performs a simple strict equality comparison on `search`.
     *        Sugar does not enhance this method to support `enhanced matching`.
     *        For such functionality, use the `findIndex` method instead.
     *
     * @example
     *
     *   [1,2,3].indexOf(3) -> 1
     *   [1,2,3].indexOf(7) -> -1
     *
     ***/
    'indexOf': function(search) {
      // Force compiler to respect argument length.
      var fromIndex = arguments[1];
      if (isString(this)) return this.indexOf(search, fromIndex);
      return arrayIndexOf(this, search, fromIndex);
    },

    /***
     * @method lastIndexOf(search, [fromIndex] = array.length - 1)
     * @returns Number
     * @polyfill ES5
     * @short Searches the array from the end and returns the first index where
     *        `search` occurs, or `-1` if the element is not found.
     * @extra [fromIndex] is the index from which to begin the search. This method
     *        performs a simple strict equality comparison on `search`.
     *        Sugar does not enhance this method to support `enhanced matching`.
     *
     * @example
     *
     *   [1,2,1].lastIndexOf(1) -> 2
     *   [1,2,1].lastIndexOf(7) -> -1
     *
     ***/
    'lastIndexOf': function(search) {
      // Force compiler to respect argument length.
      var fromIndex = arguments[1];
      if (isString(this)) return this.lastIndexOf(search, fromIndex);
      return arrayIndexOf(this, search, fromIndex, true);
    },

    /***
     * @method forEach([eachFn], [context])
     * @polyfill ES5
     * @short Iterates over the array, calling [eachFn] on each loop.
     * @extra [context] becomes the `this` object.
     *
     * @callback eachFn
     *
     *   el   The element of the current iteration.
     *   i    The index of the current iteration.
     *   arr  A reference to the array.
     *
     * @example
     *
     *   ['a','b','c'].forEach(function(a) {
     *     // Called 3 times: 'a','b','c'
     *   });
     *
     ***/
    'forEach': function(eachFn) {
      // Force compiler to respect argument length.
      var context = arguments[1];
      var length = this.length, index = 0;
      assertCallable(eachFn);
      while(index < length) {
        if (index in this) {
          eachFn.call(context, this[index], index, this);
        }
        index++;
      }
    },

    /***
     * @method reduce(reduceFn, [init])
     * @returns Mixed
     * @polyfill ES5
     * @short Reduces the array to a single result.
     * @extra This operation is sometimes called "accumulation", as it takes the
     *        result of the last iteration of `reduceFn` and passes it as the first
     *        argument to the next iteration, "accumulating" that value as it goes.
     *        The return value of this method will be the return value of the final
     *        iteration of `reduceFn`. If [init] is passed, it will be the initial
     *        "accumulator" (the first argument). If [init] is not passed, then it
     *        will take the first element in the array, and `reduceFn` will not be
     *        called for that element.
     *
     * @callback reduceFn
     *
     *   acc  The "accumulator". Either [init], the result of the last iteration
     *        of `reduceFn`, or the first element of the array.
     *   el   The current element for this iteration.
     *   idx  The current index for this iteration.
     *   arr  A reference to the array.
     *
     * @example
     *
     *   [1,2,3].reduce(function(a, b) {
     *     return a - b; // 1 - 2 - 3
     *   });
     *
     *   [1,2,3].reduce(function(a, b) {
     *     return a - b; // 100 - 1 - 2 - 3
     *   }, 100);
     *
     ***/
    'reduce': function(reduceFn) {
      // Force compiler to respect argument length.
      var context = arguments[1];
      return arrayReduce(this, reduceFn, context);
    },

    /***
     * @method reduceRight([reduceFn], [init])
     * @returns Mixed
     * @polyfill ES5
     * @short Similar to `Array#reduce`, but operates on the elements in reverse.
     *
     * @callback reduceFn
     *
     *   acc  The "accumulator", either [init], the result of the last iteration
     *        of `reduceFn`, or the last element of the array.
     *   el   The current element for this iteration.
     *   idx  The current index for this iteration.
     *   arr  A reference to the array.
     *
     * @example
     *
     *   [1,2,3].reduceRight(function(a, b) {
     *     return a - b; // 3 - 2 - 1
     *   });
     *
     *   [1,2,3].reduceRight(function(a, b) {
     *     return a - b; // 100 - 3 - 2 - 1
     *   }, 100);
     *
     *
     ***/
    'reduceRight': function(reduceFn) {
      // Force compiler to respect argument length.
      var context = arguments[1];
      return arrayReduce(this, reduceFn, context, true);
    }

  });


  /*** @namespace String ***/

  var TRIM_REG = RegExp('^[' + TRIM_CHARS + ']+|['+ TRIM_CHARS +']+$', 'g');

  defineInstancePolyfill(sugarString, {
    /***
     * @method trim()
     * @returns String
     * @polyfill ES5
     * @short Removes leading and trailing whitespace from the string.
     * @extra Whitespace is defined as line breaks, tabs, and any character in the
     *        "Space, Separator" Unicode category, conforming to the the ES5 spec.
     *
     * @example
     *
     *   '   wasabi   '.trim()      -> 'wasabi'
     *   '   wasabi   '.trimLeft()  -> 'wasabi   '
     *   '   wasabi   '.trimRight() -> '   wasabi'
     *
     ***/
    'trim': function() {
      return this.toString().replace(TRIM_REG, '');
    }
  });


  /*** @namespace Function ***/

  defineInstancePolyfill(sugarFunction, {

     /***
     * @method bind(context, [arg1], ...)
     * @returns Function
     * @polyfill ES5
     * @short Binds `context` as the `this` object for the function when it is
     *        called. Also allows currying an unlimited number of parameters.
     * @extra "currying" means setting parameters ([arg1], [arg2], etc.) ahead of
     *        time so that they are passed when the function is called later. If
     *        you pass additional parameters when the function is actually called,
     *        they will be added to the end of the curried parameters.
     *
     * @example
     *
     *   logThis.bind('woof')()   -> logs 'woof' as its this object
     *   addArgs.bind(1, 2, 3)()  -> returns 5 with 1 as the this object
     *   addArgs.bind(1)(2, 3, 4) -> returns 9
     *
     ***/
    'bind': function(context) {
      // Optimized: no leaking arguments
      var boundArgs = []; for(var $i = 1, $len = arguments.length; $i < $len; $i++) boundArgs.push(arguments[$i]);
      var fn = this, bound;
      assertCallable(this);
      bound = function() {
        // Optimized: no leaking arguments
        var args = []; for(var $i = 0, $len = arguments.length; $i < $len; $i++) args.push(arguments[$i]);
        return fn.apply(fn.prototype && this instanceof fn ? this : context, boundArgs.concat(args));
      };
      bound.prototype = this.prototype;
      return bound;
    }

  });


  /*** @namespace Date ***/

  defineStaticPolyfill(sugarDate, {

     /***
     * @method now()
     * @returns String
     * @polyfill ES5
     * @static
     * @short Returns the current time as a Unix timestamp.
     * @extra The number of milliseconds since January 1st, 1970 00:00:00 (UTC).
     *
     * @example
     *
     *   Date.now() -> ex. 1311938296231
     *
     ***/
    'now': function() {
      return new Date().getTime();
    }

  });

  function hasISOSupport() {
    var d = new Date(Date.UTC(2000, 0));
    return !!d.toISOString && d.toISOString() === '2000-01-01T00:00:00.000Z';
  }

  defineInstancePolyfill(sugarDate, {

     /***
     * @method toISOString()
     * @returns String
     * @polyfill ES5
     * @short Formats the string to ISO8601 format.
     * @extra This will always format as UTC time.
     *
     * @example
     *
     *   Date.create().toISOString() -> ex. 2011-07-05 12:24:55.528Z
     *
     ***/
    'toISOString': function() {
      return padNumber(this.getUTCFullYear(), 4) + '-' +
             padNumber(this.getUTCMonth() + 1, 2) + '-' +
             padNumber(this.getUTCDate(), 2) + 'T' +
             padNumber(this.getUTCHours(), 2) + ':' +
             padNumber(this.getUTCMinutes(), 2) + ':' +
             padNumber(this.getUTCSeconds(), 2) + '.' +
             padNumber(this.getUTCMilliseconds(), 3) + 'Z';
    },

     /***
     * @method toJSON([key])
     * @returns String
     * @polyfill ES5
     * @short Returns a JSON representation of the date.
     * @extra This is effectively an alias for `toISOString`. Will always return
     *        the date in UTC time. [key] is ignored.
     *
     * @example
     *
     *   Date.create().toJSON() -> ex. 2011-07-05 12:24:55.528Z
     *
     ***/
    'toJSON': function(key) {
      return this.toISOString(key);
    }

  }, !hasISOSupport());

}).call(commonjsGlobal);
}(sugarCore));

function isArrayIndex$2(n) {
  return n >>> 0 == n && n != 0xFFFFFFFF;
}

var isArrayIndex_1 = isArrayIndex$2;

var isArrayIndex$1 = isArrayIndex_1;

function getSparseArrayIndexes$1(arr, fromIndex, loop, fromRight) {
  var indexes = [], i;
  for (i in arr) {
    // istanbul ignore next
    if (isArrayIndex$1(i) && (loop || (fromRight ? i <= fromIndex : i >= fromIndex))) {
      indexes.push(+i);
    }
  }
  indexes.sort(function(a, b) {
    var aLoop = a > fromIndex;
    var bLoop = b > fromIndex;
    // This block cannot be reached unless ES5 methods are being shimmed.
    // istanbul ignore if
    if (aLoop !== bLoop) {
      return aLoop ? -1 : 1;
    }
    return a - b;
  });
  return indexes;
}

var getSparseArrayIndexes_1 = getSparseArrayIndexes$1;

var getSparseArrayIndexes = getSparseArrayIndexes_1;

function iterateOverSparseArray$1(arr, fn, fromIndex, loop) {
  var indexes = getSparseArrayIndexes(arr, fromIndex, loop), index;
  for (var i = 0, len = indexes.length; i < len; i++) {
    index = indexes[i];
    fn.call(arr, arr[index], index, arr);
  }
  return arr;
}

var iterateOverSparseArray_1 = iterateOverSparseArray$1;

var iterateOverSparseArray = iterateOverSparseArray_1;

function forEach$j(arr, fn) {
  for (var i = 0, len = arr.length; i < len; i++) {
    if (!(i in arr)) {
      return iterateOverSparseArray(arr, fn, i);
    }
    fn(arr[i], i);
  }
}

var forEach_1 = forEach$j;

var NATIVE_TYPES$2 = 'Boolean Number String Date RegExp Function Array Error Set Map';

var Sugar$6b = sugarCore.exports;

var coreUtilityAliases$M = {
  hasOwn: Sugar$6b.util.hasOwn,
  getOwn: Sugar$6b.util.getOwn,
  setProperty: Sugar$6b.util.setProperty,
  classToString: Sugar$6b.util.classToString,
  defineProperty: Sugar$6b.util.defineProperty,
  forEachProperty: Sugar$6b.util.forEachProperty,
  mapNativeToChainable: Sugar$6b.util.mapNativeToChainable
};

var coreUtilityAliases$L = coreUtilityAliases$M;

var classToString$5 = coreUtilityAliases$L.classToString;

function isClass$2(obj, className, str) {
  if (!str) {
    str = classToString$5(obj);
  }
  return str === '[object '+ className +']';
}

var isClass_1 = isClass$2;

function spaceSplit$6(str) {
  return str.split(' ');
}

var spaceSplit_1 = spaceSplit$6;

function isObjectType$e(obj, type) {
  return !!obj && (type || typeof obj) === 'object';
}

var isObjectType_1 = isObjectType$e;

var coreUtilityAliases$K = coreUtilityAliases$M;

var hasOwn$c = coreUtilityAliases$K.hasOwn;

function hasOwnEnumeratedProperties$1(obj) {
  // Plain objects are generally defined as having enumerated properties
  // all their own, however in early IE environments without defineProperty,
  // there may also be enumerated methods in the prototype chain, so check
  // for both of these cases.
  var objectProto = Object.prototype;
  for (var key in obj) {
    var val = obj[key];
    if (!hasOwn$c(obj, key) && val !== objectProto[key]) {
      return false;
    }
  }
  return true;
}

var hasOwnEnumeratedProperties_1 = hasOwnEnumeratedProperties$1;

var coreUtilityAliases$J = coreUtilityAliases$M;

var hasOwn$b = coreUtilityAliases$J.hasOwn;

function hasValidPlainObjectPrototype$1(obj) {
  var hasToString = 'toString' in obj;
  var hasConstructor = 'constructor' in obj;
  // An object created with Object.create(null) has no methods in the
  // prototype chain, so check if any are missing. The additional hasToString
  // check is for false positives on some host objects in old IE which have
  // toString but no constructor. If the object has an inherited constructor,
  // then check if it is Object (the "isPrototypeOf" tapdance here is a more
  // robust way of ensuring this if the global has been hijacked). Note that
  // accessing the constructor directly (without "in" or "hasOwnProperty")
  // will throw a permissions error in IE8 on cross-domain windows.
  return (!hasConstructor && !hasToString) ||
          (hasConstructor && !hasOwn$b(obj, 'constructor') &&
           hasOwn$b(obj.constructor.prototype, 'isPrototypeOf'));
}

var hasValidPlainObjectPrototype_1 = hasValidPlainObjectPrototype$1;

var isClass$1 = isClass_1,
    isObjectType$d = isObjectType_1,
    hasOwnEnumeratedProperties = hasOwnEnumeratedProperties_1,
    hasValidPlainObjectPrototype = hasValidPlainObjectPrototype_1;

function isPlainObject$4(obj, className) {
  return isObjectType$d(obj) &&
         isClass$1(obj, 'Object', className) &&
         hasValidPlainObjectPrototype(obj) &&
         hasOwnEnumeratedProperties(obj);
}

var isPlainObject_1 = isPlainObject$4;

var NATIVE_TYPES$1 = NATIVE_TYPES$2,
    forEach$i = forEach_1,
    isClass = isClass_1,
    spaceSplit$5 = spaceSplit_1,
    isPlainObject$3 = isPlainObject_1;

var isSerializable$2,
    isBoolean$5, isNumber$d, isString$k,
    isDate$a, isRegExp$7, isFunction$d,
    isArray$f, isSet$2, isMap$2, isError$2;

function buildClassChecks() {

  var knownTypes = {};

  function addCoreTypes() {

    var names = spaceSplit$5(NATIVE_TYPES$1);

    isBoolean$5 = buildPrimitiveClassCheck(names[0]);
    isNumber$d  = buildPrimitiveClassCheck(names[1]);
    isString$k  = buildPrimitiveClassCheck(names[2]);

    isDate$a   = buildClassCheck(names[3]);
    isRegExp$7 = buildClassCheck(names[4]);

    // Wanted to enhance performance here by using simply "typeof"
    // but Firefox has two major issues that make this impossible,
    // one fixed, the other not, so perform a full class check here.
    //
    // 1. Regexes can be typeof "function" in FF < 3
    //    https://bugzilla.mozilla.org/show_bug.cgi?id=61911 (fixed)
    //
    // 2. HTMLEmbedElement and HTMLObjectElement are be typeof "function"
    //    https://bugzilla.mozilla.org/show_bug.cgi?id=268945 (won't fix)
    isFunction$d = buildClassCheck(names[5]);

    // istanbul ignore next
    isArray$f = Array.isArray || buildClassCheck(names[6]);
    isError$2 = buildClassCheck(names[7]);

    isSet$2 = buildClassCheck(names[8], typeof Set !== 'undefined' && Set);
    isMap$2 = buildClassCheck(names[9], typeof Map !== 'undefined' && Map);

    // Add core types as known so that they can be checked by value below,
    // notably excluding Functions and adding Arguments and Error.
    addKnownType('Arguments');
    addKnownType(names[0]);
    addKnownType(names[1]);
    addKnownType(names[2]);
    addKnownType(names[3]);
    addKnownType(names[4]);
    addKnownType(names[6]);

  }

  function addArrayTypes() {
    var types = 'Int8 Uint8 Uint8Clamped Int16 Uint16 Int32 Uint32 Float32 Float64';
    forEach$i(spaceSplit$5(types), function(str) {
      addKnownType(str + 'Array');
    });
  }

  function addKnownType(className) {
    var str = '[object '+ className +']';
    knownTypes[str] = true;
  }

  function isKnownType(className) {
    return knownTypes[className];
  }

  function buildClassCheck(className, globalObject) {
    // istanbul ignore if
    if (globalObject && isClass(new globalObject, 'Object')) {
      return getConstructorClassCheck(globalObject);
    } else {
      return getToStringClassCheck(className);
    }
  }

  // Map and Set may be [object Object] in certain IE environments.
  // In this case we need to perform a check using the constructor
  // instead of Object.prototype.toString.
  // istanbul ignore next
  function getConstructorClassCheck(obj) {
    var ctorStr = String(obj);
    return function(obj) {
      return String(obj.constructor) === ctorStr;
    };
  }

  function getToStringClassCheck(className) {
    return function(obj, str) {
      // perf: Returning up front on instanceof appears to be slower.
      return isClass(obj, className, str);
    };
  }

  function buildPrimitiveClassCheck(className) {
    var type = className.toLowerCase();
    return function(obj) {
      var t = typeof obj;
      return t === type || t === 'object' && isClass(obj, className);
    };
  }

  addCoreTypes();
  addArrayTypes();

  isSerializable$2 = function(obj, className) {
    // Only known objects can be serialized. This notably excludes functions,
    // host objects, Symbols (which are matched by reference), and instances
    // of classes. The latter can arguably be matched by value, but
    // distinguishing between these and host objects -- which should never be
    // compared by value -- is very tricky so not dealing with it here.
    return isKnownType(className) || isPlainObject$3(obj, className);
  };

}

buildClassChecks();

var classChecks$Z = {
  isSerializable: isSerializable$2,
  isBoolean: isBoolean$5,
  isNumber: isNumber$d,
  isString: isString$k,
  isDate: isDate$a,
  isRegExp: isRegExp$7,
  isFunction: isFunction$d,
  isArray: isArray$f,
  isSet: isSet$2,
  isMap: isMap$2,
  isError: isError$2
};

function getNormalizedIndex$2(index, length, loop) {
  if (index && loop) {
    index = index % length;
  }
  if (index < 0) index = length + index;
  return index;
}

var getNormalizedIndex_1 = getNormalizedIndex$2;

var getNormalizedIndex$1 = getNormalizedIndex_1;

function entryAtIndex$1(obj, index, length, loop, isString) {
  index = getNormalizedIndex$1(index, length, loop);
  return isString ? obj.charAt(index) : obj[index];
}

var entryAtIndex_1 = entryAtIndex$1;

var forEach$h = forEach_1,
    classChecks$Y = classChecks$Z,
    entryAtIndex = entryAtIndex_1;

var isArray$e = classChecks$Y.isArray;

function getEntriesForIndexes$2(obj, find, loop, isString) {
  var result, length = obj.length;
  if (!isArray$e(find)) {
    return entryAtIndex(obj, find, length, loop, isString);
  }
  result = new Array(find.length);
  forEach$h(find, function(index, i) {
    result[i] = entryAtIndex(obj, index, length, loop, isString);
  });
  return result;
}

var getEntriesForIndexes_1 = getEntriesForIndexes$2;

var Sugar$6a = sugarCore.exports,
    getEntriesForIndexes$1 = getEntriesForIndexes_1;

Sugar$6a.String.defineInstance({

  'at': function(str, index, loop) {
    return getEntriesForIndexes$1(str, index, loop, true);
  }

});

Sugar$6a.String.at;

var CAMELIZE_REG$1 = /(^|_)([^_]+)/g;

var Inflections$4 = {};

var Inflections$3 = Inflections$4;

function getAcronym$2(str) {
  // istanbul ignore next
  return Inflections$3.acronyms && Inflections$3.acronyms.find(str);
}

var getAcronym_1 = getAcronym$2;

var Inflections$2 = Inflections$4;

function stringUnderscore$4(str) {
  var areg = Inflections$2.acronyms && Inflections$2.acronyms.reg;
  // istanbul ignore if
  if (areg) {
    str = str.replace(areg, function(acronym, index) {
      return (index > 0 ? '_' : '') + acronym.toLowerCase();
    });
  }
  return str
    .replace(/[-\s]+/g, '_')
    .replace(/([A-Z\d]+)([A-Z][a-z])/g,'$1_$2')
    .replace(/([a-z\d])([A-Z])/g,'$1_$2')
    .toLowerCase();
}

var stringUnderscore_1 = stringUnderscore$4;

var CAPITALIZE_REG$1 = /[^\u0000-\u0040\u005B-\u0060\u007B-\u007F]+('s)?/g;

function simpleCapitalize$4(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

var simpleCapitalize_1 = simpleCapitalize$4;

var CAPITALIZE_REG = CAPITALIZE_REG$1,
    simpleCapitalize$3 = simpleCapitalize_1;

function stringCapitalize$3(str, downcase, all) {
  if (downcase) {
    str = str.toLowerCase();
  }
  return all ? str.replace(CAPITALIZE_REG, simpleCapitalize$3) : simpleCapitalize$3(str);
}

var stringCapitalize_1 = stringCapitalize$3;

var CAMELIZE_REG = CAMELIZE_REG$1,
    getAcronym$1 = getAcronym_1,
    stringUnderscore$3 = stringUnderscore_1,
    stringCapitalize$2 = stringCapitalize_1;

function stringCamelize$1(str, upper) {
  str = stringUnderscore$3(str);
  return str.replace(CAMELIZE_REG, function(match, pre, word, index) {
    var cap = upper !== false || index > 0, acronym;
    acronym = getAcronym$1(word);
    // istanbul ignore if
    if (acronym && cap) {
      return acronym;
    }
    return cap ? stringCapitalize$2(word, true) : word;
  });
}

var stringCamelize_1 = stringCamelize$1;

var Sugar$69 = sugarCore.exports,
    stringCamelize = stringCamelize_1;

Sugar$69.String.defineInstance({

  'camelize': function(str, upper) {
    return stringCamelize(str, upper);
  }

});

Sugar$69.String.camelize;

var Sugar$68 = sugarCore.exports,
    stringCapitalize$1 = stringCapitalize_1;

Sugar$68.String.defineInstance({

  'capitalize': function(str, lower, all) {
    return stringCapitalize$1(str, lower, all);
  }

});

Sugar$68.String.capitalize;

function isDefined$j(o) {
  return o !== undefined;
}

var isDefined_1 = isDefined$j;

var classChecks$X = classChecks$Z;

var isString$j = classChecks$X.isString;

function escapeRegExp$6(str) {
  if (!isString$j(str)) str = String(str);
  return str.replace(/([\\/'*+?|()[\]{}.^$-])/g,'\\$1');
}

var escapeRegExp_1 = escapeRegExp$6;

function getRegExpFlags$6(reg, add) {
  var flags = '';
  add = add || '';
  function checkFlag(prop, flag) {
    if (prop || add.indexOf(flag) > -1) {
      flags += flag;
    }
  }
  checkFlag(reg.global, 'g');
  checkFlag(reg.ignoreCase, 'i');
  checkFlag(reg.multiline, 'm');
  checkFlag(reg.sticky, 'y');
  return flags;
}

var getRegExpFlags_1 = getRegExpFlags$6;

function runGlobalMatch$1(str, reg) {
  var result = [], match, lastLastIndex;
  while ((match = reg.exec(str)) != null) {
    if (reg.lastIndex === lastLastIndex) {
      reg.lastIndex += 1;
    } else {
      result.push(match[0]);
    }
    lastLastIndex = reg.lastIndex;
  }
  return result;
}

var runGlobalMatch_1 = runGlobalMatch$1;

var isDefined$i = isDefined_1,
    classChecks$W = classChecks$Z,
    escapeRegExp$5 = escapeRegExp_1,
    getRegExpFlags$5 = getRegExpFlags_1,
    runGlobalMatch = runGlobalMatch_1;

var isString$i = classChecks$W.isString,
    isRegExp$6 = classChecks$W.isRegExp,
    isFunction$c = classChecks$W.isFunction;

function stringEach$5(str, search, fn) {
  var chunks, chunk, reg, result = [];
  if (isFunction$c(search)) {
    fn = search;
    reg = /[\s\S]/g;
  } else if (!search) {
    reg = /[\s\S]/g;
  } else if (isString$i(search)) {
    reg = RegExp(escapeRegExp$5(search), 'gi');
  } else if (isRegExp$6(search)) {
    reg = RegExp(search.source, getRegExpFlags$5(search, 'g'));
  }
  // Getting the entire array of chunks up front as we need to
  // pass this into the callback function as an argument.
  chunks = runGlobalMatch(str, reg);

  if (chunks) {
    for(var i = 0, len = chunks.length, r; i < len; i++) {
      chunk = chunks[i];
      result[i] = chunk;
      if (fn) {
        r = fn.call(str, chunk, i, chunks);
        if (r === false) {
          break;
        } else if (isDefined$i(r)) {
          result[i] = r;
        }
      }
    }
  }
  return result;
}

var stringEach_1 = stringEach$5;

var Sugar$67 = sugarCore.exports,
    stringEach$4 = stringEach_1;

Sugar$67.String.defineInstance({

  'chars': function(str, search, eachCharFn) {
    return stringEach$4(str, search, eachCharFn);
  }

});

Sugar$67.String.chars;

function stringCodes$2(str, fn) {
  var codes = new Array(str.length), i, len;
  for(i = 0, len = str.length; i < len; i++) {
    var code = str.charCodeAt(i);
    codes[i] = code;
    if (fn) {
      fn.call(str, code, i, str);
    }
  }
  return codes;
}

var stringCodes_1 = stringCodes$2;

var Sugar$66 = sugarCore.exports,
    stringCodes$1 = stringCodes_1;

Sugar$66.String.defineInstance({

  'codes': function(str, eachCodeFn) {
    return stringCodes$1(str, eachCodeFn);
  }

});

Sugar$66.String.codes;

function trim$6(str) {
  return str.trim();
}

var trim_1 = trim$6;

var Sugar$65 = sugarCore.exports,
    trim$5 = trim_1;

Sugar$65.String.defineInstance({

  'compact': function(str) {
    return trim$5(str).replace(/([\r\n\s　])+/g, function(match, whitespace) {
      return whitespace === '　' ? whitespace : ' ';
    });
  }

});

Sugar$65.String.compact;

var Sugar$64 = sugarCore.exports,
    stringUnderscore$2 = stringUnderscore_1;

Sugar$64.String.defineInstance({

  'dasherize': function(str) {
    return stringUnderscore$2(str).replace(/_/g, '-');
  }

});

Sugar$64.String.dasherize;

var chr$6 = String.fromCharCode;

var chr$5 = chr$6;

var encodeBase64$1, decodeBase64$1;

function buildBase64() {
  var encodeAscii, decodeAscii;

  // istanbul ignore next
  function catchEncodingError(fn) {
    return function(str) {
      try {
        return fn(str);
      } catch(e) {
        return '';
      }
    };
  }

  // istanbul ignore if
  if (typeof Buffer !== 'undefined') {
    encodeBase64$1 = function(str) {
      return Buffer.from(str).toString('base64');
    };
    decodeBase64$1 = function(str) {
      return Buffer.from(str, 'base64').toString('utf8');
    };
    return;
  }

  // istanbul ignore if
  if (typeof btoa !== 'undefined') {
    encodeAscii = catchEncodingError(btoa);
    decodeAscii = catchEncodingError(atob);
  } else {
    var key = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    var base64reg = /[^A-Za-z0-9\+\/\=]/g;
    encodeAscii = function(str) {
      var output = '';
      var chr1, chr2, chr3;
      var enc1, enc2, enc3, enc4;
      var i = 0;
      do {
        chr1 = str.charCodeAt(i++);
        chr2 = str.charCodeAt(i++);
        chr3 = str.charCodeAt(i++);
        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
        enc4 = chr3 & 63;
        if (isNaN(chr2)) {
          enc3 = enc4 = 64;
        } else if (isNaN(chr3)) {
          enc4 = 64;
        }
        output += key.charAt(enc1);
        output += key.charAt(enc2);
        output += key.charAt(enc3);
        output += key.charAt(enc4);
        chr1 = chr2 = chr3 = '';
        enc1 = enc2 = enc3 = enc4 = '';
      } while (i < str.length);
      return output;
    };
    decodeAscii = function(input) {
      var output = '';
      var chr1, chr2, chr3;
      var enc1, enc2, enc3, enc4;
      var i = 0;
      if (input.match(base64reg)) {
        return '';
      }
      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');
      do {
        enc1 = key.indexOf(input.charAt(i++));
        enc2 = key.indexOf(input.charAt(i++));
        enc3 = key.indexOf(input.charAt(i++));
        enc4 = key.indexOf(input.charAt(i++));
        chr1 = (enc1 << 2) | (enc2 >> 4);
        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
        chr3 = ((enc3 & 3) << 6) | enc4;
        output = output + chr$5(chr1);
        if (enc3 != 64) {
          output = output + chr$5(chr2);
        }
        if (enc4 != 64) {
          output = output + chr$5(chr3);
        }
        chr1 = chr2 = chr3 = '';
        enc1 = enc2 = enc3 = enc4 = '';
      } while (i < input.length);
      return output;
    };
  }
  encodeBase64$1 = function(str) {
    return encodeAscii(unescape(encodeURIComponent(str)));
  };
  decodeBase64$1 = function(str) {
    return decodeURIComponent(escape(decodeAscii(str)));
  };
}

buildBase64();

var base64$2 = {
  encodeBase64: encodeBase64$1,
  decodeBase64: decodeBase64$1
};

var Sugar$63 = sugarCore.exports,
    base64$1 = base64$2;

var decodeBase64 = base64$1.decodeBase64;

Sugar$63.String.defineInstance({

  'decodeBase64': function(str) {
    return decodeBase64(str);
  }

});

Sugar$63.String.decodeBase64;

var Sugar$62 = sugarCore.exports,
    base64 = base64$2;

var encodeBase64 = base64.encodeBase64;

Sugar$62.String.defineInstance({

  'encodeBase64': function(str) {
    return encodeBase64(str);
  }

});

Sugar$62.String.encodeBase64;

var HTML_ESCAPE_REG$1 = /[&<>]/g;

var HTMLFromEntityMap$2 = {
  'lt':    '<',
  'gt':    '>',
  'amp':   '&',
  'nbsp':  ' ',
  'quot':  '"',
  'apos':  "'"
};

var HTMLFromEntityMap_1 = HTMLFromEntityMap$2;

var HTMLFromEntityMap$1 = HTMLFromEntityMap_1,
    coreUtilityAliases$I = coreUtilityAliases$M;

var forEachProperty$n = coreUtilityAliases$I.forEachProperty;

var HTMLToEntityMap$1;

function buildEntities() {
  HTMLToEntityMap$1 = {};
  forEachProperty$n(HTMLFromEntityMap$1, function(val, key) {
    HTMLToEntityMap$1[val] = '&' + key + ';';
  });
}

buildEntities();

var HTMLToEntityMap_1 = HTMLToEntityMap$1;

var Sugar$61 = sugarCore.exports,
    HTML_ESCAPE_REG = HTML_ESCAPE_REG$1,
    HTMLToEntityMap = HTMLToEntityMap_1,
    coreUtilityAliases$H = coreUtilityAliases$M;

var getOwn$c = coreUtilityAliases$H.getOwn;

Sugar$61.String.defineInstance({

  'escapeHTML': function(str) {
    return str.replace(HTML_ESCAPE_REG, function(chr) {
      return getOwn$c(HTMLToEntityMap, chr);
    });
  }

});

Sugar$61.String.escapeHTML;

var Sugar$60 = sugarCore.exports;

Sugar$60.String.defineInstance({

  'escapeURL': function(str, param) {
    return param ? encodeURIComponent(str) : encodeURI(str);
  }

});

Sugar$60.String.escapeURL;

function isUndefined$l(o) {
  return o === undefined;
}

var isUndefined_1 = isUndefined$l;

var Sugar$5$ = sugarCore.exports,
    isUndefined$k = isUndefined_1;

Sugar$5$.String.defineInstance({

  'first': function(str, num) {
    if (isUndefined$k(num)) num = 1;
    return str.substr(0, num);
  }

});

Sugar$5$.String.first;

var Sugar$5_ = sugarCore.exports,
    stringEach$3 = stringEach_1;

Sugar$5_.String.defineInstance({

  'forEach': function(str, search, eachFn) {
    return stringEach$3(str, search, eachFn);
  }

});

Sugar$5_.String.forEach;

var PROPERTY_RANGE_REG$1 = /^(.*?)\[([-\d]*)\.\.([-\d]*)\](.*)$/;

var CommonChars$8 = {
  HALF_WIDTH_ZERO: 0x30,
  FULL_WIDTH_ZERO: 0xff10,
  HALF_WIDTH_PERIOD: '.',
  FULL_WIDTH_PERIOD: '．',
  HALF_WIDTH_COMMA: ',',
  OPEN_BRACE: '{',
  CLOSE_BRACE: '}'
};

function map$7(arr, fn) {
  // perf: Not using fixed array len here as it may be sparse.
  var result = [];
  for (var i = 0, len = arr.length; i < len; i++) {
    if (i in arr) {
      result.push(fn(arr[i], i));
    }
  }
  return result;
}

var map_1 = map$7;

var CommonChars$7 = CommonChars$8;

var HALF_WIDTH_PERIOD$4 = CommonChars$7.HALF_WIDTH_PERIOD;

function periodSplit$3(str) {
  return str.split(HALF_WIDTH_PERIOD$4);
}

var periodSplit_1 = periodSplit$3;

var classChecks$V = classChecks$Z;

var isArray$d = classChecks$V.isArray;

function assertArray$1(obj) {
  if (!isArray$d(obj)) {
    throw new TypeError('Array required');
  }
}

var assertArray_1 = assertArray$1;

function isPrimitive$7(obj, type) {
  type = type || typeof obj;
  return obj == null || type === 'string' || type === 'number' || type === 'boolean';
}

var isPrimitive_1 = isPrimitive$7;

var isPrimitive$6 = isPrimitive_1;

function assertWritable$1(obj) {
  if (isPrimitive$6(obj)) {
    // If strict mode is active then primitives will throw an
    // error when attempting to write properties. We can't be
    // sure if strict mode is available, so pre-emptively
    // throw an error here to ensure consistent behavior.
    throw new TypeError('Property cannot be written');
  }
}

var assertWritable_1 = assertWritable$1;

var PROPERTY_RANGE_REG = PROPERTY_RANGE_REG$1,
    CommonChars$6 = CommonChars$8,
    map$6 = map_1,
    isDefined$h = isDefined_1,
    classChecks$U = classChecks$Z,
    periodSplit$2 = periodSplit_1,
    assertArray = assertArray_1,
    isObjectType$c = isObjectType_1,
    assertWritable = assertWritable_1,
    coreUtilityAliases$G = coreUtilityAliases$M;

var isString$h = classChecks$U.isString,
    hasOwn$a = coreUtilityAliases$G.hasOwn,
    HALF_WIDTH_PERIOD$3 = CommonChars$6.HALF_WIDTH_PERIOD;

function handleDeepProperty$3(obj, key, any, has, fill, fillLast, val) {
  var ns, bs, ps, cbi, set, isLast, isPush, isIndex, nextIsIndex, exists;
  ns = obj;
  if (key == null) return;

  if (isObjectType$c(key)) {
    // Allow array and array-like accessors
    bs = [key];
  } else {
    key = String(key);
    if (key.indexOf('..') !== -1) {
      return handleArrayIndexRange(obj, key, any, val);
    }
    bs = key.split('[');
  }

  set = isDefined$h(val);

  for (var i = 0, blen = bs.length; i < blen; i++) {
    ps = bs[i];

    if (isString$h(ps)) {
      ps = periodSplit$2(ps);
    }

    for (var j = 0, plen = ps.length; j < plen; j++) {
      key = ps[j];

      // Is this the last key?
      isLast = i === blen - 1 && j === plen - 1;

      // Index of the closing ]
      cbi = key.indexOf(']');

      // Is the key an array index?
      isIndex = cbi !== -1;

      // Is this array push syntax "[]"?
      isPush = set && cbi === 0;

      // If the bracket split was successful and this is the last element
      // in the dot split, then we know the next key will be an array index.
      nextIsIndex = blen > 1 && j === plen - 1;

      if (isPush) {
        // Set the index to the end of the array
        key = ns.length;
      } else if (isIndex) {
        // Remove the closing ]
        key = key.slice(0, -1);
      }

      // If the array index is less than 0, then
      // add its length to allow negative indexes.
      if (isIndex && key < 0) {
        key = +key + ns.length;
      }

      // Bracket keys may look like users[5] or just [5], so the leading
      // characters are optional. We can enter the namespace if this is the
      // 2nd part, if there is only 1 part, or if there is an explicit key.
      if (i || key || blen === 1) {

        // TODO: need to be sure this check handles ''.length when
        // we refactor.
        exists = any ? key in Object(ns) : hasOwn$a(ns, key);

        // Non-existent namespaces are only filled if they are intermediate
        // (not at the end) or explicitly filling the last.
        if (fill && (!isLast || fillLast) && !exists) {
          // For our purposes, last only needs to be an array.
          ns = ns[key] = nextIsIndex || (fillLast && isLast) ? [] : {};
          continue;
        }

        if (has) {
          if (isLast || !exists) {
            return exists;
          }
        } else if (set && isLast) {
          assertWritable(ns);
          ns[key] = val;
        }

        ns = exists ? ns[key] : undefined;
      }

    }
  }
  return ns;
}

function handleArrayIndexRange(obj, key, any, val) {
  var match, start, end, leading, trailing, arr, set;
  match = key.match(PROPERTY_RANGE_REG);
  if (!match) {
    return;
  }

  set = isDefined$h(val);
  leading = match[1];

  if (leading) {
    arr = handleDeepProperty$3(obj, leading, any, false, set ? true : false, true);
  } else {
    arr = obj;
  }

  assertArray(arr);

  trailing = match[4];
  start    = match[2] ? +match[2] : 0;
  end      = match[3] ? +match[3] : arr.length;

  // A range of 0..1 is inclusive, so we need to add 1 to the end. If this
  // pushes the index from -1 to 0, then set it to the full length of the
  // array, otherwise it will return nothing.
  end = end === -1 ? arr.length : end + 1;

  if (set) {
    for (var i = start; i < end; i++) {
      handleDeepProperty$3(arr, i + trailing, any, false, true, false, val);
    }
  } else {
    arr = arr.slice(start, end);

    // If there are trailing properties, then they need to be mapped for each
    // element in the array.
    if (trailing) {
      if (trailing.charAt(0) === HALF_WIDTH_PERIOD$3) {
        // Need to chomp the period if one is trailing after the range. We
        // can't do this at the regex level because it will be required if
        // we're setting the value as it needs to be concatentated together
        // with the array index to be set.
        trailing = trailing.slice(1);
      }
      return map$6(arr, function(el) {
        return handleDeepProperty$3(el, trailing);
      });
    }
  }
  return arr;
}

var handleDeepProperty_1 = handleDeepProperty$3;

var handleDeepProperty$2 = handleDeepProperty_1;

function deepGetProperty$4(obj, key, any) {
  return handleDeepProperty$2(obj, key, any, false);
}

var deepGetProperty_1 = deepGetProperty$4;

var STRING_FORMAT_REG$1 = /([{}])\1|{([^}]*)}|(%)%|(%(\w*))/g;

var INTERNAL_MEMOIZE_LIMIT$1 = 1000;

var INTERNAL_MEMOIZE_LIMIT = INTERNAL_MEMOIZE_LIMIT$1,
    coreUtilityAliases$F = coreUtilityAliases$M;

var hasOwn$9 = coreUtilityAliases$F.hasOwn;

function memoizeFunction$1(fn) {
  var memo = {}, counter = 0;

  return function(key) {
    if (hasOwn$9(memo, key)) {
      return memo[key];
    }
    // istanbul ignore if
    if (counter === INTERNAL_MEMOIZE_LIMIT) {
      memo = {};
      counter = 0;
    }
    counter++;
    return memo[key] = fn(key);
  };
}

var memoizeFunction_1 = memoizeFunction$1;

var STRING_FORMAT_REG = STRING_FORMAT_REG$1,
    CommonChars$5 = CommonChars$8,
    memoizeFunction = memoizeFunction_1;

var OPEN_BRACE = CommonChars$5.OPEN_BRACE,
    CLOSE_BRACE = CommonChars$5.CLOSE_BRACE;

function createFormatMatcher$2(bracketMatcher, percentMatcher, precheck) {

  var reg = STRING_FORMAT_REG;
  var compileMemoized = memoizeFunction(compile);

  function getToken(format, match) {
    var get, token, literal, fn;
    var bKey = match[2];
    var pLit = match[3];
    var pKey = match[5];
    if (match[4] && percentMatcher) {
      token = pKey;
      get = percentMatcher;
    } else if (bKey) {
      token = bKey;
      get = bracketMatcher;
    } else if (pLit && percentMatcher) {
      literal = pLit;
    } else {
      literal = match[1] || match[0];
    }
    if (get) {
      assertPassesPrecheck(precheck, bKey, pKey);
      fn = function(obj, opt) {
        return get(obj, token, opt);
      };
    }
    format.push(fn || getLiteral(literal));
  }

  function getSubstring(format, str, start, end) {
    if (end > start) {
      var sub = str.slice(start, end);
      assertNoUnmatched(sub, OPEN_BRACE);
      assertNoUnmatched(sub, CLOSE_BRACE);
      format.push(function() {
        return sub;
      });
    }
  }

  function getLiteral(str) {
    return function() {
      return str;
    };
  }

  function assertPassesPrecheck(precheck, bt, pt) {
    if (precheck && !precheck(bt, pt)) {
      throw new TypeError('Invalid token '+ (bt || pt) +' in format string');
    }
  }

  function assertNoUnmatched(str, chr) {
    if (str.indexOf(chr) !== -1) {
      throw new TypeError('Unmatched '+ chr +' in format string');
    }
  }

  function compile(str) {
    var format = [], lastIndex = 0, match;
    reg.lastIndex = 0;
    while(match = reg.exec(str)) {
      getSubstring(format, str, lastIndex, match.index);
      getToken(format, match);
      lastIndex = reg.lastIndex;
    }
    getSubstring(format, str, lastIndex, str.length);
    return format;
  }

  return function(str, obj, opt) {
    var format = compileMemoized(str), result = '';
    for (var i = 0; i < format.length; i++) {
      result += format[i](obj, opt);
    }
    return result;
  };
}

var createFormatMatcher_1 = createFormatMatcher$2;

var deepGetProperty$3 = deepGetProperty_1,
    createFormatMatcher$1 = createFormatMatcher_1;

var stringFormatMatcher$1 = createFormatMatcher$1(deepGetProperty$3);

var Sugar$5Z = sugarCore.exports,
    isObjectType$b = isObjectType_1,
    stringFormatMatcher = stringFormatMatcher$1;

Sugar$5Z.String.defineInstanceWithArguments({

  'format': function(str, args) {
    var arg1 = args[0] && args[0].valueOf();
    // Unwrap if a single object is passed in.
    if (args.length === 1 && isObjectType$b(arg1)) {
      args = arg1;
    }
    return stringFormatMatcher(str, args);
  }

});

Sugar$5Z.String.format;

var classChecks$T = classChecks$Z;

var isString$g = classChecks$T.isString;

function numberOrIndex$2(str, n, from) {
  if (isString$g(n)) {
    n = str.indexOf(n);
    if (n === -1) {
      n = from ? str.length : 0;
    }
  }
  return n;
}

var numberOrIndex_1 = numberOrIndex$2;

var Sugar$5Y = sugarCore.exports,
    numberOrIndex$1 = numberOrIndex_1;

Sugar$5Y.String.defineInstance({

  'from': function(str, from) {
    return str.slice(numberOrIndex$1(str, from, true));
  }

});

Sugar$5Y.String.from;

var ENHANCEMENTS_FLAG$7 = 'enhance';

var STRING_ENHANCEMENTS_FLAG$1 = 'enhanceString';

function fixArgumentLength$9(fn) {
  var staticFn = function(a) {
    var args = arguments;
    return fn(a, args[1], args[2], args.length - 1);
  };
  staticFn.instance = function(b) {
    var args = arguments;
    return fn(this, b, args[1], args.length);
  };
  return staticFn;
}

var fixArgumentLength_1 = fixArgumentLength$9;

var nativeIncludes$1 = String.prototype.includes;

var classChecks$S = classChecks$Z,
    nativeIncludes = nativeIncludes$1;

var isRegExp$5 = classChecks$S.isRegExp;

function callIncludesWithRegexSupport$1(str, search, position) {
  if (!isRegExp$5(search)) {
    return nativeIncludes.call(str, search, position);
  }
  if (position) {
    str = str.slice(position);
  }
  return search.test(str);
}

var callIncludesWithRegexSupport_1 = callIncludesWithRegexSupport$1;

var Sugar$5X = sugarCore.exports,
    ENHANCEMENTS_FLAG$6 = ENHANCEMENTS_FLAG$7,
    STRING_ENHANCEMENTS_FLAG = STRING_ENHANCEMENTS_FLAG$1,
    fixArgumentLength$8 = fixArgumentLength_1,
    callIncludesWithRegexSupport = callIncludesWithRegexSupport_1;

Sugar$5X.String.defineInstance({

  'includes': fixArgumentLength$8(callIncludesWithRegexSupport)

}, [ENHANCEMENTS_FLAG$6, STRING_ENHANCEMENTS_FLAG]);

Sugar$5X.String.includes;

var Sugar$5W = sugarCore.exports,
    isUndefined$j = isUndefined_1;

Sugar$5W.String.defineInstance({

  'insert': function(str, substr, index) {
    index = isUndefined$j(index) ? str.length : index;
    return str.slice(0, index) + substr + str.slice(index);
  }

});

Sugar$5W.String.insert;

var Sugar$5V = sugarCore.exports,
    trim$4 = trim_1;

Sugar$5V.String.defineInstance({

  'isBlank': function(str) {
    return trim$4(str).length === 0;
  }

});

Sugar$5V.String.isBlank;

var Sugar$5U = sugarCore.exports;

Sugar$5U.String.defineInstance({

  'isEmpty': function(str) {
    return str.length === 0;
  }

});

Sugar$5U.String.isEmpty;

var Sugar$5T = sugarCore.exports,
    isUndefined$i = isUndefined_1;

Sugar$5T.String.defineInstance({

  'last': function(str, num) {
    if (isUndefined$i(num)) num = 1;
    var start = str.length - num < 0 ? 0 : str.length - num;
    return str.substr(start);
  }

});

Sugar$5T.String.last;

var Sugar$5S = sugarCore.exports,
    trim$3 = trim_1,
    stringEach$2 = stringEach_1;

Sugar$5S.String.defineInstance({

  'lines': function(str, eachLineFn) {
    return stringEach$2(trim$3(str), /^.*$/gm, eachLineFn);
  }

});

Sugar$5S.String.lines;

function repeatString$3(str, num) {
  var result = '';
  str = str.toString();
  while (num > 0) {
    if (num & 1) {
      result += str;
    }
    if (num >>= 1) {
      str += str;
    }
  }
  return result;
}

var repeatString_1 = repeatString$3;

var isDefined$g = isDefined_1,
    repeatString$2 = repeatString_1;

function padString$3(num, padding) {
  return repeatString$2(isDefined$g(padding) ? padding : ' ', num);
}

var padString_1 = padString$3;

var mathAliases$z = {
  abs: Math.abs,
  pow: Math.pow,
  min: Math.min,
  max: Math.max,
  ceil: Math.ceil,
  floor: Math.floor,
  round: Math.round
};

var mathAliases$y = mathAliases$z;

var ceil$8 = mathAliases$y.ceil,
    floor$5 = mathAliases$y.floor;

var trunc$c = Math.trunc || function(n) {
  if (n === 0 || !isFinite(n)) return n;
  return n < 0 ? ceil$8(n) : floor$5(n);
};

var trunc_1 = trunc$c;

var trunc$b = trunc_1,
    classChecks$R = classChecks$Z;

var isNumber$c = classChecks$R.isNumber;

function coercePositiveInteger$6(n) {
  n = +n || 0;
  if (n < 0 || !isNumber$c(n) || !isFinite(n)) {
    throw new RangeError('Invalid number');
  }
  return trunc$b(n);
}

var coercePositiveInteger_1 = coercePositiveInteger$6;

var Sugar$5R = sugarCore.exports,
    padString$2 = padString_1,
    mathAliases$x = mathAliases$z,
    coercePositiveInteger$5 = coercePositiveInteger_1;

var max$a = mathAliases$x.max,
    ceil$7 = mathAliases$x.ceil,
    floor$4 = mathAliases$x.floor;

Sugar$5R.String.defineInstance({

  'pad': function(str, num, padding) {
    var half, front, back;
    num   = coercePositiveInteger$5(num);
    half  = max$a(0, num - str.length) / 2;
    front = floor$4(half);
    back  = ceil$7(half);
    return padString$2(front, padding) + str + padString$2(back, padding);
  }

});

Sugar$5R.String.pad;

var Sugar$5Q = sugarCore.exports,
    padString$1 = padString_1,
    mathAliases$w = mathAliases$z,
    coercePositiveInteger$4 = coercePositiveInteger_1;

var max$9 = mathAliases$w.max;

Sugar$5Q.String.defineInstance({

  'padLeft': function(str, num, padding) {
    num = coercePositiveInteger$4(num);
    return padString$1(max$9(0, num - str.length), padding) + str;
  }

});

Sugar$5Q.String.padLeft;

var Sugar$5P = sugarCore.exports,
    padString = padString_1,
    mathAliases$v = mathAliases$z,
    coercePositiveInteger$3 = coercePositiveInteger_1;

var max$8 = mathAliases$v.max;

Sugar$5P.String.defineInstance({

  'padRight': function(str, num, padding) {
    num = coercePositiveInteger$3(num);
    return str + padString(max$8(0, num - str.length), padding);
  }

});

Sugar$5P.String.padRight;

var escapeRegExp$4 = escapeRegExp_1;

function stringParameterize$1(str, separator) {
  if (separator === undefined) separator = '-';
  str = str.replace(/[^a-z0-9\-_]+/gi, separator);
  if (separator) {
    var reg = RegExp('^{s}+|{s}+$|({s}){s}+'.split('{s}').join(escapeRegExp$4(separator)), 'g');
    str = str.replace(reg, '$1');
  }
  return encodeURI(str.toLowerCase());
}

var stringParameterize_1 = stringParameterize$1;

var Sugar$5O = sugarCore.exports,
    stringParameterize = stringParameterize_1;

Sugar$5O.String.defineInstance({

  'parameterize': function(str, separator) {
    return stringParameterize(str, separator);
  }

});

Sugar$5O.String.parameterize;

var Sugar$5N = sugarCore.exports;

Sugar$5N.String.defineInstance({

  'remove': function(str, f) {
    return str.replace(f, '');
  }

});

Sugar$5N.String.remove;

var classChecks$Q = classChecks$Z,
    escapeRegExp$3 = escapeRegExp_1,
    getRegExpFlags$4 = getRegExpFlags_1;

var isString$f = classChecks$Q.isString;

function stringReplaceAll$2(str, f, replace) {
  var i = 0, tokens;
  if (isString$f(f)) {
    f = RegExp(escapeRegExp$3(f), 'g');
  } else if (f && !f.global) {
    f = RegExp(f.source, getRegExpFlags$4(f, 'g'));
  }
  if (!replace) {
    replace = '';
  } else {
    tokens = replace;
    replace = function() {
      var t = tokens[i++];
      return t != null ? t : '';
    };
  }
  return str.replace(f, replace);
}

var stringReplaceAll_1 = stringReplaceAll$2;

var Sugar$5M = sugarCore.exports,
    stringReplaceAll$1 = stringReplaceAll_1;

Sugar$5M.String.defineInstance({

  'removeAll': function(str, f) {
    return stringReplaceAll$1(str, f);
  }

});

Sugar$5M.String.removeAll;

var HTML_VOID_ELEMENTS$1 = [
  'area','base','br','col','command','embed','hr','img',
  'input','keygen','link','meta','param','source','track','wbr'
];

var HTML_VOID_ELEMENTS_1 = HTML_VOID_ELEMENTS$1;

function indexOf$3(arr, el) {
  for (var i = 0, len = arr.length; i < len; i++) {
    if (i in arr && arr[i] === el) return i;
  }
  return -1;
}

var indexOf_1 = indexOf$3;

var HTML_VOID_ELEMENTS = HTML_VOID_ELEMENTS_1,
    indexOf$2 = indexOf_1;

function tagIsVoid$1(tag) {
  return indexOf$2(HTML_VOID_ELEMENTS, tag.toLowerCase()) !== -1;
}

var tagIsVoid_1 = tagIsVoid$1;

var tagIsVoid = tagIsVoid_1,
    classChecks$P = classChecks$Z;

var isString$e = classChecks$P.isString;

function runTagReplacements$1(str, reg, strip, replacement, fullString) {

  var match;
  var result = '';
  var currentIndex = 0;
  var openTagName;
  var openTagAttributes;
  var openTagCount = 0;

  function processTag(index, tagName, attributes, tagLength, isVoid) {
    var content = str.slice(currentIndex, index), s = '', r = '';
    if (isString$e(replacement)) {
      r = replacement;
    } else if (replacement) {
      r = replacement.call(fullString, tagName, content, attributes, fullString) || '';
    }
    if (strip) {
      s = r;
    } else {
      content = r;
    }
    if (content) {
      content = runTagReplacements$1(content, reg, strip, replacement, fullString);
    }
    result += s + content + (isVoid ? '' : s);
    currentIndex = index + (tagLength || 0);
  }

  fullString = fullString || str;
  reg = RegExp(reg.source, 'gi');

  while(match = reg.exec(str)) {

    var tagName         = match[2];
    var attributes      = (match[3]|| '').slice(1);
    var isClosingTag    = !!match[1];
    var isSelfClosing   = !!match[4];
    var tagLength       = match[0].length;
    var isVoid          = tagIsVoid(tagName);
    var isOpeningTag    = !isClosingTag && !isSelfClosing && !isVoid;
    var isSameAsCurrent = tagName === openTagName;

    if (!openTagName) {
      result += str.slice(currentIndex, match.index);
      currentIndex = match.index;
    }

    if (isOpeningTag) {
      if (!openTagName) {
        openTagName = tagName;
        openTagAttributes = attributes;
        openTagCount++;
        currentIndex += tagLength;
      } else if (isSameAsCurrent) {
        openTagCount++;
      }
    } else if (isClosingTag && isSameAsCurrent) {
      openTagCount--;
      if (openTagCount === 0) {
        processTag(match.index, openTagName, openTagAttributes, tagLength, isVoid);
        openTagName       = null;
        openTagAttributes = null;
      }
    } else if (!openTagName) {
      processTag(match.index, tagName, attributes, tagLength, isVoid);
    }
  }
  if (openTagName) {
    processTag(str.length, openTagName, openTagAttributes);
  }
  result += str.slice(currentIndex);
  return result;
}

var runTagReplacements_1 = runTagReplacements$1;

var map$5 = map_1,
    classChecks$O = classChecks$Z,
    escapeRegExp$2 = escapeRegExp_1,
    runTagReplacements = runTagReplacements_1;

var isString$d = classChecks$O.isString;

function replaceTags$2(str, find, replacement, strip) {
  var tags = isString$d(find) ? [find] : find, reg, src;
  tags = map$5(tags || [], function(t) {
    return escapeRegExp$2(t);
  }).join('|');
  src = tags.replace('all', '') || '[^\\s>]+';
  src = '<(\\/)?(' + src + ')(\\s+[^<>]*?)?\\s*(\\/)?>';
  reg = RegExp(src, 'gi');
  return runTagReplacements(str.toString(), reg, strip, replacement);
}

var replaceTags_1 = replaceTags$2;

var Sugar$5L = sugarCore.exports,
    replaceTags$1 = replaceTags_1;

Sugar$5L.String.defineInstance({

  'removeTags': function(str, tag, replace) {
    return replaceTags$1(str, tag, replace, false);
  }

});

Sugar$5L.String.removeTags;

var Sugar$5K = sugarCore.exports,
    stringReplaceAll = stringReplaceAll_1;

Sugar$5K.String.defineInstanceWithArguments({

  'replaceAll': function(str, f, args) {
    return stringReplaceAll(str, f, args);
  }

});

Sugar$5K.String.replaceAll;

function reverseString$2(str) {
  return str.split('').reverse().join('');
}

var reverseString_1 = reverseString$2;

var Sugar$5J = sugarCore.exports,
    reverseString$1 = reverseString_1;

Sugar$5J.String.defineInstance({

  'reverse': function(str) {
    return reverseString$1(str);
  }

});

Sugar$5J.String.reverse;

var Sugar$5I = sugarCore.exports,
    chr$4 = chr$6,
    stringCodes = stringCodes_1;

Sugar$5I.String.defineInstance({

  'shift': function(str, n) {
    var result = '';
    n = n || 0;
    stringCodes(str, function(c) {
      result += chr$4(c + n);
    });
    return result;
  }

});

Sugar$5I.String.shift;

var stringUnderscore$1 = stringUnderscore_1;

function stringSpacify$2(str) {
  return stringUnderscore$1(str).replace(/_/g, ' ');
}

var stringSpacify_1 = stringSpacify$2;

var Sugar$5H = sugarCore.exports,
    stringSpacify$1 = stringSpacify_1;

Sugar$5H.String.defineInstance({

  'spacify': function(str) {
    return stringSpacify$1(str);
  }

});

Sugar$5H.String.spacify;

var Sugar$5G = sugarCore.exports,
    replaceTags = replaceTags_1;

Sugar$5G.String.defineInstance({

  'stripTags': function(str, tag, replace) {
    return replaceTags(str, tag, replace, true);
  }

});

Sugar$5G.String.stripTags;

var DOWNCASED_WORDS$1 = [
  'and', 'or', 'nor', 'a', 'an', 'the', 'so', 'but', 'to', 'of', 'at',
  'by', 'from', 'into', 'on', 'onto', 'off', 'out', 'in', 'over',
  'with', 'for'
];

var DOWNCASED_WORDS_1 = DOWNCASED_WORDS$1;

var trim$2 = trim_1,
    stringEach$1 = stringEach_1;

function eachWord$1(str, fn) {
  return stringEach$1(trim$2(str), /\S+/g, fn);
}

var eachWord_1 = eachWord$1;

var Inflections$1 = Inflections$4;

function getHumanWord$1(str) {
  // istanbul ignore next
  return Inflections$1.human && Inflections$1.human.find(str);
}

var getHumanWord_1 = getHumanWord$1;

var Inflections = Inflections$4;

function runHumanRules$1(str) {
  // istanbul ignore next
  return Inflections.human && Inflections.human.runRules(str) || str;
}

var runHumanRules_1 = runHumanRules$1;

var DOWNCASED_WORDS = DOWNCASED_WORDS_1,
    indexOf$1 = indexOf_1,
    eachWord = eachWord_1,
    getAcronym = getAcronym_1,
    getHumanWord = getHumanWord_1,
    runHumanRules = runHumanRules_1,
    stringSpacify = stringSpacify_1,
    stringCapitalize = stringCapitalize_1;

function stringTitleize$1(str) {
  var fullStopPunctuation = /[.:;!]$/, lastHadPunctuation;
  str = runHumanRules(str);
  str = stringSpacify(str);
  return eachWord(str, function(word, index, words) {
    word = getHumanWord(word) || word;
    word = getAcronym(word) || word;
    var hasPunctuation, isFirstOrLast;
    var first = index == 0, last = index == words.length - 1;
    hasPunctuation = fullStopPunctuation.test(word);
    isFirstOrLast = first || last || hasPunctuation || lastHadPunctuation;
    lastHadPunctuation = hasPunctuation;
    if (isFirstOrLast || indexOf$1(DOWNCASED_WORDS, word) === -1) {
      return stringCapitalize(word, false, true);
    } else {
      return word;
    }
  }).join(' ');
}

var stringTitleize_1 = stringTitleize$1;

var Sugar$5F = sugarCore.exports,
    stringTitleize = stringTitleize_1;

Sugar$5F.String.defineInstance({

  'titleize': function(str) {
    return stringTitleize(str);
  }

});

Sugar$5F.String.titleize;

var Sugar$5E = sugarCore.exports,
    isUndefined$h = isUndefined_1,
    numberOrIndex = numberOrIndex_1;

Sugar$5E.String.defineInstance({

  'to': function(str, to) {
    if (isUndefined$h(to)) to = str.length;
    return str.slice(0, numberOrIndex(str, to));
  }

});

Sugar$5E.String.to;

function allCharsReg$2(src) {
  return RegExp('[' + src + ']', 'g');
}

var allCharsReg_1 = allCharsReg$2;

var CommonChars$4 = CommonChars$8,
    chr$3 = chr$6,
    allCharsReg$1 = allCharsReg_1;

var HALF_WIDTH_ZERO$1 = CommonChars$4.HALF_WIDTH_ZERO,
    FULL_WIDTH_ZERO$1 = CommonChars$4.FULL_WIDTH_ZERO,
    HALF_WIDTH_PERIOD$2 = CommonChars$4.HALF_WIDTH_PERIOD,
    FULL_WIDTH_PERIOD = CommonChars$4.FULL_WIDTH_PERIOD,
    HALF_WIDTH_COMMA$2 = CommonChars$4.HALF_WIDTH_COMMA;

var fullWidthNumberReg$1, fullWidthNumberMap$2, fullWidthNumbers$1;

function buildFullWidthNumber() {
  var fwp = FULL_WIDTH_PERIOD, hwp = HALF_WIDTH_PERIOD$2, hwc = HALF_WIDTH_COMMA$2, fwn = '';
  fullWidthNumberMap$2 = {};
  for (var i = 0, digit; i <= 9; i++) {
    digit = chr$3(i + FULL_WIDTH_ZERO$1);
    fwn += digit;
    fullWidthNumberMap$2[digit] = chr$3(i + HALF_WIDTH_ZERO$1);
  }
  fullWidthNumberMap$2[hwc] = '';
  fullWidthNumberMap$2[fwp] = hwp;
  // Mapping this to itself to capture it easily
  // in stringToNumber to detect decimals later.
  fullWidthNumberMap$2[hwp] = hwp;
  fullWidthNumberReg$1 = allCharsReg$1(fwn + fwp + hwc + hwp);
  fullWidthNumbers$1 = fwn;
}

buildFullWidthNumber();

var fullwidthNumberHelpers$2 = {
  fullWidthNumberReg: fullWidthNumberReg$1,
  fullWidthNumberMap: fullWidthNumberMap$2,
  fullWidthNumbers: fullWidthNumbers$1
};

var CommonChars$3 = CommonChars$8,
    coreUtilityAliases$E = coreUtilityAliases$M,
    fullwidthNumberHelpers$1 = fullwidthNumberHelpers$2;

var fullWidthNumberReg = fullwidthNumberHelpers$1.fullWidthNumberReg,
    fullWidthNumberMap$1 = fullwidthNumberHelpers$1.fullWidthNumberMap,
    getOwn$b = coreUtilityAliases$E.getOwn,
    HALF_WIDTH_PERIOD$1 = CommonChars$3.HALF_WIDTH_PERIOD;

function stringToNumber$2(str, base) {
  var sanitized, isDecimal;
  sanitized = str.replace(fullWidthNumberReg, function(chr) {
    var replacement = getOwn$b(fullWidthNumberMap$1, chr);
    if (replacement === HALF_WIDTH_PERIOD$1) {
      isDecimal = true;
    }
    return replacement;
  });
  return isDecimal ? parseFloat(sanitized) : parseInt(sanitized, base || 10);
}

var stringToNumber_1 = stringToNumber$2;

var Sugar$5D = sugarCore.exports,
    stringToNumber$1 = stringToNumber_1;

Sugar$5D.String.defineInstance({

  'toNumber': function(str, base) {
    return stringToNumber$1(str, base);
  }

});

Sugar$5D.String.toNumber;

var TRIM_CHARS$3 = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u2028\u2029\u3000\uFEFF';

var TRIM_CHARS$2 = TRIM_CHARS$3;

var LEFT_TRIM_REG$1 = RegExp('^['+ TRIM_CHARS$2 +']+');

var Sugar$5C = sugarCore.exports,
    LEFT_TRIM_REG = LEFT_TRIM_REG$1;

Sugar$5C.String.defineInstance({

  'trimLeft': function(str) {
    return str.replace(LEFT_TRIM_REG, '');
  }

});

Sugar$5C.String.trimLeft;

var TRIM_CHARS$1 = TRIM_CHARS$3;

var RIGHT_TRIM_REG$1 = RegExp('['+ TRIM_CHARS$1 +']+$');

var Sugar$5B = sugarCore.exports,
    RIGHT_TRIM_REG = RIGHT_TRIM_REG$1;

Sugar$5B.String.defineInstance({

  'trimRight': function(str) {
    return str.replace(RIGHT_TRIM_REG, '');
  }

});

Sugar$5B.String.trimRight;

var TRIM_CHARS = TRIM_CHARS$3;

var TRUNC_REG$1 = RegExp('(?=[' + TRIM_CHARS + '])');

function filter$3(arr, fn) {
  var result = [];
  for (var i = 0, len = arr.length; i < len; i++) {
    var el = arr[i];
    if (i in arr && fn(el, i)) {
      result.push(el);
    }
  }
  return result;
}

var filter_1 = filter$3;

var TRUNC_REG = TRUNC_REG$1,
    filter$2 = filter_1,
    reverseString = reverseString_1;

function truncateOnWord$1(str, limit, fromLeft) {
  if (fromLeft) {
    return reverseString(truncateOnWord$1(reverseString(str), limit));
  }
  var words = str.split(TRUNC_REG);
  var count = 0;
  return filter$2(words, function(word) {
    count += word.length;
    return count <= limit;
  }).join('');
}

var truncateOnWord_1 = truncateOnWord$1;

var isUndefined$g = isUndefined_1,
    mathAliases$u = mathAliases$z,
    truncateOnWord = truncateOnWord_1;

var ceil$6 = mathAliases$u.ceil,
    floor$3 = mathAliases$u.floor;

function truncateString$2(str, length, from, ellipsis, split) {
  var str1, str2, len1, len2;
  if (str.length <= length) {
    return str.toString();
  }
  ellipsis = isUndefined$g(ellipsis) ? '...' : ellipsis;
  switch(from) {
    case 'left':
      str2 = split ? truncateOnWord(str, length, true) : str.slice(str.length - length);
      return ellipsis + str2;
    case 'middle':
      len1 = ceil$6(length / 2);
      len2 = floor$3(length / 2);
      str1 = split ? truncateOnWord(str, len1) : str.slice(0, len1);
      str2 = split ? truncateOnWord(str, len2, true) : str.slice(str.length - len2);
      return str1 + ellipsis + str2;
    default:
      str1 = split ? truncateOnWord(str, length) : str.slice(0, length);
      return str1 + ellipsis;
  }
}

var truncateString_1 = truncateString$2;

var Sugar$5A = sugarCore.exports,
    truncateString$1 = truncateString_1;

Sugar$5A.String.defineInstance({

  'truncate': function(str, length, from, ellipsis) {
    return truncateString$1(str, length, from, ellipsis);
  }

});

Sugar$5A.String.truncate;

var Sugar$5z = sugarCore.exports,
    truncateString = truncateString_1;

Sugar$5z.String.defineInstance({

  'truncateOnWord': function(str, length, from, ellipsis) {
    return truncateString(str, length, from, ellipsis, true);
  }

});

Sugar$5z.String.truncateOnWord;

var Sugar$5y = sugarCore.exports,
    stringUnderscore = stringUnderscore_1;

Sugar$5y.String.defineInstance({

  'underscore': function(str) {
    return stringUnderscore(str);
  }

});

Sugar$5y.String.underscore;

var HTML_ENTITY_REG$1 = /&#?(x)?([\w\d]{0,5});/gi;

var HTML_ENTITY_REG = HTML_ENTITY_REG$1,
    HTMLFromEntityMap = HTMLFromEntityMap_1,
    chr$2 = chr$6;

function unescapeHTML$1(str) {
  return str.replace(HTML_ENTITY_REG, function(full, hex, code) {
    var special = HTMLFromEntityMap[code];
    return special || chr$2(hex ? parseInt(code, 16) : +code);
  });
}

var unescapeHTML_1 = unescapeHTML$1;

var Sugar$5x = sugarCore.exports,
    unescapeHTML = unescapeHTML_1;

Sugar$5x.String.defineInstance({

  'unescapeHTML': function(str) {
    return unescapeHTML(str);
  }

});

Sugar$5x.String.unescapeHTML;

var Sugar$5w = sugarCore.exports;

Sugar$5w.String.defineInstance({

  'unescapeURL': function(str, param) {
    return param ? decodeURI(str) : decodeURIComponent(str);
  }

});

Sugar$5w.String.unescapeURL;

var Sugar$5v = sugarCore.exports,
    trim$1 = trim_1,
    stringEach = stringEach_1;

Sugar$5v.String.defineInstance({

  'words': function(str, eachWordFn) {
    return stringEach(trim$1(str), /\S+/g, eachWordFn);
  }

});

Sugar$5v.String.words;

var Sugar$5u = sugarCore.exports,
    trunc$a = trunc_1,
    mathAliases$t = mathAliases$z,
    isUndefined$f = isUndefined_1;

var min$6 = mathAliases$t.min,
    max$7 = mathAliases$t.max;

Sugar$5u.Number.defineStatic({

  'random': function(n1, n2) {
    var minNum, maxNum;
    if (arguments.length == 1) n2 = n1, n1 = 0;
    minNum = min$6(n1 || 0, isUndefined$f(n2) ? 1 : n2);
    maxNum = max$7(n1 || 0, isUndefined$f(n2) ? 1 : n2) + 1;
    return trunc$a((Math.random() * (maxNum - minNum)) + minNum);
  }

});

Sugar$5u.Number.random;

var AbbreviationUnits$3 = {
  BASIC_UNITS: '|kmbt',
  MEMORY_UNITS: '|KMGTPE',
  MEMORY_BINARY_UNITS: '|,Ki,Mi,Gi,Ti,Pi,Ei',
  METRIC_UNITS_SHORT: 'nμm|k',
  METRIC_UNITS_FULL: 'yzafpnμm|KMGTPEZY'
};

var CommonChars$2 = CommonChars$8;

var HALF_WIDTH_COMMA$1 = CommonChars$2.HALF_WIDTH_COMMA;

function commaSplit$2(str) {
  return str.split(HALF_WIDTH_COMMA$1);
}

var commaSplit_1 = commaSplit$2;

var mathAliases$s = mathAliases$z;

var abs$9 = mathAliases$s.abs,
    pow$2 = mathAliases$s.pow,
    round$4 = mathAliases$s.round;

function withPrecision$5(val, precision, fn) {
  var multiplier = pow$2(10, abs$9(precision || 0));
  fn = fn || round$4;
  if (precision < 0) multiplier = 1 / multiplier;
  return fn(val * multiplier) / multiplier;
}

var withPrecision_1 = withPrecision$5;

var CommonChars$1 = CommonChars$8;

var HALF_WIDTH_PERIOD = CommonChars$1.HALF_WIDTH_PERIOD,
    HALF_WIDTH_COMMA = CommonChars$1.HALF_WIDTH_COMMA;

var NUMBER_OPTIONS$1 = {
  'decimal': HALF_WIDTH_PERIOD,
  'thousands': HALF_WIDTH_COMMA
};

var NUMBER_OPTIONS_1 = NUMBER_OPTIONS$1;

var Sugar$5t = sugarCore.exports;

var namespaceAliases$e = {
  sugarObject: Sugar$5t.Object,
  sugarArray: Sugar$5t.Array,
  sugarDate: Sugar$5t.Date,
  sugarString: Sugar$5t.String,
  sugarNumber: Sugar$5t.Number,
  sugarFunction: Sugar$5t.Function,
  sugarRegExp: Sugar$5t.RegExp
};

var coreUtilityAliases$D = coreUtilityAliases$M;

var forEachProperty$m = coreUtilityAliases$D.forEachProperty;

function simpleMerge$4(target, source) {
  forEachProperty$m(source, function(val, key) {
    target[key] = val;
  });
  return target;
}

var simpleMerge_1 = simpleMerge$4;

var simpleMerge$3 = simpleMerge_1;

function simpleClone$4(obj) {
  return simpleMerge$3({}, obj);
}

var simpleClone_1 = simpleClone$4;

var coreUtilityAliases$C = coreUtilityAliases$M;

var setProperty$1 = coreUtilityAliases$C.setProperty;

function defineAccessor$1(namespace, name, fn) {
  setProperty$1(namespace, name, fn);
}

var defineAccessor_1 = defineAccessor$1;

var simpleClone$3 = simpleClone_1,
    defineAccessor = defineAccessor_1,
    coreUtilityAliases$B = coreUtilityAliases$M;

var forEachProperty$l = coreUtilityAliases$B.forEachProperty;

function defineOptionsAccessor$3(namespace, defaults) {
  var obj = simpleClone$3(defaults);

  function getOption(name) {
    return obj[name];
  }

  function setOption(arg1, arg2) {
    var options;
    if (arguments.length === 1) {
      options = arg1;
    } else {
      options = {};
      options[arg1] = arg2;
    }
    forEachProperty$l(options, function(val, name) {
      if (val === null) {
        val = defaults[name];
      }
      obj[name] = val;
    });
  }

  defineAccessor(namespace, 'getOption', getOption);
  defineAccessor(namespace, 'setOption', setOption);
  return getOption;
}

var defineOptionsAccessor_1 = defineOptionsAccessor$3;

var NUMBER_OPTIONS = NUMBER_OPTIONS_1,
    namespaceAliases$d = namespaceAliases$e,
    defineOptionsAccessor$2 = defineOptionsAccessor_1;

var sugarNumber$2 = namespaceAliases$d.sugarNumber;

var _numberOptions$1 = defineOptionsAccessor$2(sugarNumber$2, NUMBER_OPTIONS);

var classChecks$N = classChecks$Z,
    mathAliases$r = mathAliases$z,
    periodSplit$1 = periodSplit_1,
    repeatString$1 = repeatString_1,
    withPrecision$4 = withPrecision_1,
    _numberOptions = _numberOptions$1;

var isNumber$b = classChecks$N.isNumber,
    max$6 = mathAliases$r.max;

function numberFormat$2(num, place) {
  var result = '', thousands, decimal, fraction, integer, split, str;

  decimal   = _numberOptions('decimal');
  thousands = _numberOptions('thousands');

  if (isNumber$b(place)) {
    str = withPrecision$4(num, place || 0).toFixed(max$6(place, 0));
  } else {
    str = num.toString();
  }

  str = str.replace(/^-/, '');
  split    = periodSplit$1(str);
  integer  = split[0];
  fraction = split[1];
  if (/e/.test(str)) {
    result = str;
  } else {
    for(var i = integer.length; i > 0; i -= 3) {
      if (i < integer.length) {
        result = thousands + result;
      }
      result = integer.slice(max$6(0, i - 3), i) + result;
    }
  }
  if (fraction) {
    result += decimal + repeatString$1('0', (place || 0) - fraction.length) + fraction;
  }
  return (num < 0 ? '-' : '') + result;
}

var numberFormat_1 = numberFormat$2;

var commaSplit$1 = commaSplit_1,
    mathAliases$q = mathAliases$z,
    numberFormat$1 = numberFormat_1,
    withPrecision$3 = withPrecision_1;

var abs$8 = mathAliases$q.abs,
    pow$1 = mathAliases$q.pow,
    min$5 = mathAliases$q.min,
    max$5 = mathAliases$q.max,
    floor$2 = mathAliases$q.floor;

function abbreviateNumber$3(num, precision, ustr, bytes) {
  var fixed        = num.toFixed(20),
      decimalPlace = fixed.search(/\./),
      numeralPlace = fixed.search(/[1-9]/),
      significant  = decimalPlace - numeralPlace,
      units, unit, mid, i, divisor;
  if (significant > 0) {
    significant -= 1;
  }
  units = commaSplit$1(ustr);
  if (units.length === 1) {
    units = ustr.split('');
  }
  mid = units.indexOf('|');
  if (mid === -1) {
    // Skipping the placeholder means the units should start from zero,
    // otherwise assume they end at zero.
    mid = units[0] === '_' ? 0 : units.length;
  }
  i = max$5(min$5(floor$2(significant / 3), units.length - mid - 1), -mid);
  unit = units[i + mid];
  while (unit === '_') {
    i += i < 0 ? -1 : 1;
    unit = units[i + mid];
  }
  if (unit === '|') {
    unit = '';
  }
  if (significant < -9) {
    precision = abs$8(significant) - 9;
  }
  divisor = bytes ? pow$1(2, 10 * i) : pow$1(10, i * 3);
  return numberFormat$1(withPrecision$3(num / divisor, precision || 0)) + unit;
}

var abbreviateNumber_1 = abbreviateNumber$3;

var Sugar$5s = sugarCore.exports,
    AbbreviationUnits$2 = AbbreviationUnits$3,
    abbreviateNumber$2 = abbreviateNumber_1;

var BASIC_UNITS = AbbreviationUnits$2.BASIC_UNITS;

Sugar$5s.Number.defineInstance({

  'abbr': function(n, precision) {
    return abbreviateNumber$2(n, precision, BASIC_UNITS);
  }

});

Sugar$5s.Number.abbr;

function wrapNamespace$1(method) {
  return function(sugarNamespace, arg1, arg2) {
    sugarNamespace[method](arg1, arg2);
  };
}

var wrapNamespace_1 = wrapNamespace$1;

var wrapNamespace = wrapNamespace_1;

var methodDefineAliases$3 = {
  alias: wrapNamespace('alias'),
  defineStatic: wrapNamespace('defineStatic'),
  defineInstance: wrapNamespace('defineInstance'),
  defineStaticPolyfill: wrapNamespace('defineStaticPolyfill'),
  defineInstancePolyfill: wrapNamespace('defineInstancePolyfill'),
  defineInstanceAndStatic: wrapNamespace('defineInstanceAndStatic'),
  defineInstanceWithArguments: wrapNamespace('defineInstanceWithArguments')
};

var forEach$g = forEach_1,
    spaceSplit$4 = spaceSplit_1,
    classChecks$M = classChecks$Z;

var isString$c = classChecks$M.isString;

function collectSimilarMethods$2(set, fn) {
  var methods = {};
  if (isString$c(set)) {
    set = spaceSplit$4(set);
  }
  forEach$g(set, function(el, i) {
    fn(methods, el, i);
  });
  return methods;
}

var collectSimilarMethods_1 = collectSimilarMethods$2;

var methodDefineAliases$2 = methodDefineAliases$3,
    collectSimilarMethods$1 = collectSimilarMethods_1;

var defineInstance = methodDefineAliases$2.defineInstance;

function defineInstanceSimilar$5(sugarNamespace, set, fn, flags) {
  defineInstance(sugarNamespace, collectSimilarMethods$1(set, fn), flags);
}

var defineInstanceSimilar_1 = defineInstanceSimilar$5;

var namespaceAliases$c = namespaceAliases$e,
    defineInstanceSimilar$4 = defineInstanceSimilar_1;

var sugarNumber$1 = namespaceAliases$c.sugarNumber;

function buildMathAliases$1() {
  defineInstanceSimilar$4(sugarNumber$1, 'abs pow sin asin cos acos tan atan exp pow sqrt', function(methods, name) {
    methods[name] = function(n, arg) {
      // Note that .valueOf() here is only required due to a
      // very strange bug in iOS7 that only occurs occasionally
      // in which Math.abs() called on non-primitive numbers
      // returns a completely different number (Issue #400)
      return Math[name](n.valueOf(), arg);
    };
  });
}

var buildMathAliases_1 = buildMathAliases$1;

var buildMathAliases = buildMathAliases_1;

buildMathAliases();

var Sugar$5r = sugarCore.exports;



Sugar$5r.Number.abs;

var Sugar$5q = sugarCore.exports;



Sugar$5q.Number.acos;

var Sugar$5p = sugarCore.exports;



Sugar$5p.Number.asin;

var Sugar$5o = sugarCore.exports;



Sugar$5o.Number.atan;

var Sugar$5n = sugarCore.exports,
    AbbreviationUnits$1 = AbbreviationUnits$3,
    abbreviateNumber$1 = abbreviateNumber_1;

var MEMORY_UNITS = AbbreviationUnits$1.MEMORY_UNITS,
    MEMORY_BINARY_UNITS = AbbreviationUnits$1.MEMORY_BINARY_UNITS;

Sugar$5n.Number.defineInstance({

  'bytes': function(n, precision, binary, units) {
    if (units === 'binary' || (!units && binary)) {
      units = MEMORY_BINARY_UNITS;
    } else if(units === 'si' || !units) {
      units = MEMORY_UNITS;
    }
    return abbreviateNumber$1(n, precision, units, binary) + 'B';
  }

});

Sugar$5n.Number.bytes;

var withPrecision$2 = withPrecision_1;

function createRoundingFunction$3(fn) {
  return function(n, precision) {
    return precision ? withPrecision$2(n, precision, fn) : fn(n);
  };
}

var createRoundingFunction_1 = createRoundingFunction$3;

var Sugar$5m = sugarCore.exports,
    mathAliases$p = mathAliases$z,
    createRoundingFunction$2 = createRoundingFunction_1;

var ceil$5 = mathAliases$p.ceil;

Sugar$5m.Number.defineInstance({

  'ceil': createRoundingFunction$2(ceil$5)

});

Sugar$5m.Number.ceil;

var Sugar$5l = sugarCore.exports,
    chr$1 = chr$6;

Sugar$5l.Number.defineInstance({

  'chr': function(n) {
    return chr$1(n);
  }

});

Sugar$5l.Number.chr;

var Sugar$5k = sugarCore.exports;



Sugar$5k.Number.cos;

var Sugar$5j = sugarCore.exports;



Sugar$5j.Number.exp;

var Sugar$5i = sugarCore.exports,
    mathAliases$o = mathAliases$z,
    createRoundingFunction$1 = createRoundingFunction_1;

var floor$1 = mathAliases$o.floor;

Sugar$5i.Number.defineInstance({

  'floor': createRoundingFunction$1(floor$1)

});

Sugar$5i.Number.floor;

var Sugar$5h = sugarCore.exports,
    numberFormat = numberFormat_1;

Sugar$5h.Number.defineInstance({

  'format': function(n, place) {
    return numberFormat(n, place);
  }

});

Sugar$5h.Number.format;

var mathAliases$n = mathAliases$z,
    repeatString = repeatString_1;

var abs$7 = mathAliases$n.abs;

function padNumber$5(num, place, sign, base, replacement) {
  var str = abs$7(num).toString(base || 10);
  str = repeatString(replacement || '0', place - str.replace(/\.\d+/, '').length) + str;
  if (sign || num < 0) {
    str = (num < 0 ? '-' : '+') + str;
  }
  return str;
}

var padNumber_1 = padNumber$5;

var Sugar$5g = sugarCore.exports,
    padNumber$4 = padNumber_1;

Sugar$5g.Number.defineInstance({

  'hex': function(n, pad) {
    return padNumber$4(n, pad || 1, false, 16);
  }

});

Sugar$5g.Number.hex;

function isMultipleOf$3(n1, n2) {
  return n1 % n2 === 0;
}

var isMultipleOf_1 = isMultipleOf$3;

var Sugar$5f = sugarCore.exports,
    isMultipleOf$2 = isMultipleOf_1;

Sugar$5f.Number.defineInstance({

  'isEven': function(n) {
    return isMultipleOf$2(n, 2);
  }

});

Sugar$5f.Number.isEven;

function isInteger$2(n) {
  return n % 1 === 0;
}

var isInteger_1 = isInteger$2;

var Sugar$5e = sugarCore.exports,
    isInteger$1 = isInteger_1;

Sugar$5e.Number.defineInstance({

  'isInteger': function(n) {
    return isInteger$1(n);
  }

});

Sugar$5e.Number.isInteger;

var Sugar$5d = sugarCore.exports,
    isMultipleOf$1 = isMultipleOf_1;

Sugar$5d.Number.defineInstance({

  'isMultipleOf': function(n, num) {
    return isMultipleOf$1(n, num);
  }

});

Sugar$5d.Number.isMultipleOf;

var Sugar$5c = sugarCore.exports,
    isInteger = isInteger_1,
    isMultipleOf = isMultipleOf_1;

Sugar$5c.Number.defineInstance({

  'isOdd': function(n) {
    return isInteger(n) && !isMultipleOf(n, 2);
  }

});

Sugar$5c.Number.isOdd;

var Sugar$5b = sugarCore.exports;

Sugar$5b.Number.defineInstance({

  'log': function(n, base) {
    return Math.log(n) / (base ? Math.log(base) : 1);
  }

});

Sugar$5b.Number.log;

var Sugar$5a = sugarCore.exports,
    AbbreviationUnits = AbbreviationUnits$3,
    abbreviateNumber = abbreviateNumber_1;

var METRIC_UNITS_SHORT = AbbreviationUnits.METRIC_UNITS_SHORT,
    METRIC_UNITS_FULL = AbbreviationUnits.METRIC_UNITS_FULL;

Sugar$5a.Number.defineInstance({

  'metric': function(n, precision, units) {
    if (units === 'all') {
      units = METRIC_UNITS_FULL;
    } else if (!units) {
      units = METRIC_UNITS_SHORT;
    }
    return abbreviateNumber(n, precision, units);
  }

});

Sugar$5a.Number.metric;

function getOrdinalSuffix$2(num) {
  if (num >= 11 && num <= 13) {
    return 'th';
  } else {
    switch(num % 10) {
      case 1:  return 'st';
      case 2:  return 'nd';
      case 3:  return 'rd';
      default: return 'th';
    }
  }
}

var getOrdinalSuffix_1 = getOrdinalSuffix$2;

var Sugar$59 = sugarCore.exports,
    mathAliases$m = mathAliases$z,
    getOrdinalSuffix$1 = getOrdinalSuffix_1;

var abs$6 = mathAliases$m.abs;

Sugar$59.Number.defineInstance({

  'ordinalize': function(n) {
    var num = abs$6(n), last = +num.toString().slice(-2);
    return n + getOrdinalSuffix$1(last);
  }

});

Sugar$59.Number.ordinalize;

var Sugar$58 = sugarCore.exports,
    padNumber$3 = padNumber_1;

Sugar$58.Number.defineInstance({

  'pad': function(n, place, sign, base) {
    return padNumber$3(n, place, sign, base);
  }

});

Sugar$58.Number.pad;

var Sugar$57 = sugarCore.exports;



Sugar$57.Number.pow;

var Sugar$56 = sugarCore.exports,
    mathAliases$l = mathAliases$z,
    createRoundingFunction = createRoundingFunction_1;

var round$3 = mathAliases$l.round;

Sugar$56.Number.defineInstance({

  'round': createRoundingFunction(round$3)

});

Sugar$56.Number.round;

var Sugar$55 = sugarCore.exports;



Sugar$55.Number.sin;

var Sugar$54 = sugarCore.exports;



Sugar$54.Number.sqrt;

var Sugar$53 = sugarCore.exports;



Sugar$53.Number.tan;

var Sugar$52 = sugarCore.exports,
    isDefined$f = isDefined_1;

Sugar$52.Number.defineInstance({

  'times': function(n, indexMapFn) {
    var arr, result;
    for(var i = 0; i < n; i++) {
      result = indexMapFn.call(n, i);
      if (isDefined$f(result)) {
        if (!arr) {
          arr = [];
        }
        arr.push(result);
      }
    }
    return arr;
  }

});

Sugar$52.Number.times;

var Sugar$51 = sugarCore.exports;

Sugar$51.Number.defineInstance({

  'toNumber': function(n) {
    return n.valueOf();
  }

});

Sugar$51.Number.toNumber;

var Sugar$50 = sugarCore.exports;

Sugar$50.Number.getOption;

var Sugar$4$ = sugarCore.exports;

Sugar$4$.Number.setOption;

var Sugar$4_ = sugarCore.exports,
    coercePositiveInteger$2 = coercePositiveInteger_1;

Sugar$4_.Array.defineStatic({

  'construct': function(n, indexMapFn) {
    n = coercePositiveInteger$2(n);
    return Array.from(new Array(n), function(el, i) {
      return indexMapFn && indexMapFn(i);
    });
  }

});

Sugar$4_.Array.construct;

var forEach$f = forEach_1;

function arrayClone$6(arr) {
  var clone = new Array(arr.length);
  forEach$f(arr, function(el, i) {
    clone[i] = el;
  });
  return clone;
}

var arrayClone_1 = arrayClone$6;

var classChecks$L = classChecks$Z;

var isArray$c = classChecks$L.isArray;

function isArrayOrInherited$1(obj) {
  return obj && obj.constructor && isArray$c(obj.constructor.prototype);
}

var isArrayOrInherited_1 = isArrayOrInherited$1;

var isDefined$e = isDefined_1,
    arrayClone$5 = arrayClone_1,
    classChecks$K = classChecks$Z,
    isObjectType$a = isObjectType_1,
    isArrayOrInherited = isArrayOrInherited_1;

var isString$b = classChecks$K.isString;

function arrayCreate$2(obj, clone) {
  var arr;
  if (isArrayOrInherited(obj)) {
    arr = clone ? arrayClone$5(obj) : obj;
  } else if (isObjectType$a(obj) || isString$b(obj)) {
    arr = Array.from(obj);
  } else if (isDefined$e(obj)) {
    arr = [obj];
  }
  return arr || [];
}

var arrayCreate_1 = arrayCreate$2;

function setChainableConstructor$2(sugarNamespace, createFn) {
  sugarNamespace.prototype.constructor = function() {
    return createFn.apply(this, arguments);
  };
}

var setChainableConstructor_1 = setChainableConstructor$2;

var arrayCreate$1 = arrayCreate_1,
    namespaceAliases$b = namespaceAliases$e,
    setChainableConstructor$1 = setChainableConstructor_1;

var sugarArray$2 = namespaceAliases$b.sugarArray;

function setArrayChainableConstructor$1() {
  setChainableConstructor$1(sugarArray$2, arrayCreate$1);
}

var setArrayChainableConstructor_1 = setArrayChainableConstructor$1;

var setArrayChainableConstructor = setArrayChainableConstructor_1;

setArrayChainableConstructor();

var Sugar$4Z = sugarCore.exports,
    arrayCreate = arrayCreate_1;



Sugar$4Z.Array.defineStatic({

  'create': function(obj, clone) {
    return arrayCreate(obj, clone);
  }

});

Sugar$4Z.Array.create;

var isDefined$d = isDefined_1;

function arrayAppend$2(arr, el, index) {
  var spliceArgs;
  index = +index;
  if (isNaN(index)) {
    index = arr.length;
  }
  spliceArgs = [index, 0];
  if (isDefined$d(el)) {
    spliceArgs = spliceArgs.concat(el);
  }
  arr.splice.apply(arr, spliceArgs);
  return arr;
}

var arrayAppend_1 = arrayAppend$2;

var Sugar$4Y = sugarCore.exports,
    arrayClone$4 = arrayClone_1,
    arrayAppend$1 = arrayAppend_1;

Sugar$4Y.Array.defineInstance({

  'add': function(arr, item, index) {
    return arrayAppend$1(arrayClone$4(arr), item, index);
  }

});

Sugar$4Y.Array.add;

var Sugar$4X = sugarCore.exports,
    arrayAppend = arrayAppend_1;

Sugar$4X.Array.defineInstance({

  'append': function(arr, item, index) {
    return arrayAppend(arr, item, index);
  }

});

Sugar$4X.Array.append;

var Sugar$4W = sugarCore.exports,
    getEntriesForIndexes = getEntriesForIndexes_1;

Sugar$4W.Array.defineInstance({

  'at': function(arr, index, loop) {
    return getEntriesForIndexes(arr, index, loop);
  }

});

Sugar$4W.Array.at;

var Sugar$4V = sugarCore.exports,
    arrayClone$3 = arrayClone_1;

Sugar$4V.Array.defineInstance({

  'clone': function(arr) {
    return arrayClone$3(arr);
  }

});

Sugar$4V.Array.clone;

var filter$1 = filter_1;

function arrayCompact$1(arr, all) {
  return filter$1(arr, function(el) {
    return el || (!all && el != null && el.valueOf() === el.valueOf());
  });
}

var arrayCompact_1 = arrayCompact$1;

var Sugar$4U = sugarCore.exports,
    arrayCompact = arrayCompact_1;

Sugar$4U.Array.defineInstance({

  'compact': function(arr, all) {
    return arrayCompact(arr, all);
  }

});

Sugar$4U.Array.compact;

function dateMatcher$1(d) {
  var ms = d.getTime();
  return function(el) {
    return !!(el && el.getTime) && el.getTime() === ms;
  };
}

var dateMatcher_1 = dateMatcher$1;

function regexMatcher$1(reg) {
  reg = RegExp(reg);
  return function(el) {
    return reg.test(el);
  };
}

var regexMatcher_1 = regexMatcher$1;

function getKeys$6(obj) {
  return Object.keys(obj);
}

var getKeys_1 = getKeys$6;

function setToArray$1(set) {
  var arr = new Array(set.size), i = 0;
  set.forEach(function(val) {
    arr[i++] = val;
  });
  return arr;
}

var setToArray_1 = setToArray$1;

function mapToArray$1(map) {
  var arr = new Array(map.size), i = 0;
  map.forEach(function(val, key) {
    arr[i++] = [key, val];
  });
  return arr;
}

var mapToArray_1 = mapToArray$1;

var getKeys$5 = getKeys_1,
    coreUtilityAliases$A = coreUtilityAliases$M;

var forEachProperty$k = coreUtilityAliases$A.forEachProperty;

function iterateWithCyclicCheck$2(obj, sortedKeys, stack, fn) {

  function next(val, key) {
    var cyc = false;

    // Allowing a step into the structure before triggering this check to save
    // cycles on standard JSON structures and also to try as hard as possible to
    // catch basic properties that may have been modified.
    if (stack.length > 1) {
      var i = stack.length;
      while (i--) {
        if (stack[i] === val) {
          cyc = true;
        }
      }
    }

    stack.push(val);
    fn(key, val, cyc, stack);
    stack.pop();
  }

  function iterateWithSortedKeys() {
    // Sorted keys is required for serialization, where object order
    // does not matter but stringified order does.
    var arr = getKeys$5(obj).sort(), key;
    for (var i = 0; i < arr.length; i++) {
      key = arr[i];
      next(obj[key], arr[i]);
    }
  }

  // This method for checking for cyclic structures was egregiously stolen from
  // the ingenious method by @kitcambridge from the Underscore script:
  // https://github.com/documentcloud/underscore/issues/240
  if (!stack) {
    stack = [];
  }

  if (sortedKeys) {
    iterateWithSortedKeys();
  } else {
    forEachProperty$k(obj, next);
  }
}

var iterateWithCyclicCheck_1 = iterateWithCyclicCheck$2;

var getKeys$4 = getKeys_1,
    setToArray = setToArray_1,
    mapToArray = mapToArray_1,
    classChecks$J = classChecks$Z,
    isObjectType$9 = isObjectType_1,
    coreUtilityAliases$z = coreUtilityAliases$M,
    iterateWithCyclicCheck$1 = iterateWithCyclicCheck_1;

var classToString$4 = coreUtilityAliases$z.classToString,
    isSerializable$1 = classChecks$J.isSerializable,
    isSet$1 = classChecks$J.isSet,
    isMap$1 = classChecks$J.isMap,
    isError$1 = classChecks$J.isError;

function isEqual$4(a, b, stack) {
  var aClass, bClass;
  if (a === b) {
    // Return quickly up front when matched by reference,
    // but be careful about 0 !== -0.
    return a !== 0 || 1 / a === 1 / b;
  }
  aClass = classToString$4(a);
  bClass = classToString$4(b);
  if (aClass !== bClass) {
    return false;
  }

  if (isSerializable$1(a, aClass) && isSerializable$1(b, bClass)) {
    return objectIsEqual(a, b, aClass, stack);
  } else if (isSet$1(a, aClass) && isSet$1(b, bClass)) {
    return a.size === b.size && isEqual$4(setToArray(a), setToArray(b), stack);
  } else if (isMap$1(a, aClass) && isMap$1(b, bClass)) {
    return a.size === b.size && isEqual$4(mapToArray(a), mapToArray(b), stack);
  } else if (isError$1(a, aClass) && isError$1(b, bClass)) {
    return a.toString() === b.toString();
  }

  return false;
}

function objectIsEqual(a, b, aClass, stack) {
  var aType = typeof a, bType = typeof b, propsEqual, count;
  if (aType !== bType) {
    return false;
  }
  if (isObjectType$9(a.valueOf())) {
    if (a.length !== b.length) {
      // perf: Quickly returning up front for arrays.
      return false;
    }
    count = 0;
    propsEqual = true;
    iterateWithCyclicCheck$1(a, false, stack, function(key, val, cyc, stack) {
      if (!cyc && (!(key in b) || !isEqual$4(val, b[key], stack))) {
        propsEqual = false;
      }
      count++;
      return propsEqual;
    });
    if (!propsEqual || count !== getKeys$4(b).length) {
      return false;
    }
  }
  // Stringifying the value handles NaN, wrapped primitives, dates, and errors in one go.
  return a.valueOf().toString() === b.valueOf().toString();
}

var isEqual_1 = isEqual$4;

var isEqual$3 = isEqual_1;

function defaultMatcher$1(f) {
  return function(el) {
    return isEqual$3(el, f);
  };
}

var defaultMatcher_1 = defaultMatcher$1;

function functionMatcher$1(fn) {
  return function(el, i, arr) {
    // Return true up front if match by reference
    return el === fn || fn.call(arr, el, i, arr);
  };
}

var functionMatcher_1 = functionMatcher$1;

var isPrimitive$5 = isPrimitive_1,
    classChecks$I = classChecks$Z,
    dateMatcher = dateMatcher_1,
    regexMatcher = regexMatcher_1,
    isObjectType$8 = isObjectType_1,
    isPlainObject$2 = isPlainObject_1,
    defaultMatcher = defaultMatcher_1,
    functionMatcher = functionMatcher_1,
    coreUtilityAliases$y = coreUtilityAliases$M;

var getOwn$a = coreUtilityAliases$y.getOwn,
    classToString$3 = coreUtilityAliases$y.classToString,
    forEachProperty$j = coreUtilityAliases$y.forEachProperty,
    isDate$9 = classChecks$I.isDate,
    isRegExp$4 = classChecks$I.isRegExp,
    isFunction$b = classChecks$I.isFunction;

function getMatcher$8(f) {
  if (!isPrimitive$5(f)) {
    var className = classToString$3(f);
    if (isRegExp$4(f, className)) {
      return regexMatcher(f);
    } else if (isDate$9(f, className)) {
      return dateMatcher(f);
    } else if (isFunction$b(f, className)) {
      return functionMatcher(f);
    } else if (isPlainObject$2(f, className)) {
      return fuzzyMatcher(f);
    }
  }
  // Default is standard isEqual
  return defaultMatcher(f);
}

function fuzzyMatcher(obj) {
  var matchers = {};
  return function(el, i, arr) {
    var matched = true;
    if (!isObjectType$8(el)) {
      return false;
    }
    forEachProperty$j(obj, function(val, key) {
      matchers[key] = getOwn$a(matchers, key) || getMatcher$8(val);
      if (matchers[key].call(arr, el[key], i, arr) === false) {
        matched = false;
      }
      return matched;
    });
    return matched;
  };
}

var getMatcher_1 = getMatcher$8;

var getMatcher$7 = getMatcher_1;

function arrayExclude$1(arr, f) {
  var result = [], matcher = getMatcher$7(f);
  for (var i = 0; i < arr.length; i++) {
    if (!matcher(arr[i], i, arr)) {
      result.push(arr[i]);
    }
  }
  return result;
}

var arrayExclude_1 = arrayExclude$1;

var Sugar$4T = sugarCore.exports,
    arrayExclude = arrayExclude_1;

Sugar$4T.Array.defineInstance({

  'exclude': function(arr, f) {
    return arrayExclude(arr, f);
  }

});

Sugar$4T.Array.exclude;

var Sugar$4S = sugarCore.exports,
    isUndefined$e = isUndefined_1;

Sugar$4S.Array.defineInstance({

  'first': function(arr, num) {
    if (isUndefined$e(num)) return arr[0];
    if (num < 0) num = 0;
    return arr.slice(0, num);
  }

});

Sugar$4S.Array.first;

var forEach$e = forEach_1,
    classChecks$H = classChecks$Z;

var isArray$b = classChecks$H.isArray;

function arrayFlatten$1(arr, level, current) {
  var result = [];
  level = level || Infinity;
  current = current || 0;
  forEach$e(arr, function(el) {
    if (isArray$b(el) && current < level) {
      result = result.concat(arrayFlatten$1(el, level, current + 1));
    } else {
      result.push(el);
    }
  });
  return result;
}

var arrayFlatten_1 = arrayFlatten$1;

var Sugar$4R = sugarCore.exports,
    arrayFlatten = arrayFlatten_1;

Sugar$4R.Array.defineInstance({

  'flatten': function(arr, limit) {
    return arrayFlatten(arr, limit);
  }

});

Sugar$4R.Array.flatten;

var Sugar$4Q = sugarCore.exports;

Sugar$4Q.Array.defineInstance({

  'from': function(arr, num) {
    return arr.slice(num);
  }

});

Sugar$4Q.Array.from;

var map$4 = map_1,
    classChecks$G = classChecks$Z,
    deepGetProperty$2 = deepGetProperty_1;

var isFunction$a = classChecks$G.isFunction,
    isArray$a = classChecks$G.isArray;

function mapWithShortcuts$6(el, f, context, mapArgs) {
  if (!f) {
    return el;
  } else if (f.apply) {
    return f.apply(context, mapArgs);
  } else if (isArray$a(f)) {
    return map$4(f, function(m) {
      return mapWithShortcuts$6(el, m, context, mapArgs);
    });
  } else if (isFunction$a(el[f])) {
    return el[f].call(el);
  } else {
    return deepGetProperty$2(el, f, true);
  }
}

var mapWithShortcuts_1 = mapWithShortcuts$6;

var forEach$d = forEach_1,
    mapWithShortcuts$5 = mapWithShortcuts_1,
    coreUtilityAliases$x = coreUtilityAliases$M;

var hasOwn$8 = coreUtilityAliases$x.hasOwn,
    forEachProperty$i = coreUtilityAliases$x.forEachProperty;

function arrayGroupBy$1(arr, map, fn) {
  var result = {}, key;
  forEach$d(arr, function(el, i) {
    key = mapWithShortcuts$5(el, map, arr, [el, i, arr]);
    if (!hasOwn$8(result, key)) {
      result[key] = [];
    }
    result[key].push(el);
  });
  if (fn) {
    forEachProperty$i(result, fn);
  }
  return result;
}

var arrayGroupBy_1 = arrayGroupBy$1;

var Sugar$4P = sugarCore.exports,
    arrayGroupBy = arrayGroupBy_1;

Sugar$4P.Array.defineInstance({

  'groupBy': function(arr, map, groupFn) {
    return arrayGroupBy(arr, map, groupFn);
  }

});

Sugar$4P.Array.groupBy;

function simpleRepeat$2(n, fn) {
  for (var i = 0; i < n; i++) {
    fn(i);
  }
}

var simpleRepeat_1 = simpleRepeat$2;

var Sugar$4O = sugarCore.exports,
    isDefined$c = isDefined_1,
    mathAliases$k = mathAliases$z,
    simpleRepeat$1 = simpleRepeat_1;

var ceil$4 = mathAliases$k.ceil;

Sugar$4O.Array.defineInstance({

  'inGroups': function(arr, num, padding) {
    var pad = isDefined$c(padding);
    var result = new Array(num);
    var divisor = ceil$4(arr.length / num);
    simpleRepeat$1(num, function(i) {
      var index = i * divisor;
      var group = arr.slice(index, index + divisor);
      if (pad && group.length < divisor) {
        simpleRepeat$1(divisor - group.length, function() {
          group.push(padding);
        });
      }
      result[i] = group;
    });
    return result;
  }

});

Sugar$4O.Array.inGroups;

var Sugar$4N = sugarCore.exports,
    isUndefined$d = isUndefined_1,
    mathAliases$j = mathAliases$z,
    simpleRepeat = simpleRepeat_1;

var ceil$3 = mathAliases$j.ceil;

Sugar$4N.Array.defineInstance({

  'inGroupsOf': function(arr, num, padding) {
    var result = [], len = arr.length, group;
    if (len === 0 || num === 0) return arr;
    if (isUndefined$d(num)) num = 1;
    if (isUndefined$d(padding)) padding = null;
    simpleRepeat(ceil$3(len / num), function(i) {
      group = arr.slice(num * i, num * i + num);
      while(group.length < num) {
        group.push(padding);
      }
      result.push(group);
    });
    return result;
  }

});

Sugar$4N.Array.inGroupsOf;

function arrayWrap$1(obj) {
  var arr = [];
  arr.push(obj);
  return arr;
}

var arrayWrap_1 = arrayWrap$1;

function isRealNaN$1(obj) {
  // This is only true of NaN
  return obj != null && obj !== obj;
}

var isRealNaN_1 = isRealNaN$1;

var indexOf = indexOf_1,
    isRealNaN = isRealNaN_1,
    isPrimitive$4 = isPrimitive_1,
    classChecks$F = classChecks$Z,
    isObjectType$7 = isObjectType_1,
    coreUtilityAliases$w = coreUtilityAliases$M,
    iterateWithCyclicCheck = iterateWithCyclicCheck_1;

var classToString$2 = coreUtilityAliases$w.classToString,
    isSerializable = classChecks$F.isSerializable;

function serializeInternal$4(obj, refs, stack) {
  var type = typeof obj, sign = '', className, value, ref;

  // Return up front on
  if (1 / obj === -Infinity) {
    sign = '-';
  }

  // Return quickly for primitives to save cycles
  if (isPrimitive$4(obj, type) && !isRealNaN(obj)) {
    return type + sign + obj;
  }

  className = classToString$2(obj);

  if (!isSerializable(obj, className)) {
    ref = indexOf(refs, obj);
    if (ref === -1) {
      ref = refs.length;
      refs.push(obj);
    }
    return ref;
  } else if (isObjectType$7(obj)) {
    value = serializeDeep(obj, refs, stack) + obj.toString();
  } else if (obj.valueOf) {
    value = obj.valueOf();
  }
  return type + className + sign + value;
}

function serializeDeep(obj, refs, stack) {
  var result = '';
  iterateWithCyclicCheck(obj, true, stack, function(key, val, cyc, stack) {
    result += cyc ? 'CYC' : key + serializeInternal$4(val, refs, stack);
  });
  return result;
}

var serializeInternal_1 = serializeInternal$4;

var forEach$c = forEach_1,
    arrayWrap = arrayWrap_1,
    classChecks$E = classChecks$Z,
    serializeInternal$3 = serializeInternal_1,
    coreUtilityAliases$v = coreUtilityAliases$M;

var isArray$9 = classChecks$E.isArray,
    hasOwn$7 = coreUtilityAliases$v.hasOwn;

function arrayIntersectOrSubtract$2(arr1, arr2, subtract) {
  var result = [], obj = {}, refs = [];
  if (!isArray$9(arr2)) {
    arr2 = arrayWrap(arr2);
  }
  forEach$c(arr2, function(el) {
    obj[serializeInternal$3(el, refs)] = true;
  });
  forEach$c(arr1, function(el) {
    var key = serializeInternal$3(el, refs);
    if (hasOwn$7(obj, key) !== subtract) {
      delete obj[key];
      result.push(el);
    }
  });
  return result;
}

var arrayIntersectOrSubtract_1 = arrayIntersectOrSubtract$2;

var Sugar$4M = sugarCore.exports,
    arrayIntersectOrSubtract$1 = arrayIntersectOrSubtract_1;

Sugar$4M.Array.defineInstance({

  'intersect': function(arr1, arr2) {
    return arrayIntersectOrSubtract$1(arr1, arr2, false);
  }

});

Sugar$4M.Array.intersect;

var Sugar$4L = sugarCore.exports;

Sugar$4L.Array.defineInstance({

  'isEmpty': function(arr) {
    return arr.length === 0;
  }

});

Sugar$4L.Array.isEmpty;

var Sugar$4K = sugarCore.exports,
    isEqual$2 = isEqual_1;

Sugar$4K.Array.defineInstance({

  'isEqual': function(a, b) {
    return isEqual$2(a, b);
  }

});

Sugar$4K.Array.isEqual;

var Sugar$4J = sugarCore.exports,
    isUndefined$c = isUndefined_1;

Sugar$4J.Array.defineInstance({

  'last': function(arr, num) {
    if (isUndefined$c(num)) return arr[arr.length - 1];
    var start = arr.length - num < 0 ? 0 : arr.length - num;
    return arr.slice(start);
  }

});

Sugar$4J.Array.last;

var getMatcher$6 = getMatcher_1;

function arrayRemove$1(arr, f) {
  var matcher = getMatcher$6(f), i = 0;
  while(i < arr.length) {
    if (matcher(arr[i], i, arr)) {
      arr.splice(i, 1);
    } else {
      i++;
    }
  }
  return arr;
}

var arrayRemove_1 = arrayRemove$1;

var Sugar$4I = sugarCore.exports,
    arrayRemove = arrayRemove_1;

Sugar$4I.Array.defineInstance({

  'remove': function(arr, f) {
    return arrayRemove(arr, f);
  }

});

Sugar$4I.Array.remove;

var Sugar$4H = sugarCore.exports,
    isUndefined$b = isUndefined_1;

Sugar$4H.Array.defineInstance({

  'removeAt': function(arr, start, end) {
    if (isUndefined$b(start)) return arr;
    if (isUndefined$b(end))   end = start;
    arr.splice(start, end - start + 1);
    return arr;
  }

});

Sugar$4H.Array.removeAt;

var Sugar$4G = sugarCore.exports,
    trunc$9 = trunc_1,
    arrayClone$2 = arrayClone_1,
    classChecks$D = classChecks$Z,
    isUndefined$a = isUndefined_1,
    mathAliases$i = mathAliases$z;

var isBoolean$4 = classChecks$D.isBoolean,
    min$4 = mathAliases$i.min;

Sugar$4G.Array.defineInstance({

  'sample': function(arr, arg1, arg2) {
    var result = [], num, remove, single;
    if (isBoolean$4(arg1)) {
      remove = arg1;
    } else {
      num = arg1;
      remove = arg2;
    }
    if (isUndefined$a(num)) {
      num = 1;
      single = true;
    }
    if (!remove) {
      arr = arrayClone$2(arr);
    }
    num = min$4(num, arr.length);
    for (var i = 0, index; i < num; i++) {
      index = trunc$9(Math.random() * arr.length);
      result.push(arr[index]);
      arr.splice(index, 1);
    }
    return single ? result[0] : result;
  }

});

Sugar$4G.Array.sample;

var arrayClone$1 = arrayClone_1;

function arrayShuffle$1(arr) {
  arr = arrayClone$1(arr);
  var i = arr.length, j, x;
  while(i) {
    j = (Math.random() * i) | 0;
    x = arr[--i];
    arr[i] = arr[j];
    arr[j] = x;
  }
  return arr;
}

var arrayShuffle_1 = arrayShuffle$1;

var Sugar$4F = sugarCore.exports,
    arrayShuffle = arrayShuffle_1;

Sugar$4F.Array.defineInstance({

  'shuffle': function(arr) {
    return arrayShuffle(arr);
  }

});

Sugar$4F.Array.shuffle;

var map$3 = map_1;

function getSortOrder$1() {
  var order = 'AÁÀÂÃĄBCĆČÇDĎÐEÉÈĚÊËĘFGĞHıIÍÌİÎÏJKLŁMNŃŇÑOÓÒÔPQRŘSŚŠŞTŤUÚÙŮÛÜVWXYÝZŹŻŽÞÆŒØÕÅÄÖ';
  return map$3(order.split(''), function(str) {
    return str + str.toLowerCase();
  }).join('');
}

var getSortOrder_1 = getSortOrder$1;

var HALF_WIDTH_NINE$1 = 0x39;

var FULL_WIDTH_NINE$1 = 0xff19;

var HALF_WIDTH_NINE = HALF_WIDTH_NINE$1,
    FULL_WIDTH_NINE = FULL_WIDTH_NINE$1,
    CommonChars = CommonChars$8;

var HALF_WIDTH_ZERO = CommonChars.HALF_WIDTH_ZERO,
    FULL_WIDTH_ZERO = CommonChars.FULL_WIDTH_ZERO;

function codeIsNumeral$1(code) {
  return (code >= HALF_WIDTH_ZERO && code <= HALF_WIDTH_NINE) ||
         (code >= FULL_WIDTH_ZERO && code <= FULL_WIDTH_NINE);
}

var codeIsNumeral_1 = codeIsNumeral$1;

function getSortOrderIndex$1(chr, sortOrder) {
  if (!chr) {
    return null;
  } else {
    return sortOrder.indexOf(chr);
  }
}

var getSortOrderIndex_1 = getSortOrderIndex$1;

var forEach$b = forEach_1,
    spaceSplit$3 = spaceSplit_1;

function getSortEquivalents$1() {
  var equivalents = {};
  forEach$b(spaceSplit$3('AÁÀÂÃÄ CÇ EÉÈÊË IÍÌİÎÏ OÓÒÔÕÖ Sß UÚÙÛÜ'), function(set) {
    var first = set.charAt(0);
    forEach$b(set.slice(1).split(''), function(chr) {
      equivalents[chr] = first;
      equivalents[chr.toLowerCase()] = first.toLowerCase();
    });
  });
  return equivalents;
}

var getSortEquivalents_1 = getSortEquivalents$1;

var coreUtilityAliases$u = coreUtilityAliases$M;

var getOwn$9 = coreUtilityAliases$u.getOwn;

function getCollationCharacter$1(str, index, sortEquivalents) {
  var chr = str.charAt(index);
  return getOwn$9(sortEquivalents, chr) || chr;
}

var getCollationCharacter_1 = getCollationCharacter$1;

function getCollationReadyString$1(str, sortIgnore, sortIgnoreCase) {
  if (sortIgnoreCase) {
    str = str.toLowerCase();
  }
  if (sortIgnore) {
    str = str.replace(sortIgnore, '');
  }
  return str;
}

var getCollationReadyString_1 = getCollationReadyString$1;

var getSortOrder = getSortOrder_1,
    codeIsNumeral = codeIsNumeral_1,
    stringToNumber = stringToNumber_1,
    namespaceAliases$a = namespaceAliases$e,
    getSortOrderIndex = getSortOrderIndex_1,
    getSortEquivalents = getSortEquivalents_1,
    defineOptionsAccessor$1 = defineOptionsAccessor_1,
    getCollationCharacter = getCollationCharacter_1,
    getCollationReadyString = getCollationReadyString_1;

var sugarArray$1 = namespaceAliases$a.sugarArray;

var ARRAY_OPTIONS$1 = {
  'sortIgnore':      null,
  'sortNatural':     true,
  'sortIgnoreCase':  true,
  'sortOrder':       getSortOrder(),
  'sortCollate':     collateStrings,
  'sortEquivalents': getSortEquivalents()
};

var _arrayOptions$1 = defineOptionsAccessor$1(sugarArray$1, ARRAY_OPTIONS$1);

function collateStrings(a, b) {
  var aValue, bValue, aChar, bChar, aEquiv, bEquiv, index = 0, tiebreaker = 0;

  var sortOrder       = _arrayOptions$1('sortOrder');
  var sortIgnore      = _arrayOptions$1('sortIgnore');
  var sortNatural     = _arrayOptions$1('sortNatural');
  var sortIgnoreCase  = _arrayOptions$1('sortIgnoreCase');
  var sortEquivalents = _arrayOptions$1('sortEquivalents');

  a = getCollationReadyString(a, sortIgnore, sortIgnoreCase);
  b = getCollationReadyString(b, sortIgnore, sortIgnoreCase);

  do {

    aChar  = getCollationCharacter(a, index, sortEquivalents);
    bChar  = getCollationCharacter(b, index, sortEquivalents);
    aValue = getSortOrderIndex(aChar, sortOrder);
    bValue = getSortOrderIndex(bChar, sortOrder);

    if (aValue === -1 || bValue === -1) {
      aValue = a.charCodeAt(index) || null;
      bValue = b.charCodeAt(index) || null;
      if (sortNatural && codeIsNumeral(aValue) && codeIsNumeral(bValue)) {
        aValue = stringToNumber(a.slice(index));
        bValue = stringToNumber(b.slice(index));
      }
    } else {
      aEquiv = aChar !== a.charAt(index);
      bEquiv = bChar !== b.charAt(index);
      if (aEquiv !== bEquiv && tiebreaker === 0) {
        tiebreaker = aEquiv - bEquiv;
      }
    }
    index += 1;
  } while(aValue != null && bValue != null && aValue === bValue);
  if (aValue === bValue) return tiebreaker;
  return aValue - bValue;
}

var ARRAY_OPTIONS_1 = {
  ARRAY_OPTIONS: ARRAY_OPTIONS$1,
  _arrayOptions: _arrayOptions$1
};

var ARRAY_OPTIONS = ARRAY_OPTIONS_1,
    classChecks$C = classChecks$Z;

var isString$a = classChecks$C.isString,
    isArray$8 = classChecks$C.isArray,
    _arrayOptions = ARRAY_OPTIONS._arrayOptions;

function compareValue$1(aVal, bVal) {
  var cmp, i, collate;
  if (isString$a(aVal) && isString$a(bVal)) {
    collate = _arrayOptions('sortCollate');
    return collate(aVal, bVal);
  } else if (isArray$8(aVal) && isArray$8(bVal)) {
    if (aVal.length < bVal.length) {
      return -1;
    } else if (aVal.length > bVal.length) {
      return 1;
    } else {
      for(i = 0; i < aVal.length; i++) {
        cmp = compareValue$1(aVal[i], bVal[i]);
        if (cmp !== 0) {
          return cmp;
        }
      }
      return 0;
    }
  }
  return aVal < bVal ? -1 : aVal > bVal ? 1 : 0;
}

var compareValue_1 = compareValue$1;

var Sugar$4E = sugarCore.exports,
    compareValue = compareValue_1,
    mapWithShortcuts$4 = mapWithShortcuts_1;

Sugar$4E.Array.defineInstance({

  'sortBy': function(arr, map, desc) {
    arr.sort(function(a, b) {
      var aProperty = mapWithShortcuts$4(a, map, arr, [a]);
      var bProperty = mapWithShortcuts$4(b, map, arr, [b]);
      return compareValue(aProperty, bProperty) * (desc ? -1 : 1);
    });
    return arr;
  }

});

Sugar$4E.Array.sortBy;

var Sugar$4D = sugarCore.exports,
    arrayIntersectOrSubtract = arrayIntersectOrSubtract_1;

Sugar$4D.Array.defineInstance({

  'subtract': function(arr, item) {
    return arrayIntersectOrSubtract(arr, item, true);
  }

});

Sugar$4D.Array.subtract;

var Sugar$4C = sugarCore.exports,
    isUndefined$9 = isUndefined_1;

Sugar$4C.Array.defineInstance({

  'to': function(arr, num) {
    if (isUndefined$9(num)) num = arr.length;
    return arr.slice(0, num);
  }

});

Sugar$4C.Array.to;

var forEach$a = forEach_1,
    mapWithShortcuts$3 = mapWithShortcuts_1,
    serializeInternal$2 = serializeInternal_1,
    coreUtilityAliases$t = coreUtilityAliases$M;

var hasOwn$6 = coreUtilityAliases$t.hasOwn;

function arrayUnique$2(arr, map) {
  var result = [], obj = {}, refs = [];
  forEach$a(arr, function(el, i) {
    var transformed = map ? mapWithShortcuts$3(el, map, arr, [el, i, arr]) : el;
    var key = serializeInternal$2(transformed, refs);
    if (!hasOwn$6(obj, key)) {
      result.push(el);
      obj[key] = true;
    }
  });
  return result;
}

var arrayUnique_1 = arrayUnique$2;

var HAS_CONCAT_BUG$1 = !('0' in [].concat(undefined).concat());

var forEach$9 = forEach_1,
    arrayClone = arrayClone_1,
    classChecks$B = classChecks$Z;

var isArray$7 = classChecks$B.isArray;

function arraySafeConcat$1(arr, arg) {
  var result = arrayClone(arr), len = result.length, arr2;
  arr2 = isArray$7(arg) ? arg : [arg];
  result.length += arr2.length;
  forEach$9(arr2, function(el, i) {
    result[len + i] = el;
  });
  return result;
}

var arraySafeConcat_1 = arraySafeConcat$1;

var HAS_CONCAT_BUG = HAS_CONCAT_BUG$1,
    arraySafeConcat = arraySafeConcat_1;

function arrayConcat$1(arr1, arr2) {
  // istanbul ignore if
  if (HAS_CONCAT_BUG) {
    return arraySafeConcat(arr1, arr2);
  }
  return arr1.concat(arr2);
}

var arrayConcat_1 = arrayConcat$1;

var Sugar$4B = sugarCore.exports,
    arrayUnique$1 = arrayUnique_1,
    arrayConcat = arrayConcat_1;

Sugar$4B.Array.defineInstance({

  'union': function(arr1, arr2) {
    return arrayUnique$1(arrayConcat(arr1, arr2));
  }

});

Sugar$4B.Array.union;

var Sugar$4A = sugarCore.exports,
    arrayUnique = arrayUnique_1;

Sugar$4A.Array.defineInstance({

  'unique': function(arr, map) {
    return arrayUnique(arr, map);
  }

});

Sugar$4A.Array.unique;

var Sugar$4z = sugarCore.exports,
    map$2 = map_1;

Sugar$4z.Array.defineInstanceWithArguments({

  'zip': function(arr, args) {
    return map$2(arr, function(el, i) {
      return [el].concat(map$2(args, function(k) {
        return (i in k) ? k[i] : null;
      }));
    });
  }

});

Sugar$4z.Array.zip;

var Sugar$4y = sugarCore.exports;

Sugar$4y.Array.alias('insert', 'append');

Sugar$4y.Array.insert;

var Sugar$4x = sugarCore.exports;

Sugar$4x.Array.getOption;

var Sugar$4w = sugarCore.exports;

Sugar$4w.Array.setOption;

var classChecks$A = classChecks$Z,
    isArrayIndex = isArrayIndex_1,
    mapWithShortcuts$2 = mapWithShortcuts_1,
    coreUtilityAliases$s = coreUtilityAliases$M;

var isArray$6 = classChecks$A.isArray,
    forEachProperty$h = coreUtilityAliases$s.forEachProperty;

function enumerateWithMapping$5(obj, map, fn) {
  var arrayIndexes = isArray$6(obj);
  forEachProperty$h(obj, function(val, key) {
    if (arrayIndexes) {
      if (!isArrayIndex(key)) {
        return;
      }
      key = +key;
    }
    var mapped = mapWithShortcuts$2(val, map, obj, [val, key, obj]);
    fn(mapped, key);
  });
}

var enumerateWithMapping_1 = enumerateWithMapping$5;

var enumerateWithMapping$4 = enumerateWithMapping_1;

function average$2(obj, map) {
  var sum = 0, count = 0;
  enumerateWithMapping$4(obj, map, function(val) {
    sum += val;
    count++;
  });
  // Prevent divide by 0
  return sum / (count || 1);
}

var average_1 = average$2;

var Sugar$4v = sugarCore.exports,
    average$1 = average_1;

Sugar$4v.Object.defineInstanceAndStatic({

  'average': function(obj, map) {
    return average$1(obj, map);
  }

});

Sugar$4v.Object.average;

var getMatcher$5 = getMatcher_1,
    coreUtilityAliases$r = coreUtilityAliases$M;

var forEachProperty$g = coreUtilityAliases$r.forEachProperty;

function objectCount$1(obj, f) {
  var matcher = getMatcher$5(f), count = 0;
  forEachProperty$g(obj, function(val, key) {
    if (matcher(val, key, obj)) {
      count++;
    }
  });
  return count;
}

var objectCount_1 = objectCount$1;

var Sugar$4u = sugarCore.exports,
    objectCount = objectCount_1;

Sugar$4u.Object.defineInstanceAndStatic({

  'count': function(obj, f) {
    return objectCount(obj, f);
  }

});

Sugar$4u.Object.count;

var getKeys$3 = getKeys_1,
    getMatcher$4 = getMatcher_1;

function wrapObjectMatcher$1(name) {
  var nativeFn = Array.prototype[name];
  return function(obj, f) {
    var matcher = getMatcher$4(f);
    return nativeFn.call(getKeys$3(obj), function(key) {
      return matcher(obj[key], key, obj);
    });
  };
}

var wrapObjectMatcher_1 = wrapObjectMatcher$1;

var wrapObjectMatcher = wrapObjectMatcher_1;

var objectMatchers$4 = {
  objectSome: wrapObjectMatcher('some'),
  objectFind: wrapObjectMatcher('find'),
  objectEvery: wrapObjectMatcher('every')
};

var Sugar$4t = sugarCore.exports,
    objectMatchers$3 = objectMatchers$4;

var objectEvery = objectMatchers$3.objectEvery;

Sugar$4t.Object.defineInstanceAndStatic({

  'every': objectEvery

});

Sugar$4t.Object.every;

var getMatcher$3 = getMatcher_1,
    coreUtilityAliases$q = coreUtilityAliases$M;

var forEachProperty$f = coreUtilityAliases$q.forEachProperty;

function objectFilter$1(obj, f) {
  var matcher = getMatcher$3(f), result = {};
  forEachProperty$f(obj, function(val, key) {
    if (matcher(val, key, obj)) {
      result[key] = val;
    }
  });
  return result;
}

var objectFilter_1 = objectFilter$1;

var Sugar$4s = sugarCore.exports,
    objectFilter = objectFilter_1;

Sugar$4s.Object.defineInstanceAndStatic({

  'filter': function(obj, f) {
    return objectFilter(obj, f);
  }

});

Sugar$4s.Object.filter;

var Sugar$4r = sugarCore.exports,
    objectMatchers$2 = objectMatchers$4;

var objectFind = objectMatchers$2.objectFind;

Sugar$4r.Object.defineInstanceAndStatic({

  'find': objectFind

});

Sugar$4r.Object.find;

var classChecks$z = classChecks$Z;

var isFunction$9 = classChecks$z.isFunction;

function assertCallable$1(obj) {
  if (!isFunction$9(obj)) {
    throw new TypeError('Function is not callable');
  }
}

var assertCallable_1 = assertCallable$1;

var assertCallable = assertCallable_1,
    coreUtilityAliases$p = coreUtilityAliases$M;

var forEachProperty$e = coreUtilityAliases$p.forEachProperty;

function objectForEach$1(obj, fn) {
  assertCallable(fn);
  forEachProperty$e(obj, function(val, key) {
    fn(val, key, obj);
  });
  return obj;
}

var objectForEach_1 = objectForEach$1;

var Sugar$4q = sugarCore.exports,
    objectForEach = objectForEach_1;

Sugar$4q.Object.defineInstanceAndStatic({

  'forEach': function(obj, eachFn) {
    return objectForEach(obj, eachFn);
  }

});

Sugar$4q.Object.forEach;

function getReducedMinMaxResult$2(result, obj, all, asObject) {
  if (asObject && all) {
    // The method has returned an array of keys so use this array
    // to build up the resulting object in the form we want it in.
    return result.reduce(function(o, key) {
      o[key] = obj[key];
      return o;
    }, {});
  } else if (result && !all) {
    result = result[0];
  }
  return result;
}

var getReducedMinMaxResult_1 = getReducedMinMaxResult$2;

var classChecks$y = classChecks$Z,
    isUndefined$8 = isUndefined_1,
    enumerateWithMapping$3 = enumerateWithMapping_1,
    getReducedMinMaxResult$1 = getReducedMinMaxResult_1;

var isBoolean$3 = classChecks$y.isBoolean;

function getMinOrMax$5(obj, arg1, arg2, max, asObject) {
  var result = [], pushVal, edge, all, map;
  if (isBoolean$3(arg1)) {
    all = arg1;
    map = arg2;
  } else {
    map = arg1;
  }
  enumerateWithMapping$3(obj, map, function(val, key) {
    if (isUndefined$8(val)) {
      throw new TypeError('Cannot compare with undefined');
    }
    pushVal = asObject ? key : obj[key];
    if (val === edge) {
      result.push(pushVal);
    } else if (isUndefined$8(edge) || (max && val > edge) || (!max && val < edge)) {
      result = [pushVal];
      edge = val;
    }
  });
  return getReducedMinMaxResult$1(result, obj, all, asObject);
}

var getMinOrMax_1 = getMinOrMax$5;

var classChecks$x = classChecks$Z,
    getMinOrMax$4 = getMinOrMax_1,
    serializeInternal$1 = serializeInternal_1,
    coreUtilityAliases$o = coreUtilityAliases$M,
    enumerateWithMapping$2 = enumerateWithMapping_1,
    getReducedMinMaxResult = getReducedMinMaxResult_1;

var isBoolean$2 = classChecks$x.isBoolean,
    getOwn$8 = coreUtilityAliases$o.getOwn,
    forEachProperty$d = coreUtilityAliases$o.forEachProperty;

function getLeastOrMost$4(obj, arg1, arg2, most, asObject) {
  var group = {}, refs = [], minMaxResult, result, all, map;
  if (isBoolean$2(arg1)) {
    all = arg1;
    map = arg2;
  } else {
    map = arg1;
  }
  enumerateWithMapping$2(obj, map, function(val, key) {
    var groupKey = serializeInternal$1(val, refs);
    var arr = getOwn$8(group, groupKey) || [];
    arr.push(asObject ? key : obj[key]);
    group[groupKey] = arr;
  });
  minMaxResult = getMinOrMax$4(group, !!all, 'length', most, true);
  if (all) {
    result = [];
    // Flatten result
    forEachProperty$d(minMaxResult, function(val) {
      result = result.concat(val);
    });
  } else {
    result = getOwn$8(group, minMaxResult);
  }
  return getReducedMinMaxResult(result, obj, all, asObject);
}

var getLeastOrMost_1 = getLeastOrMost$4;

var Sugar$4p = sugarCore.exports,
    getLeastOrMost$3 = getLeastOrMost_1;

Sugar$4p.Object.defineInstanceAndStatic({

  'least': function(obj, all, map) {
    return getLeastOrMost$3(obj, all, map, false, true);
  }

});

Sugar$4p.Object.least;

var mapWithShortcuts$1 = mapWithShortcuts_1,
    coreUtilityAliases$n = coreUtilityAliases$M;

var forEachProperty$c = coreUtilityAliases$n.forEachProperty;

function objectMap$1(obj, map) {
  var result = {};
  forEachProperty$c(obj, function(val, key) {
    result[key] = mapWithShortcuts$1(val, map, obj, [val, key, obj]);
  });
  return result;
}

var objectMap_1 = objectMap$1;

var Sugar$4o = sugarCore.exports,
    objectMap = objectMap_1;

Sugar$4o.Object.defineInstanceAndStatic({

  'map': function(obj, map) {
    return objectMap(obj, map);
  }

});

Sugar$4o.Object.map;

var Sugar$4n = sugarCore.exports,
    getMinOrMax$3 = getMinOrMax_1;

Sugar$4n.Object.defineInstanceAndStatic({

  'max': function(obj, all, map) {
    return getMinOrMax$3(obj, all, map, true, true);
  }

});

Sugar$4n.Object.max;

var trunc$8 = trunc_1,
    enumerateWithMapping$1 = enumerateWithMapping_1;

function median$2(obj, map) {
  var result = [], middle, len;
  enumerateWithMapping$1(obj, map, function(val) {
    result.push(val);
  });
  len = result.length;
  if (!len) return 0;
  result.sort(function(a, b) {
    // IE7 will throw errors on non-numbers!
    return (a || 0) - (b || 0);
  });
  middle = trunc$8(len / 2);
  return len % 2 ? result[middle] : (result[middle - 1] + result[middle]) / 2;
}

var median_1 = median$2;

var Sugar$4m = sugarCore.exports,
    median$1 = median_1;

Sugar$4m.Object.defineInstanceAndStatic({

  'median': function(obj, map) {
    return median$1(obj, map);
  }

});

Sugar$4m.Object.median;

var Sugar$4l = sugarCore.exports,
    getMinOrMax$2 = getMinOrMax_1;

Sugar$4l.Object.defineInstanceAndStatic({

  'min': function(obj, all, map) {
    return getMinOrMax$2(obj, all, map, false, true);
  }

});

Sugar$4l.Object.min;

var Sugar$4k = sugarCore.exports,
    getLeastOrMost$2 = getLeastOrMost_1;

Sugar$4k.Object.defineInstanceAndStatic({

  'most': function(obj, all, map) {
    return getLeastOrMost$2(obj, all, map, true, true);
  }

});

Sugar$4k.Object.most;

var objectMatchers$1 = objectMatchers$4;

var objectSome$1 = objectMatchers$1.objectSome;

function objectNone$1(obj, f) {
  return !objectSome$1(obj, f);
}

var objectNone_1 = objectNone$1;

var Sugar$4j = sugarCore.exports,
    objectNone = objectNone_1;

Sugar$4j.Object.defineInstanceAndStatic({

  'none': function(obj, f) {
    return objectNone(obj, f);
  }

});

Sugar$4j.Object.none;

var isDefined$b = isDefined_1,
    coreUtilityAliases$m = coreUtilityAliases$M;

var forEachProperty$b = coreUtilityAliases$m.forEachProperty;

function objectReduce$1(obj, fn, acc) {
  var init = isDefined$b(acc);
  forEachProperty$b(obj, function(val, key) {
    if (!init) {
      acc = val;
      init = true;
      return;
    }
    acc = fn(acc, val, key, obj);
  });
  return acc;
}

var objectReduce_1 = objectReduce$1;

var Sugar$4i = sugarCore.exports,
    objectReduce = objectReduce_1;

Sugar$4i.Object.defineInstanceAndStatic({

  'reduce': function(obj, fn, init) {
    return objectReduce(obj, fn, init);
  }

});

Sugar$4i.Object.reduce;

var Sugar$4h = sugarCore.exports,
    objectMatchers = objectMatchers$4;

var objectSome = objectMatchers.objectSome;

Sugar$4h.Object.defineInstanceAndStatic({

  'some': objectSome

});

Sugar$4h.Object.some;

var enumerateWithMapping = enumerateWithMapping_1;

function sum$2(obj, map) {
  var sum = 0;
  enumerateWithMapping(obj, map, function(val) {
    sum += val;
  });
  return sum;
}

var sum_1 = sum$2;

var Sugar$4g = sugarCore.exports,
    sum$1 = sum_1;

Sugar$4g.Object.defineInstanceAndStatic({

  'sum': function(obj, map) {
    return sum$1(obj, map);
  }

});

Sugar$4g.Object.sum;

var Sugar$4f = sugarCore.exports,
    average = average_1;

Sugar$4f.Array.defineInstance({

  'average': function(arr, map) {
    return average(arr, map);
  }

});

Sugar$4f.Array.average;

var getMatcher$2 = getMatcher_1,
    classChecks$w = classChecks$Z;

var isFunction$8 = classChecks$w.isFunction;

function enhancedMatching$2(f) {
  var matcher;
  if (isFunction$8(f)) {
    return f;
  }
  matcher = getMatcher$2(f);
  return function(el, i, arr) {
    return matcher(el, i, arr);
  };
}

var enhancedMatching_1 = enhancedMatching$2;

function assertArgument$2(exists) {
  if (!exists) {
    throw new TypeError('Argument required');
  }
}

var assertArgument_1 = assertArgument$2;

var assertArgument$1 = assertArgument_1;

function wrapNativeArrayMethod$2(methodName, wrapper) {
  var nativeFn = Array.prototype[methodName];
  return function(arr, f, context, argsLen) {
    var args = new Array(2);
    assertArgument$1(argsLen > 0);
    args[0] = wrapper(f, context);
    args[1] = context;
    return nativeFn.apply(arr, args);
  };
}

var wrapNativeArrayMethod_1 = wrapNativeArrayMethod$2;

var enhancedMatching$1 = enhancedMatching_1,
    wrapNativeArrayMethod$1 = wrapNativeArrayMethod_1;

function buildEnhancedMatching$1(name) {
  return wrapNativeArrayMethod$1(name, enhancedMatching$1);
}

var buildEnhancedMatching_1 = buildEnhancedMatching$1;

var buildEnhancedMatching = buildEnhancedMatching_1;

var enhancedMatcherMethods$7 = {
  enhancedFind: buildEnhancedMatching('find'),
  enhancedSome: buildEnhancedMatching('some'),
  enhancedEvery: buildEnhancedMatching('every'),
  enhancedFilter: buildEnhancedMatching('filter'),
  enhancedFindIndex: buildEnhancedMatching('findIndex')
};

var isUndefined$7 = isUndefined_1,
    enhancedMatcherMethods$6 = enhancedMatcherMethods$7;

var enhancedFilter$1 = enhancedMatcherMethods$6.enhancedFilter;

function arrayCount$1(arr, f) {
  if (isUndefined$7(f)) {
    return arr.length;
  }
  return enhancedFilter$1.apply(this, arguments).length;
}

var arrayCount_1 = arrayCount$1;

var Sugar$4e = sugarCore.exports,
    arrayCount = arrayCount_1,
    fixArgumentLength$7 = fixArgumentLength_1;

Sugar$4e.Array.defineInstance({

  'count': fixArgumentLength$7(arrayCount)

});

Sugar$4e.Array.count;

var ARRAY_ENHANCEMENTS_FLAG$6 = 'enhanceArray';

var Sugar$4d = sugarCore.exports,
    ENHANCEMENTS_FLAG$5 = ENHANCEMENTS_FLAG$7,
    ARRAY_ENHANCEMENTS_FLAG$5 = ARRAY_ENHANCEMENTS_FLAG$6,
    fixArgumentLength$6 = fixArgumentLength_1,
    enhancedMatcherMethods$5 = enhancedMatcherMethods$7;

var enhancedEvery = enhancedMatcherMethods$5.enhancedEvery;

Sugar$4d.Array.defineInstance({

  'every': fixArgumentLength$6(enhancedEvery)

}, [ENHANCEMENTS_FLAG$5, ARRAY_ENHANCEMENTS_FLAG$5]);

Sugar$4d.Array.every;

var classChecks$v = classChecks$Z,
    mapWithShortcuts = mapWithShortcuts_1;

var isFunction$7 = classChecks$v.isFunction;

function enhancedMapping$2(map, context) {
  if (isFunction$7(map)) {
    return map;
  } else if (map) {
    return function(el, i, arr) {
      return mapWithShortcuts(el, map, context, [el, i, arr]);
    };
  }
}

var enhancedMapping_1 = enhancedMapping$2;

var forEach$8 = forEach_1,
    spaceSplit$2 = spaceSplit_1,
    classChecks$u = classChecks$Z,
    mathAliases$h = mathAliases$z,
    assertArgument = assertArgument_1,
    enhancedMapping$1 = enhancedMapping_1,
    namespaceAliases$9 = namespaceAliases$e,
    enhancedMatching = enhancedMatching_1,
    getNormalizedIndex = getNormalizedIndex_1,
    coreUtilityAliases$l = coreUtilityAliases$M,
    methodDefineAliases$1 = methodDefineAliases$3;

var forEachProperty$a = coreUtilityAliases$l.forEachProperty,
    defineInstanceWithArguments = methodDefineAliases$1.defineInstanceWithArguments,
    sugarArray = namespaceAliases$9.sugarArray,
    min$3 = mathAliases$h.min,
    max$4 = mathAliases$h.max,
    isBoolean$1 = classChecks$u.isBoolean;

function buildFromIndexMethods$1() {

  var methods = {
    'forEach': {
      base: forEachAsNative
    },
    'map': {
      wrapper: enhancedMapping$1
    },
    'some every': {
      wrapper: enhancedMatching
    },
    'findIndex': {
      wrapper: enhancedMatching,
      result: indexResult
    },
    'reduce': {
      apply: applyReduce
    },
    'filter find': {
      wrapper: enhancedMatching
    },
    'reduceRight': {
      apply: applyReduce,
      slice: sliceArrayFromRight,
      clamp: clampStartIndexFromRight
    }
  };

  forEachProperty$a(methods, function(opts, key) {
    forEach$8(spaceSplit$2(key), function(baseName) {
      var methodName = baseName + 'FromIndex';
      var fn = createFromIndexWithOptions(baseName, opts);
      defineInstanceWithArguments(sugarArray, methodName, fn);
    });
  });

  function forEachAsNative(fn) {
    forEach$8(this, fn);
  }

  // Methods like filter and find have a direct association between the value
  // returned by the callback and the element of the current iteration. This
  // means that when looping, array elements must match the actual index for
  // which they are being called, so the array must be sliced. This is not the
  // case for methods like forEach and map, which either do not use return
  // values or use them in a way that simply getting the element at a shifted
  // index will not affect the final return value. However, these methods will
  // still fail on sparse arrays, so always slicing them here. For example, if
  // "forEachFromIndex" were to be called on [1,,2] from index 1, although the
  // actual index 1 would itself would be skipped, when the array loops back to
  // index 0, shifting it by adding 1 would result in the element for that
  // iteration being undefined. For shifting to work, all gaps in the array
  // between the actual index and the shifted index would have to be accounted
  // for. This is infeasible and is easily solved by simply slicing the actual
  // array instead so that gaps align. Note also that in the case of forEach,
  // we are using the internal function which handles sparse arrays in a way
  // that does not increment the index, and so is highly optimized compared to
  // the others here, which are simply going through the native implementation.
  function sliceArrayFromLeft(arr, startIndex, loop) {
    var result = arr;
    if (startIndex) {
      result = arr.slice(startIndex);
      if (loop) {
        result = result.concat(arr.slice(0, startIndex));
      }
    }
    return result;
  }

  // When iterating from the right, indexes are effectively shifted by 1.
  // For example, iterating from the right from index 2 in an array of 3
  // should also include the last element in the array. This matches the
  // "lastIndexOf" method which also iterates from the right.
  function sliceArrayFromRight(arr, startIndex, loop) {
    if (!loop) {
      startIndex += 1;
      arr = arr.slice(0, max$4(0, startIndex));
    }
    return arr;
  }

  function clampStartIndex(startIndex, len) {
    return min$3(len, max$4(0, startIndex));
  }

  // As indexes are shifted by 1 when starting from the right, clamping has to
  // go down to -1 to accommodate the full range of the sliced array.
  function clampStartIndexFromRight(startIndex, len) {
    return min$3(len, max$4(-1, startIndex));
  }

  function applyReduce(arr, startIndex, fn, context, len, loop) {
    return function(acc, val, i) {
      i = getNormalizedIndex(i + startIndex, len, loop);
      return fn.call(arr, acc, val, i, arr);
    };
  }

  function applyEach(arr, startIndex, fn, context, len, loop) {
    return function(el, i) {
      i = getNormalizedIndex(i + startIndex, len, loop);
      return fn.call(context, arr[i], i, arr);
    };
  }

  function indexResult(result, startIndex, len) {
    if (result !== -1) {
      result = (result + startIndex) % len;
    }
    return result;
  }

  function createFromIndexWithOptions(methodName, opts) {

    var baseFn = opts.base || Array.prototype[methodName],
        applyCallback = opts.apply || applyEach,
        sliceArray = opts.slice || sliceArrayFromLeft,
        clampIndex = opts.clamp || clampStartIndex,
        getResult = opts.result,
        wrapper = opts.wrapper;

    return function(arr, startIndex, args) {
      var callArgs = [], argIndex = 0, lastArg, result, len, loop, fn;
      len = arr.length;
      if (isBoolean$1(args[0])) {
        loop = args[argIndex++];
      }
      fn = args[argIndex++];
      lastArg = args[argIndex];
      if (startIndex < 0) {
        startIndex += len;
      }
      startIndex = clampIndex(startIndex, len);
      assertArgument(args.length);
      fn = wrapper ? wrapper(fn, lastArg) : fn;
      callArgs.push(applyCallback(arr, startIndex, fn, lastArg, len, loop));
      if (lastArg) {
        callArgs.push(lastArg);
      }
      result = baseFn.apply(sliceArray(arr, startIndex, loop), callArgs);
      if (getResult) {
        result = getResult(result, startIndex, len);
      }
      return result;
    };
  }
}

var buildFromIndexMethods_1 = buildFromIndexMethods$1;

var buildFromIndexMethods = buildFromIndexMethods_1;

buildFromIndexMethods();

var Sugar$4c = sugarCore.exports;



Sugar$4c.Array.everyFromIndex;

var Sugar$4b = sugarCore.exports,
    ENHANCEMENTS_FLAG$4 = ENHANCEMENTS_FLAG$7,
    ARRAY_ENHANCEMENTS_FLAG$4 = ARRAY_ENHANCEMENTS_FLAG$6,
    fixArgumentLength$5 = fixArgumentLength_1,
    enhancedMatcherMethods$4 = enhancedMatcherMethods$7;

var enhancedFilter = enhancedMatcherMethods$4.enhancedFilter;

Sugar$4b.Array.defineInstance({

  'filter': fixArgumentLength$5(enhancedFilter)

}, [ENHANCEMENTS_FLAG$4, ARRAY_ENHANCEMENTS_FLAG$4]);

Sugar$4b.Array.filter;

var Sugar$4a = sugarCore.exports;



Sugar$4a.Array.filterFromIndex;

var Sugar$49 = sugarCore.exports,
    ENHANCEMENTS_FLAG$3 = ENHANCEMENTS_FLAG$7,
    ARRAY_ENHANCEMENTS_FLAG$3 = ARRAY_ENHANCEMENTS_FLAG$6,
    fixArgumentLength$4 = fixArgumentLength_1,
    enhancedMatcherMethods$3 = enhancedMatcherMethods$7;

var enhancedFind = enhancedMatcherMethods$3.enhancedFind;

Sugar$49.Array.defineInstance({

  'find': fixArgumentLength$4(enhancedFind)

}, [ENHANCEMENTS_FLAG$3, ARRAY_ENHANCEMENTS_FLAG$3]);

Sugar$49.Array.find;

var Sugar$48 = sugarCore.exports;



Sugar$48.Array.findFromIndex;

var Sugar$47 = sugarCore.exports,
    ENHANCEMENTS_FLAG$2 = ENHANCEMENTS_FLAG$7,
    ARRAY_ENHANCEMENTS_FLAG$2 = ARRAY_ENHANCEMENTS_FLAG$6,
    fixArgumentLength$3 = fixArgumentLength_1,
    enhancedMatcherMethods$2 = enhancedMatcherMethods$7;

var enhancedFindIndex = enhancedMatcherMethods$2.enhancedFindIndex;

Sugar$47.Array.defineInstance({

  'findIndex': fixArgumentLength$3(enhancedFindIndex)

}, [ENHANCEMENTS_FLAG$2, ARRAY_ENHANCEMENTS_FLAG$2]);

Sugar$47.Array.findIndex;

var Sugar$46 = sugarCore.exports;



Sugar$46.Array.findIndexFromIndex;

var Sugar$45 = sugarCore.exports;



Sugar$45.Array.forEachFromIndex;

var Sugar$44 = sugarCore.exports,
    getLeastOrMost$1 = getLeastOrMost_1;

Sugar$44.Array.defineInstance({

  'least': function(arr, all, map) {
    return getLeastOrMost$1(arr, all, map);
  }

});

Sugar$44.Array.least;

var enhancedMapping = enhancedMapping_1,
    wrapNativeArrayMethod = wrapNativeArrayMethod_1;

function buildEnhancedMapping$1(name) {
  return wrapNativeArrayMethod(name, enhancedMapping);
}

var buildEnhancedMapping_1 = buildEnhancedMapping$1;

var buildEnhancedMapping = buildEnhancedMapping_1;

var enhancedMap$1 = buildEnhancedMapping('map');

var Sugar$43 = sugarCore.exports,
    ENHANCEMENTS_FLAG$1 = ENHANCEMENTS_FLAG$7,
    ARRAY_ENHANCEMENTS_FLAG$1 = ARRAY_ENHANCEMENTS_FLAG$6,
    enhancedMap = enhancedMap$1,
    fixArgumentLength$2 = fixArgumentLength_1;

Sugar$43.Array.defineInstance({

  'map': fixArgumentLength$2(enhancedMap)

}, [ENHANCEMENTS_FLAG$1, ARRAY_ENHANCEMENTS_FLAG$1]);

Sugar$43.Array.map;

var Sugar$42 = sugarCore.exports;



Sugar$42.Array.mapFromIndex;

var Sugar$41 = sugarCore.exports,
    getMinOrMax$1 = getMinOrMax_1;

Sugar$41.Array.defineInstance({

  'max': function(arr, all, map) {
    return getMinOrMax$1(arr, all, map, true);
  }

});

Sugar$41.Array.max;

var Sugar$40 = sugarCore.exports,
    median = median_1;

Sugar$40.Array.defineInstance({

  'median': function(arr, map) {
    return median(arr, map);
  }

});

Sugar$40.Array.median;

var Sugar$3$ = sugarCore.exports,
    getMinOrMax = getMinOrMax_1;

Sugar$3$.Array.defineInstance({

  'min': function(arr, all, map) {
    return getMinOrMax(arr, all, map);
  }

});

Sugar$3$.Array.min;

var Sugar$3_ = sugarCore.exports,
    getLeastOrMost = getLeastOrMost_1;

Sugar$3_.Array.defineInstance({

  'most': function(arr, all, map) {
    return getLeastOrMost(arr, all, map, true);
  }

});

Sugar$3_.Array.most;

var enhancedMatcherMethods$1 = enhancedMatcherMethods$7;

var enhancedSome$1 = enhancedMatcherMethods$1.enhancedSome;

function arrayNone$1() {
  return !enhancedSome$1.apply(this, arguments);
}

var arrayNone_1 = arrayNone$1;

var Sugar$3Z = sugarCore.exports,
    arrayNone = arrayNone_1,
    fixArgumentLength$1 = fixArgumentLength_1;

Sugar$3Z.Array.defineInstance({

  'none': fixArgumentLength$1(arrayNone)

});

Sugar$3Z.Array.none;

var Sugar$3Y = sugarCore.exports;



Sugar$3Y.Array.reduceFromIndex;

var Sugar$3X = sugarCore.exports;



Sugar$3X.Array.reduceRightFromIndex;

var Sugar$3W = sugarCore.exports,
    ENHANCEMENTS_FLAG = ENHANCEMENTS_FLAG$7,
    ARRAY_ENHANCEMENTS_FLAG = ARRAY_ENHANCEMENTS_FLAG$6,
    fixArgumentLength = fixArgumentLength_1,
    enhancedMatcherMethods = enhancedMatcherMethods$7;

var enhancedSome = enhancedMatcherMethods.enhancedSome;

Sugar$3W.Array.defineInstance({

  'some': fixArgumentLength(enhancedSome)

}, [ENHANCEMENTS_FLAG, ARRAY_ENHANCEMENTS_FLAG]);

Sugar$3W.Array.some;

var Sugar$3V = sugarCore.exports;



Sugar$3V.Array.someFromIndex;

var Sugar$3U = sugarCore.exports,
    sum = sum_1;

Sugar$3U.Array.defineInstance({

  'sum': function(arr, map) {
    return sum(arr, map);
  }

});

Sugar$3U.Array.sum;

var getOwnPropertyNames$2 = Object.getOwnPropertyNames;

var classChecks$t = classChecks$Z,
    isPrimitive$3 = isPrimitive_1,
    isPlainObject$1 = isPlainObject_1,
    getRegExpFlags$3 = getRegExpFlags_1,
    coreUtilityAliases$k = coreUtilityAliases$M;

var classToString$1 = coreUtilityAliases$k.classToString,
    isDate$8 = classChecks$t.isDate,
    isRegExp$3 = classChecks$t.isRegExp,
    isArray$5 = classChecks$t.isArray;

function getNewObjectForMerge$2(source) {
  var klass = classToString$1(source);
  // Primitive types, dates, and regexes have no "empty" state. If they exist
  // at all, then they have an associated value. As we are only creating new
  // objects when they don't exist in the target, these values can come alone
  // for the ride when created.
  if (isArray$5(source, klass)) {
    return [];
  } else if (isPlainObject$1(source, klass)) {
    return {};
  } else if (isDate$8(source, klass)) {
    return new Date(source.getTime());
  } else if (isRegExp$3(source, klass)) {
    return RegExp(source.source, getRegExpFlags$3(source));
  } else if (isPrimitive$3(source && source.valueOf())) {
    return source;
  }
  // If the object is not of a known type, then simply merging its
  // properties into a plain object will result in something different
  // (it will not respond to instanceof operator etc). Similarly we don't
  // want to call a constructor here as we can't know for sure what the
  // original constructor was called with (Events etc), so throw an
  // error here instead. Non-standard types can be handled if either they
  // already exist and simply have their properties merged, if the merge
  // is not deep so their references will simply be copied over, or if a
  // resolve function is used to assist the merge.
  throw new TypeError('Must be a basic data type');
}

var getNewObjectForMerge_1 = getNewObjectForMerge$2;

var getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;

var getOwnPropertyDescriptor$1 = getOwnPropertyDescriptor$2;

function iterateOverKeys$1(getFn, obj, fn, hidden) {
  var keys = getFn(obj), desc;
  for (var i = 0, key; key = keys[i]; i++) {
    desc = getOwnPropertyDescriptor$1(obj, key);
    if (desc.enumerable || hidden) {
      fn(obj[key], key);
    }
  }
}

var iterateOverKeys_1 = iterateOverKeys$1;

var getOwnPropertySymbols$1 = Object.getOwnPropertySymbols;

var iterateOverKeys = iterateOverKeys_1,
    coreUtilityAliases$j = coreUtilityAliases$M,
    getOwnPropertyNames$1 = getOwnPropertyNames$2,
    getOwnPropertySymbols = getOwnPropertySymbols$1;

var forEachProperty$9 = coreUtilityAliases$j.forEachProperty;

function iterateOverProperties$1(hidden, obj, fn) {
  if (getOwnPropertyNames$1 && hidden) {
    iterateOverKeys(getOwnPropertyNames$1, obj, fn, hidden);
  } else {
    forEachProperty$9(obj, fn);
  }
  if (getOwnPropertySymbols) {
    iterateOverKeys(getOwnPropertySymbols, obj, fn, hidden);
  }
}

var iterateOverProperties_1 = iterateOverProperties$1;

var NO_KEYS_IN_STRING_OBJECTS$1 = !('0' in Object('a'));

function forceStringCoercion$1(obj) {
  var i = 0, chr;
  while (chr = obj.charAt(i)) {
    obj[i++] = chr;
  }
}

var forceStringCoercion_1 = forceStringCoercion$1;

var NO_KEYS_IN_STRING_OBJECTS = NO_KEYS_IN_STRING_OBJECTS$1,
    isPrimitive$2 = isPrimitive_1,
    classChecks$s = classChecks$Z,
    forceStringCoercion = forceStringCoercion_1;

var isString$9 = classChecks$s.isString;

function coercePrimitiveToObject$3(obj) {
  if (isPrimitive$2(obj)) {
    obj = Object(obj);
  }
  // istanbul ignore next
  if (NO_KEYS_IN_STRING_OBJECTS && isString$9(obj)) {
    forceStringCoercion(obj);
  }
  return obj;
}

var coercePrimitiveToObject_1 = coercePrimitiveToObject$3;

var isDefined$a = isDefined_1,
    coreUtilityAliases$i = coreUtilityAliases$M,
    getOwnPropertyDescriptor = getOwnPropertyDescriptor$2;

var defineProperty = coreUtilityAliases$i.defineProperty;

function mergeByPropertyDescriptor$1(target, source, prop, sourceVal) {
  var descriptor = getOwnPropertyDescriptor(source, prop);
  if (isDefined$a(descriptor.value)) {
    descriptor.value = sourceVal;
  }
  defineProperty(target, prop, descriptor);
}

var mergeByPropertyDescriptor_1 = mergeByPropertyDescriptor$1;

var Sugar$3T = sugarCore.exports,
    isDefined$9 = isDefined_1,
    classChecks$r = classChecks$Z,
    isPrimitive$1 = isPrimitive_1,
    isUndefined$6 = isUndefined_1,
    isObjectType$6 = isObjectType_1,
    coreUtilityAliases$h = coreUtilityAliases$M,
    getOwnPropertyNames = getOwnPropertyNames$2,
    getNewObjectForMerge$1 = getNewObjectForMerge_1,
    iterateOverProperties = iterateOverProperties_1,
    coercePrimitiveToObject$2 = coercePrimitiveToObject_1,
    mergeByPropertyDescriptor = mergeByPropertyDescriptor_1;

var isDate$7 = classChecks$r.isDate,
    isRegExp$2 = classChecks$r.isRegExp,
    isFunction$6 = classChecks$r.isFunction,
    getOwn$7 = coreUtilityAliases$h.getOwn;

function objectMerge$3(target, source, deep, resolve, hidden, descriptor) {
  var resolveByFunction = isFunction$6(resolve), resolveConflicts = resolve !== false;

  if (isUndefined$6(target)) {
    target = getNewObjectForMerge$1(source);
  } else if (resolveConflicts && isDate$7(target) && isDate$7(source)) {
    // A date's timestamp is a property that can only be reached through its
    // methods, so actively set it up front if both are dates.
    target.setTime(source.getTime());
  }

  if (isPrimitive$1(target)) {
    // Will not merge into a primitive type, so simply override.
    return source;
  }

  // If the source object is a primitive
  // type then coerce it into an object.
  if (isPrimitive$1(source)) {
    source = coercePrimitiveToObject$2(source);
  }

  iterateOverProperties(hidden, source, function(val, key) {
    var sourceVal, targetVal, resolved, goDeep, result;

    sourceVal = source[key];

    // We are iterating over properties of the source, so hasOwnProperty on
    // it is guaranteed to always be true. However, the target may happen to
    // have properties in its prototype chain that should not be considered
    // as conflicts.
    targetVal = getOwn$7(target, key);

    if (resolveByFunction) {
      result = resolve(key, targetVal, sourceVal, target, source);
      if (isUndefined$6(result)) {
        // Result is undefined so do not merge this property.
        return;
      } else if (isDefined$9(result) && result !== Sugar$3T) {
        // If the source returns anything except undefined, then the conflict
        // has been resolved, so don't continue traversing into the object. If
        // the returned value is the Sugar global object, then allowing Sugar
        // to resolve the conflict, so continue on.
        sourceVal = result;
        resolved = true;
      }
    } else if (isUndefined$6(sourceVal)) {
      // Will not merge undefined.
      return;
    }

    // Regex properties are read-only, so intentionally disallowing deep
    // merging for now. Instead merge by reference even if deep.
    goDeep = !resolved && deep && isObjectType$6(sourceVal) && !isRegExp$2(sourceVal);

    if (!goDeep && !resolveConflicts && isDefined$9(targetVal)) {
      return;
    }

    if (goDeep) {
      sourceVal = objectMerge$3(targetVal, sourceVal, deep, resolve, hidden, descriptor);
    }

    // getOwnPropertyNames is standing in as
    // a test for property descriptor support
    if (getOwnPropertyNames && descriptor) {
      mergeByPropertyDescriptor(target, source, key, sourceVal);
    } else {
      target[key] = sourceVal;
    }

  });
  return target;
}

var objectMerge_1 = objectMerge$3;

var objectMerge$2 = objectMerge_1,
    getNewObjectForMerge = getNewObjectForMerge_1;

function clone$3(source, deep) {
  var target = getNewObjectForMerge(source);
  return objectMerge$2(target, source, deep, true, true, true);
}

var clone_1 = clone$3;

var objectMerge$1 = objectMerge_1;

function mergeWithOptions$3(target, source, opts) {
  opts = opts || {};
  return objectMerge$1(target, source, opts.deep, opts.resolve, opts.hidden, opts.descriptor);
}

var mergeWithOptions_1 = mergeWithOptions$3;

var Sugar$3S = sugarCore.exports,
    clone$2 = clone_1,
    mergeWithOptions$2 = mergeWithOptions_1;

Sugar$3S.Object.defineInstanceAndStatic({

  'add': function(obj1, obj2, opts) {
    return mergeWithOptions$2(clone$2(obj1), obj2, opts);
  }

});

Sugar$3S.Object.add;

var forEach$7 = forEach_1,
    classChecks$q = classChecks$Z,
    mergeWithOptions$1 = mergeWithOptions_1;

var isArray$4 = classChecks$q.isArray;

function mergeAll$3(target, sources, opts) {
  if (!isArray$4(sources)) {
    sources = [sources];
  }
  forEach$7(sources, function(source) {
    return mergeWithOptions$1(target, source, opts);
  });
  return target;
}

var mergeAll_1 = mergeAll$3;

var Sugar$3R = sugarCore.exports,
    clone$1 = clone_1,
    mergeAll$2 = mergeAll_1;

Sugar$3R.Object.defineInstanceAndStatic({

  'addAll': function(obj, sources, opts) {
    return mergeAll$2(clone$1(obj), sources, opts);
  }

});

Sugar$3R.Object.addAll;

var Sugar$3Q = sugarCore.exports,
    clone = clone_1;

Sugar$3Q.Object.defineInstanceAndStatic({

  'clone': function(obj, deep) {
    return clone(obj, deep);
  }

});

Sugar$3Q.Object.clone;

var mergeAll$1 = mergeAll_1;

function defaults$1(target, sources, opts) {
  opts = opts || {};
  opts.resolve = opts.resolve || false;
  return mergeAll$1(target, sources, opts);
}

var defaults_1 = defaults$1;

var Sugar$3P = sugarCore.exports,
    defaults = defaults_1;

Sugar$3P.Object.defineInstanceAndStatic({

  'defaults': function(target, sources, opts) {
    return defaults(target, sources, opts);
  }

});

Sugar$3P.Object.defaults;

var getMatcher$1 = getMatcher_1,
    coreUtilityAliases$g = coreUtilityAliases$M;

var forEachProperty$8 = coreUtilityAliases$g.forEachProperty;

function objectExclude$1(obj, f) {
  var result = {};
  var matcher = getMatcher$1(f);
  forEachProperty$8(obj, function(val, key) {
    if (!matcher(val, key, obj)) {
      result[key] = val;
    }
  });
  return result;
}

var objectExclude_1 = objectExclude$1;

var Sugar$3O = sugarCore.exports,
    objectExclude = objectExclude_1;

Sugar$3O.Object.defineInstanceAndStatic({

  'exclude': function(obj, f) {
    return objectExclude(obj, f);
  }

});

Sugar$3O.Object.exclude;

var DEEP_QUERY_STRING_REG$1 = /^(.+?)(\[.*\])$/;

var NON_DECIMAL_REG$1 = /[^\d.-]/;

var NON_DECIMAL_REG = NON_DECIMAL_REG$1;

function stringIsDecimal$1(str) {
  return str !== '' && !NON_DECIMAL_REG.test(str);
}

var stringIsDecimal_1 = stringIsDecimal$1;

var classChecks$p = classChecks$Z,
    stringIsDecimal = stringIsDecimal_1,
    coreUtilityAliases$f = coreUtilityAliases$M;

var getOwn$6 = coreUtilityAliases$f.getOwn,
    isArray$3 = classChecks$p.isArray;

function getQueryValueAuto$1(obj, key, val) {
  if (!val) {
    return null;
  } else if (val === 'true') {
    return true;
  } else if (val === 'false') {
    return false;
  }
  var num = +val;
  if (!isNaN(num) && stringIsDecimal(val)) {
    return num;
  }
  var existing = getOwn$6(obj, key);
  if (val && existing) {
    return isArray$3(existing) ? existing.concat(val) : [existing, val];
  }
  return val;
}

var getQueryValueAuto_1 = getQueryValueAuto$1;

var isDefined$8 = isDefined_1,
    getQueryValueAuto = getQueryValueAuto_1;

function setQueryProperty$2(obj, key, val, auto, transform) {
  var fnValue;
  if (transform) {
    fnValue = transform(val, key, obj);
  }
  if (isDefined$8(fnValue)) {
    val = fnValue;
  } else if (auto) {
    val = getQueryValueAuto(obj, key, val);
  }
  obj[key] = val;
}

var setQueryProperty_1 = setQueryProperty$2;

function mapQuerySeparatorToKeys$1(key, separator) {
  var split = key.split(separator), result = split[0];
  for (var i = 1, len = split.length; i < len; i++) {
    result += '[' + split[i] + ']';
  }
  return result;
}

var mapQuerySeparatorToKeys_1 = mapQuerySeparatorToKeys$1;

var forEach$6 = forEach_1,
    setQueryProperty$1 = setQueryProperty_1,
    coreUtilityAliases$e = coreUtilityAliases$M;

var hasOwn$5 = coreUtilityAliases$e.hasOwn,
    getOwn$5 = coreUtilityAliases$e.getOwn;

function parseDeepQueryComponent$1(obj, match, val, deep, auto, separator, transform) {
  var key = match[1];
  var inner = match[2].slice(1, -1).split('][');
  forEach$6(inner, function(k) {
    if (!hasOwn$5(obj, key)) {
      obj[key] = k ? {} : [];
    }
    obj = getOwn$5(obj, key);
    key = k ? k : obj.length.toString();
  });
  setQueryProperty$1(obj, key, val, auto, transform);
}

var parseDeepQueryComponent_1 = parseDeepQueryComponent$1;

var DEEP_QUERY_STRING_REG = DEEP_QUERY_STRING_REG$1,
    setQueryProperty = setQueryProperty_1,
    mapQuerySeparatorToKeys = mapQuerySeparatorToKeys_1,
    parseDeepQueryComponent = parseDeepQueryComponent_1;

function parseQueryComponent$1(obj, key, val, deep, auto, separator, transform) {
  var match;
  if (separator) {
    key = mapQuerySeparatorToKeys(key, separator);
    deep = true;
  }
  if (deep === true && (match = key.match(DEEP_QUERY_STRING_REG))) {
    parseDeepQueryComponent(obj, match, val, deep, auto, separator, transform);
  } else {
    setQueryProperty(obj, key, val, auto, transform);
  }
}

var parseQueryComponent_1 = parseQueryComponent$1;

var forEach$5 = forEach_1,
    parseQueryComponent = parseQueryComponent_1;

function fromQueryStringWithOptions$1(obj, opts) {
  var str = String(obj || '').replace(/^.*?\?/, ''), result = {}, auto;
  opts = opts || {};
  if (str) {
    forEach$5(str.split('&'), function(p) {
      var split = p.split('=');
      var key = decodeURIComponent(split[0]);
      var val = split.length === 2 ? decodeURIComponent(split[1]) : '';
      auto = opts.auto !== false;
      parseQueryComponent(result, key, val, opts.deep, auto, opts.separator, opts.transform);
    });
  }
  return result;
}

var fromQueryStringWithOptions_1 = fromQueryStringWithOptions$1;

var Sugar$3N = sugarCore.exports,
    fromQueryStringWithOptions = fromQueryStringWithOptions_1;

Sugar$3N.Object.defineStatic({

  'fromQueryString': function(obj, options) {
    return fromQueryStringWithOptions(obj, options);
  }

});

Sugar$3N.Object.fromQueryString;

var Sugar$3M = sugarCore.exports,
    deepGetProperty$1 = deepGetProperty_1;

Sugar$3M.Object.defineInstanceAndStatic({

  'get': function(obj, key, any) {
    return deepGetProperty$1(obj, key, any);
  }

});

Sugar$3M.Object.get;

var handleDeepProperty$1 = handleDeepProperty_1;

function deepHasProperty$1(obj, key, any) {
  return handleDeepProperty$1(obj, key, any, true);
}

var deepHasProperty_1 = deepHasProperty$1;

var Sugar$3L = sugarCore.exports,
    deepHasProperty = deepHasProperty_1;

Sugar$3L.Object.defineInstanceAndStatic({

  'has': function(obj, key, any) {
    return deepHasProperty(obj, key, any);
  }

});

Sugar$3L.Object.has;

var isEqual$1 = isEqual_1,
    objectMerge = objectMerge_1,
    isObjectType$5 = isObjectType_1,
    coercePrimitiveToObject$1 = coercePrimitiveToObject_1;

function objectIntersectOrSubtract$2(obj1, obj2, subtract) {
  if (!isObjectType$5(obj1)) {
    return subtract ? obj1 : {};
  }
  obj2 = coercePrimitiveToObject$1(obj2);
  function resolve(key, val, val1) {
    var exists = key in obj2 && isEqual$1(val1, obj2[key]);
    if (exists !== subtract) {
      return val1;
    }
  }
  return objectMerge({}, obj1, false, resolve);
}

var objectIntersectOrSubtract_1 = objectIntersectOrSubtract$2;

var Sugar$3K = sugarCore.exports,
    objectIntersectOrSubtract$1 = objectIntersectOrSubtract_1;

Sugar$3K.Object.defineInstanceAndStatic({

  'intersect': function(obj1, obj2) {
    return objectIntersectOrSubtract$1(obj1, obj2, false);
  }

});

Sugar$3K.Object.intersect;

var Sugar$3J = sugarCore.exports,
    coreUtilityAliases$d = coreUtilityAliases$M;

var hasOwn$4 = coreUtilityAliases$d.hasOwn,
    forEachProperty$7 = coreUtilityAliases$d.forEachProperty;

Sugar$3J.Object.defineInstanceAndStatic({

  'invert': function(obj, multi) {
    var result = {};
    multi = multi === true;
    forEachProperty$7(obj, function(val, key) {
      if (hasOwn$4(result, val) && multi) {
        result[val].push(key);
      } else if (multi) {
        result[val] = [key];
      } else {
        result[val] = key;
      }
    });
    return result;
  }

});

Sugar$3J.Object.invert;

var isPrimitive = isPrimitive_1;

function hasProperty$1(obj, prop) {
  return !isPrimitive(obj) && prop in obj;
}

var hasProperty_1 = hasProperty$1;

var hasProperty = hasProperty_1,
    coreUtilityAliases$c = coreUtilityAliases$M;

var classToString = coreUtilityAliases$c.classToString;

function isArguments$1(obj, className) {
  className = className || classToString(obj);
  // .callee exists on Arguments objects in < IE8
  return hasProperty(obj, 'length') && (className === '[object Arguments]' || !!obj.callee);
}

var isArguments_1 = isArguments$1;

var Sugar$3I = sugarCore.exports,
    isArguments = isArguments_1;

Sugar$3I.Object.defineInstanceAndStatic({

  'isArguments': function(obj) {
    return isArguments(obj);
  }

});

Sugar$3I.Object.isArguments;

var methodDefineAliases = methodDefineAliases$3,
    collectSimilarMethods = collectSimilarMethods_1;

var defineInstanceAndStatic = methodDefineAliases.defineInstanceAndStatic;

function defineInstanceAndStaticSimilar$1(sugarNamespace, set, fn, flags) {
  defineInstanceAndStatic(sugarNamespace, collectSimilarMethods(set, fn), flags);
}

var defineInstanceAndStaticSimilar_1 = defineInstanceAndStaticSimilar$1;

var NATIVE_TYPES = NATIVE_TYPES$2,
    classChecks$o = classChecks$Z,
    namespaceAliases$8 = namespaceAliases$e,
    defineInstanceAndStaticSimilar = defineInstanceAndStaticSimilar_1;

var isBoolean = classChecks$o.isBoolean,
    isNumber$a = classChecks$o.isNumber,
    isString$8 = classChecks$o.isString,
    isDate$6 = classChecks$o.isDate,
    isRegExp$1 = classChecks$o.isRegExp,
    isFunction$5 = classChecks$o.isFunction,
    isArray$2 = classChecks$o.isArray,
    isSet = classChecks$o.isSet,
    isMap = classChecks$o.isMap,
    isError = classChecks$o.isError,
    sugarObject = namespaceAliases$8.sugarObject;

function buildClassCheckMethods$1() {
  var checks = [isBoolean, isNumber$a, isString$8, isDate$6, isRegExp$1, isFunction$5, isArray$2, isError, isSet, isMap];
  defineInstanceAndStaticSimilar(sugarObject, NATIVE_TYPES, function(methods, name, i) {
    methods['is' + name] = checks[i];
  });
}

var buildClassCheckMethods_1 = buildClassCheckMethods$1;

var buildClassCheckMethods = buildClassCheckMethods_1;

buildClassCheckMethods();

var Sugar$3H = sugarCore.exports;



Sugar$3H.Object.isArray;

var Sugar$3G = sugarCore.exports;



Sugar$3G.Object.isBoolean;

var Sugar$3F = sugarCore.exports;



Sugar$3F.Object.isDate;

var getKeys$2 = getKeys_1,
    coercePrimitiveToObject = coercePrimitiveToObject_1;

function getKeysWithObjectCoercion$1(obj) {
  return getKeys$2(coercePrimitiveToObject(obj));
}

var getKeysWithObjectCoercion_1 = getKeysWithObjectCoercion$1;

var getKeysWithObjectCoercion = getKeysWithObjectCoercion_1;

function objectSize$2(obj) {
  return getKeysWithObjectCoercion(obj).length;
}

var objectSize_1 = objectSize$2;

var Sugar$3E = sugarCore.exports,
    objectSize$1 = objectSize_1;

Sugar$3E.Object.defineInstanceAndStatic({

  'isEmpty': function(obj) {
    return objectSize$1(obj) === 0;
  }

});

Sugar$3E.Object.isEmpty;

var Sugar$3D = sugarCore.exports,
    isEqual = isEqual_1;

Sugar$3D.Object.defineInstanceAndStatic({

  'isEqual': function(obj1, obj2) {
    return isEqual(obj1, obj2);
  }

});

Sugar$3D.Object.isEqual;

var Sugar$3C = sugarCore.exports;



Sugar$3C.Object.isError;

var Sugar$3B = sugarCore.exports;



Sugar$3B.Object.isFunction;

var Sugar$3A = sugarCore.exports;



Sugar$3A.Object.isMap;

var Sugar$3z = sugarCore.exports;



Sugar$3z.Object.isNumber;

var Sugar$3y = sugarCore.exports,
    isPlainObject = isPlainObject_1;

Sugar$3y.Object.defineInstanceAndStatic({

  'isObject': function(obj) {
    return isPlainObject(obj);
  }

});

Sugar$3y.Object.isObject;

var Sugar$3x = sugarCore.exports;



Sugar$3x.Object.isRegExp;

var Sugar$3w = sugarCore.exports;



Sugar$3w.Object.isSet;

var Sugar$3v = sugarCore.exports;



Sugar$3v.Object.isString;

var Sugar$3u = sugarCore.exports,
    mergeWithOptions = mergeWithOptions_1;

Sugar$3u.Object.defineInstanceAndStatic({

  'merge': function(target, source, opts) {
    return mergeWithOptions(target, source, opts);
  }

});

Sugar$3u.Object.merge;

var Sugar$3t = sugarCore.exports,
    mergeAll = mergeAll_1;

Sugar$3t.Object.defineInstanceAndStatic({

  'mergeAll': function(target, sources, opts) {
    return mergeAll(target, sources, opts);
  }

});

Sugar$3t.Object.mergeAll;

var classChecks$n = classChecks$Z,
    isObjectType$4 = isObjectType_1;

var isRegExp = classChecks$n.isRegExp;

function matchInObject$1(match, key) {
  if (isRegExp(match)) {
    return match.test(key);
  } else if (isObjectType$4(match)) {
    return key in match;
  } else {
    return key === String(match);
  }
}

var matchInObject_1 = matchInObject$1;

var matchInObject = matchInObject_1,
    coreUtilityAliases$b = coreUtilityAliases$M;

var forEachProperty$6 = coreUtilityAliases$b.forEachProperty;

function selectFromObject$2(obj, f, select) {
  var match, result = {};
  f = [].concat(f);
  forEachProperty$6(obj, function(val, key) {
    match = false;
    for (var i = 0; i < f.length; i++) {
      if (matchInObject(f[i], key)) {
        match = true;
      }
    }
    if (match === select) {
      result[key] = val;
    }
  });
  return result;
}

var selectFromObject_1 = selectFromObject$2;

var selectFromObject$1 = selectFromObject_1;

function objectReject$1(obj, f) {
  return selectFromObject$1(obj, f, false);
}

var objectReject_1 = objectReject$1;

var Sugar$3s = sugarCore.exports,
    objectReject = objectReject_1;

Sugar$3s.Object.defineInstanceAndStatic({

  'reject': function(obj, f) {
    return objectReject(obj, f);
  }

});

Sugar$3s.Object.reject;

var getMatcher = getMatcher_1,
    coreUtilityAliases$a = coreUtilityAliases$M;

var forEachProperty$5 = coreUtilityAliases$a.forEachProperty;

function objectRemove$1(obj, f) {
  var matcher = getMatcher(f);
  forEachProperty$5(obj, function(val, key) {
    if (matcher(val, key, obj)) {
      delete obj[key];
    }
  });
  return obj;
}

var objectRemove_1 = objectRemove$1;

var Sugar$3r = sugarCore.exports,
    objectRemove = objectRemove_1;

Sugar$3r.Object.defineInstanceAndStatic({

  'remove': function(obj, f) {
    return objectRemove(obj, f);
  }

});

Sugar$3r.Object.remove;

var selectFromObject = selectFromObject_1;

function objectSelect$1(obj, f) {
  return selectFromObject(obj, f, true);
}

var objectSelect_1 = objectSelect$1;

var Sugar$3q = sugarCore.exports,
    objectSelect = objectSelect_1;

Sugar$3q.Object.defineInstanceAndStatic({

  'select': function(obj, f) {
    return objectSelect(obj, f);
  }

});

Sugar$3q.Object.select;

var handleDeepProperty = handleDeepProperty_1;

function deepSetProperty$1(obj, key, val) {
  handleDeepProperty(obj, key, false, false, true, false, val);
  return obj;
}

var deepSetProperty_1 = deepSetProperty$1;

var Sugar$3p = sugarCore.exports,
    deepSetProperty = deepSetProperty_1;

Sugar$3p.Object.defineInstanceAndStatic({

  'set': function(obj, key, val) {
    return deepSetProperty(obj, key, val);
  }

});

Sugar$3p.Object.set;

var Sugar$3o = sugarCore.exports,
    objectSize = objectSize_1;

Sugar$3o.Object.defineInstanceAndStatic({

  'size': function(obj) {
    return objectSize(obj);
  }

});

Sugar$3o.Object.size;

var Sugar$3n = sugarCore.exports,
    objectIntersectOrSubtract = objectIntersectOrSubtract_1;

Sugar$3n.Object.defineInstanceAndStatic({

  'subtract': function(obj1, obj2) {
    return objectIntersectOrSubtract(obj1, obj2, true);
  }

});

Sugar$3n.Object.subtract;

var classChecks$m = classChecks$Z;

var isFunction$4 = classChecks$m.isFunction;

function tap$1(obj, arg) {
  var fn = arg;
  if (!isFunction$4(arg)) {
    fn = function() {
      if (arg) obj[arg]();
    };
  }
  fn.call(obj, obj);
  return obj;
}

var tap_1 = tap$1;

var Sugar$3m = sugarCore.exports,
    tap = tap_1;

Sugar$3m.Object.defineInstanceAndStatic({

  'tap': function(obj, arg) {
    return tap(obj, arg);
  }

});

Sugar$3m.Object.tap;

var internalToString$1 = Object.prototype.toString;

function sanitizeURIComponent$2(obj) {
  // undefined, null, and NaN are represented as a blank string,
  // while false and 0 are stringified.
  return !obj && obj !== false && obj !== 0 ? '' : encodeURIComponent(obj);
}

var sanitizeURIComponent_1 = sanitizeURIComponent$2;

var classChecks$l = classChecks$Z,
    sanitizeURIComponent$1 = sanitizeURIComponent_1;

var isDate$5 = classChecks$l.isDate;

function getURIComponentValue$1(obj, prefix, transform) {
  var value;
  if (transform) {
    value = transform(obj, prefix);
  } else if (isDate$5(obj)) {
    value = obj.getTime();
  } else {
    value = obj;
  }
  return sanitizeURIComponent$1(prefix) + '=' + sanitizeURIComponent$1(value);
}

var getURIComponentValue_1 = getURIComponentValue$1;

var classChecks$k = classChecks$Z,
    isObjectType$3 = isObjectType_1,
    internalToString = internalToString$1,
    coreUtilityAliases$9 = coreUtilityAliases$M,
    getURIComponentValue = getURIComponentValue_1,
    sanitizeURIComponent = sanitizeURIComponent_1;

var isArray$1 = classChecks$k.isArray,
    forEachProperty$4 = coreUtilityAliases$9.forEachProperty;

function toQueryString$1(obj, deep, transform, prefix, separator) {
  if (isArray$1(obj)) {
    return collectArrayAsQueryString(obj, deep, transform, prefix, separator);
  } else if (isObjectType$3(obj) && obj.toString === internalToString) {
    return collectObjectAsQueryString(obj, deep, transform, prefix, separator);
  } else if (prefix) {
    return getURIComponentValue(obj, prefix, transform);
  }
  return '';
}

function collectArrayAsQueryString(arr, deep, transform, prefix, separator) {
  var el, qc, key, result = [];
  // Intentionally treating sparse arrays as dense here by avoiding map,
  // otherwise indexes will shift during the process of serialization.
  for (var i = 0, len = arr.length; i < len; i++) {
    el = arr[i];
    key = prefix + (prefix && deep ? '[]' : '');
    if (!key && !isObjectType$3(el)) {
      // If there is no key, then the values of the array should be
      // considered as null keys, so use them instead;
      qc = sanitizeURIComponent(el);
    } else {
      qc = toQueryString$1(el, deep, transform, key, separator);
    }
    result.push(qc);
  }
  return result.join('&');
}

function collectObjectAsQueryString(obj, deep, transform, prefix, separator) {
  var result = [];
  forEachProperty$4(obj, function(val, key) {
    var fullKey;
    if (prefix && deep) {
      fullKey = prefix + '[' + key + ']';
    } else if (prefix) {
      fullKey = prefix + separator + key;
    } else {
      fullKey = key;
    }
    result.push(toQueryString$1(val, deep, transform, fullKey, separator));
  });
  return result.join('&');
}

var toQueryString_1 = toQueryString$1;

var isUndefined$5 = isUndefined_1,
    toQueryString = toQueryString_1;

function toQueryStringWithOptions$1(obj, opts) {
  opts = opts || {};
  if (isUndefined$5(opts.separator)) {
    opts.separator = '_';
  }
  return toQueryString(obj, opts.deep, opts.transform, opts.prefix || '', opts.separator);
}

var toQueryStringWithOptions_1 = toQueryStringWithOptions$1;

var Sugar$3l = sugarCore.exports,
    toQueryStringWithOptions = toQueryStringWithOptions_1;

Sugar$3l.Object.defineInstanceAndStatic({

  'toQueryString': function(obj, options) {
    return toQueryStringWithOptions(obj, options);
  }

});

Sugar$3l.Object.toQueryString;

var coreUtilityAliases$8 = coreUtilityAliases$M;

var forEachProperty$3 = coreUtilityAliases$8.forEachProperty;

function getValues$1(obj) {
  var values = [];
  forEachProperty$3(obj, function(val) {
    values.push(val);
  });
  return values;
}

var getValues_1 = getValues$1;

var Sugar$3k = sugarCore.exports,
    getValues = getValues_1;

Sugar$3k.Object.defineInstanceAndStatic({

  'values': function(obj) {
    return getValues(obj);
  }

});

Sugar$3k.Object.values;

var Sugar$3j = sugarCore.exports,
    getKeys$1 = getKeys_1;

Sugar$3j.Object.defineInstance({

  'keys': function(obj) {
    return getKeys$1(obj);
  }

});

Sugar$3j.Object.keys;

var EnglishLocaleBaseDefinition$1 = {
  'code': 'en',
  'plural': true,
  'timeMarkers': 'at',
  'ampm': 'AM|A.M.|a,PM|P.M.|p',
  'units': 'millisecond:|s,second:|s,minute:|s,hour:|s,day:|s,week:|s,month:|s,year:|s',
  'months': 'Jan:uary|,Feb:ruary|,Mar:ch|,Apr:il|,May,Jun:e|,Jul:y|,Aug:ust|,Sep:tember|t|,Oct:ober|,Nov:ember|,Dec:ember|',
  'weekdays': 'Sun:day|,Mon:day|,Tue:sday|,Wed:nesday|,Thu:rsday|,Fri:day|,Sat:urday|+weekend',
  'numerals': 'zero,one|first,two|second,three|third,four:|th,five|fifth,six:|th,seven:|th,eight:|h,nin:e|th,ten:|th',
  'articles': 'a,an,the',
  'tokens': 'the,st|nd|rd|th,of|in,a|an,on',
  'time': '{H}:{mm}',
  'past': '{num} {unit} {sign}',
  'future': '{num} {unit} {sign}',
  'duration': '{num} {unit}',
  'modifiers': [
    { 'name': 'half',   'src': 'half', 'value': .5 },
    { 'name': 'midday', 'src': 'noon', 'value': 12 },
    { 'name': 'midday', 'src': 'midnight', 'value': 24 },
    { 'name': 'day',    'src': 'yesterday', 'value': -1 },
    { 'name': 'day',    'src': 'today|tonight', 'value': 0 },
    { 'name': 'day',    'src': 'tomorrow', 'value': 1 },
    { 'name': 'sign',   'src': 'ago|before', 'value': -1 },
    { 'name': 'sign',   'src': 'from now|after|from|in|later', 'value': 1 },
    { 'name': 'edge',   'src': 'first day|first|beginning', 'value': -2 },
    { 'name': 'edge',   'src': 'last day', 'value': 1 },
    { 'name': 'edge',   'src': 'end|last', 'value': 2 },
    { 'name': 'shift',  'src': 'last', 'value': -1 },
    { 'name': 'shift',  'src': 'the|this', 'value': 0 },
    { 'name': 'shift',  'src': 'next', 'value': 1 }
  ],
  'parse': [
    '(?:just)? now',
    '{shift} {unit:5-7}',
    '{months?} {year}',
    '{midday} {4?} {day|weekday}',
    '{months},?[-.\\/\\s]?{year?}',
    '{edge} of (?:day)? {day|weekday}',
    '{0} {num}{1?} {weekday} {2} {months},? {year?}',
    '{shift?} {day?} {weekday?} (?:at)? {midday}',
    '{sign?} {3?} {half} {3?} {unit:3-4|unit:7} {sign?}',
    '{0?} {edge} {weekday?} {2} {shift?} {unit:4-7?} {months?},? {year?}'
  ],
  'timeParse': [
    '{day|weekday}',
    '{shift} {unit:5?} {weekday}',
    '{0?} {date}{1?} {2?} {months?}',
    '{weekday} {2?} {shift} {unit:5}',
    '{0?} {num} {2?} {months}\\.?,? {year?}',
    '{num?} {unit:4-5} {sign} {day|weekday}',
    '{0|months} {date?}{1?} of {shift} {unit:6-7}',
    '{0?} {num}{1?} {weekday} of {shift} {unit:6}',
    '{year?}[-.\\/\\s]?{months}[-.\\/\\s]{date}',
    '{date}[-.\\/\\s]{months}(?:[-.\\/\\s]{year|yy})?',
    '{weekday?}\\.?,? {months}\\.?,? {date}{1?},? {year?}',
    '{weekday?}\\.?,? {date} {months} {year}'
  ],
  'timeFrontParse': [
    '{sign} {num} {unit}',
    '{num} {unit} {sign}',
    '{4?} {day|weekday}'
  ]
};

var EnglishLocaleBaseDefinition_1 = EnglishLocaleBaseDefinition$1;

var EnglishLocaleBaseDefinition = EnglishLocaleBaseDefinition_1,
    simpleMerge$2 = simpleMerge_1,
    simpleClone$2 = simpleClone_1;

function getEnglishVariant$3(v) {
  return simpleMerge$2(simpleClone$2(EnglishLocaleBaseDefinition), v);
}

var getEnglishVariant_1 = getEnglishVariant$3;

var getEnglishVariant$2 = getEnglishVariant_1;

var BritishEnglishDefinition$1 = getEnglishVariant$2({
  'short':  '{dd}/{MM}/{yyyy}',
  'medium': '{d} {Month} {yyyy}',
  'long':   '{d} {Month} {yyyy} {H}:{mm}',
  'full':   '{Weekday}, {d} {Month}, {yyyy} {time}',
  'stamp':  '{Dow} {d} {Mon} {yyyy} {time}'
});

var BritishEnglishDefinition_1 = BritishEnglishDefinition$1;

var getEnglishVariant$1 = getEnglishVariant_1;

var AmericanEnglishDefinition$2 = getEnglishVariant$1({
  'mdy': true,
  'firstDayOfWeek': 0,
  'firstDayOfWeekYear': 1,
  'short':  '{MM}/{dd}/{yyyy}',
  'medium': '{Month} {d}, {yyyy}',
  'long':   '{Month} {d}, {yyyy} {time}',
  'full':   '{Weekday}, {Month} {d}, {yyyy} {time}',
  'stamp':  '{Dow} {Mon} {d} {yyyy} {time}',
  'time':   '{h}:{mm} {TT}'
});

var AmericanEnglishDefinition_1 = AmericanEnglishDefinition$2;

var getEnglishVariant = getEnglishVariant_1;

var CanadianEnglishDefinition$1 = getEnglishVariant({
  'short':  '{yyyy}-{MM}-{dd}',
  'medium': '{d} {Month}, {yyyy}',
  'long':   '{d} {Month}, {yyyy} {H}:{mm}',
  'full':   '{Weekday}, {d} {Month}, {yyyy} {time}',
  'stamp':  '{Dow} {d} {Mon} {yyyy} {time}'
});

var CanadianEnglishDefinition_1 = CanadianEnglishDefinition$1;

var BritishEnglishDefinition = BritishEnglishDefinition_1,
    AmericanEnglishDefinition$1 = AmericanEnglishDefinition_1,
    CanadianEnglishDefinition = CanadianEnglishDefinition_1;

var LazyLoadedLocales$1 = {
  'en-US': AmericanEnglishDefinition$1,
  'en-GB': BritishEnglishDefinition,
  'en-AU': BritishEnglishDefinition,
  'en-CA': CanadianEnglishDefinition
};

var LazyLoadedLocales_1 = LazyLoadedLocales$1;

var LOCALE_ARRAY_FIELDS$1 = [
  'months', 'weekdays', 'units', 'numerals', 'placeholders',
  'articles', 'tokens', 'timeMarkers', 'ampm', 'timeSuffixes',
  'parse', 'timeParse', 'timeFrontParse', 'modifiers'
];

var LOCALE_ARRAY_FIELDS_1 = LOCALE_ARRAY_FIELDS$1;

var ISODefaults$3 = {
  ISO_FIRST_DAY_OF_WEEK: 1,
  ISO_FIRST_DAY_OF_WEEK_YEAR: 4
};

var CoreParsingTokens$1 = {
  'yyyy': {
    param: 'year',
    src: '[-−+]?\\d{4,6}'
  },
  'yy': {
    param: 'year',
    src: '\\d{2}'
  },
  'y': {
    param: 'year',
    src: '\\d'
  },
  'ayy': {
    param: 'year',
    src: '\'\\d{2}'
  },
  'MM': {
    param: 'month',
    src: '(?:1[012]|0?[1-9])'
  },
  'dd': {
    param: 'date',
    src: '(?:3[01]|[12][0-9]|0?[1-9])'
  },
  'hh': {
    param: 'hour',
    src: '(?:2[0-4]|[01]?[0-9])'
  },
  'mm': {
    param: 'minute',
    src: '[0-5]\\d'
  },
  'ss': {
    param: 'second',
    src: '[0-5]\\d(?:[,.]\\d+)?'
  },
  'tzHour': {
    src: '[-−+](?:2[0-4]|[01]?[0-9])'
  },
  'tzMinute': {
    src: '[0-5]\\d'
  },
  'iyyyy': {
    param: 'year',
    src: '(?:[-−+]?\\d{4}|[-−+]\\d{5,6})'
  },
  'ihh': {
    param: 'hour',
    src: '(?:2[0-4]|[01][0-9])(?:[,.]\\d+)?'
  },
  'imm': {
    param: 'minute',
    src: '[0-5]\\d(?:[,.]\\d+)?'
  },
  'GMT': {
    param: 'utc',
    src: 'GMT'
  },
  'Z': {
    param: 'utc',
    src: 'Z'
  },
  'timestamp': {
    src: '\\d+'
  }
};

var CoreParsingTokens_1 = CoreParsingTokens$1;

var CoreParsingFormats$1 = [
  {
    // 12-1978
    // 08-1978 (MDY)
    src: '{MM}[-.\\/]{yyyy}'
  },
  {
    // 12/08/1978
    // 08/12/1978 (MDY)
    time: true,
    src: '{dd}[-\\/]{MM}(?:[-\\/]{yyyy|yy|y})?',
    mdy: '{MM}[-\\/]{dd}(?:[-\\/]{yyyy|yy|y})?'
  },
  {
    // 12.08.1978
    // 08.12.1978 (MDY)
    time: true,
    src: '{dd}\\.{MM}(?:\\.{yyyy|yy|y})?',
    mdy: '{MM}\\.{dd}(?:\\.{yyyy|yy|y})?',
    localeCheck: function(loc) {
      // Do not allow this format if the locale
      // uses a period as a time separator.
      return loc.timeSeparator !== '.';
    }
  },
  {
    // 1975-08-25
    time: true,
    src: '{yyyy}[-.\\/]{MM}(?:[-.\\/]{dd})?'
  },
  {
    // .NET JSON
    src: '\\\\/Date\\({timestamp}(?:[-+]\\d{4,4})?\\)\\\\/'
  },
  {
    // ISO-8601
    src: '{iyyyy}(?:-?{MM}(?:-?{dd}(?:T{ihh}(?::?{imm}(?::?{ss})?)?)?)?)?{tzOffset?}'
  }
];

var CoreParsingFormats_1 = CoreParsingFormats$1;

var LocalizedParsingTokens$2 = {
  'year': {
    base: 'yyyy|ayy',
    requiresSuffix: true
  },
  'month': {
    base: 'MM',
    requiresSuffix: true
  },
  'date': {
    base: 'dd',
    requiresSuffix: true
  },
  'hour': {
    base: 'hh',
    requiresSuffixOr: ':'
  },
  'minute': {
    base: 'mm'
  },
  'second': {
    base: 'ss'
  },
  'num': {
    src: '\\d+',
    requiresNumerals: true
  }
};

var LocalizedParsingTokens_1 = LocalizedParsingTokens$2;

function getArrayWithOffset$1(arr, n, alternate, offset) {
  var val;
  if (alternate > 1) {
    val = arr[n + (alternate - 1) * offset];
  }
  return val || arr[n];
}

var getArrayWithOffset_1 = getArrayWithOffset$1;

function getRegNonCapturing$2(src, opt) {
  if (src.length > 1) {
    src = '(?:' + src + ')';
  }
  if (opt) {
    src += '?';
  }
  return src;
}

var getRegNonCapturing_1 = getRegNonCapturing$2;

var PRIVATE_PROP_PREFIX$1 = '_sugar_';

var PRIVATE_PROP_PREFIX = PRIVATE_PROP_PREFIX$1,
    coreUtilityAliases$7 = coreUtilityAliases$M;

var setProperty = coreUtilityAliases$7.setProperty;

function privatePropertyAccessor$5(key) {
  var privateKey = PRIVATE_PROP_PREFIX + key;
  return function(obj, val) {
    if (arguments.length > 1) {
      setProperty(obj, privateKey, val);
      return obj;
    }
    return obj[privateKey];
  };
}

var privatePropertyAccessor_1 = privatePropertyAccessor$5;

var privatePropertyAccessor$4 = privatePropertyAccessor_1;

var _utc$8 = privatePropertyAccessor$4('utc');

var _utc$7 = _utc$8;

function callDateGet$a(d, method) {
  return d['get' + (_utc$7(d) ? 'UTC' : '') + method]();
}

var callDateGet_1 = callDateGet$a;

var callDateGet$9 = callDateGet_1;

function getYear$8(d) {
  return callDateGet$9(d, 'FullYear');
}

var getYear_1 = getYear$8;

var callDateGet$8 = callDateGet_1;

function getMonth$7(d) {
  return callDateGet$8(d, 'Month');
}

var getMonth_1 = getMonth$7;

var getYear$7 = getYear_1,
    getMonth$6 = getMonth_1,
    callDateGet$7 = callDateGet_1;

function getDaysInMonth$2(d) {
  return 32 - callDateGet$7(new Date(getYear$7(d), getMonth$6(d), 32), 'Date');
}

var getDaysInMonth_1 = getDaysInMonth$2;

var getDaysInMonth$1 = getDaysInMonth_1;

var DateUnits$7 = [
  {
    name: 'millisecond',
    method: 'Milliseconds',
    multiplier: 1,
    start: 0,
    end: 999
  },
  {
    name: 'second',
    method: 'Seconds',
    multiplier: 1000,
    start: 0,
    end: 59
  },
  {
    name: 'minute',
    method: 'Minutes',
    multiplier: 60 * 1000,
    start: 0,
    end: 59
  },
  {
    name: 'hour',
    method: 'Hours',
    multiplier: 60 * 60 * 1000,
    start: 0,
    end: 23
  },
  {
    name: 'day',
    alias: 'date',
    method: 'Date',
    ambiguous: true,
    multiplier: 24 * 60 * 60 * 1000,
    start: 1,
    end: function(d) {
      return getDaysInMonth$1(d);
    }
  },
  {
    name: 'week',
    method: 'ISOWeek',
    ambiguous: true,
    multiplier: 7 * 24 * 60 * 60 * 1000
  },
  {
    name: 'month',
    method: 'Month',
    ambiguous: true,
    multiplier: 30.4375 * 24 * 60 * 60 * 1000,
    start: 0,
    end: 11
  },
  {
    name: 'year',
    method: 'FullYear',
    ambiguous: true,
    multiplier: 365.25 * 24 * 60 * 60 * 1000,
    start: 0
  }
];

var DateUnits_1 = DateUnits$7;

var DateUnitIndexes$i = {
  HOURS_INDEX: 3,
  DAY_INDEX: 4,
  WEEK_INDEX: 5,
  MONTH_INDEX: 6,
  YEAR_INDEX: 7
};

var DateUnits$6 = DateUnits_1,
    DateUnitIndexes$h = DateUnitIndexes$i,
    isUndefined$4 = isUndefined_1;

var YEAR_INDEX$4 = DateUnitIndexes$h.YEAR_INDEX;

function iterateOverDateUnits$3(fn, startIndex, endIndex) {
  endIndex = endIndex || 0;
  if (isUndefined$4(startIndex)) {
    startIndex = YEAR_INDEX$4;
  }
  for (var index = startIndex; index >= endIndex; index--) {
    if (fn(DateUnits$6[index], index) === false) {
      break;
    }
  }
}

var iterateOverDateUnits_1 = iterateOverDateUnits$3;

var map$1 = map_1,
    escapeRegExp$1 = escapeRegExp_1;

function arrayToRegAlternates$1(arr) {
  var joined = arr.join('');
  if (!arr || !arr.length) {
    return '';
  }
  if (joined.length === arr.length) {
    return '[' + joined + ']';
  }
  // map handles sparse arrays so no need to compact the array here.
  return map$1(arr, escapeRegExp$1).join('|');
}

var arrayToRegAlternates_1 = arrayToRegAlternates$1;

var mathAliases$g = mathAliases$z,
    iterateOverDateUnits$2 = iterateOverDateUnits_1;

var abs$5 = mathAliases$g.abs;

function getAdjustedUnit$2(ms, fn) {
  var unitIndex = 0, value = 0;
  iterateOverDateUnits$2(function(unit, i) {
    value = abs$5(fn(unit));
    if (value >= 1) {
      unitIndex = i;
      return false;
    }
  });
  return [value, unitIndex, ms];
}

var getAdjustedUnit_1 = getAdjustedUnit$2;

var trunc$7 = trunc_1,
    withPrecision$1 = withPrecision_1,
    getAdjustedUnit$1 = getAdjustedUnit_1;

function getAdjustedUnitForNumber$1(ms) {
  return getAdjustedUnit$1(ms, function(unit) {
    return trunc$7(withPrecision$1(ms / unit.multiplier, 1));
  });
}

var getAdjustedUnitForNumber_1 = getAdjustedUnitForNumber$1;

var LocalizedParsingTokens$1 = LocalizedParsingTokens_1,
    getRegNonCapturing$1 = getRegNonCapturing_1;

function getParsingTokenWithSuffix$1(field, src, suffix) {
  var token = LocalizedParsingTokens$1[field];
  if (token.requiresSuffix) {
    src = getRegNonCapturing$1(src + getRegNonCapturing$1(suffix));
  } else if (token.requiresSuffixOr) {
    src += getRegNonCapturing$1(token.requiresSuffixOr + '|' + suffix);
  } else {
    src += getRegNonCapturing$1(suffix, true);
  }
  return src;
}

var getParsingTokenWithSuffix_1 = getParsingTokenWithSuffix$1;

var LOCALE_ARRAY_FIELDS = LOCALE_ARRAY_FIELDS_1,
    ISODefaults$2 = ISODefaults$3,
    CoreParsingTokens = CoreParsingTokens_1,
    CoreParsingFormats = CoreParsingFormats_1,
    LocalizedParsingTokens = LocalizedParsingTokens_1,
    map = map_1,
    filter = filter_1,
    forEach$4 = forEach_1,
    isDefined$7 = isDefined_1,
    commaSplit = commaSplit_1,
    classChecks$j = classChecks$Z,
    mathAliases$f = mathAliases$z,
    isUndefined$3 = isUndefined_1,
    simpleMerge$1 = simpleMerge_1,
    getOrdinalSuffix = getOrdinalSuffix_1,
    getArrayWithOffset = getArrayWithOffset_1,
    getRegNonCapturing = getRegNonCapturing_1,
    coreUtilityAliases$6 = coreUtilityAliases$M,
    iterateOverDateUnits$1 = iterateOverDateUnits_1,
    arrayToRegAlternates = arrayToRegAlternates_1,
    fullwidthNumberHelpers = fullwidthNumberHelpers$2,
    getAdjustedUnitForNumber = getAdjustedUnitForNumber_1,
    getParsingTokenWithSuffix = getParsingTokenWithSuffix_1;

var hasOwn$3 = coreUtilityAliases$6.hasOwn,
    getOwn$4 = coreUtilityAliases$6.getOwn,
    forEachProperty$2 = coreUtilityAliases$6.forEachProperty,
    fullWidthNumberMap = fullwidthNumberHelpers.fullWidthNumberMap,
    fullWidthNumbers = fullwidthNumberHelpers.fullWidthNumbers,
    pow = mathAliases$f.pow,
    max$3 = mathAliases$f.max,
    ISO_FIRST_DAY_OF_WEEK$2 = ISODefaults$2.ISO_FIRST_DAY_OF_WEEK,
    ISO_FIRST_DAY_OF_WEEK_YEAR$2 = ISODefaults$2.ISO_FIRST_DAY_OF_WEEK_YEAR,
    isString$7 = classChecks$j.isString,
    isFunction$3 = classChecks$j.isFunction;

function getNewLocale$1(def) {

  function Locale(def) {
    this.init(def);
  }

  Locale.prototype = {

    getMonthName: function(n, alternate) {
      if (this.monthSuffix) {
        return (n + 1) + this.monthSuffix;
      }
      return getArrayWithOffset(this.months, n, alternate, 12);
    },

    getWeekdayName: function(n, alternate) {
      return getArrayWithOffset(this.weekdays, n, alternate, 7);
    },

    // TODO: rename to parse in next major version
    parseValue: function(str, param) {
      var map = this[param + 'Map'];
      if (hasOwn$3(map, str)) {
        return map[str];
      }
      return this.parseNumber(str, param);
    },

    // TODO: analyze performance of parsing first vs checking
    // numeralMap first.
    parseNumber: function(str, param) {
      var val;

      // Simple numerals such as "one" are mapped directly in
      // the numeral map so catch up front if there is a match.
      if (hasOwn$3(this.numeralMap, str)) {
        val = this.numeralMap[str];
      }

      // TODO: perf test isNaN vs other methods
      if (isNaN(val)) {
        val = this.parseRegularNumerals(str);
      }

      if (isNaN(val)) {
        val = this.parseIrregularNumerals(str);
      }

      if (param === 'month') {
        // Months are the only numeric date field
        // whose value is not the same as its number.
        val -= 1;
      }

      return val;
    },

    // TODO: perf test returning up front if no regular decimals exist
    parseRegularNumerals: function(str) {
      // Allow decimals as commas and the minus-sign as per ISO-8601.
      str = str.replace(/^−/, '-').replace(/,/, '.');

      // The unary plus operator here shows better performance and handles
      // every format that parseFloat does with the exception of trailing
      // characters, which are guaranteed not to be in our string at this point.
      return +str;
    },

    parseIrregularNumerals: function(str) {
      var place = 1, num = 0, lastWasPlace, isPlace, numeral, digit, arr;

      // Note that "numerals" that need to be converted through this method are
      // all considered to be single characters in order to handle CJK. This
      // method is by no means unique to CJK, but the complexity of handling
      // inflections in non-CJK languages adds too much overhead for not enough
      // value, so avoiding for now.
      arr = str.split('');
      for (var i = arr.length - 1; numeral = arr[i]; i--) {
        digit = getOwn$4(this.numeralMap, numeral);
        if (isUndefined$3(digit)) {
          digit = getOwn$4(fullWidthNumberMap, numeral) || 0;
        }
        isPlace = digit > 0 && digit % 10 === 0;
        if (isPlace) {
          if (lastWasPlace) {
            num += place;
          }
          if (i) {
            place = digit;
          } else {
            num += digit;
          }
        } else {
          num += digit * place;
          place *= 10;
        }
        lastWasPlace = isPlace;
      }
      return num;
    },

    getOrdinal: function(n) {
      var suffix = this.ordinalSuffix;
      return suffix || getOrdinalSuffix(n);
    },

    getRelativeFormat: function(adu, type) {
      return this.convertAdjustedToFormat(adu, type);
    },

    getDuration: function(ms) {
      return this.convertAdjustedToFormat(getAdjustedUnitForNumber(max$3(0, ms)), 'duration');
    },

    getFirstDayOfWeek: function() {
      var val = this.firstDayOfWeek;
      return isDefined$7(val) ? val : ISO_FIRST_DAY_OF_WEEK$2;
    },

    getFirstDayOfWeekYear: function() {
      return this.firstDayOfWeekYear || ISO_FIRST_DAY_OF_WEEK_YEAR$2;
    },

    convertAdjustedToFormat: function(adu, type) {
      var sign, unit, mult,
          num    = adu[0],
          u      = adu[1],
          ms     = adu[2],
          format = this[type] || this.relative;
      if (isFunction$3(format)) {
        return format.call(this, num, u, ms, type);
      }
      mult = !this.plural || num === 1 ? 0 : 1;
      unit = this.units[mult * 8 + u] || this.units[u];
      sign = this[ms > 0 ? 'fromNow' : 'ago'];
      return format.replace(/\{(.*?)\}/g, function(full, match) {
        switch(match) {
          case 'num': return num;
          case 'unit': return unit;
          case 'sign': return sign;
        }
      });
    },

    cacheFormat: function(dif, i) {
      this.compiledFormats.splice(i, 1);
      this.compiledFormats.unshift(dif);
    },

    addFormat: function(format) {
      var loc = this, src, to;

      function getTokenSrc(token) {
        var suffix, src, tmp,
            opt   = token.match(/\?$/),
            nc    = token.match(/^(\d+)\??$/),
            slice = token.match(/(\d)(?:-(\d))?/),
            param = token.replace(/[^a-z]+$/i, '');

        // Allowing alias tokens such as {time}
        if (tmp = getOwn$4(loc.parsingAliases, param)) {
          src = formatToSrc(tmp);
          if (opt) {
            src = getRegNonCapturing(src, true);
          }
          return src;
        }

        if (nc) {
          src = loc.tokens[nc[1]];
        } else if (tmp = getOwn$4(CoreParsingTokens, param)) {
          src = tmp.src;
          param = tmp.param || param;
        } else {
          tmp = getOwn$4(loc.parsingTokens, param) || getOwn$4(loc, param);

          // Both the "months" array and the "month" parsing token can be accessed
          // by either {month} or {months}, falling back as necessary, however
          // regardless of whether or not a fallback occurs, the final field to
          // be passed to addRawFormat must be normalized as singular.
          param = param.replace(/s$/, '');

          if (!tmp) {
            tmp = getOwn$4(loc.parsingTokens, param) || getOwn$4(loc, param + 's');
          }

          if (isString$7(tmp)) {
            src = tmp;
            suffix = loc[param + 'Suffix'];
          } else {

            // This is a hack to temporarily disallow parsing of single character
            // weekdays until the format can be changed to allow for this.
            if (param === 'weekday' && loc.code === 'ko') {
              tmp = filter(tmp, function(str) {
                return str.length > 1;
              });
            }

            if (slice) {
              tmp = filter(tmp, function(m, i) {
                var mod = i % (loc.units ? 8 : tmp.length);
                return mod >= slice[1] && mod <= (slice[2] || slice[1]);
              });
            }
            src = arrayToRegAlternates(tmp);
          }
        }
        if (!src) {
          return '';
        }
        if (nc) {
          // Non-capturing tokens like {0}
          src = getRegNonCapturing(src);
        } else {
          // Capturing group and add to parsed tokens
          to.push(param);
          src = '(' + src + ')';
        }
        if (suffix) {
          // Date/time suffixes such as those in CJK
          src = getParsingTokenWithSuffix(param, src, suffix);
        }
        if (opt) {
          src += '?';
        }
        return src;
      }

      function formatToSrc(str) {

        // Make spaces optional
        str = str.replace(/ /g, ' ?');

        str = str.replace(/\{([^,]+?)\}/g, function(match, token) {
          var tokens = token.split('|');
          if (tokens.length > 1) {
            return getRegNonCapturing(map(tokens, getTokenSrc).join('|'));
          } else {
            return getTokenSrc(token);
          }
        });

        return str;
      }

      function parseInputFormat() {
        to = [];
        src = formatToSrc(format);
      }

      parseInputFormat();
      loc.addRawFormat(src, to);
    },

    addRawFormat: function(format, to) {
      this.compiledFormats.unshift({
        reg: RegExp('^ *' + format + ' *$', 'i'),
        to: to
      });
    },

    init: function(def) {
      var loc = this;

      // -- Initialization helpers

      function initFormats() {
        loc.compiledFormats = [];
        loc.parsingAliases = {};
        loc.parsingTokens = {};
      }

      function initDefinition() {
        simpleMerge$1(loc, def);
      }

      function initArrayFields() {
        forEach$4(LOCALE_ARRAY_FIELDS, function(name) {
          var val = loc[name];
          if (isString$7(val)) {
            loc[name] = commaSplit(val);
          } else if (!val) {
            loc[name] = [];
          }
        });
      }

      // -- Value array build helpers

      function buildValueArray(name, mod, map, fn) {
        var field = name, all = [], setMap;
        if (!loc[field]) {
          field += 's';
        }
        if (!map) {
          map = {};
          setMap = true;
        }
        forAllAlternates(field, function(alt, j, i) {
          var idx = j * mod + i, val;
          val = fn ? fn(i) : i;
          map[alt] = val;
          map[alt.toLowerCase()] = val;
          all[idx] = alt;
        });
        loc[field] = all;
        if (setMap) {
          loc[name + 'Map'] = map;
        }
      }

      function forAllAlternates(field, fn) {
        forEach$4(loc[field], function(str, i) {
          forEachAlternate(str, function(alt, j) {
            fn(alt, j, i);
          });
        });
      }

      function forEachAlternate(str, fn) {
        var arr = map(str.split('+'), function(split) {
          return split.replace(/(.+):(.+)$/, function(full, base, suffixes) {
            return map(suffixes.split('|'), function(suffix) {
              return base + suffix;
            }).join('|');
          });
        }).join('|');
        forEach$4(arr.split('|'), fn);
      }

      function buildNumerals() {
        var map = {};
        buildValueArray('numeral', 10, map);
        buildValueArray('article', 1, map, function() {
          return 1;
        });
        buildValueArray('placeholder', 4, map, function(n) {
          return pow(10, n + 1);
        });
        loc.numeralMap = map;
      }

      function buildTimeFormats() {
        loc.parsingAliases['time'] = getTimeFormat();
        loc.parsingAliases['tzOffset'] = getTZOffsetFormat();
      }

      function getTimeFormat(standalone) {
        var src, sep;
        sep = getTimeSeparatorSrc();
        if (loc.ampmFront) {
          // "ampmFront" exists mostly for CJK locales, which also presume that
          // time suffixes exist, allowing this to be a simpler regex.
          src = '{ampm?} {hour} (?:{minute} (?::?{second})?)?';
        } else if(loc.ampm.length) {
          src = '{hour}(?:'+sep+'{minute?}(?:'+sep+'{second?})? {ampm?}| {ampm})';
        } else {
          src = '{hour}(?:'+sep+'{minute?}(?:'+sep+'{second?})?)';
        }
        return src;
      }

      function getTimeSeparatorSrc() {
        if (loc.timeSeparator) {
          return '[:' + loc.timeSeparator + ']';
        } else {
          return ':';
        }
      }

      function getTZOffsetFormat() {
        return '(?:{Z}|{GMT?}(?:{tzHour}(?::?{tzMinute}(?: \\([\\w\\s]+\\))?)?)?)?';
      }

      function buildParsingTokens() {
        forEachProperty$2(LocalizedParsingTokens, function(token, name) {
          var src = token.base ? getCoreTokensForBase(token.base) : token.src, arr;
          if (token.requiresNumerals || loc.numeralUnits) {
            src += getNumeralSrc();
          }
          arr = loc[name + 's'];
          if (arr && arr.length) {
            src += '|' + arrayToRegAlternates(arr);
          }
          loc.parsingTokens[name] = src;
        });
      }

      function getCoreTokensForBase(base) {
        return map(base.split('|'), function(key) {
          return CoreParsingTokens[key].src;
        }).join('|');
      }

      function getNumeralSrc() {
        var all, src = '';
        all = loc.numerals.concat(loc.placeholders).concat(loc.articles);
        if (loc.allowsFullWidth) {
          all = all.concat(fullWidthNumbers.split(''));
        }
        if (all.length) {
          src = '|(?:' + arrayToRegAlternates(all) + ')+';
        }
        return src;
      }

      function buildTimeSuffixes() {
        iterateOverDateUnits$1(function(unit, i) {
          var token = loc.timeSuffixes[i];
          if (token) {
            loc[(unit.alias || unit.name) + 'Suffix'] = token;
          }
        });
      }

      function buildModifiers() {
        forEach$4(loc.modifiers, function(modifier) {
          var name = modifier.name, mapKey = name + 'Map', map;
          map = loc[mapKey] || {};
          forEachAlternate(modifier.src, function(alt, j) {
            var token = getOwn$4(loc.parsingTokens, name), val = modifier.value;
            map[alt] = val;
            loc.parsingTokens[name] = token ? token + '|' + alt : alt;
            if (modifier.name === 'sign' && j === 0) {
              // Hooking in here to set the first "fromNow" or "ago" modifier
              // directly on the locale, so that it can be reused in the
              // relative format.
              loc[val === 1 ? 'fromNow' : 'ago'] = alt;
            }
          });
          loc[mapKey] = map;
        });
      }

      // -- Format adding helpers

      function addCoreFormats() {
        forEach$4(CoreParsingFormats, function(df) {
          var src = df.src;
          if (df.localeCheck && !df.localeCheck(loc)) {
            return;
          }
          if (df.mdy && loc.mdy) {
            // Use the mm/dd/yyyy variant if it
            // exists and the locale requires it
            src = df.mdy;
          }
          if (df.time) {
            // Core formats that allow time require the time
            // reg on both sides, so add both versions here.
            loc.addFormat(getFormatWithTime(src, true));
            loc.addFormat(getFormatWithTime(src));
          } else {
            loc.addFormat(src);
          }
        });
        loc.addFormat('{time}');
      }

      function addLocaleFormats() {
        addFormatSet('parse');
        addFormatSet('timeParse', true);
        addFormatSet('timeFrontParse', true, true);
      }

      function addFormatSet(field, allowTime, timeFront) {
        forEach$4(loc[field], function(format) {
          if (allowTime) {
            format = getFormatWithTime(format, timeFront);
          }
          loc.addFormat(format);
        });
      }

      function getFormatWithTime(baseFormat, timeBefore) {
        if (timeBefore) {
          return getTimeBefore() + baseFormat;
        }
        return baseFormat + getTimeAfter();
      }

      function getTimeBefore() {
        return getRegNonCapturing('{time}[,\\s\\u3000]', true);
      }

      function getTimeAfter() {
        var markers = ',?[\\s\\u3000]', localized;
        localized = arrayToRegAlternates(loc.timeMarkers);
        if (localized) {
          markers += '| (?:' + localized + ') ';
        }
        markers = getRegNonCapturing(markers, loc.timeMarkerOptional);
        return getRegNonCapturing(markers + '{time}{tzOffset}', true);
      }

      initFormats();
      initDefinition();
      initArrayFields();

      buildValueArray('month', 12);
      buildValueArray('weekday', 7);
      buildValueArray('unit', 8);
      buildValueArray('ampm', 2);

      buildNumerals();
      buildTimeFormats();
      buildParsingTokens();
      buildTimeSuffixes();
      buildModifiers();

      // The order of these formats is important. Order is reversed so formats
      // that are initialized later will take precedence. Generally, this means
      // that more specific formats should come later.
      addCoreFormats();
      addLocaleFormats();

    }

  };

  return new Locale(def);
}

var getNewLocale_1 = getNewLocale$1;

var LazyLoadedLocales = LazyLoadedLocales_1,
    AmericanEnglishDefinition = AmericanEnglishDefinition_1,
    getNewLocale = getNewLocale_1;

var English$3, localeManager$f;

function buildLocales() {

  function LocaleManager(loc) {
    this.locales = {};
    this.add(loc);
  }

  LocaleManager.prototype = {

    get: function(code, fallback) {
      var loc = this.locales[code];
      if (!loc && LazyLoadedLocales[code]) {
        loc = this.add(code, LazyLoadedLocales[code]);
      } else if (!loc && code) {
        loc = this.locales[code.slice(0, 2)];
      }
      return loc || fallback === false ? loc : this.current;
    },

    getAll: function() {
      return this.locales;
    },

    set: function(code) {
      var loc = this.get(code, false);
      if (!loc) {
        throw new TypeError('Invalid Locale: ' + code);
      }
      return this.current = loc;
    },

    add: function(code, def) {
      if (!def) {
        def = code;
        code = def.code;
      } else {
        def.code = code;
      }
      var loc = def.compiledFormats ? def : getNewLocale(def);
      this.locales[code] = loc;
      if (!this.current) {
        this.current = loc;
      }
      return loc;
    },

    remove: function(code) {
      if (this.current.code === code) {
        this.current = this.get('en');
      }
      return delete this.locales[code];
    }

  };

  // Sorry about this guys...
  English$3 = getNewLocale(AmericanEnglishDefinition);
  localeManager$f = new LocaleManager(English$3);
}

buildLocales();

var LocaleHelpers$h = {
  English: English$3,
  localeManager: localeManager$f
};

var Sugar$3i = sugarCore.exports,
    LocaleHelpers$g = LocaleHelpers$h;

var localeManager$e = LocaleHelpers$g.localeManager;

Sugar$3i.Date.defineStatic({

  'addLocale': function(code, set) {
    return localeManager$e.add(code, set);
  }

});

Sugar$3i.Date.addLocale;

var MINUTES$2 = 60 * 1000;

var ABBREVIATED_YEAR_REG$1 = /^'?(\d{1,2})$/;

function tzOffset$4(d) {
  return d.getTimezoneOffset();
}

var tzOffset_1 = tzOffset$4;

var _utc$6 = _utc$8,
    callDateGet$6 = callDateGet_1;

function callDateSet$6(d, method, value, safe) {
  // "Safe" denotes not setting the date if the value is the same as what is
  // currently set. In theory this should be a noop, however it will cause
  // timezone shifts when in the middle of a DST fallback. This is unavoidable
  // as the notation itself is ambiguous (i.e. there are two "1:00ams" on
  // November 1st, 2015 in northern hemisphere timezones that follow DST),
  // however when advancing or rewinding dates this can throw off calculations
  // so avoiding this unintentional shifting on an opt-in basis.
  if (safe && value === callDateGet$6(d, method)) {
    return;
  }
  d['set' + (_utc$6(d) ? 'UTC' : '') + method](value);
}

var callDateSet_1 = callDateSet$6;

var DateUnitIndexes$g = DateUnitIndexes$i;

var HOURS_INDEX$2 = DateUnitIndexes$g.HOURS_INDEX,
    DAY_INDEX$9 = DateUnitIndexes$g.DAY_INDEX,
    WEEK_INDEX$4 = DateUnitIndexes$g.WEEK_INDEX,
    MONTH_INDEX$6 = DateUnitIndexes$g.MONTH_INDEX;

function getLowerUnitIndex$5(index) {
  if (index === MONTH_INDEX$6) {
    return DAY_INDEX$9;
  } else if (index === WEEK_INDEX$4) {
    return HOURS_INDEX$2;
  }
  return index - 1;
}

var getLowerUnitIndex_1 = getLowerUnitIndex$5;

var DateUnits$5 = DateUnits_1,
    getLowerUnitIndex$4 = getLowerUnitIndex_1;

function walkUnitDown$2(unitIndex, fn) {
  while (unitIndex >= 0) {
    if (fn(DateUnits$5[unitIndex], unitIndex) === false) {
      break;
    }
    unitIndex = getLowerUnitIndex$4(unitIndex);
  }
}

var walkUnitDown_1 = walkUnitDown$2;

var isDefined$6 = isDefined_1,
    classChecks$i = classChecks$Z,
    callDateSet$5 = callDateSet_1,
    walkUnitDown$1 = walkUnitDown_1;

var isFunction$2 = classChecks$i.isFunction;

function setUnitAndLowerToEdge$6(d, startIndex, stopIndex, end) {
  walkUnitDown$1(startIndex, function(unit, i) {
    var val = end ? unit.end : unit.start;
    if (isFunction$2(val)) {
      val = val(d);
    }
    callDateSet$5(d, unit.method, val);
    return !isDefined$6(stopIndex) || i > stopIndex;
  });
  return d;
}

var setUnitAndLowerToEdge_1 = setUnitAndLowerToEdge$6;

var DateUnitIndexes$f = DateUnitIndexes$i,
    setUnitAndLowerToEdge$5 = setUnitAndLowerToEdge_1;

var HOURS_INDEX$1 = DateUnitIndexes$f.HOURS_INDEX;

function resetTime$2(d) {
  return setUnitAndLowerToEdge$5(d, HOURS_INDEX$1);
}

var resetTime_1 = resetTime$2;

function defaultNewDate$1() {
  return new Date;
}

var defaultNewDate_1 = defaultNewDate$1;

var defaultNewDate = defaultNewDate_1;

var DATE_OPTIONS$1 = {
  'newDateInternal': defaultNewDate
};

var DATE_OPTIONS_1 = DATE_OPTIONS$1;

var DATE_OPTIONS = DATE_OPTIONS_1,
    namespaceAliases$7 = namespaceAliases$e,
    defineOptionsAccessor = defineOptionsAccessor_1;

var sugarDate$6 = namespaceAliases$7.sugarDate;

var _dateOptions$1 = defineOptionsAccessor(sugarDate$6, DATE_OPTIONS);

var _dateOptions = _dateOptions$1;

function getNewDate$5() {
  return _dateOptions('newDateInternal')();
}

var getNewDate_1 = getNewDate$5;

var callDateSet$4 = callDateSet_1;

function setDate$6(d, val) {
  callDateSet$4(d, 'Date', val);
}

var setDate_1 = setDate$6;

var callDateGet$5 = callDateGet_1;

function getDate$6(d) {
  return callDateGet$5(d, 'Date');
}

var getDate_1 = getDate$6;

var callDateGet$4 = callDateGet_1;

function getWeekday$9(d) {
  return callDateGet$4(d, 'Day');
}

var getWeekday_1 = getWeekday$9;

var setDate$5 = setDate_1,
    getDate$5 = getDate_1,
    getWeekday$8 = getWeekday_1,
    classChecks$h = classChecks$Z,
    mathAliases$e = mathAliases$z;

var isNumber$9 = classChecks$h.isNumber,
    abs$4 = mathAliases$e.abs;

function setWeekday$8(d, dow, dir) {
  if (!isNumber$9(dow)) return;
  var currentWeekday = getWeekday$8(d);
  if (dir) {
    // Allow a "direction" parameter to determine whether a weekday can
    // be set beyond the current weekday in either direction.
    var ndir = dir > 0 ? 1 : -1;
    var offset = dow % 7 - currentWeekday;
    if (offset && offset / abs$4(offset) !== ndir) {
      dow += 7 * ndir;
    }
  }
  setDate$5(d, getDate$5(d) + dow - currentWeekday);
  return d.getTime();
}

var setWeekday_1 = setWeekday$8;

var getLowerUnitIndex$3 = getLowerUnitIndex_1,
    setUnitAndLowerToEdge$4 = setUnitAndLowerToEdge_1;

function resetLowerUnits$1(d, unitIndex) {
  return setUnitAndLowerToEdge$4(d, getLowerUnitIndex$3(unitIndex));
}

var resetLowerUnits_1 = resetLowerUnits$1;

var DateUnitIndexes$e = DateUnitIndexes$i;

var DAY_INDEX$8 = DateUnitIndexes$e.DAY_INDEX,
    MONTH_INDEX$5 = DateUnitIndexes$e.MONTH_INDEX;

function getHigherUnitIndex$1(index) {
  return index === DAY_INDEX$8 ? MONTH_INDEX$5 : index + 1;
}

var getHigherUnitIndex_1 = getHigherUnitIndex$1;

var callDateSet$3 = callDateSet_1;

function setYear$1(d, val) {
  callDateSet$3(d, 'FullYear', val);
}

var setYear_1 = setYear$1;

var callDateSet$2 = callDateSet_1;

function setMonth$1(d, val) {
  callDateSet$2(d, 'Month', val);
}

var setMonth_1 = setMonth$1;

var _utc$5 = _utc$8;

function cloneDate$6(d) {
  // Rhino environments have a bug where new Date(d) truncates
  // milliseconds so need to call getTime() here.
  var clone = new Date(d.getTime());
  _utc$5(clone, !!_utc$5(d));
  return clone;
}

var cloneDate_1 = cloneDate$6;

var setWeekday$7 = setWeekday_1,
    getWeekday$7 = getWeekday_1,
    mathAliases$d = mathAliases$z;

var floor = mathAliases$d.floor;

function moveToBeginningOfWeek$3(d, firstDayOfWeek) {
  setWeekday$7(d, floor((getWeekday$7(d) - firstDayOfWeek) / 7) * 7 + firstDayOfWeek);
  return d;
}

var moveToBeginningOfWeek_1 = moveToBeginningOfWeek$3;

var DateUnitIndexes$d = DateUnitIndexes$i,
    setDate$4 = setDate_1,
    setUnitAndLowerToEdge$3 = setUnitAndLowerToEdge_1,
    moveToBeginningOfWeek$2 = moveToBeginningOfWeek_1;

var MONTH_INDEX$4 = DateUnitIndexes$d.MONTH_INDEX;

function moveToFirstDayOfWeekYear$2(d, firstDayOfWeek, firstDayOfWeekYear) {
  setUnitAndLowerToEdge$3(d, MONTH_INDEX$4);
  setDate$4(d, firstDayOfWeekYear);
  moveToBeginningOfWeek$2(d, firstDayOfWeek);
}

var moveToFirstDayOfWeekYear_1 = moveToFirstDayOfWeekYear$2;

var ISODefaults$1 = ISODefaults$3,
    getDate$4 = getDate_1,
    setDate$3 = setDate_1,
    setYear = setYear_1,
    getYear$6 = getYear_1,
    getMonth$5 = getMonth_1,
    setMonth = setMonth_1,
    cloneDate$5 = cloneDate_1,
    getWeekday$6 = getWeekday_1,
    setWeekday$6 = setWeekday_1,
    classChecks$g = classChecks$Z,
    moveToFirstDayOfWeekYear$1 = moveToFirstDayOfWeekYear_1;

var isNumber$8 = classChecks$g.isNumber,
    ISO_FIRST_DAY_OF_WEEK$1 = ISODefaults$1.ISO_FIRST_DAY_OF_WEEK,
    ISO_FIRST_DAY_OF_WEEK_YEAR$1 = ISODefaults$1.ISO_FIRST_DAY_OF_WEEK_YEAR;

function setISOWeekNumber$2(d, num) {
  if (isNumber$8(num)) {
    // Intentionally avoiding updateDate here to prevent circular dependencies.
    var isoWeek = cloneDate$5(d), dow = getWeekday$6(d);
    moveToFirstDayOfWeekYear$1(isoWeek, ISO_FIRST_DAY_OF_WEEK$1, ISO_FIRST_DAY_OF_WEEK_YEAR$1);
    setDate$3(isoWeek, getDate$4(isoWeek) + 7 * (num - 1));
    setYear(d, getYear$6(isoWeek));
    setMonth(d, getMonth$5(isoWeek));
    setDate$3(d, getDate$4(isoWeek));
    setWeekday$6(d, dow || 7);
  }
  return d.getTime();
}

var setISOWeekNumber_1 = setISOWeekNumber$2;

var callDateSet$1 = callDateSet_1,
    setISOWeekNumber$1 = setISOWeekNumber_1;

function callDateSetWithWeek$1(d, method, value, safe) {
  if (method === 'ISOWeek') {
    setISOWeekNumber$1(d, value);
  } else {
    callDateSet$1(d, method, value, safe);
  }
}

var callDateSetWithWeek_1 = callDateSetWithWeek$1;

var coreUtilityAliases$5 = coreUtilityAliases$M;

var hasOwn$2 = coreUtilityAliases$5.hasOwn;

function getOwnKey$1(obj, key) {
  if (hasOwn$2(obj, key)) {
    return key;
  }
}

var getOwnKey_1 = getOwnKey$1;

var getOwnKey = getOwnKey_1;

function getDateParamKey$2(params, key) {
  return getOwnKey(params, key) ||
         getOwnKey(params, key + 's') ||
         (key === 'day' && getOwnKey(params, 'date'));
}

var getDateParamKey_1 = getDateParamKey$2;

var getDateParamKey$1 = getDateParamKey_1,
    coreUtilityAliases$4 = coreUtilityAliases$M;

var getOwn$3 = coreUtilityAliases$4.getOwn;

function getDateParam$1(params, key) {
  return getOwn$3(params, getDateParamKey$1(params, key));
}

var getDateParam_1 = getDateParam$1;

var DateUnitIndexes$c = DateUnitIndexes$i,
    isDefined$5 = isDefined_1,
    getDateParam = getDateParam_1,
    iterateOverDateUnits = iterateOverDateUnits_1;

var DAY_INDEX$7 = DateUnitIndexes$c.DAY_INDEX;

function iterateOverDateParams$4(params, fn, startIndex, endIndex) {

  function run(name, unit, i) {
    var val = getDateParam(params, name);
    if (isDefined$5(val)) {
      fn(name, val, unit, i);
    }
  }

  iterateOverDateUnits(function (unit, i) {
    var result = run(unit.name, unit, i);
    if (result !== false && i === DAY_INDEX$7) {
      // Check for "weekday", which has a distinct meaning
      // in the context of setting a date, but has the same
      // meaning as "day" as a unit of time.
      result = run('weekday', unit, i);
    }
    return result;
  }, startIndex, endIndex);

}

var iterateOverDateParams_1 = iterateOverDateParams$4;

var DateUnits$4 = DateUnits_1,
    DateUnitIndexes$b = DateUnitIndexes$i,
    trunc$6 = trunc_1,
    setDate$2 = setDate_1,
    getDate$3 = getDate_1,
    getMonth$4 = getMonth_1,
    getNewDate$4 = getNewDate_1,
    setWeekday$5 = setWeekday_1,
    mathAliases$c = mathAliases$z,
    callDateGet$3 = callDateGet_1,
    classChecks$f = classChecks$Z,
    resetLowerUnits = resetLowerUnits_1,
    getLowerUnitIndex$2 = getLowerUnitIndex_1,
    getHigherUnitIndex = getHigherUnitIndex_1,
    callDateSetWithWeek = callDateSetWithWeek_1,
    iterateOverDateParams$3 = iterateOverDateParams_1;

var DAY_INDEX$6 = DateUnitIndexes$b.DAY_INDEX,
    WEEK_INDEX$3 = DateUnitIndexes$b.WEEK_INDEX,
    MONTH_INDEX$3 = DateUnitIndexes$b.MONTH_INDEX,
    YEAR_INDEX$3 = DateUnitIndexes$b.YEAR_INDEX,
    round$2 = mathAliases$c.round,
    isNumber$7 = classChecks$f.isNumber;

function updateDate$4(d, params, reset, advance, prefer, weekdayDir, contextDate) {
  var upperUnitIndex;

  function setUpperUnit(unitName, unitIndex) {
    if (prefer && !upperUnitIndex) {
      if (unitName === 'weekday') {
        upperUnitIndex = WEEK_INDEX$3;
      } else {
        upperUnitIndex = getHigherUnitIndex(unitIndex);
      }
    }
  }

  function setSpecificity(unitIndex) {
    // Other functions may preemptively set the specificity before arriving
    // here so concede to them if they have already set more specific units.
    if (unitIndex > params.specificity) {
      return;
    }
    params.specificity = unitIndex;
  }

  function canDisambiguate() {
    if (!upperUnitIndex || upperUnitIndex > YEAR_INDEX$3) {
      return;
    }

    switch(prefer) {
      case -1: return d >= (contextDate || getNewDate$4());
      case  1: return d <= (contextDate || getNewDate$4());
    }
  }

  function disambiguateHigherUnit() {
    var unit = DateUnits$4[upperUnitIndex];
    advance = prefer;
    setUnit(unit.name, 1, unit, upperUnitIndex);
  }

  function handleFraction(unit, unitIndex, fraction) {
    if (unitIndex) {
      var lowerUnit = DateUnits$4[getLowerUnitIndex$2(unitIndex)];
      var val = round$2(unit.multiplier / lowerUnit.multiplier * fraction);
      params[lowerUnit.name] = val;
    }
  }

  function monthHasShifted(d, targetMonth) {
    if (targetMonth < 0) {
      targetMonth = targetMonth % 12 + 12;
    }
    return targetMonth % 12 !== getMonth$4(d);
  }

  function setUnit(unitName, value, unit, unitIndex) {
    var method = unit.method, checkMonth, fraction;

    setUpperUnit(unitName, unitIndex);
    setSpecificity(unitIndex);

    fraction = value % 1;
    if (fraction) {
      handleFraction(unit, unitIndex, fraction);
      value = trunc$6(value);
    }

    if (unitName === 'weekday') {
      if (!advance) {
        // Weekdays are always considered absolute units so simply set them
        // here even if it is an "advance" operation. This is to help avoid
        // ambiguous meanings in "advance" as well as to neatly allow formats
        // like "Wednesday of next week" without more complex logic.
        setWeekday$5(d, value, weekdayDir);
      }
      return;
    }
    checkMonth = unitIndex === MONTH_INDEX$3 && getDate$3(d) > 28;

    // If we are advancing or rewinding, then we need we need to set the
    // absolute time if the unit is "hours" or less. This is due to the fact
    // that setting by method is ambiguous during DST shifts. For example,
    // 1:00am on November 1st 2015 occurs twice in North American timezones
    // with DST, the second time being after the clocks are rolled back at
    // 2:00am. When springing forward this is automatically handled as there
    // is no 2:00am so the date automatically jumps to 3:00am. However, when
    // rolling back, setHours(2) will always choose the first "2am" even if
    // the date is currently set to the second, causing unintended jumps.
    // This ambiguity is unavoidable when setting dates as the notation is
    // ambiguous. However when advancing, we clearly want the resulting date
    // to be an acutal hour ahead, which can only be accomplished by setting
    // the absolute time. Conversely, any unit higher than "hours" MUST use
    // the internal set methods, as they are ambiguous as absolute units of
    // time. Years may be 365 or 366 days depending on leap years, months are
    // all over the place, and even days may be 23-25 hours depending on DST
    // shifts. Finally, note that the kind of jumping described above will
    // occur when calling ANY "set" method on the date and will occur even if
    // the value being set is identical to the one currently set (i.e.
    // setHours(2) on a date at 2am may not be a noop). This is precarious,
    // so avoiding this situation in callDateSet by checking up front that
    // the value is not the same before setting.
    if (advance && !unit.ambiguous) {
      d.setTime(d.getTime() + (value * advance * unit.multiplier));
      return;
    } else if (advance) {
      if (unitIndex === WEEK_INDEX$3) {
        value *= 7;
        method = DateUnits$4[DAY_INDEX$6].method;
      }
      value = (value * advance) + callDateGet$3(d, method);
    }
    callDateSetWithWeek(d, method, value, advance);
    if (checkMonth && monthHasShifted(d, value)) {
      // As we are setting the units in reverse order, there is a chance that
      // our date may accidentally traverse into a new month, such as setting
      // { month: 1, date 15 } on January 31st. Check for this here and reset
      // the date to the last day of the previous month if this has happened.
      setDate$2(d, 0);
    }
  }

  if (isNumber$7(params) && advance) {
    // If param is a number and advancing, the number is in milliseconds.
    params = { millisecond: params };
  } else if (isNumber$7(params)) {
    // Otherwise just set the timestamp and return.
    d.setTime(params);
    return d;
  }

  iterateOverDateParams$3(params, setUnit);

  if (reset && params.specificity) {
    resetLowerUnits(d, params.specificity);
  }

  // If past or future is preferred, then the process of "disambiguation" will
  // ensure that an ambiguous time/date ("4pm", "thursday", "June", etc.) will
  // be in the past or future. Weeks are only considered ambiguous if there is
  // a weekday, i.e. "thursday" is an ambiguous week, but "the 4th" is an
  // ambiguous month.
  if (canDisambiguate()) {
    disambiguateHigherUnit();
  }
  return d;
}

var updateDate_1 = updateDate$4;

var updateDate$3 = updateDate_1;

function advanceDate$5(d, unit, num, reset) {
  var set = {};
  set[unit] = num;
  return updateDate$3(d, set, reset, 1);
}

var advanceDate_1 = advanceDate$5;

function dateIsValid$5(d) {
  return !isNaN(d.getTime());
}

var dateIsValid_1 = dateIsValid$5;

var setWeekday$4 = setWeekday_1,
    getWeekday$5 = getWeekday_1,
    mathAliases$b = mathAliases$z;

var ceil$2 = mathAliases$b.ceil;

function moveToEndOfWeek$2(d, firstDayOfWeek) {
  var target = firstDayOfWeek - 1;
  setWeekday$4(d, ceil$2((getWeekday$5(d) - target) / 7) * 7 + target);
  return d;
}

var moveToEndOfWeek_1 = moveToEndOfWeek$2;

var LocaleHelpers$f = LocaleHelpers$h,
    DateUnitIndexes$a = DateUnitIndexes$i,
    moveToEndOfWeek$1 = moveToEndOfWeek_1,
    getLowerUnitIndex$1 = getLowerUnitIndex_1,
    setUnitAndLowerToEdge$2 = setUnitAndLowerToEdge_1;

var WEEK_INDEX$2 = DateUnitIndexes$a.WEEK_INDEX,
    localeManager$d = LocaleHelpers$f.localeManager;

function moveToEndOfUnit$4(d, unitIndex, localeCode, stopIndex) {
  if (unitIndex === WEEK_INDEX$2) {
    moveToEndOfWeek$1(d, localeManager$d.get(localeCode).getFirstDayOfWeek());
  }
  return setUnitAndLowerToEdge$2(d, getLowerUnitIndex$1(unitIndex), stopIndex, true);
}

var moveToEndOfUnit_1 = moveToEndOfUnit$4;

var getDateParamKey = getDateParamKey_1;

function deleteDateParam$1(params, key) {
  delete params[getDateParamKey(params, key)];
}

var deleteDateParam_1 = deleteDateParam$1;

var LocaleHelpers$e = LocaleHelpers$h,
    DateUnitIndexes$9 = DateUnitIndexes$i,
    getLowerUnitIndex = getLowerUnitIndex_1,
    moveToBeginningOfWeek$1 = moveToBeginningOfWeek_1,
    setUnitAndLowerToEdge$1 = setUnitAndLowerToEdge_1;

var WEEK_INDEX$1 = DateUnitIndexes$9.WEEK_INDEX,
    localeManager$c = LocaleHelpers$e.localeManager;

function moveToBeginningOfUnit$4(d, unitIndex, localeCode) {
  if (unitIndex === WEEK_INDEX$1) {
    moveToBeginningOfWeek$1(d, localeManager$c.get(localeCode).getFirstDayOfWeek());
  }
  return setUnitAndLowerToEdge$1(d, getLowerUnitIndex(unitIndex));
}

var moveToBeginningOfUnit_1 = moveToBeginningOfUnit$4;

var getYear$5 = getYear_1,
    mathAliases$a = mathAliases$z;

var abs$3 = mathAliases$a.abs;

function getYearFromAbbreviation$1(str, d, prefer) {
  // Following IETF here, adding 1900 or 2000 depending on the last two digits.
  // Note that this makes no accordance for what should happen after 2050, but
  // intentionally ignoring this for now. https://www.ietf.org/rfc/rfc2822.txt
  var val = +str, delta;
  val += val < 50 ? 2000 : 1900;
  if (prefer) {
    delta = val - getYear$5(d);
    if (delta / abs$3(delta) !== prefer) {
      val += prefer * 100;
    }
  }
  return val;
}

var getYearFromAbbreviation_1 = getYearFromAbbreviation$1;

var DateUnitIndexes$8 = DateUnitIndexes$i,
    iterateOverDateParams$2 = iterateOverDateParams_1;

var DAY_INDEX$5 = DateUnitIndexes$8.DAY_INDEX,
    YEAR_INDEX$2 = DateUnitIndexes$8.YEAR_INDEX;

function iterateOverHigherDateParams$1(params, fn) {
  iterateOverDateParams$2(params, fn, YEAR_INDEX$2, DAY_INDEX$5);
}

var iterateOverHigherDateParams_1 = iterateOverHigherDateParams$1;

var MINUTES$1 = MINUTES$2,
    ABBREVIATED_YEAR_REG = ABBREVIATED_YEAR_REG$1,
    LocaleHelpers$d = LocaleHelpers$h,
    DateUnitIndexes$7 = DateUnitIndexes$i,
    _utc$4 = _utc$8,
    trunc$5 = trunc_1,
    forEach$3 = forEach_1,
    tzOffset$3 = tzOffset_1,
    isDefined$4 = isDefined_1,
    resetTime$1 = resetTime_1,
    getNewDate$3 = getNewDate_1,
    updateDate$2 = updateDate_1,
    setWeekday$3 = setWeekday_1,
    simpleMerge = simpleMerge_1,
    advanceDate$4 = advanceDate_1,
    isUndefined$2 = isUndefined_1,
    classChecks$e = classChecks$Z,
    dateIsValid$4 = dateIsValid_1,
    simpleClone$1 = simpleClone_1,
    isObjectType$2 = isObjectType_1,
    moveToEndOfUnit$3 = moveToEndOfUnit_1,
    deleteDateParam = deleteDateParam_1,
    coreUtilityAliases$3 = coreUtilityAliases$M,
    moveToBeginningOfUnit$3 = moveToBeginningOfUnit_1,
    iterateOverDateParams$1 = iterateOverDateParams_1,
    getYearFromAbbreviation = getYearFromAbbreviation_1,
    iterateOverHigherDateParams = iterateOverHigherDateParams_1;

var isNumber$6 = classChecks$e.isNumber,
    isString$6 = classChecks$e.isString,
    isDate$4 = classChecks$e.isDate,
    getOwn$2 = coreUtilityAliases$3.getOwn,
    English$2 = LocaleHelpers$d.English,
    localeManager$b = LocaleHelpers$d.localeManager,
    DAY_INDEX$4 = DateUnitIndexes$7.DAY_INDEX,
    WEEK_INDEX = DateUnitIndexes$7.WEEK_INDEX,
    MONTH_INDEX$2 = DateUnitIndexes$7.MONTH_INDEX,
    YEAR_INDEX$1 = DateUnitIndexes$7.YEAR_INDEX;

function getExtendedDate$3(contextDate, d, opt, forceClone) {

  // Locals
  var date, set, loc, afterCallbacks, relative, weekdayDir;

  // Options
  var optPrefer, optLocale, optFromUTC, optSetUTC, optParams, optClone;

  afterCallbacks = [];

  setupOptions(opt);

  function setupOptions(opt) {
    opt = isString$6(opt) ? { locale: opt } : opt || {};
    optPrefer  = +!!getOwn$2(opt, 'future') - +!!getOwn$2(opt, 'past');
    optLocale  = getOwn$2(opt, 'locale');
    optFromUTC = getOwn$2(opt, 'fromUTC');
    optSetUTC  = getOwn$2(opt, 'setUTC');
    optParams  = getOwn$2(opt, 'params');
    optClone   = getOwn$2(opt, 'clone');
  }

  function parseFormatValues(match, dif) {
    var set = optParams || {};
    forEach$3(dif.to, function(param, i) {
      var str = match[i + 1], val;
      if (!str) return;

      val = parseIrregular(str, param);

      if (isUndefined$2(val)) {
        val = loc.parseValue(str, param);
      }

      set[param] = val;
    });
    return set;
  }

  function parseIrregular(str, param) {
    if (param === 'utc') {
      return 1;
    } else if (param === 'year') {
      var match = str.match(ABBREVIATED_YEAR_REG);
      if (match) {
        return getYearFromAbbreviation(match[1], date, optPrefer);
      }
    }
  }

  // Force the UTC flags to be true if the source date
  // date is UTC, as they will be overwritten later.
  function cloneDateByFlag(d, clone) {
    if (_utc$4(d) && !isDefined$4(optFromUTC)) {
      optFromUTC = true;
    }
    if (_utc$4(d) && !isDefined$4(optSetUTC)) {
      optSetUTC = true;
    }
    if (clone) {
      d = new Date(d.getTime());
    }
    return d;
  }

  function afterDateSet(fn) {
    afterCallbacks.push(fn);
  }

  function fireCallbacks() {
    forEach$3(afterCallbacks, function(fn) {
      fn.call();
    });
  }

  function parseStringDate(str) {

    str = str.toLowerCase();

    // The act of getting the locale will initialize
    // if it is missing and add the required formats.
    loc = localeManager$b.get(optLocale);

    for (var i = 0, dif, match; dif = loc.compiledFormats[i]; i++) {
      match = str.match(dif.reg);
      if (match) {

        // Note that caching the format will modify the compiledFormats array
        // which is not a good idea to do inside its for loop, however we
        // know at this point that we have a matched format and that we will
        // break out below, so simpler to do it here.
        loc.cacheFormat(dif, i);

        set = parseFormatValues(match, dif);

        if (isDefined$4(set.timestamp)) {
          date.setTime(set.timestamp);
          break;
        }

        if (isDefined$4(set.ampm)) {
          handleAmpm(set.ampm);
        }

        if (set.utc || isDefined$4(set.tzHour)) {
          handleTimezoneOffset(set.tzHour, set.tzMinute);
        }

        if (isDefined$4(set.shift) && isUndefined$2(set.unit)) {
          // "next january", "next monday", etc
          handleUnitlessShift();
        }

        if (isDefined$4(set.num) && isUndefined$2(set.unit)) {
          // "the second of January", etc
          handleUnitlessNum(set.num);
        }

        if (set.midday) {
          // "noon" and "midnight"
          handleMidday(set.midday);
        }

        if (isDefined$4(set.day)) {
          // Relative day localizations such as "today" and "tomorrow".
          handleRelativeDay(set.day);
        }

        if (isDefined$4(set.unit)) {
          // "3 days ago", etc
          handleRelativeUnit(set.unit);
        }

        if (set.edge) {
          // "the end of January", etc
          handleEdge(set.edge, set);
        }

        break;
      }
    }

    if (!set) {
      // TODO: remove in next major version
      // Fall back to native parsing
      date = new Date(str);
      if (optFromUTC && dateIsValid$4(date)) {
        // Falling back to system date here which cannot be parsed as UTC,
        // so if we're forcing UTC then simply add the offset.
        date.setTime(date.getTime() + (tzOffset$3(date) * MINUTES$1));
      }
    } else if (relative) {
      updateDate$2(date, set, false, 1);
    } else {
      updateDate$2(date, set, true, 0, optPrefer, weekdayDir, contextDate);
    }
    fireCallbacks();
    return date;
  }

  function handleAmpm(ampm) {
    if (ampm === 1 && set.hour < 12) {
      // If the time is 1pm-11pm advance the time by 12 hours.
      set.hour += 12;
    } else if (ampm === 0 && set.hour === 12) {
      // If it is 12:00am then set the hour to 0.
      set.hour = 0;
    }
  }

  function handleTimezoneOffset(tzHour, tzMinute) {
    // Adjust for timezone offset
    _utc$4(date, true);

    // Sign is parsed as part of the hour, so flip
    // the minutes if it's negative.

    if (tzHour < 0) {
      tzMinute *= -1;
    }

    var offset = tzHour * 60 + (tzMinute || 0);
    if (offset) {
      set.minute = (set.minute || 0) - offset;
    }
  }

  function handleUnitlessShift() {
    if (isDefined$4(set.month)) {
      // "next January"
      set.unit = YEAR_INDEX$1;
    } else if (isDefined$4(set.weekday)) {
      // "next Monday"
      set.unit = WEEK_INDEX;
    }
  }

  function handleUnitlessNum(num) {
    if (isDefined$4(set.weekday)) {
      // "The second Tuesday of March"
      setOrdinalWeekday(num);
    } else if (isDefined$4(set.month)) {
      // "The second of March"
      set.date = set.num;
    }
  }

  function handleMidday(hour) {
    set.hour = hour % 24;
    if (hour > 23) {
      // If the date has hours past 24, we need to prevent it from traversing
      // into a new day as that would make it being part of a new week in
      // ambiguous dates such as "Monday".
      afterDateSet(function() {
        advanceDate$4(date, 'date', trunc$5(hour / 24));
      });
    }
  }

  function handleRelativeDay() {
    resetTime$1(date);
    if (isUndefined$2(set.unit)) {
      set.unit = DAY_INDEX$4;
      set.num  = set.day;
      delete set.day;
    }
  }

  function handleRelativeUnit(unitIndex) {
    var num;

    if (isDefined$4(set.num)) {
      num = set.num;
    } else if (isDefined$4(set.edge) && isUndefined$2(set.shift)) {
      num = 0;
    } else {
      num = 1;
    }

    // If a weekday is defined, there are 3 possible formats being applied:
    //
    // 1. "the day after monday": unit is days
    // 2. "next monday": short for "next week monday", unit is weeks
    // 3. "the 2nd monday of next month": unit is months
    //
    // In the first case, we need to set the weekday up front, as the day is
    // relative to it. The second case also needs to be handled up front for
    // formats like "next monday at midnight" which will have its weekday reset
    // if not set up front. The last case will set up the params necessary to
    // shift the weekday and allow separateAbsoluteUnits below to handle setting
    // it after the date has been shifted.
    if(isDefined$4(set.weekday)) {
      if(unitIndex === MONTH_INDEX$2) {
        setOrdinalWeekday(num);
        num = 1;
      } else {
        updateDate$2(date, { weekday: set.weekday }, true);
        delete set.weekday;
      }
    }

    if (set.half) {
      // Allow localized "half" as a standalone colloquialism. Purposely avoiding
      // the locale number system to reduce complexity. The units "month" and
      // "week" are purposely excluded in the English date formats below, as
      // "half a week" and "half a month" are meaningless as exact dates.
      num *= set.half;
    }

    if (isDefined$4(set.shift)) {
      // Shift and unit, ie "next month", "last week", etc.
      num *= set.shift;
    } else if (set.sign) {
      // Unit and sign, ie "months ago", "weeks from now", etc.
      num *= set.sign;
    }

    if (isDefined$4(set.day)) {
      // "the day after tomorrow"
      num += set.day;
      delete set.day;
    }

    // Formats like "the 15th of last month" or "6:30pm of next week"
    // contain absolute units in addition to relative ones, so separate
    // them here, remove them from the params, and set up a callback to
    // set them after the relative ones have been set.
    separateAbsoluteUnits(unitIndex);

    // Finally shift the unit.
    set[English$2.units[unitIndex]] = num;
    relative = true;
  }

  function handleEdge(edge, params) {
    var edgeIndex = params.unit, weekdayOfMonth;
    if (!edgeIndex) {
      // If we have "the end of January", then we need to find the unit index.
      iterateOverHigherDateParams(params, function(unitName, val, unit, i) {
        if (unitName === 'weekday' && isDefined$4(params.month)) {
          // If both a month and weekday exist, then we have a format like
          // "the last tuesday in November, 2012", where the "last" is still
          // relative to the end of the month, so prevent the unit "weekday"
          // from taking over.
          return;
        }
        edgeIndex = i;
      });
    }
    if (edgeIndex === MONTH_INDEX$2 && isDefined$4(params.weekday)) {
      // If a weekday in a month exists (as described above),
      // then set it up to be set after the date has been shifted.
      weekdayOfMonth = params.weekday;
      delete params.weekday;
    }
    afterDateSet(function() {
      var stopIndex;
      // "edge" values that are at the very edge are "2" so the beginning of the
      // year is -2 and the end of the year is 2. Conversely, the "last day" is
      // actually 00:00am so it is 1. -1 is reserved but unused for now.
      if (edge < 0) {
        moveToBeginningOfUnit$3(date, edgeIndex, optLocale);
      } else if (edge > 0) {
        if (edge === 1) {
          stopIndex = DAY_INDEX$4;
          moveToBeginningOfUnit$3(date, DAY_INDEX$4);
        }
        moveToEndOfUnit$3(date, edgeIndex, optLocale, stopIndex);
      }
      if (isDefined$4(weekdayOfMonth)) {
        setWeekday$3(date, weekdayOfMonth, -edge);
        resetTime$1(date);
      }
    });
    if (edgeIndex === MONTH_INDEX$2) {
      params.specificity = DAY_INDEX$4;
    } else {
      params.specificity = edgeIndex - 1;
    }
  }

  function setOrdinalWeekday(num) {
    // If we have "the 2nd Tuesday of June", then pass the "weekdayDir"
    // flag along to updateDate so that the date does not accidentally traverse
    // into the previous month. This needs to be independent of the "prefer"
    // flag because we are only ensuring that the weekday is in the future, not
    // the entire date.
    set.weekday = 7 * (num - 1) + set.weekday;
    set.date = 1;
    weekdayDir = 1;
  }

  function separateAbsoluteUnits(unitIndex) {
    var params;

    iterateOverDateParams$1(set, function(name, val, unit, i) {
      // If there is a time unit set that is more specific than
      // the matched unit we have a string like "5:30am in 2 minutes",
      // which is meaningless, so invalidate the date...
      if (i >= unitIndex) {
        date.setTime(NaN);
        return false;
      } else if (i < unitIndex) {
        // ...otherwise set the params to set the absolute date
        // as a callback after the relative date has been set.
        params = params || {};
        params[name] = val;
        deleteDateParam(set, name);
      }
    });
    if (params) {
      afterDateSet(function() {
        updateDate$2(date, params, true, 0, false, weekdayDir);
        if (optParams) {
          simpleMerge(optParams, params);
        }
      });
      if (set.edge) {
        // "the end of March of next year"
        handleEdge(set.edge, params);
        delete set.edge;
      }
    }
  }

  if (contextDate && d) {
    // If a context date is passed ("get" and "unitsFromNow"),
    // then use it as the starting point.
    date = cloneDateByFlag(contextDate, true);
  } else {
    date = getNewDate$3();
  }

  _utc$4(date, optFromUTC);

  if (isString$6(d)) {
    date = parseStringDate(d);
  } else if (isDate$4(d)) {
    date = cloneDateByFlag(d, optClone || forceClone);
  } else if (isObjectType$2(d)) {
    set = simpleClone$1(d);
    updateDate$2(date, set, true);
  } else if (isNumber$6(d) || d === null) {
    date.setTime(d);
  }
  // A date created by parsing a string presumes that the format *itself* is
  // UTC, but not that the date, once created, should be manipulated as such. In
  // other words, if you are creating a date object from a server time
  // "2012-11-15T12:00:00Z", in the majority of cases you are using it to create
  // a date that will, after creation, be manipulated as local, so reset the utc
  // flag here unless "setUTC" is also set.
  _utc$4(date, !!optSetUTC);
  return {
    set: set,
    date: date
  };
}

var getExtendedDate_1 = getExtendedDate$3;

var getExtendedDate$2 = getExtendedDate_1;

function createDate$8(d, options, forceClone) {
  return getExtendedDate$2(null, d, options, forceClone).date;
}

var createDate_1 = createDate$8;

var createDate$7 = createDate_1,
    namespaceAliases$6 = namespaceAliases$e,
    setChainableConstructor = setChainableConstructor_1;

var sugarDate$5 = namespaceAliases$6.sugarDate;

function setDateChainableConstructor$1() {
  setChainableConstructor(sugarDate$5, createDate$7);
}

var setDateChainableConstructor_1 = setDateChainableConstructor$1;

var setDateChainableConstructor = setDateChainableConstructor_1;

setDateChainableConstructor();

var Sugar$3h = sugarCore.exports,
    createDate$6 = createDate_1;



Sugar$3h.Date.defineStatic({

  'create': function(d, options) {
    return createDate$6(d, options);
  }

});

Sugar$3h.Date.create;

var Sugar$3g = sugarCore.exports,
    LocaleHelpers$c = LocaleHelpers$h,
    getKeys = getKeys_1;

var localeManager$a = LocaleHelpers$c.localeManager;

Sugar$3g.Date.defineStatic({

  'getAllLocaleCodes': function() {
    return getKeys(localeManager$a.getAll());
  }

});

Sugar$3g.Date.getAllLocaleCodes;

var Sugar$3f = sugarCore.exports,
    LocaleHelpers$b = LocaleHelpers$h;

var localeManager$9 = LocaleHelpers$b.localeManager;

Sugar$3f.Date.defineStatic({

  'getAllLocales': function() {
    return localeManager$9.getAll();
  }

});

Sugar$3f.Date.getAllLocales;

var Sugar$3e = sugarCore.exports,
    LocaleHelpers$a = LocaleHelpers$h;

var localeManager$8 = LocaleHelpers$a.localeManager;

Sugar$3e.Date.defineStatic({

  'getLocale': function(code) {
    return localeManager$8.get(code, !code);
  }

});

Sugar$3e.Date.getLocale;

var Sugar$3d = sugarCore.exports,
    LocaleHelpers$9 = LocaleHelpers$h;

var localeManager$7 = LocaleHelpers$9.localeManager;

Sugar$3d.Date.defineStatic({

  'removeLocale': function(code) {
    return localeManager$7.remove(code);
  }

});

Sugar$3d.Date.removeLocale;

var Sugar$3c = sugarCore.exports,
    LocaleHelpers$8 = LocaleHelpers$h;

var localeManager$6 = LocaleHelpers$8.localeManager;

Sugar$3c.Date.defineStatic({

  'setLocale': function(code) {
    return localeManager$6.set(code);
  }

});

Sugar$3c.Date.setLocale;

var DateUnits$3 = DateUnits_1,
    createDate$5 = createDate_1,
    mathAliases$9 = mathAliases$z,
    advanceDate$3 = advanceDate_1,
    namespaceAliases$5 = namespaceAliases$e,
    defineInstanceSimilar$3 = defineInstanceSimilar_1;

var sugarNumber = namespaceAliases$5.sugarNumber,
    round$1 = mathAliases$9.round;

function buildNumberUnitMethods$1() {
  defineInstanceSimilar$3(sugarNumber, DateUnits$3, function(methods, unit) {
    var name = unit.name, base, after, before;
    base = function(n) {
      return round$1(n * unit.multiplier);
    };
    after = function(n, d, options) {
      return advanceDate$3(createDate$5(d, options, true), name, n);
    };
    before = function(n, d, options) {
      return advanceDate$3(createDate$5(d, options, true), name, -n);
    };
    methods[name] = base;
    methods[name + 's'] = base;
    methods[name + 'Before'] = before;
    methods[name + 'sBefore'] = before;
    methods[name + 'Ago'] = before;
    methods[name + 'sAgo'] = before;
    methods[name + 'After'] = after;
    methods[name + 'sAfter'] = after;
    methods[name + 'FromNow'] = after;
    methods[name + 'sFromNow'] = after;
  });
}

var buildNumberUnitMethods_1 = buildNumberUnitMethods$1;

var buildNumberUnitMethods = buildNumberUnitMethods_1;

buildNumberUnitMethods();

var Sugar$3b = sugarCore.exports;



Sugar$3b.Number.day;

var Sugar$3a = sugarCore.exports;



Sugar$3a.Number.dayAfter;

var Sugar$39 = sugarCore.exports;



Sugar$39.Number.dayAgo;

var Sugar$38 = sugarCore.exports;



Sugar$38.Number.dayBefore;

var Sugar$37 = sugarCore.exports;



Sugar$37.Number.dayFromNow;

var Sugar$36 = sugarCore.exports;



Sugar$36.Number.days;

var Sugar$35 = sugarCore.exports;



Sugar$35.Number.daysAfter;

var Sugar$34 = sugarCore.exports;



Sugar$34.Number.daysAgo;

var Sugar$33 = sugarCore.exports;



Sugar$33.Number.daysBefore;

var Sugar$32 = sugarCore.exports;



Sugar$32.Number.daysFromNow;

var Sugar$31 = sugarCore.exports,
    LocaleHelpers$7 = LocaleHelpers$h;

var localeManager$5 = LocaleHelpers$7.localeManager;

Sugar$31.Number.defineInstance({

  'duration': function(n, localeCode) {
    return localeManager$5.get(localeCode).getDuration(n);
  }

});

Sugar$31.Number.duration;

var Sugar$30 = sugarCore.exports;



Sugar$30.Number.hour;

var Sugar$2$ = sugarCore.exports;



Sugar$2$.Number.hourAfter;

var Sugar$2_ = sugarCore.exports;



Sugar$2_.Number.hourAgo;

var Sugar$2Z = sugarCore.exports;



Sugar$2Z.Number.hourBefore;

var Sugar$2Y = sugarCore.exports;



Sugar$2Y.Number.hourFromNow;

var Sugar$2X = sugarCore.exports;



Sugar$2X.Number.hours;

var Sugar$2W = sugarCore.exports;



Sugar$2W.Number.hoursAfter;

var Sugar$2V = sugarCore.exports;



Sugar$2V.Number.hoursAgo;

var Sugar$2U = sugarCore.exports;



Sugar$2U.Number.hoursBefore;

var Sugar$2T = sugarCore.exports;



Sugar$2T.Number.hoursFromNow;

var Sugar$2S = sugarCore.exports;



Sugar$2S.Number.millisecond;

var Sugar$2R = sugarCore.exports;



Sugar$2R.Number.millisecondAfter;

var Sugar$2Q = sugarCore.exports;



Sugar$2Q.Number.millisecondAgo;

var Sugar$2P = sugarCore.exports;



Sugar$2P.Number.millisecondBefore;

var Sugar$2O = sugarCore.exports;



Sugar$2O.Number.millisecondFromNow;

var Sugar$2N = sugarCore.exports;



Sugar$2N.Number.milliseconds;

var Sugar$2M = sugarCore.exports;



Sugar$2M.Number.millisecondsAfter;

var Sugar$2L = sugarCore.exports;



Sugar$2L.Number.millisecondsAgo;

var Sugar$2K = sugarCore.exports;



Sugar$2K.Number.millisecondsBefore;

var Sugar$2J = sugarCore.exports;



Sugar$2J.Number.millisecondsFromNow;

var Sugar$2I = sugarCore.exports;



Sugar$2I.Number.minute;

var Sugar$2H = sugarCore.exports;



Sugar$2H.Number.minuteAfter;

var Sugar$2G = sugarCore.exports;



Sugar$2G.Number.minuteAgo;

var Sugar$2F = sugarCore.exports;



Sugar$2F.Number.minuteBefore;

var Sugar$2E = sugarCore.exports;



Sugar$2E.Number.minuteFromNow;

var Sugar$2D = sugarCore.exports;



Sugar$2D.Number.minutes;

var Sugar$2C = sugarCore.exports;



Sugar$2C.Number.minutesAfter;

var Sugar$2B = sugarCore.exports;



Sugar$2B.Number.minutesAgo;

var Sugar$2A = sugarCore.exports;



Sugar$2A.Number.minutesBefore;

var Sugar$2z = sugarCore.exports;



Sugar$2z.Number.minutesFromNow;

var Sugar$2y = sugarCore.exports;



Sugar$2y.Number.month;

var Sugar$2x = sugarCore.exports;



Sugar$2x.Number.monthAfter;

var Sugar$2w = sugarCore.exports;



Sugar$2w.Number.monthAgo;

var Sugar$2v = sugarCore.exports;



Sugar$2v.Number.monthBefore;

var Sugar$2u = sugarCore.exports;



Sugar$2u.Number.monthFromNow;

var Sugar$2t = sugarCore.exports;



Sugar$2t.Number.months;

var Sugar$2s = sugarCore.exports;



Sugar$2s.Number.monthsAfter;

var Sugar$2r = sugarCore.exports;



Sugar$2r.Number.monthsAgo;

var Sugar$2q = sugarCore.exports;



Sugar$2q.Number.monthsBefore;

var Sugar$2p = sugarCore.exports;



Sugar$2p.Number.monthsFromNow;

var Sugar$2o = sugarCore.exports;



Sugar$2o.Number.second;

var Sugar$2n = sugarCore.exports;



Sugar$2n.Number.secondAfter;

var Sugar$2m = sugarCore.exports;



Sugar$2m.Number.secondAgo;

var Sugar$2l = sugarCore.exports;



Sugar$2l.Number.secondBefore;

var Sugar$2k = sugarCore.exports;



Sugar$2k.Number.secondFromNow;

var Sugar$2j = sugarCore.exports;



Sugar$2j.Number.seconds;

var Sugar$2i = sugarCore.exports;



Sugar$2i.Number.secondsAfter;

var Sugar$2h = sugarCore.exports;



Sugar$2h.Number.secondsAgo;

var Sugar$2g = sugarCore.exports;



Sugar$2g.Number.secondsBefore;

var Sugar$2f = sugarCore.exports;



Sugar$2f.Number.secondsFromNow;

var Sugar$2e = sugarCore.exports;



Sugar$2e.Number.week;

var Sugar$2d = sugarCore.exports;



Sugar$2d.Number.weekAfter;

var Sugar$2c = sugarCore.exports;



Sugar$2c.Number.weekAgo;

var Sugar$2b = sugarCore.exports;



Sugar$2b.Number.weekBefore;

var Sugar$2a = sugarCore.exports;



Sugar$2a.Number.weekFromNow;

var Sugar$29 = sugarCore.exports;



Sugar$29.Number.weeks;

var Sugar$28 = sugarCore.exports;



Sugar$28.Number.weeksAfter;

var Sugar$27 = sugarCore.exports;



Sugar$27.Number.weeksAgo;

var Sugar$26 = sugarCore.exports;



Sugar$26.Number.weeksBefore;

var Sugar$25 = sugarCore.exports;



Sugar$25.Number.weeksFromNow;

var Sugar$24 = sugarCore.exports;



Sugar$24.Number.year;

var Sugar$23 = sugarCore.exports;



Sugar$23.Number.yearAfter;

var Sugar$22 = sugarCore.exports;



Sugar$22.Number.yearAgo;

var Sugar$21 = sugarCore.exports;



Sugar$21.Number.yearBefore;

var Sugar$20 = sugarCore.exports;



Sugar$20.Number.yearFromNow;

var Sugar$1$ = sugarCore.exports;



Sugar$1$.Number.years;

var Sugar$1_ = sugarCore.exports;



Sugar$1_.Number.yearsAfter;

var Sugar$1Z = sugarCore.exports;



Sugar$1Z.Number.yearsAgo;

var Sugar$1Y = sugarCore.exports;



Sugar$1Y.Number.yearsBefore;

var Sugar$1X = sugarCore.exports;



Sugar$1X.Number.yearsFromNow;

var MINUTES = MINUTES$2,
    DateUnits$2 = DateUnits_1,
    DateUnitIndexes$6 = DateUnitIndexes$i,
    _utc$3 = _utc$8,
    tzOffset$2 = tzOffset_1,
    cloneDate$4 = cloneDate_1,
    isDefined$3 = isDefined_1,
    advanceDate$2 = advanceDate_1,
    dateIsValid$3 = dateIsValid_1,
    moveToEndOfUnit$2 = moveToEndOfUnit_1,
    getExtendedDate$1 = getExtendedDate_1,
    moveToBeginningOfUnit$2 = moveToBeginningOfUnit_1;

var MONTH_INDEX$1 = DateUnitIndexes$6.MONTH_INDEX;

function compareDate$2(date, d, margin, localeCode, options) {
  var loMargin = 0, hiMargin = 0, timezoneShift, compareEdges, override, min, max, p, t;

  function getTimezoneShift() {
    // If there is any specificity in the date then we're implicitly not
    // checking absolute time, so ignore timezone shifts.
    if (p.set && p.set.specificity) {
      return 0;
    }
    return (tzOffset$2(p.date) - tzOffset$2(date)) * MINUTES;
  }

  function addSpecificUnit() {
    var unit = DateUnits$2[p.set.specificity];
    return advanceDate$2(cloneDate$4(p.date), unit.name, 1).getTime() - 1;
  }

  if (_utc$3(date)) {
    options = options || {};
    options.fromUTC = true;
    options.setUTC = true;
  }

  p = getExtendedDate$1(null, d, options, true);

  if (margin > 0) {
    loMargin = hiMargin = margin;
    override = true;
  }
  if (!dateIsValid$3(p.date)) return false;
  if (p.set && p.set.specificity) {
    if (isDefined$3(p.set.edge) || isDefined$3(p.set.shift)) {
      compareEdges = true;
      moveToBeginningOfUnit$2(p.date, p.set.specificity, localeCode);
    }
    if (compareEdges || p.set.specificity === MONTH_INDEX$1) {
      max = moveToEndOfUnit$2(cloneDate$4(p.date), p.set.specificity, localeCode).getTime();
    } else {
      max = addSpecificUnit();
    }
    if (!override && isDefined$3(p.set.sign) && p.set.specificity) {
      // If the time is relative, there can occasionally be an disparity between
      // the relative date and "now", which it is being compared to, so set an
      // extra margin to account for this.
      loMargin = 50;
      hiMargin = -50;
    }
  }
  t   = date.getTime();
  min = p.date.getTime();
  max = max || min;
  timezoneShift = getTimezoneShift();
  // istanbul ignore if
  if (timezoneShift) {
    min -= timezoneShift;
    max -= timezoneShift;
  }
  return t >= (min - loMargin) && t <= (max + hiMargin);
}

var compareDate_1 = compareDate$2;

var trunc$4 = trunc_1,
    cloneDate$3 = cloneDate_1,
    advanceDate$1 = advanceDate_1;

function getTimeDistanceForUnit$3(d1, d2, unit) {
  var fwd = d2 > d1, num, tmp;
  if (!fwd) {
    tmp = d2;
    d2  = d1;
    d1  = tmp;
  }
  num = d2 - d1;
  if (unit.multiplier > 1) {
    num = trunc$4(num / unit.multiplier);
  }
  // For higher order with potential ambiguity, use the numeric calculation
  // as a starting point, then iterate until we pass the target date. Decrement
  // starting point by 1 to prevent overshooting the date due to inconsistencies
  // in ambiguous units numerically. For example, calculating the number of days
  // from the beginning of the year to August 5th at 11:59:59 by doing a simple
  // d2 - d1 will produce different results depending on whether or not a
  // timezone shift was encountered due to DST, however that should not have an
  // effect on our calculation here, so subtract by 1 to ensure that the
  // starting point has not already overshot our target date.
  if (unit.ambiguous) {
    d1 = cloneDate$3(d1);
    if (num) {
      num -= 1;
      advanceDate$1(d1, unit.name, num);
    }
    while (d1 < d2) {
      advanceDate$1(d1, unit.name, 1);
      if (d1 > d2) {
        break;
      }
      num += 1;
    }
  }
  return fwd ? -num : num;
}

var getTimeDistanceForUnit_1 = getTimeDistanceForUnit$3;

var DateUnits$1 = DateUnits_1,
    DateUnitIndexes$5 = DateUnitIndexes$i,
    forEach$2 = forEach_1,
    createDate$4 = createDate_1,
    compareDate$1 = compareDate_1,
    advanceDate = advanceDate_1,
    moveToEndOfUnit$1 = moveToEndOfUnit_1,
    namespaceAliases$4 = namespaceAliases$e,
    simpleCapitalize$2 = simpleCapitalize_1,
    moveToBeginningOfUnit$1 = moveToBeginningOfUnit_1,
    defineInstanceSimilar$2 = defineInstanceSimilar_1,
    getTimeDistanceForUnit$2 = getTimeDistanceForUnit_1;

var sugarDate$4 = namespaceAliases$4.sugarDate,
    HOURS_INDEX = DateUnitIndexes$5.HOURS_INDEX,
    DAY_INDEX$3 = DateUnitIndexes$5.DAY_INDEX;

function buildDateUnitMethods$1() {

  defineInstanceSimilar$2(sugarDate$4, DateUnits$1, function(methods, unit, index) {
    var name = unit.name, caps = simpleCapitalize$2(name);

    if (index > DAY_INDEX$3) {
      forEach$2(['Last','This','Next'], function(shift) {
        methods['is' + shift + caps] = function(d, localeCode) {
          return compareDate$1(d, shift + ' ' + name, 0, localeCode, { locale: 'en' });
        };
      });
    }
    if (index > HOURS_INDEX) {
      methods['beginningOf' + caps] = function(d, localeCode) {
        return moveToBeginningOfUnit$1(d, index, localeCode);
      };
      methods['endOf' + caps] = function(d, localeCode) {
        return moveToEndOfUnit$1(d, index, localeCode);
      };
    }

    methods['add' + caps + 's'] = function(d, num, reset) {
      return advanceDate(d, name, num, reset);
    };

    var since = function(date, d, options) {
      return getTimeDistanceForUnit$2(date, createDate$4(d, options, true), unit);
    };
    var until = function(date, d, options) {
      return getTimeDistanceForUnit$2(createDate$4(d, options, true), date, unit);
    };

    methods[name + 'sAgo']   = methods[name + 'sUntil']   = until;
    methods[name + 'sSince'] = methods[name + 'sFromNow'] = since;

  });

}

var buildDateUnitMethods_1 = buildDateUnitMethods$1;

var buildDateUnitMethods = buildDateUnitMethods_1;

buildDateUnitMethods();

var Sugar$1W = sugarCore.exports;



Sugar$1W.Date.addDays;

var Sugar$1V = sugarCore.exports;



Sugar$1V.Date.addHours;

var Sugar$1U = sugarCore.exports;



Sugar$1U.Date.addMilliseconds;

var Sugar$1T = sugarCore.exports;



Sugar$1T.Date.addMinutes;

var Sugar$1S = sugarCore.exports;



Sugar$1S.Date.addMonths;

var Sugar$1R = sugarCore.exports;



Sugar$1R.Date.addSeconds;

var Sugar$1Q = sugarCore.exports;



Sugar$1Q.Date.addWeeks;

var Sugar$1P = sugarCore.exports;



Sugar$1P.Date.addYears;

var isUndefined$1 = isUndefined_1;

function getDateParamsFromString$1(str) {
  var match, num, params = {};
  match = str.match(/^(-?\d*[\d.]\d*)?\s?(\w+?)s?$/i);
  if (match) {
    if (isUndefined$1(num)) {
      num = match[1] ? +match[1] : 1;
    }
    params[match[2].toLowerCase()] = num;
  }
  return params;
}

var getDateParamsFromString_1 = getDateParamsFromString$1;

var DateUnitIndexes$4 = DateUnitIndexes$i,
    isDefined$2 = isDefined_1,
    walkUnitDown = walkUnitDown_1;

var YEAR_INDEX = DateUnitIndexes$4.YEAR_INDEX;

function collectDateParamsFromArguments$1(args) {
  var params = {}, index = 0;
  walkUnitDown(YEAR_INDEX, function(unit) {
    var arg = args[index++];
    if (isDefined$2(arg)) {
      params[unit.name] = arg;
    }
  });
  return params;
}

var collectDateParamsFromArguments_1 = collectDateParamsFromArguments$1;

var classChecks$d = classChecks$Z,
    simpleClone = simpleClone_1,
    isObjectType$1 = isObjectType_1,
    getDateParamsFromString = getDateParamsFromString_1,
    collectDateParamsFromArguments = collectDateParamsFromArguments_1;

var isNumber$5 = classChecks$d.isNumber,
    isString$5 = classChecks$d.isString;

function collectUpdateDateArguments$2(args, allowDuration) {
  var arg1 = args[0], arg2 = args[1], params, reset;
  if (allowDuration && isString$5(arg1)) {
    params = getDateParamsFromString(arg1);
    reset  = arg2;
  } else if (isNumber$5(arg1) && isNumber$5(arg2)) {
    params = collectDateParamsFromArguments(args);
  } else {
    params = isObjectType$1(arg1) ? simpleClone(arg1) : arg1;
    reset  = arg2;
  }
  return [params, reset];
}

var collectUpdateDateArguments_1 = collectUpdateDateArguments$2;

var updateDate$1 = updateDate_1,
    collectUpdateDateArguments$1 = collectUpdateDateArguments_1;

function advanceDateWithArgs$2(d, args, dir) {
  args = collectUpdateDateArguments$1(args, true);
  return updateDate$1(d, args[0], args[1], dir);
}

var advanceDateWithArgs_1 = advanceDateWithArgs$2;

var Sugar$1O = sugarCore.exports,
    advanceDateWithArgs$1 = advanceDateWithArgs_1;

Sugar$1O.Date.defineInstanceWithArguments({

  'advance': function(d, args) {
    return advanceDateWithArgs$1(d, args, 1);
  }

});

Sugar$1O.Date.advance;

var Sugar$1N = sugarCore.exports;



Sugar$1N.Date.beginningOfDay;

var Sugar$1M = sugarCore.exports,
    resetTime = resetTime_1,
    getWeekday$4 = getWeekday_1,
    setWeekday$2 = setWeekday_1;

Sugar$1M.Date.defineInstance({

  'beginningOfISOWeek': function(date) {
    var day = getWeekday$4(date);
    if (day === 0) {
      day = -6;
    } else if (day !== 1) {
      day = 1;
    }
    setWeekday$2(date, day);
    return resetTime(date);
  }

});

Sugar$1M.Date.beginningOfISOWeek;

var Sugar$1L = sugarCore.exports;



Sugar$1L.Date.beginningOfMonth;

var Sugar$1K = sugarCore.exports;



Sugar$1K.Date.beginningOfWeek;

var Sugar$1J = sugarCore.exports;



Sugar$1J.Date.beginningOfYear;

var Sugar$1I = sugarCore.exports,
    cloneDate$2 = cloneDate_1;

Sugar$1I.Date.defineInstance({

  'clone': function(date) {
    return cloneDate$2(date);
  }

});

Sugar$1I.Date.clone;

var Sugar$1H = sugarCore.exports;



Sugar$1H.Date.daysAgo;

var Sugar$1G = sugarCore.exports;



Sugar$1G.Date.daysFromNow;

var Sugar$1F = sugarCore.exports,
    getDaysInMonth = getDaysInMonth_1;

Sugar$1F.Date.defineInstance({

  'daysInMonth': function(date) {
    return getDaysInMonth(date);
  }

});

Sugar$1F.Date.daysInMonth;

var Sugar$1E = sugarCore.exports;



Sugar$1E.Date.daysSince;

var Sugar$1D = sugarCore.exports;



Sugar$1D.Date.daysUntil;

var Sugar$1C = sugarCore.exports;



Sugar$1C.Date.endOfDay;

var Sugar$1B = sugarCore.exports,
    DateUnitIndexes$3 = DateUnitIndexes$i,
    getWeekday$3 = getWeekday_1,
    setWeekday$1 = setWeekday_1,
    moveToEndOfUnit = moveToEndOfUnit_1;

var DAY_INDEX$2 = DateUnitIndexes$3.DAY_INDEX;

Sugar$1B.Date.defineInstance({

  'endOfISOWeek': function(date) {
    if (getWeekday$3(date) !== 0) {
      setWeekday$1(date, 7);
    }
    return moveToEndOfUnit(date, DAY_INDEX$2);
  }

});

Sugar$1B.Date.endOfISOWeek;

var Sugar$1A = sugarCore.exports;



Sugar$1A.Date.endOfMonth;

var Sugar$1z = sugarCore.exports;



Sugar$1z.Date.endOfWeek;

var Sugar$1y = sugarCore.exports;



Sugar$1y.Date.endOfYear;

var CoreOutputFormats$2 = {
  'ISO8601': '{yyyy}-{MM}-{dd}T{HH}:{mm}:{ss}.{SSS}{Z}',
  'RFC1123': '{Dow}, {dd} {Mon} {yyyy} {HH}:{mm}:{ss} {ZZ}',
  'RFC1036': '{Weekday}, {dd}-{Mon}-{yy} {HH}:{mm}:{ss} {ZZ}'
};

var CoreOutputFormats_1 = CoreOutputFormats$2;

var TIMEZONE_ABBREVIATION_REG$1 = /\(([-+]\d{2,4}|\w{3,5})\)$/;

var callDateGet$2 = callDateGet_1;

function getHours$2(d) {
  return callDateGet$2(d, 'Hours');
}

var getHours_1 = getHours$2;

var ISODefaults = ISODefaults$3,
    setDate$1 = setDate_1,
    getDate$2 = getDate_1,
    cloneDate$1 = cloneDate_1,
    isUndefined = isUndefined_1,
    moveToEndOfWeek = moveToEndOfWeek_1,
    moveToBeginningOfWeek = moveToBeginningOfWeek_1,
    moveToFirstDayOfWeekYear = moveToFirstDayOfWeekYear_1;

var ISO_FIRST_DAY_OF_WEEK = ISODefaults.ISO_FIRST_DAY_OF_WEEK,
    ISO_FIRST_DAY_OF_WEEK_YEAR = ISODefaults.ISO_FIRST_DAY_OF_WEEK_YEAR;

function getWeekNumber$3(d, allowPrevious, firstDayOfWeek, firstDayOfWeekYear) {
  var isoWeek, n = 0;
  if (isUndefined(firstDayOfWeek)) {
    firstDayOfWeek = ISO_FIRST_DAY_OF_WEEK;
  }
  if (isUndefined(firstDayOfWeekYear)) {
    firstDayOfWeekYear = ISO_FIRST_DAY_OF_WEEK_YEAR;
  }
  // Moving to the end of the week allows for forward year traversal, ie
  // Dec 29 2014 is actually week 01 of 2015.
  isoWeek = moveToEndOfWeek(cloneDate$1(d), firstDayOfWeek);
  moveToFirstDayOfWeekYear(isoWeek, firstDayOfWeek, firstDayOfWeekYear);
  if (allowPrevious && d < isoWeek) {
    // If the date is still before the start of the year, then it should be
    // the last week of the previous year, ie Jan 1 2016 is actually week 53
    // of 2015, so move to the beginning of the week to traverse the year.
    isoWeek = moveToBeginningOfWeek(cloneDate$1(d), firstDayOfWeek);
    moveToFirstDayOfWeekYear(isoWeek, firstDayOfWeek, firstDayOfWeekYear);
  }
  while (isoWeek <= d) {
    // Doing a very simple walk to get the week number.
    setDate$1(isoWeek, getDate$2(isoWeek) + 7);
    n++;
  }
  return n;
}

var getWeekNumber_1 = getWeekNumber$3;

var LocaleHelpers$6 = LocaleHelpers$h,
    getYear$4 = getYear_1,
    getMonth$3 = getMonth_1,
    getWeekNumber$2 = getWeekNumber_1;

var localeManager$4 = LocaleHelpers$6.localeManager;

function getWeekYear$1(d, localeCode, iso) {
  var year, month, firstDayOfWeek, firstDayOfWeekYear, week, loc;
  year = getYear$4(d);
  month = getMonth$3(d);
  if (month === 0 || month === 11) {
    if (!iso) {
      loc = localeManager$4.get(localeCode);
      firstDayOfWeek = loc.getFirstDayOfWeek(localeCode);
      firstDayOfWeekYear = loc.getFirstDayOfWeekYear(localeCode);
    }
    week = getWeekNumber$2(d, false, firstDayOfWeek, firstDayOfWeekYear);
    if (month === 0 && week === 0) {
      year -= 1;
    } else if (month === 11 && week === 1) {
      year += 1;
    }
  }
  return year;
}

var getWeekYear_1 = getWeekYear$1;

var _utc$2 = _utc$8,
    trunc$3 = trunc_1,
    tzOffset$1 = tzOffset_1,
    padNumber$2 = padNumber_1,
    mathAliases$8 = mathAliases$z;

var abs$2 = mathAliases$8.abs;

function getUTCOffset$2(d, iso) {
  var offset = _utc$2(d) ? 0 : tzOffset$1(d), hours, mins, colon;
  colon  = iso === true ? ':' : '';
  if (!offset && iso) return 'Z';
  hours = padNumber$2(trunc$3(-offset / 60), 2, true);
  mins = padNumber$2(abs$2(offset % 60), 2);
  return  hours + colon + mins;
}

var getUTCOffset_1 = getUTCOffset$2;

var DateUnits = DateUnits_1,
    DateUnitIndexes$2 = DateUnitIndexes$i,
    getTimeDistanceForUnit$1 = getTimeDistanceForUnit_1;

var DAY_INDEX$1 = DateUnitIndexes$2.DAY_INDEX;

function getDaysSince$1(d1, d2) {
  return getTimeDistanceForUnit$1(d1, d2, DateUnits[DAY_INDEX$1]);
}

var getDaysSince_1 = getDaysSince$1;

var LocaleHelpers$5 = LocaleHelpers$h,
    trunc$2 = trunc_1,
    getHours$1 = getHours_1;

var localeManager$3 = LocaleHelpers$5.localeManager;

function getMeridiemToken$1(d, localeCode) {
  var hours = getHours$1(d);
  return localeManager$3.get(localeCode).ampm[trunc$2(hours / 12)] || '';
}

var getMeridiemToken_1 = getMeridiemToken$1;

var TIMEZONE_ABBREVIATION_REG = TIMEZONE_ABBREVIATION_REG$1,
    LocaleHelpers$4 = LocaleHelpers$h,
    DateUnitIndexes$1 = DateUnitIndexes$i,
    trunc$1 = trunc_1,
    getDate$1 = getDate_1,
    getYear$3 = getYear_1,
    getHours = getHours_1,
    getMonth$2 = getMonth_1,
    cloneDate = cloneDate_1,
    padNumber$1 = padNumber_1,
    getWeekday$2 = getWeekday_1,
    callDateGet$1 = callDateGet_1,
    mathAliases$7 = mathAliases$z,
    getWeekYear = getWeekYear_1,
    getUTCOffset$1 = getUTCOffset_1,
    getDaysSince = getDaysSince_1,
    getWeekNumber$1 = getWeekNumber_1,
    getMeridiemToken = getMeridiemToken_1,
    setUnitAndLowerToEdge = setUnitAndLowerToEdge_1;

var localeManager$2 = LocaleHelpers$4.localeManager,
    MONTH_INDEX = DateUnitIndexes$1.MONTH_INDEX,
    ceil$1 = mathAliases$7.ceil;

var FormatTokensBase$1 = [
  {
    ldml: 'Dow',
    strf: 'a',
    lowerToken: 'dow',
    get: function(d, localeCode) {
      return localeManager$2.get(localeCode).getWeekdayName(getWeekday$2(d), 2);
    }
  },
  {
    ldml: 'Weekday',
    strf: 'A',
    lowerToken: 'weekday',
    allowAlternates: true,
    get: function(d, localeCode, alternate) {
      return localeManager$2.get(localeCode).getWeekdayName(getWeekday$2(d), alternate);
    }
  },
  {
    ldml: 'Mon',
    strf: 'b h',
    lowerToken: 'mon',
    get: function(d, localeCode) {
      return localeManager$2.get(localeCode).getMonthName(getMonth$2(d), 2);
    }
  },
  {
    ldml: 'Month',
    strf: 'B',
    lowerToken: 'month',
    allowAlternates: true,
    get: function(d, localeCode, alternate) {
      return localeManager$2.get(localeCode).getMonthName(getMonth$2(d), alternate);
    }
  },
  {
    strf: 'C',
    get: function(d) {
      return getYear$3(d).toString().slice(0, 2);
    }
  },
  {
    ldml: 'd date day',
    strf: 'd',
    strfPadding: 2,
    ldmlPaddedToken: 'dd',
    ordinalToken: 'do',
    get: function(d) {
      return getDate$1(d);
    }
  },
  {
    strf: 'e',
    get: function(d) {
      return padNumber$1(getDate$1(d), 2, false, 10, ' ');
    }
  },
  {
    ldml: 'H 24hr',
    strf: 'H',
    strfPadding: 2,
    ldmlPaddedToken: 'HH',
    get: function(d) {
      return getHours(d);
    }
  },
  {
    ldml: 'h hours 12hr',
    strf: 'I',
    strfPadding: 2,
    ldmlPaddedToken: 'hh',
    get: function(d) {
      return getHours(d) % 12 || 12;
    }
  },
  {
    ldml: 'D',
    strf: 'j',
    strfPadding: 3,
    ldmlPaddedToken: 'DDD',
    get: function(d) {
      var s = setUnitAndLowerToEdge(cloneDate(d), MONTH_INDEX);
      return getDaysSince(d, s) + 1;
    }
  },
  {
    ldml: 'M',
    strf: 'm',
    strfPadding: 2,
    ordinalToken: 'Mo',
    ldmlPaddedToken: 'MM',
    get: function(d) {
      return getMonth$2(d) + 1;
    }
  },
  {
    ldml: 'm minutes',
    strf: 'M',
    strfPadding: 2,
    ldmlPaddedToken: 'mm',
    get: function(d) {
      return callDateGet$1(d, 'Minutes');
    }
  },
  {
    ldml: 'Q',
    get: function(d) {
      return ceil$1((getMonth$2(d) + 1) / 3);
    }
  },
  {
    ldml: 'TT',
    strf: 'p',
    get: function(d, localeCode) {
      return getMeridiemToken(d, localeCode);
    }
  },
  {
    ldml: 'tt',
    strf: 'P',
    get: function(d, localeCode) {
      return getMeridiemToken(d, localeCode).toLowerCase();
    }
  },
  {
    ldml: 'T',
    lowerToken: 't',
    get: function(d, localeCode) {
      return getMeridiemToken(d, localeCode).charAt(0);
    }
  },
  {
    ldml: 's seconds',
    strf: 'S',
    strfPadding: 2,
    ldmlPaddedToken: 'ss',
    get: function(d) {
      return callDateGet$1(d, 'Seconds');
    }
  },
  {
    ldml: 'S ms',
    strfPadding: 3,
    ldmlPaddedToken: 'SSS',
    get: function(d) {
      return callDateGet$1(d, 'Milliseconds');
    }
  },
  {
    ldml: 'e',
    strf: 'u',
    ordinalToken: 'eo',
    get: function(d) {
      return getWeekday$2(d) || 7;
    }
  },
  {
    strf: 'U',
    strfPadding: 2,
    get: function(d) {
      // Sunday first, 0-53
      return getWeekNumber$1(d, false, 0);
    }
  },
  {
    ldml: 'W',
    strf: 'V',
    strfPadding: 2,
    ordinalToken: 'Wo',
    ldmlPaddedToken: 'WW',
    get: function(d) {
      // Monday first, 1-53 (ISO8601)
      return getWeekNumber$1(d, true);
    }
  },
  {
    strf: 'w',
    get: function(d) {
      return getWeekday$2(d);
    }
  },
  {
    ldml: 'w',
    ordinalToken: 'wo',
    ldmlPaddedToken: 'ww',
    get: function(d, localeCode) {
      // Locale dependent, 1-53
      var loc = localeManager$2.get(localeCode),
          dow = loc.getFirstDayOfWeek(localeCode),
          doy = loc.getFirstDayOfWeekYear(localeCode);
      return getWeekNumber$1(d, true, dow, doy);
    }
  },
  {
    strf: 'W',
    strfPadding: 2,
    get: function(d) {
      // Monday first, 0-53
      return getWeekNumber$1(d, false);
    }
  },
  {
    ldmlPaddedToken: 'gggg',
    ldmlTwoDigitToken: 'gg',
    get: function(d, localeCode) {
      return getWeekYear(d, localeCode);
    }
  },
  {
    strf: 'G',
    strfPadding: 4,
    strfTwoDigitToken: 'g',
    ldmlPaddedToken: 'GGGG',
    ldmlTwoDigitToken: 'GG',
    get: function(d, localeCode) {
      return getWeekYear(d, localeCode, true);
    }
  },
  {
    ldml: 'year',
    ldmlPaddedToken: 'yyyy',
    ldmlTwoDigitToken: 'yy',
    strf: 'Y',
    strfPadding: 4,
    strfTwoDigitToken: 'y',
    get: function(d) {
      return getYear$3(d);
    }
  },
  {
    ldml: 'ZZ',
    strf: 'z',
    get: function(d) {
      return getUTCOffset$1(d);
    }
  },
  {
    ldml: 'X',
    get: function(d) {
      return trunc$1(d.getTime() / 1000);
    }
  },
  {
    ldml: 'x',
    get: function(d) {
      return d.getTime();
    }
  },
  {
    ldml: 'Z',
    get: function(d) {
      return getUTCOffset$1(d, true);
    }
  },
  {
    ldml: 'z',
    strf: 'Z',
    get: function(d) {
      // Note that this is not accurate in all browsing environments!
      // https://github.com/moment/moment/issues/162
      // It will continue to be supported for Node and usage with the
      // understanding that it may be blank.
      var match = d.toString().match(TIMEZONE_ABBREVIATION_REG);
      // istanbul ignore next
      return match ? match[1] : '';
    }
  },
  {
    strf: 'D',
    alias: '%m/%d/%y'
  },
  {
    strf: 'F',
    alias: '%Y-%m-%d'
  },
  {
    strf: 'r',
    alias: '%I:%M:%S %p'
  },
  {
    strf: 'R',
    alias: '%H:%M'
  },
  {
    strf: 'T',
    alias: '%H:%M:%S'
  },
  {
    strf: 'x',
    alias: '{short}'
  },
  {
    strf: 'X',
    alias: '{time}'
  },
  {
    strf: 'c',
    alias: '{stamp}'
  }
];

var FormatTokensBase_1 = FormatTokensBase$1;

var LocaleHelpers$3 = LocaleHelpers$h,
    FormatTokensBase = FormatTokensBase_1,
    CoreOutputFormats$1 = CoreOutputFormats_1,
    forEach$1 = forEach_1,
    padNumber = padNumber_1,
    spaceSplit$1 = spaceSplit_1,
    namespaceAliases$3 = namespaceAliases$e,
    coreUtilityAliases$2 = coreUtilityAliases$M,
    createFormatMatcher = createFormatMatcher_1,
    defineInstanceSimilar$1 = defineInstanceSimilar_1;

var localeManager$1 = LocaleHelpers$3.localeManager,
    hasOwn$1 = coreUtilityAliases$2.hasOwn,
    getOwn$1 = coreUtilityAliases$2.getOwn,
    forEachProperty$1 = coreUtilityAliases$2.forEachProperty,
    sugarDate$3 = namespaceAliases$3.sugarDate;

var ldmlTokens, strfTokens;

function buildDateFormatTokens() {

  function addFormats(target, tokens, fn) {
    if (tokens) {
      forEach$1(spaceSplit$1(tokens), function(token) {
        target[token] = fn;
      });
    }
  }

  function buildLowercase(get) {
    return function(d, localeCode) {
      return get(d, localeCode).toLowerCase();
    };
  }

  function buildOrdinal(get) {
    return function(d, localeCode) {
      var n = get(d, localeCode);
      return n + localeManager$1.get(localeCode).getOrdinal(n);
    };
  }

  function buildPadded(get, padding) {
    return function(d, localeCode) {
      return padNumber(get(d, localeCode), padding);
    };
  }

  function buildTwoDigits(get) {
    return function(d, localeCode) {
      return get(d, localeCode) % 100;
    };
  }

  function buildAlias(alias) {
    return function(d, localeCode) {
      return dateFormatMatcher$1(alias, d, localeCode);
    };
  }

  function buildAlternates(f) {
    for (var n = 1; n <= 5; n++) {
      buildAlternate(f, n);
    }
  }

  function buildAlternate(f, n) {
    var alternate = function(d, localeCode) {
      return f.get(d, localeCode, n);
    };
    addFormats(ldmlTokens, f.ldml + n, alternate);
    if (f.lowerToken) {
      ldmlTokens[f.lowerToken + n] = buildLowercase(alternate);
    }
  }

  function getIdentityFormat(name) {
    return function(d, localeCode) {
      var loc = localeManager$1.get(localeCode);
      return dateFormatMatcher$1(loc[name], d, localeCode);
    };
  }

  ldmlTokens = {};
  strfTokens = {};

  forEach$1(FormatTokensBase, function(f) {
    var get = f.get, getPadded;
    if (f.lowerToken) {
      ldmlTokens[f.lowerToken] = buildLowercase(get);
    }
    if (f.ordinalToken) {
      ldmlTokens[f.ordinalToken] = buildOrdinal(get);
    }
    if (f.ldmlPaddedToken) {
      ldmlTokens[f.ldmlPaddedToken] = buildPadded(get, f.ldmlPaddedToken.length);
    }
    if (f.ldmlTwoDigitToken) {
      ldmlTokens[f.ldmlTwoDigitToken] = buildPadded(buildTwoDigits(get), 2);
    }
    if (f.strfTwoDigitToken) {
      strfTokens[f.strfTwoDigitToken] = buildPadded(buildTwoDigits(get), 2);
    }
    if (f.strfPadding) {
      getPadded = buildPadded(get, f.strfPadding);
    }
    if (f.alias) {
      get = buildAlias(f.alias);
    }
    if (f.allowAlternates) {
      buildAlternates(f);
    }
    addFormats(ldmlTokens, f.ldml, get);
    addFormats(strfTokens, f.strf, getPadded || get);
  });

  forEachProperty$1(CoreOutputFormats$1, function(src, name) {
    addFormats(ldmlTokens, name, buildAlias(src));
  });

  defineInstanceSimilar$1(sugarDate$3, 'short medium long full', function(methods, name) {
    var fn = getIdentityFormat(name);
    addFormats(ldmlTokens, name, fn);
    methods[name] = fn;
  });

  addFormats(ldmlTokens, 'time', getIdentityFormat('time'));
  addFormats(ldmlTokens, 'stamp', getIdentityFormat('stamp'));
}

var dateFormatMatcher$1;

function buildDateFormatMatcher() {

  function getLdml(d, token, localeCode) {
    return getOwn$1(ldmlTokens, token)(d, localeCode);
  }

  function getStrf(d, token, localeCode) {
    return getOwn$1(strfTokens, token)(d, localeCode);
  }

  function checkDateToken(ldml, strf) {
    return hasOwn$1(ldmlTokens, ldml) || hasOwn$1(strfTokens, strf);
  }

  // Format matcher for LDML or STRF tokens.
  dateFormatMatcher$1 = createFormatMatcher(getLdml, getStrf, checkDateToken);
}

buildDateFormatTokens();

buildDateFormatMatcher();

var formattingTokens$1 = {
  ldmlTokens: ldmlTokens,
  strfTokens: strfTokens,
  dateFormatMatcher: dateFormatMatcher$1
};

var dateIsValid$2 = dateIsValid_1;

function assertDateIsValid$2(d) {
  if (!dateIsValid$2(d)) {
    throw new TypeError('Date is not valid');
  }
}

var assertDateIsValid_1 = assertDateIsValid$2;

var CoreOutputFormats = CoreOutputFormats_1,
    formattingTokens = formattingTokens$1,
    assertDateIsValid$1 = assertDateIsValid_1;

var dateFormatMatcher = formattingTokens.dateFormatMatcher;

function dateFormat$2(d, format, localeCode) {
  assertDateIsValid$1(d);
  format = CoreOutputFormats[format] || format || '{long}';
  return dateFormatMatcher(format, d, localeCode);
}

var dateFormat_1 = dateFormat$2;

var Sugar$1x = sugarCore.exports,
    dateFormat$1 = dateFormat_1;

Sugar$1x.Date.defineInstance({

  'format': function(date, f, localeCode) {
    return dateFormat$1(date, f, localeCode);
  }

});

Sugar$1x.Date.format;

var getExtendedDate = getExtendedDate_1;

function createDateWithContext$1(contextDate, d, options, forceClone) {
  return getExtendedDate(contextDate, d, options, forceClone).date;
}

var createDateWithContext_1 = createDateWithContext$1;

var Sugar$1w = sugarCore.exports,
    createDateWithContext = createDateWithContext_1;

Sugar$1w.Date.defineInstance({

  'get': function(date, d, options) {
    return createDateWithContext(date, d, options);
  }

});

Sugar$1w.Date.get;

var Sugar$1v = sugarCore.exports,
    getWeekNumber = getWeekNumber_1;

Sugar$1v.Date.defineInstance({

  'getISOWeek': function(date) {
    return getWeekNumber(date, true);
  }

});

Sugar$1v.Date.getISOWeek;

var Sugar$1u = sugarCore.exports,
    getUTCOffset = getUTCOffset_1;

Sugar$1u.Date.defineInstance({

  'getUTCOffset': function(date, iso) {
    return getUTCOffset(date, iso);
  }

});

Sugar$1u.Date.getUTCOffset;

var Sugar$1t = sugarCore.exports;

Sugar$1t.Date.defineInstance({

  'getUTCWeekday': function(date) {
    return date.getUTCDay();
  }

});

Sugar$1t.Date.getUTCWeekday;

var Sugar$1s = sugarCore.exports,
    getWeekday$1 = getWeekday_1;

Sugar$1s.Date.defineInstance({

  'getWeekday': function(date) {
    return getWeekday$1(date);
  }

});

Sugar$1s.Date.getWeekday;

var Sugar$1r = sugarCore.exports;



Sugar$1r.Date.hoursAgo;

var Sugar$1q = sugarCore.exports;



Sugar$1q.Date.hoursFromNow;

var Sugar$1p = sugarCore.exports;



Sugar$1p.Date.hoursSince;

var Sugar$1o = sugarCore.exports;



Sugar$1o.Date.hoursUntil;

var setDate = setDate_1,
    getDate = getDate_1,
    getYear$2 = getYear_1,
    getMonth$1 = getMonth_1,
    getNewDate$2 = getNewDate_1;

function compareDay$1(d, shift) {
  var comp = getNewDate$2();
  if (shift) {
    setDate(comp, getDate(comp) + shift);
  }
  return getYear$2(d) === getYear$2(comp) &&
         getMonth$1(d) === getMonth$1(comp) &&
         getDate(d) === getDate(comp);
}

var compareDay_1 = compareDay$1;

var LocaleHelpers$2 = LocaleHelpers$h,
    trim = trim_1,
    getMonth = getMonth_1,
    isDefined$1 = isDefined_1,
    getNewDate$1 = getNewDate_1,
    compareDay = compareDay_1,
    getWeekday = getWeekday_1,
    dateIsValid$1 = dateIsValid_1,
    classChecks$c = classChecks$Z,
    compareDate = compareDate_1;

var isString$4 = classChecks$c.isString,
    English$1 = LocaleHelpers$2.English;

function fullCompareDate$2(date, d, margin) {
  var tmp;
  if (!dateIsValid$1(date)) return;
  if (isString$4(d)) {
    d = trim(d).toLowerCase();
    switch(true) {
      case d === 'future':    return date.getTime() > getNewDate$1().getTime();
      case d === 'past':      return date.getTime() < getNewDate$1().getTime();
      case d === 'today':     return compareDay(date);
      case d === 'tomorrow':  return compareDay(date,  1);
      case d === 'yesterday': return compareDay(date, -1);
      case d === 'weekday':   return getWeekday(date) > 0 && getWeekday(date) < 6;
      case d === 'weekend':   return getWeekday(date) === 0 || getWeekday(date) === 6;

      case (isDefined$1(tmp = English$1.weekdayMap[d])):
        return getWeekday(date) === tmp;
      case (isDefined$1(tmp = English$1.monthMap[d])):
        return getMonth(date) === tmp;
    }
  }
  return compareDate(date, d, margin);
}

var fullCompareDate_1 = fullCompareDate$2;

var Sugar$1n = sugarCore.exports,
    fullCompareDate$1 = fullCompareDate_1;

Sugar$1n.Date.defineInstance({

  'is': function(date, d, margin) {
    return fullCompareDate$1(date, d, margin);
  }

});

Sugar$1n.Date.is;

var Sugar$1m = sugarCore.exports,
    createDate$3 = createDate_1;

Sugar$1m.Date.defineInstance({

  'isAfter': function(date, d, margin) {
    return date.getTime() > createDate$3(d).getTime() - (margin || 0);
  }

});

Sugar$1m.Date.isAfter;

var Sugar$1l = sugarCore.exports,
    createDate$2 = createDate_1;

Sugar$1l.Date.defineInstance({

  'isBefore': function(date, d, margin) {
    return date.getTime() < createDate$2(d).getTime() + (margin || 0);
  }

});

Sugar$1l.Date.isBefore;

var Sugar$1k = sugarCore.exports,
    createDate$1 = createDate_1,
    mathAliases$6 = mathAliases$z;

var min$2 = mathAliases$6.min,
    max$2 = mathAliases$6.max;

Sugar$1k.Date.defineInstance({

  'isBetween': function(date, d1, d2, margin) {
    var t  = date.getTime();
    var t1 = createDate$1(d1).getTime();
    var t2 = createDate$1(d2).getTime();
    var lo = min$2(t1, t2);
    var hi = max$2(t1, t2);
    margin = margin || 0;
    return (lo - margin <= t) && (hi + margin >= t);
  }

});

Sugar$1k.Date.isBetween;

var LocaleHelpers$1 = LocaleHelpers$h,
    spaceSplit = spaceSplit_1,
    fullCompareDate = fullCompareDate_1,
    namespaceAliases$2 = namespaceAliases$e,
    defineInstanceSimilar = defineInstanceSimilar_1;

var English = LocaleHelpers$1.English,
    sugarDate$2 = namespaceAliases$2.sugarDate;

function buildRelativeAliases$1() {
  var special  = spaceSplit('Today Yesterday Tomorrow Weekday Weekend Future Past');
  var weekdays = English.weekdays.slice(0, 7);
  var months   = English.months.slice(0, 12);
  var together = special.concat(weekdays).concat(months);
  defineInstanceSimilar(sugarDate$2, together, function(methods, name) {
    methods['is'+ name] = function(d) {
      return fullCompareDate(d, name);
    };
  });
}

var buildRelativeAliases_1 = buildRelativeAliases$1;

var buildRelativeAliases = buildRelativeAliases_1;

buildRelativeAliases();

var Sugar$1j = sugarCore.exports;



Sugar$1j.Date.isFriday;

var Sugar$1i = sugarCore.exports;



Sugar$1i.Date.isFuture;

var Sugar$1h = sugarCore.exports;



Sugar$1h.Date.isLastMonth;

var Sugar$1g = sugarCore.exports;



Sugar$1g.Date.isLastWeek;

var Sugar$1f = sugarCore.exports;



Sugar$1f.Date.isLastYear;

var Sugar$1e = sugarCore.exports,
    getYear$1 = getYear_1;

Sugar$1e.Date.defineInstance({

  'isLeapYear': function(date) {
    var year = getYear$1(date);
    return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
  }

});

Sugar$1e.Date.isLeapYear;

var Sugar$1d = sugarCore.exports;



Sugar$1d.Date.isMonday;

var Sugar$1c = sugarCore.exports;



Sugar$1c.Date.isNextMonth;

var Sugar$1b = sugarCore.exports;



Sugar$1b.Date.isNextWeek;

var Sugar$1a = sugarCore.exports;



Sugar$1a.Date.isNextYear;

var Sugar$19 = sugarCore.exports;



Sugar$19.Date.isPast;

var Sugar$18 = sugarCore.exports;



Sugar$18.Date.isSaturday;

var Sugar$17 = sugarCore.exports;



Sugar$17.Date.isSunday;

var Sugar$16 = sugarCore.exports;



Sugar$16.Date.isThisMonth;

var Sugar$15 = sugarCore.exports;



Sugar$15.Date.isThisWeek;

var Sugar$14 = sugarCore.exports;



Sugar$14.Date.isThisYear;

var Sugar$13 = sugarCore.exports;



Sugar$13.Date.isThursday;

var Sugar$12 = sugarCore.exports;



Sugar$12.Date.isToday;

var Sugar$11 = sugarCore.exports;



Sugar$11.Date.isTomorrow;

var Sugar$10 = sugarCore.exports;



Sugar$10.Date.isTuesday;

var _utc$1 = _utc$8,
    tzOffset = tzOffset_1;

function isUTC$1(d) {
  return !!_utc$1(d) || tzOffset(d) === 0;
}

var isUTC_1 = isUTC$1;

var Sugar$$ = sugarCore.exports,
    isUTC = isUTC_1;

Sugar$$.Date.defineInstance({

  'isUTC': function(date) {
    return isUTC(date);
  }

});

Sugar$$.Date.isUTC;

var Sugar$_ = sugarCore.exports,
    dateIsValid = dateIsValid_1;

Sugar$_.Date.defineInstance({

  'isValid': function(date) {
    return dateIsValid(date);
  }

});

Sugar$_.Date.isValid;

var Sugar$Z = sugarCore.exports;



Sugar$Z.Date.isWednesday;

var Sugar$Y = sugarCore.exports;



Sugar$Y.Date.isWeekday;

var Sugar$X = sugarCore.exports;



Sugar$X.Date.isWeekend;

var Sugar$W = sugarCore.exports;



Sugar$W.Date.isYesterday;

var Sugar$V = sugarCore.exports;

Sugar$V.Date.defineInstance({

  'iso': function(date) {
    return date.toISOString();
  }

});

Sugar$V.Date.iso;

var Sugar$U = sugarCore.exports;



Sugar$U.Date.millisecondsAgo;

var Sugar$T = sugarCore.exports;



Sugar$T.Date.millisecondsFromNow;

var Sugar$S = sugarCore.exports;



Sugar$S.Date.millisecondsSince;

var Sugar$R = sugarCore.exports;



Sugar$R.Date.millisecondsUntil;

var Sugar$Q = sugarCore.exports;



Sugar$Q.Date.minutesAgo;

var Sugar$P = sugarCore.exports;



Sugar$P.Date.minutesFromNow;

var Sugar$O = sugarCore.exports;



Sugar$O.Date.minutesSince;

var Sugar$N = sugarCore.exports;



Sugar$N.Date.minutesUntil;

var Sugar$M = sugarCore.exports;



Sugar$M.Date.monthsAgo;

var Sugar$L = sugarCore.exports;



Sugar$L.Date.monthsFromNow;

var Sugar$K = sugarCore.exports;



Sugar$K.Date.monthsSince;

var Sugar$J = sugarCore.exports;



Sugar$J.Date.monthsUntil;

var getNewDate = getNewDate_1,
    mathAliases$5 = mathAliases$z,
    getAdjustedUnit = getAdjustedUnit_1,
    getTimeDistanceForUnit = getTimeDistanceForUnit_1;

var abs$1 = mathAliases$5.abs;

function getAdjustedUnitForDate$1(d, dRelative) {
  var ms;
  if (!dRelative) {
    dRelative = getNewDate();
    if (d > dRelative) {
      // If our date is greater than the one that we got from getNewDate, it
      // means that we are finding the unit for a date that is in the future
      // relative to now. However, often the incoming date was created in
      // the same cycle as our comparison, but our "now" date will have been
      // created an instant after it, creating situations where "5 minutes from
      // now" becomes "4 minutes from now" in the same tick. To prevent this,
      // subtract a buffer of 10ms to compensate.
      dRelative = new Date(dRelative.getTime() - 10);
    }
  }
  ms = d - dRelative;
  return getAdjustedUnit(ms, function(u) {
    return abs$1(getTimeDistanceForUnit(d, dRelative, u));
  });
}

var getAdjustedUnitForDate_1 = getAdjustedUnitForDate$1;

var LocaleHelpers = LocaleHelpers$h,
    dateFormat = dateFormat_1,
    classChecks$b = classChecks$Z,
    assertDateIsValid = assertDateIsValid_1,
    getAdjustedUnitForDate = getAdjustedUnitForDate_1;

var isFunction$1 = classChecks$b.isFunction,
    localeManager = LocaleHelpers.localeManager;

function dateRelative$2(d, dRelative, arg1, arg2) {
  var adu, format, type, localeCode, fn;
  assertDateIsValid(d);
  if (isFunction$1(arg1)) {
    fn = arg1;
  } else {
    localeCode = arg1;
    fn = arg2;
  }
  adu = getAdjustedUnitForDate(d, dRelative);
  if (fn) {
    format = fn.apply(d, adu.concat(localeManager.get(localeCode)));
    if (format) {
      return dateFormat(d, format, localeCode);
    }
  }
  // Adjust up if time is in ms, as this doesn't
  // look very good for a standard relative date.
  if (adu[1] === 0) {
    adu[1] = 1;
    adu[0] = 1;
  }
  if (dRelative) {
    type = 'duration';
  } else if (adu[2] > 0) {
    type = 'future';
  } else {
    type = 'past';
  }
  return localeManager.get(localeCode).getRelativeFormat(adu, type);
}

var dateRelative_1 = dateRelative$2;

var Sugar$I = sugarCore.exports,
    dateRelative$1 = dateRelative_1;

Sugar$I.Date.defineInstance({

  'relative': function(date, localeCode, relativeFn) {
    return dateRelative$1(date, null, localeCode, relativeFn);
  }

});

Sugar$I.Date.relative;

var Sugar$H = sugarCore.exports,
    createDate = createDate_1,
    dateRelative = dateRelative_1;

Sugar$H.Date.defineInstance({

  'relativeTo': function(date, d, localeCode) {
    return dateRelative(date, createDate(d), localeCode);
  }

});

Sugar$H.Date.relativeTo;

var iterateOverDateParams = iterateOverDateParams_1;

function getUnitIndexForParamName$1(name) {
  var params = {}, unitIndex;
  params[name] = 1;
  iterateOverDateParams(params, function(name, val, unit, i) {
    unitIndex = i;
    return false;
  });
  return unitIndex;
}

var getUnitIndexForParamName_1 = getUnitIndexForParamName$1;

var Sugar$G = sugarCore.exports,
    DateUnitIndexes = DateUnitIndexes$i,
    moveToBeginningOfUnit = moveToBeginningOfUnit_1,
    getUnitIndexForParamName = getUnitIndexForParamName_1;

var DAY_INDEX = DateUnitIndexes.DAY_INDEX;

Sugar$G.Date.defineInstance({

  'reset': function(date, unit, localeCode) {
    var unitIndex = unit ? getUnitIndexForParamName(unit) : DAY_INDEX;
    moveToBeginningOfUnit(date, unitIndex, localeCode);
    return date;
  }

});

Sugar$G.Date.reset;

var Sugar$F = sugarCore.exports,
    advanceDateWithArgs = advanceDateWithArgs_1;

Sugar$F.Date.defineInstanceWithArguments({

  'rewind': function(d, args) {
    return advanceDateWithArgs(d, args, -1);
  }

});

Sugar$F.Date.rewind;

var Sugar$E = sugarCore.exports;



Sugar$E.Date.secondsAgo;

var Sugar$D = sugarCore.exports;



Sugar$D.Date.secondsFromNow;

var Sugar$C = sugarCore.exports;



Sugar$C.Date.secondsSince;

var Sugar$B = sugarCore.exports;



Sugar$B.Date.secondsUntil;

var Sugar$A = sugarCore.exports,
    updateDate = updateDate_1,
    collectUpdateDateArguments = collectUpdateDateArguments_1;

Sugar$A.Date.defineInstanceWithArguments({

  'set': function(d, args) {
    args = collectUpdateDateArguments(args);
    return updateDate(d, args[0], args[1]);
  }

});

Sugar$A.Date.set;

var Sugar$z = sugarCore.exports,
    setISOWeekNumber = setISOWeekNumber_1;

Sugar$z.Date.defineInstance({

  'setISOWeek': function(date, num) {
    return setISOWeekNumber(date, num);
  }

});

Sugar$z.Date.setISOWeek;

var Sugar$y = sugarCore.exports,
    _utc = _utc$8;

Sugar$y.Date.defineInstance({

  'setUTC': function(date, on) {
    return _utc(date, on);
  }

});

Sugar$y.Date.setUTC;

var Sugar$x = sugarCore.exports,
    setWeekday = setWeekday_1;

Sugar$x.Date.defineInstance({

  'setWeekday': function(date, dow) {
    return setWeekday(date, dow);
  }

});

Sugar$x.Date.setWeekday;

var Sugar$w = sugarCore.exports;



Sugar$w.Date.weeksAgo;

var Sugar$v = sugarCore.exports;



Sugar$v.Date.weeksFromNow;

var Sugar$u = sugarCore.exports;



Sugar$u.Date.weeksSince;

var Sugar$t = sugarCore.exports;



Sugar$t.Date.weeksUntil;

var Sugar$s = sugarCore.exports;



Sugar$s.Date.yearsAgo;

var Sugar$r = sugarCore.exports;



Sugar$r.Date.yearsFromNow;

var Sugar$q = sugarCore.exports;



Sugar$q.Date.yearsSince;

var Sugar$p = sugarCore.exports;



Sugar$p.Date.yearsUntil;

var Sugar$o = sugarCore.exports;

Sugar$o.Date.getOption;

var Sugar$n = sugarCore.exports;

Sugar$n.Date.setOption;

var classChecks$a = classChecks$Z;

var isDate$3 = classChecks$a.isDate;

function getRangeMemberPrimitiveValue$2(m) {
  if (m == null) return m;
  return isDate$3(m) ? m.getTime() : m.valueOf();
}

var getRangeMemberPrimitiveValue_1 = getRangeMemberPrimitiveValue$2;

var classChecks$9 = classChecks$Z,
    getRangeMemberPrimitiveValue$1 = getRangeMemberPrimitiveValue_1;

var isDate$2 = classChecks$9.isDate;

function cloneRangeMember$2(m) {
  if (isDate$2(m)) {
    return new Date(m.getTime());
  } else {
    return getRangeMemberPrimitiveValue$1(m);
  }
}

var cloneRangeMember_1 = cloneRangeMember$2;

var cloneRangeMember$1 = cloneRangeMember_1;

function Range$h(start, end) {
  this.start = cloneRangeMember$1(start);
  this.end   = cloneRangeMember$1(end);
}

var Range_1 = Range$h;

var classChecks$8 = classChecks$Z,
    namespaceAliases$1 = namespaceAliases$e;

var isDate$1 = classChecks$8.isDate,
    sugarDate$1 = namespaceAliases$1.sugarDate;

function getDateForRange$2(d) {
  if (isDate$1(d)) {
    return d;
  } else if (d == null) {
    return new Date();
  } else if (sugarDate$1.create) {
    return sugarDate$1.create(d);
  }
  return new Date(d);
}

var getDateForRange_1 = getDateForRange$2;

var DURATION_UNITS$3 = 'year|month|week|day|hour|minute|second|millisecond';

var DURATION_UNITS$2 = DURATION_UNITS$3;

var FULL_CAPTURED_DURATION$1 = '((?:\\d+)?\\s*(?:' + DURATION_UNITS$2 + '))s?';

var FULL_CAPTURED_DURATION = FULL_CAPTURED_DURATION$1;

var DurationTextFormats$1 = {
  RANGE_REG_FROM_TO: /(?:from)?\s*(.+)\s+(?:to|until)\s+(.+)$/i,
  RANGE_REG_REAR_DURATION: RegExp('(.+)\\s*for\\s*' + FULL_CAPTURED_DURATION, 'i'),
  RANGE_REG_FRONT_DURATION: RegExp('(?:for)?\\s*'+ FULL_CAPTURED_DURATION +'\\s*(?:starting)?\\s(?:at\\s)?(.+)', 'i')
};

var MULTIPLIERS$2 = {
  'Hours': 60 * 60 * 1000,
  'Minutes': 60 * 1000,
  'Seconds': 1000,
  'Milliseconds': 1
};

var MULTIPLIERS_1 = MULTIPLIERS$2;

var MULTIPLIERS$1 = MULTIPLIERS_1,
    callDateSet = callDateSet_1,
    callDateGet = callDateGet_1;

function incrementDate$2(src, amount, unit) {
  var mult = MULTIPLIERS$1[unit], d;
  if (mult) {
    d = new Date(src.getTime() + (amount * mult));
  } else {
    d = new Date(src);
    callDateSet(d, unit, callDateGet(src, unit) + amount);
  }
  return d;
}

var incrementDate_1 = incrementDate$2;

var DURATION_UNITS$1 = DURATION_UNITS$3;

var DURATION_REG$1 = RegExp('(\\d+)?\\s*('+ DURATION_UNITS$1 +')s?', 'i');

var DURATION_REG = DURATION_REG$1,
    classChecks$7 = classChecks$Z,
    simpleCapitalize$1 = simpleCapitalize_1;

var isNumber$4 = classChecks$7.isNumber;

function getDateIncrementObject$2(amt) {
  var match, val, unit;
  if (isNumber$4(amt)) {
    return [amt, 'Milliseconds'];
  }
  match = amt.match(DURATION_REG);
  val = +match[1] || 1;
  unit = simpleCapitalize$1(match[2].toLowerCase());
  if (unit.match(/hour|minute|second/i)) {
    unit += 's';
  } else if (unit === 'Year') {
    unit = 'FullYear';
  } else if (unit === 'Week') {
    unit = 'Date';
    val *= 7;
  } else if (unit === 'Day') {
    unit = 'Date';
  }
  return [val, unit];
}

var getDateIncrementObject_1 = getDateIncrementObject$2;

var Range$g = Range_1,
    DurationTextFormats = DurationTextFormats$1,
    incrementDate$1 = incrementDate_1,
    getDateForRange$1 = getDateForRange_1,
    namespaceAliases = namespaceAliases$e,
    getDateIncrementObject$1 = getDateIncrementObject_1;

var sugarDate = namespaceAliases.sugarDate,
    RANGE_REG_FROM_TO = DurationTextFormats.RANGE_REG_FROM_TO,
    RANGE_REG_REAR_DURATION = DurationTextFormats.RANGE_REG_REAR_DURATION,
    RANGE_REG_FRONT_DURATION = DurationTextFormats.RANGE_REG_FRONT_DURATION;

function createDateRangeFromString$1(str) {
  var match, datetime, duration, dio, start, end;
  if (sugarDate.get && (match = str.match(RANGE_REG_FROM_TO))) {
    start = getDateForRange$1(match[1].replace('from', 'at'));
    end = sugarDate.get(start, match[2]);
    return new Range$g(start, end);
  }
  if (match = str.match(RANGE_REG_FRONT_DURATION)) {
    duration = match[1];
    datetime = match[2];
  }
  if (match = str.match(RANGE_REG_REAR_DURATION)) {
    datetime = match[1];
    duration = match[2];
  }
  if (datetime && duration) {
    start = getDateForRange$1(datetime);
    dio = getDateIncrementObject$1(duration);
    end = incrementDate$1(start, dio[0], dio[1]);
  } else {
    start = str;
  }
  return new Range$g(getDateForRange$1(start), getDateForRange$1(end));
}

var createDateRangeFromString_1 = createDateRangeFromString$1;

var Range$f = Range_1,
    classChecks$6 = classChecks$Z,
    getDateForRange = getDateForRange_1,
    createDateRangeFromString = createDateRangeFromString_1;

var isString$3 = classChecks$6.isString;

var DateRangeConstructor$1 = function(start, end) {
  if (arguments.length === 1 && isString$3(start)) {
    return createDateRangeFromString(start);
  }
  return new Range$f(getDateForRange(start), getDateForRange(end));
};

var DateRangeConstructor_1 = DateRangeConstructor$1;

var Sugar$m = sugarCore.exports,
    DateRangeConstructor = DateRangeConstructor_1;

Sugar$m.Date.defineStatic({

  'range': DateRangeConstructor

});

Sugar$m.Date.range;

var Range$e = Range_1;

var PrimitiveRangeConstructor$2 = function(start, end) {
  return new Range$e(start, end);
};

var PrimitiveRangeConstructor_1 = PrimitiveRangeConstructor$2;

var Sugar$l = sugarCore.exports,
    PrimitiveRangeConstructor$1 = PrimitiveRangeConstructor_1;

Sugar$l.Number.defineStatic({

  'range': PrimitiveRangeConstructor$1

});

Sugar$l.Number.range;

var Sugar$k = sugarCore.exports,
    PrimitiveRangeConstructor = PrimitiveRangeConstructor_1;

Sugar$k.String.defineStatic({

  'range': PrimitiveRangeConstructor

});

Sugar$k.String.range;

var cloneRangeMember = cloneRangeMember_1;

function rangeClamp$3(range, obj) {
  var clamped,
      start = range.start,
      end = range.end,
      min = end < start ? end : start,
      max = start > end ? start : end;
  if (obj < min) {
    clamped = min;
  } else if (obj > max) {
    clamped = max;
  } else {
    clamped = obj;
  }
  return cloneRangeMember(clamped);
}

var rangeClamp_1 = rangeClamp$3;

var Sugar$j = sugarCore.exports,
    Range$d = Range_1,
    rangeClamp$2 = rangeClamp_1;

Sugar$j.Number.defineInstance({

  'cap': function(n, max) {
    return rangeClamp$2(new Range$d(undefined, max), n);
  }

});

Sugar$j.Number.cap;

var Sugar$i = sugarCore.exports,
    Range$c = Range_1,
    rangeClamp$1 = rangeClamp_1;

Sugar$i.Number.defineInstance({

  'clamp': function(n, start, end) {
    return rangeClamp$1(new Range$c(start, end), n);
  }

});

Sugar$i.Number.clamp;

function valueIsNotInfinite$1(m) {
  return m !== -Infinity && m !== Infinity;
}

var valueIsNotInfinite_1 = valueIsNotInfinite$1;

var valueIsNotInfinite = valueIsNotInfinite_1,
    getRangeMemberPrimitiveValue = getRangeMemberPrimitiveValue_1;

function isValidRangeMember$1(m) {
  var val = getRangeMemberPrimitiveValue(m);
  return (!!val || val === 0) && valueIsNotInfinite(m);
}

var isValidRangeMember_1 = isValidRangeMember$1;

var isValidRangeMember = isValidRangeMember_1;

function rangeIsValid$4(range) {
  return isValidRangeMember(range.start) &&
         isValidRangeMember(range.end) &&
         typeof range.start === typeof range.end;
}

var rangeIsValid_1 = rangeIsValid$4;

var withPrecision = withPrecision_1;

function incrementNumber$1(current, amount, precision) {
  return withPrecision(current + amount, precision);
}

var incrementNumber_1 = incrementNumber$1;

var chr = chr$6;

function incrementString$1(current, amount) {
  return chr(current.charCodeAt(0) + amount);
}

var incrementString_1 = incrementString$1;

var periodSplit = periodSplit_1;

function getPrecision$1(n) {
  var split = periodSplit(n.toString());
  return split[1] ? split[1].length : 0;
}

var getPrecision_1 = getPrecision$1;

var mathAliases$4 = mathAliases$z,
    getPrecision = getPrecision_1;

var max$1 = mathAliases$4.max;

function getGreaterPrecision$1(n1, n2) {
  return max$1(getPrecision(n1), getPrecision(n2));
}

var getGreaterPrecision_1 = getGreaterPrecision$1;

var classChecks$5 = classChecks$Z,
    rangeIsValid$3 = rangeIsValid_1,
    incrementDate = incrementDate_1,
    incrementNumber = incrementNumber_1,
    incrementString = incrementString_1,
    getGreaterPrecision = getGreaterPrecision_1,
    getDateIncrementObject = getDateIncrementObject_1;

var isNumber$3 = classChecks$5.isNumber,
    isString$2 = classChecks$5.isString,
    isDate = classChecks$5.isDate,
    isFunction = classChecks$5.isFunction;

function rangeEvery$4(range, step, countOnly, fn) {
  var increment,
      precision,
      dio,
      unit,
      start   = range.start,
      end     = range.end,
      inverse = end < start,
      current = start,
      index   = 0,
      result  = [];

  if (!rangeIsValid$3(range)) {
    return countOnly ? NaN : [];
  }
  if (isFunction(step)) {
    fn = step;
    step = null;
  }
  step = step || 1;
  if (isNumber$3(start)) {
    precision = getGreaterPrecision(start, step);
    increment = function() {
      return incrementNumber(current, step, precision);
    };
  } else if (isString$2(start)) {
    increment = function() {
      return incrementString(current, step);
    };
  } else if (isDate(start)) {
    dio  = getDateIncrementObject(step);
    step = dio[0];
    unit = dio[1];
    increment = function() {
      return incrementDate(current, step, unit);
    };
  }
  // Avoiding infinite loops
  if (inverse && step > 0) {
    step *= -1;
  }
  while(inverse ? current >= end : current <= end) {
    if (!countOnly) {
      result.push(current);
    }
    if (fn) {
      fn(current, index, range);
    }
    current = increment();
    index++;
  }
  return countOnly ? index - 1 : result;
}

var rangeEvery_1 = rangeEvery$4;

var Sugar$h = sugarCore.exports,
    Range$b = Range_1,
    rangeEvery$3 = rangeEvery_1;

Sugar$h.Number.defineInstance({

  'upto': function(n, num, step, everyFn) {
    return rangeEvery$3(new Range$b(n, num), step, false, everyFn);
  }

});

Sugar$h.Number.upto;

var coreUtilityAliases$1 = coreUtilityAliases$M;

var forEachProperty = coreUtilityAliases$1.forEachProperty;

function defineOnPrototype$b(ctor, methods) {
  var proto = ctor.prototype;
  forEachProperty(methods, function(val, key) {
    proto[key] = val;
  });
}

var defineOnPrototype_1 = defineOnPrototype$b;

var Range$a = Range_1,
    rangeClamp = rangeClamp_1,
    defineOnPrototype$a = defineOnPrototype_1;

defineOnPrototype$a(Range$a, {

  'clamp': function(el) {
    return rangeClamp(this, el);
  }

});

var Range$9 = Range_1,
    defineOnPrototype$9 = defineOnPrototype_1;

defineOnPrototype$9(Range$9, {

  'clone': function() {
    return new Range$9(this.start, this.end);
  }

});

var Range$8 = Range_1,
    defineOnPrototype$8 = defineOnPrototype_1;

defineOnPrototype$8(Range$8, {

  'contains': function(el) {
    if (el == null) return false;
    if (el.start && el.end) {
      return el.start >= this.start && el.start <= this.end &&
             el.end   >= this.start && el.end   <= this.end;
    } else {
      return el >= this.start && el <= this.end;
    }
  }

});

var MULTIPLIERS = MULTIPLIERS_1,
    DURATION_UNITS = DURATION_UNITS$3,
    Range$7 = Range_1,
    trunc = trunc_1,
    forEach = forEach_1,
    rangeEvery$2 = rangeEvery_1,
    simpleCapitalize = simpleCapitalize_1,
    defineOnPrototype$7 = defineOnPrototype_1;

function buildDateRangeUnits$1() {
  var methods = {};
  forEach(DURATION_UNITS.split('|'), function(unit, i) {
    var name = unit + 's', mult, fn;
    if (i < 4) {
      fn = function() {
        return rangeEvery$2(this, unit, true);
      };
    } else {
      mult = MULTIPLIERS[simpleCapitalize(name)];
      fn = function() {
        return trunc((this.end - this.start) / mult);
      };
    }
    methods[name] = fn;
  });
  defineOnPrototype$7(Range$7, methods);
}

var buildDateRangeUnits_1 = buildDateRangeUnits$1;

var buildDateRangeUnits = buildDateRangeUnits_1;

buildDateRangeUnits();

var Range$6 = Range_1,
    rangeEvery$1 = rangeEvery_1,
    defineOnPrototype$6 = defineOnPrototype_1;

defineOnPrototype$6(Range$6, {

  'every': function(amount, everyFn) {
    return rangeEvery$1(this, amount, false, everyFn);
  }

});

var Range$5 = Range_1,
    defineOnPrototype$5 = defineOnPrototype_1;

defineOnPrototype$5(Range$5, {

  'intersect': function(range) {
    if (range.start > this.end || range.end < this.start) {
      return new Range$5(NaN, NaN);
    }
    return new Range$5(
      this.start > range.start ? this.start : range.start,
      this.end   < range.end   ? this.end   : range.end
    );
  }

});

var Range$4 = Range_1,
    rangeIsValid$2 = rangeIsValid_1,
    defineOnPrototype$4 = defineOnPrototype_1;

defineOnPrototype$4(Range$4, {

  'isValid': function() {
    return rangeIsValid$2(this);
  }

});

var classChecks$4 = classChecks$Z;

var isString$1 = classChecks$4.isString;

function getRangeMemberNumericValue$1(m) {
  return isString$1(m) ? m.charCodeAt(0) : m;
}

var getRangeMemberNumericValue_1 = getRangeMemberNumericValue$1;

var Range$3 = Range_1,
    mathAliases$3 = mathAliases$z,
    rangeIsValid$1 = rangeIsValid_1,
    defineOnPrototype$3 = defineOnPrototype_1,
    getRangeMemberNumericValue = getRangeMemberNumericValue_1;

var abs = mathAliases$3.abs;

defineOnPrototype$3(Range$3, {

  'span': function() {
    var n = getRangeMemberNumericValue(this.end) - getRangeMemberNumericValue(this.start);
    return rangeIsValid$1(this) ? abs(n) + 1 : NaN;
  }

});

var Range$2 = Range_1,
    rangeEvery = rangeEvery_1,
    defineOnPrototype$2 = defineOnPrototype_1;

defineOnPrototype$2(Range$2, {

  'toArray': function() {
    return rangeEvery(this);
  }

});

var Range$1 = Range_1,
    rangeIsValid = rangeIsValid_1,
    defineOnPrototype$1 = defineOnPrototype_1;

defineOnPrototype$1(Range$1, {

  'toString': function() {
    return rangeIsValid(this) ? this.start + '..' + this.end : 'Invalid Range';
  }

});

var Range = Range_1,
    defineOnPrototype = defineOnPrototype_1;

defineOnPrototype(Range, {

  'union': function(range) {
    return new Range(
      this.start < range.start ? this.start : range.start,
      this.end   > range.end   ? this.end   : range.end
    );
  }

});

var Sugar$g = sugarCore.exports;

Sugar$g.Number.alias('downto', 'upto');

Sugar$g.Number.downto;

var Sugar$f = sugarCore.exports,
    coercePositiveInteger$1 = coercePositiveInteger_1;

Sugar$f.Function.defineInstance({

  'after': function(fn, num) {
    var count = 0, collectedArgs = [];
    num = coercePositiveInteger$1(num);
    return function() {
      // Optimized: no leaking arguments
      var args = []; for(var $i = 0, $len = arguments.length; $i < $len; $i++) args.push(arguments[$i]);
      collectedArgs.push(args);
      count++;
      if (count >= num) {
        return fn.call(this, collectedArgs);
      }
    };
  }

});

Sugar$f.Function.after;

var privatePropertyAccessor$3 = privatePropertyAccessor_1;

var _timers$2 = privatePropertyAccessor$3('timers');

var privatePropertyAccessor$2 = privatePropertyAccessor_1;

var _canceled$2 = privatePropertyAccessor$2('canceled');

var _timers$1 = _timers$2,
    _canceled$1 = _canceled$2,
    classChecks$3 = classChecks$Z;

var isArray = classChecks$3.isArray;

function cancelFunction$2(fn) {
  var timers = _timers$1(fn), timer;
  if (isArray(timers)) {
    while(timer = timers.shift()) {
      clearTimeout(timer);
    }
  }
  _canceled$1(fn, true);
  return fn;
}

var cancelFunction_1 = cancelFunction$2;

var Sugar$e = sugarCore.exports,
    cancelFunction$1 = cancelFunction_1;

Sugar$e.Function.defineInstance({

  'cancel': function(fn) {
    return cancelFunction$1(fn);
  }

});

Sugar$e.Function.cancel;

var _timers = _timers$2,
    _canceled = _canceled$2,
    coercePositiveInteger = coercePositiveInteger_1;

function setDelay$4(fn, ms, after, scope, args) {
  // Delay of infinity is never called of course...
  ms = coercePositiveInteger(ms || 0);
  if (!_timers(fn)) {
    _timers(fn, []);
  }
  // This is a workaround for <= IE8, which apparently has the
  // ability to call timeouts in the queue on the same tick (ms?)
  // even if functionally they have already been cleared.
  _canceled(fn, false);
  _timers(fn).push(setTimeout(function() {
    if (!_canceled(fn)) {
      after.apply(scope, args || []);
    }
  }, ms));
}

var setDelay_1 = setDelay$4;

var Sugar$d = sugarCore.exports,
    setDelay$3 = setDelay_1,
    cancelFunction = cancelFunction_1;

Sugar$d.Function.defineInstance({

  'debounce': function(fn, ms) {
    function debounced() {
      // Optimized: no leaking arguments
      var args = []; for(var $i = 0, $len = arguments.length; $i < $len; $i++) args.push(arguments[$i]);
      cancelFunction(debounced);
      setDelay$3(debounced, ms, fn, this, args);
    }
    return debounced;
  }

});

Sugar$d.Function.debounce;

var Sugar$c = sugarCore.exports,
    setDelay$2 = setDelay_1;

Sugar$c.Function.defineInstanceWithArguments({

  'delay': function(fn, ms, args) {
    setDelay$2(fn, ms, fn, fn, args);
    return fn;
  }

});

Sugar$c.Function.delay;

var Sugar$b = sugarCore.exports,
    setDelay$1 = setDelay_1;

Sugar$b.Function.defineInstanceWithArguments({

  'every': function(fn, ms, args) {
    function execute () {
      // Set the delay first here, so that cancel
      // can be called within the executing function.
      setDelay$1(fn, ms, execute);
      fn.apply(fn, args);
    }
    setDelay$1(fn, ms, execute);
    return fn;
  }

});

Sugar$b.Function.every;

var setDelay = setDelay_1,
    mathAliases$2 = mathAliases$z;

var max = mathAliases$2.max,
    ceil = mathAliases$2.ceil,
    round = mathAliases$2.round;

function createLazyFunction$2(fn, ms, immediate, limit) {
  var queue = [], locked = false, execute, rounded, perExecution, result;
  ms = ms || 1;
  limit = limit || Infinity;
  rounded = ceil(ms);
  perExecution = round(rounded / ms) || 1;
  execute = function() {
    var queueLength = queue.length, maxPerRound;
    if (queueLength == 0) return;
    // Allow fractions of a millisecond by calling
    // multiple times per actual timeout execution
    maxPerRound = max(queueLength - perExecution, 0);
    while(queueLength > maxPerRound) {
      // Getting uber-meta here...
      result = Function.prototype.apply.apply(fn, queue.shift());
      queueLength--;
    }
    setDelay(lazy, rounded, function() {
      locked = false;
      execute();
    });
  };
  function lazy() {
    // If the execution has locked and it's immediate, then
    // allow 1 less in the queue as 1 call has already taken place.
    if (queue.length < limit - (locked && immediate ? 1 : 0)) {
      // Optimized: no leaking arguments
      var args = []; for(var $i = 0, $len = arguments.length; $i < $len; $i++) args.push(arguments[$i]);
      queue.push([this, args]);
    }
    if (!locked) {
      locked = true;
      if (immediate) {
        execute();
      } else {
        setDelay(lazy, rounded, execute);
      }
    }
    // Return the memoized result
    return result;
  }
  return lazy;
}

var createLazyFunction_1 = createLazyFunction$2;

var Sugar$a = sugarCore.exports,
    createLazyFunction$1 = createLazyFunction_1;

Sugar$a.Function.defineInstance({

  'lazy': function(fn, ms, immediate, limit) {
    return createLazyFunction$1(fn, ms, immediate, limit);
  }

});

Sugar$a.Function.lazy;

var privatePropertyAccessor$1 = privatePropertyAccessor_1;

var _lock$2 = privatePropertyAccessor$1('lock');

var privatePropertyAccessor = privatePropertyAccessor_1;

var _partial$2 = privatePropertyAccessor('partial');

var Sugar$9 = sugarCore.exports,
    _lock$1 = _lock$2,
    _partial$1 = _partial$2,
    classChecks$2 = classChecks$Z,
    mathAliases$1 = mathAliases$z;

var isNumber$2 = classChecks$2.isNumber,
    min$1 = mathAliases$1.min;

Sugar$9.Function.defineInstance({

  'lock': function(fn, n) {
    var lockedFn;
    if (_partial$1(fn)) {
      _lock$1(fn, isNumber$2(n) ? n : null);
      return fn;
    }
    lockedFn = function() {
      arguments.length = min$1(_lock$1(lockedFn), arguments.length);
      return fn.apply(this, arguments);
    };
    _lock$1(lockedFn, isNumber$2(n) ? n : fn.length);
    return lockedFn;
  }

});

Sugar$9.Function.lock;

function collectArguments$1() {
  var args = arguments, i = args.length, arr = new Array(i);
  while (i--) {
    arr[i] = args[i];
  }
  return arr;
}

var collectArguments_1 = collectArguments$1;

var serializeInternal = serializeInternal_1,
    coreUtilityAliases = coreUtilityAliases$M;

var hasOwn = coreUtilityAliases.hasOwn,
    getOwn = coreUtilityAliases.getOwn;

function createHashedMemoizeFunction$1(fn, hashFn, limit) {
  var map = {}, refs = [], counter = 0;
  return function() {
    var hashObj = hashFn.apply(this, arguments);
    var key = serializeInternal(hashObj, refs);
    if (hasOwn(map, key)) {
      return getOwn(map, key);
    }
    if (counter === limit) {
      map = {};
      refs = [];
      counter = 0;
    }
    counter++;
    return map[key] = fn.apply(this, arguments);
  };
}

var createHashedMemoizeFunction_1 = createHashedMemoizeFunction$1;

var Sugar$8 = sugarCore.exports,
    classChecks$1 = classChecks$Z,
    deepGetProperty = deepGetProperty_1,
    collectArguments = collectArguments_1,
    createHashedMemoizeFunction = createHashedMemoizeFunction_1;

var isNumber$1 = classChecks$1.isNumber,
    isString = classChecks$1.isString;

Sugar$8.Function.defineInstance({

  'memoize': function(fn, arg1, arg2) {
    var hashFn, limit, prop;
    if (isNumber$1(arg1)) {
      limit = arg1;
    } else {
      hashFn = arg1;
      limit  = arg2;
    }
    if (isString(hashFn)) {
      prop = hashFn;
      hashFn = function(obj) {
        return deepGetProperty(obj, prop);
      };
    } else if (!hashFn) {
      hashFn = collectArguments;
    }
    return createHashedMemoizeFunction(fn, hashFn, limit);
  }

});

Sugar$8.Function.memoize;

var Sugar$7 = sugarCore.exports;

Sugar$7.Function.defineInstance({

  'once': function(fn) {
    var called = false, val;
    return function() {
      if (called) {
        return val;
      }
      called = true;
      return val = fn.apply(this, arguments);
    };
  }

});

Sugar$7.Function.once;

var createInstanceFromPrototype$1 = Object.create || function(prototype) {
  var ctor = function() {};
  ctor.prototype = prototype;
  return new ctor;
};

var createInstanceFromPrototype_1 = createInstanceFromPrototype$1;

var Sugar$6 = sugarCore.exports,
    _lock = _lock$2,
    _partial = _partial$2,
    isDefined = isDefined_1,
    classChecks = classChecks$Z,
    mathAliases = mathAliases$z,
    isObjectType = isObjectType_1,
    createInstanceFromPrototype = createInstanceFromPrototype_1;

var isNumber = classChecks.isNumber,
    min = mathAliases.min;

Sugar$6.Function.defineInstanceWithArguments({

  'partial': function(fn, curriedArgs) {
    var curriedLen = curriedArgs.length;
    var partialFn = function() {
      var argIndex = 0, applyArgs = [], self = this, lock = _lock(partialFn), result, i;
      for (i = 0; i < curriedLen; i++) {
        var arg = curriedArgs[i];
        if (isDefined(arg)) {
          applyArgs[i] = arg;
        } else {
          applyArgs[i] = arguments[argIndex++];
        }
      }
      for (i = argIndex; i < arguments.length; i++) {
        applyArgs.push(arguments[i]);
      }
      if (lock === null) {
        lock = curriedLen;
      }
      if (isNumber(lock)) {
        applyArgs.length = min(applyArgs.length, lock);
      }
      // If the bound "this" object is an instance of the partialed
      // function, then "new" was used, so preserve the prototype
      // so that constructor functions can also be partialed.
      if (self instanceof partialFn) {
        self = createInstanceFromPrototype(fn.prototype);
        result = fn.apply(self, applyArgs);
        // An explicit return value is allowed from constructors
        // as long as they are of "object" type, so return the
        // correct result here accordingly.
        return isObjectType(result) ? result : self;
      }
      return fn.apply(self, applyArgs);
    };
    _partial(partialFn, true);
    return partialFn;
  }

});

Sugar$6.Function.partial;

var Sugar$5 = sugarCore.exports,
    createLazyFunction = createLazyFunction_1;

Sugar$5.Function.defineInstance({

  'throttle': function(fn, ms) {
    return createLazyFunction(fn, ms, true, 1);
  }

});

Sugar$5.Function.throttle;

var Sugar$4 = sugarCore.exports,
    escapeRegExp = escapeRegExp_1;

Sugar$4.RegExp.defineStatic({

  'escape': function(str) {
    return escapeRegExp(str);
  }

});

Sugar$4.RegExp.escape;

var Sugar$3 = sugarCore.exports,
    getRegExpFlags$2 = getRegExpFlags_1;

Sugar$3.RegExp.defineInstance({

  'addFlags': function(r, flags) {
    return RegExp(r.source, getRegExpFlags$2(r, flags));
  }

});

Sugar$3.RegExp.addFlags;

var Sugar$2 = sugarCore.exports,
    getRegExpFlags$1 = getRegExpFlags_1;

Sugar$2.RegExp.defineInstance({

  'getFlags': function(r) {
    return getRegExpFlags$1(r);
  }

});

Sugar$2.RegExp.getFlags;

var Sugar$1 = sugarCore.exports,
    allCharsReg = allCharsReg_1,
    getRegExpFlags = getRegExpFlags_1;

Sugar$1.RegExp.defineInstance({

  'removeFlags': function(r, flags) {
    var reg = allCharsReg(flags);
    return RegExp(r.source, getRegExpFlags(r).replace(reg, ''));
  }

});

Sugar$1.RegExp.removeFlags;

var Sugar = sugarCore.exports;

Sugar.RegExp.defineInstance({

  'setFlags': function(r, flags) {
    return RegExp(r.source, flags);
  }

});

Sugar.RegExp.setFlags;

var sugar = sugarCore.exports;

function getLocalityFormat(firstDate, secondDate, shoudShowYear) {
    var shouldShowSecondMonth = (firstDate.getMonth() !== secondDate.getMonth());
    var locality = LocalityService.getLocality();
    switch (locality) {
        case LocalityEnum.US:
            return sugar.Date.format(firstDate, shoudShowYear ? "{mon} {d} {yyyy}" : shouldShowSecondMonth ? "{mon} {d} - " + sugar.Date.format(secondDate, "{mon} {d}") : "{mon} {d} - " + sugar.Date.format(secondDate, "{d}"));
        case LocalityEnum.AU:
            return sugar.Date.format(firstDate, shoudShowYear ? "{d} {mon} {yyyy}" : shouldShowSecondMonth ? "{d} {mon} - " + sugar.Date.format(secondDate, "{d} {mon}") : "{d} - " + sugar.Date.format(secondDate, "{d}") + " {mon}");
        default:
            return sugar.Date.format(firstDate, shoudShowYear ? "{mon} {d} {yyyy}" : shouldShowSecondMonth ? "{mon} {d} - " + sugar.Date.format(secondDate, " {mon} {d}") : "{mon} {d} - " + sugar.Date.format(secondDate, "{d}"));
    }
}
function getDayOfWeekRange(firstDate, secondDate) {
    if (!firstDate || !secondDate) {
        return "";
    }
    return sugar.Date.format(firstDate, "{dow}") + " - " + sugar.Date.format(secondDate, "{dow}");
}
function getMonthAndDates(firstDate, secondDate) {
    if (!firstDate || !secondDate) {
        return "";
    }
    var formattedDate = getLocalityFormat(firstDate, secondDate);
    return formattedDate;
}
function getYear(date) {
    if (!date) {
        return "";
    }
    return sugar.Date.format(date, "{yyyy}");
}

function parseAllLowerCaseKeys(querystring) {
    return parseGeneric(querystring, function (valueFromQueryString) {
        return valueFromQueryString.toLowerCase();
    });
}
function parse(querystring) {
    return parseGeneric(querystring, function (valueFromQueryString) {
        return valueFromQueryString;
    });
}
function parseGeneric(querystring, getKey) {
    if (!querystring) {
        return {};
    }
    if (querystring.charAt(0) === '?') {
        querystring = querystring.substring(1);
    }
    var hash = {};
    querystring.split('&').map(function (n) { return n.split('='); }).forEach(function (kv) {
        hash[getKey(decodeURIComponent(kv[0]))] = decodeURIComponent(kv[1]);
    });
    return hash;
}
function stringify(querystring) {
    var arr = [];
    for (var propName in querystring) {
        if (!Object.prototype.hasOwnProperty(propName)) {
            arr.push("".concat(encodeURIComponent(propName), "=").concat(encodeURIComponent(querystring[propName])));
        }
    }
    if (arr.length > 0) {
        return '?' + arr.join('&');
    }
    return arr.join('&');
}

var SYNTHETIC_COOKIE = 'KTNX';
function getSyntheticValueFromQueryString() {
    var qs = parseAllLowerCaseKeys$1(window.location.search);
    var syntheticParam = qs['ktnx'];
    return syntheticParam ? syntheticParam.toLowerCase() : syntheticParam;
}
function getSyntheticValueFromCookie() {
    var syntheticCookie = CookieService.get(SYNTHETIC_COOKIE);
    return syntheticCookie ? syntheticCookie.toLowerCase() : syntheticCookie;
}
function isSyntheticScript() {
    return getSyntheticValueFromQueryString() === 'true' || getSyntheticValueFromCookie() === 'true';
}

export { AccordionItem, AdaGlobalOutline, ArrowStyled, Border08pxGray, Border1pxBlack2, Border1pxGray, Border1pxOutlineStructuresoutlineGr, Border1pxToryBlue, Border21pxToryBlue, Border2pxToryBlue, Button, ButtonChevron, CheckBox, Chip, CruiseGlance, CustomBorderErrorStyle, CustomColorErrorStyle, CustomInput, CustomSelect, DEFAULT_BREAKPOINTS, DaySelect, Error$1 as Error, ExpandableButton, Focus, FocusTrap, GuestLevelPricing, IconContainer, ItineraryTitle, LinkToggle, Loader, MerchandisingChip, MonthSelect, Offers, OhSnap, OpensansBoldCrimson14px, OpensansBoldFunBlue14px, OpensansBoldSonicSilver12px, OpensansBoldSonicSilver14px, OpensansBoldToryBlue12px, OpensansBoldToryBlue14px, OpensansBoldToryBlue16px, OpensansBoldToryBlue18px, OpensansBoldTundora12px, OpensansBoldTundora14px, OpensansBoldTundora16px, OpensansBoldTundora18px, OpensansBoldTundora20px, OpensansBoldTundora22px, OpensansBoldTundora24px, OpensansBoldTundora32px, OpensansBoldWhite12px, OpensansBoldWhite14px, OpensansBoldWhite16px, OpensansBoldWhite24px, OpensansHeavyCrimson12px, OpensansNormalDark12px, OpensansNormalSonicSilver12px, OpensansNormalToryBlue12px, OpensansNormalToryBlue14px, OpensansNormalToryBlue16px, OpensansNormalTundora10px, OpensansNormalTundora12px, OpensansNormalTundora14px, OpensansNormalTundora14px2, OpensansNormalTundora16px, OpensansNormalWhite12px, OpensansNormalWhite14px, OpensansSemiBoldSonicSilver10px, OpensansSemiBoldWhite12px, OptimizelyScript, PlainButton, PlainButtonStyle, Pricing, ProfileService, RadioButton, ReadMore, ResourcesLookup, RoomDescription, SYNTHETIC_COOKIE, SaveItinerary, Select, SharedModal, SlideOutOverlay, StateSelect, StatesService, TempostdHeavycondensedNormalToryBlu, TempostdHeavycondensedNormalToryBlu1, TempostdHeavycondensedNormalToryBlu18px, TempostdHeavycondensedNormalToryBlu2, TempostdHeavycondensedNormalTundora, TempostdHeavycondensedNormalWhite18, TempostdHeavycondensedNormalWhite34, ValignTextMiddle, VisuallyHidden, YearSelect, fetchApi, getDayOfWeekRange, getLocalResources, getLocalResourcesAU, getLocalityFormat, getMonthAndDates, getYear, initAndOpenLoginSignUpModal, isSyntheticScript, parse, parseAllLowerCaseKeys, stringify, useBreakpoints, useProfile, useResources };
//# sourceMappingURL=index.js.map
